/* eslint-disable max-len */
const brandName = 'dLocal Go';

export default {
  'msgError.invitationPassword.alreadyUsed': {
    en: 'Invitation already used or user already active.',
    es: 'La invitación ya fue utilizada o el usuario ya está activo.',
    pt: 'O convite já foi utilizado ou o usuário já está ativo.',
  },
  'invitationPassword.title': {
    en: 'Create your password',
    es: 'Crea tu contraseña',
    pt: 'Crie sua senha',
  },
  'common.yes': {
    en: 'Yes',
    es: 'Sí',
    pt: 'Sim',
  },
  'common.no': {
    en: 'No',
    es: 'No',
    pt: 'Não',
  },
  'common.total': {
    en: 'Total',
    es: 'Total',
    pt: 'Total',
  },
  'common.of': {
    en: 'of',
    es: 'de',
    pt: 'de',
  },
  'common.cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    pt: 'Cancelar',
  },
  'common.clearAll': {
    en: 'Clear all',
    es: 'Limpiar todo',
    pt: 'Limpar filtros',
  },
  'common.apply': {
    en: 'Apply',
    es: 'Aplicar',
    pt: 'Aplicar',
  },
  'common.delete': {
    en: 'Delete',
    es: 'Eliminar',
    pt: 'Deletar',
  },
  'common.close': {
    en: 'Close',
    es: 'Cerrar',
    pt: 'Fechar',
  },
  'common.return': {
    en: 'Return',
    es: 'Volver',
    pt: 'Voltar',
  },
  'common.confirm': {
    en: 'Confirm',
    es: 'Confirmar',
    pt: 'Confirmar',
  },
  'common.previous': {
    en: 'previous',
    es: 'Anterior',
    pt: 'Anterior',
  },
  'common.next': {
    en: 'Next',
    es: 'Siguiente',
    pt: 'Seguinte',
  },
  'common.filter': {
    en: 'Filter',
    es: 'Filtro',
    pt: 'Filtro',
  },
  'common.default.option': {
    en: 'Select',
    es: 'Seleccionar',
    pt: 'Selecionar',
  },
  'common.all.m': {
    en: 'All',
    es: 'Todos',
    pt: 'Todos',
  },
  'common.all.f': {
    en: 'All',
    es: 'Todas',
    pt: 'Todas',
  },
  'common.others': {
    en: 'Others',
    es: 'Otros',
    pt: 'Outros',
  },
  'common.submit': {
    en: 'Submit',
    es: 'Enviar',
    pt: 'Enviar',
  },
  'common.pending': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'common.in': {
    en: 'in',
    es: 'en',
    pt: 'em',
  },
  'common.days': {
    en: 'Days',
    es: 'Días',
    pt: 'Dias',
  },
  'common.noMoreOptions': {
    en: 'No options available',
    es: 'No hay opciones disponibles',
    pt: 'Nenhuma opção disponível',
  },
  'common.language.en': {
    en: 'English',
    es: 'Inglés',
    pt: 'Inglês',
  },
  'common.language.es': {
    en: 'Spanish',
    es: 'Español',
    pt: 'Espanhol',
  },
  'common.language.pt': {
    en: 'Portuguese',
    es: 'Portugués',
    pt: 'Português',
  },
  'common.currency.USD': {
    en: 'US dollar (USD)',
    es: 'Dólar americano (USD)',
    pt: 'Dólar americano (USD)',
  },
  'common.currency.ARS': {
    en: 'Argentine peso (ARS)',
    es: 'Peso argentino (ARS)',
    pt: 'Peso argentino (ARS)',
  },
  'common.currency.BOB': {
    en: 'Bolivian (BOB)',
    es: 'Boliviano (BOB)',
    pt: 'Boliviano (BOB)',
  },
  'common.currency.BRL': {
    en: 'Brazilian real (BRL)',
    es: 'Real brasileño (BRL)',
    pt: 'Real (BRL)',
  },
  'common.currency.COP': {
    en: 'Colombian peso (COP)',
    es: 'Peso colombiano (COP)',
    pt: 'Peso colombiano (COP)',
  },
  'common.currency.DOP': {
    en: 'Dominican peso (DOP)',
    es: 'Peso dominicano (DOP)',
    pt: 'Peso dominicano (DOP)',
  },
  'common.currency.EUR': {
    en: 'Euro (EUR)',
    es: 'Euro (EUR)',
    pt: 'Euro (EUR)',
  },
  'common.currency.IDR': {
    en: 'Rupiah (IDR)',
    es: 'Rupiah (IDR)',
    pt: 'Rupiah (IDR)',
  },
  'common.currency.KES': {
    en: 'Kenyan shilling (KES)',
    es: 'Chelín Keniano (KES)',
    pt: 'Xelim Queniano (KES)',
  },
  'common.currency.MXN': {
    en: 'Mexican peso (MXN)',
    es: 'Peso mexicano (MXN)',
    pt: 'Peso mexicano (MXN)',
  },
  'common.currency.MYR': {
    en: 'Malaysian Ringgit (MYR)',
    es: 'Malaysian Ringgit (MYR)',
    pt: 'Malaysian Ringgit (MYR)',
  },
  'common.currency.NGN': {
    en: 'Naira (NGN)',
    es: 'Naira (NGN)',
    pt: 'Naira (NGN)',
  },
  'common.currency.CLP': {
    en: 'Chilean peso (CLP)',
    es: 'Peso chileno (CLP)',
    pt: 'Peso chileno (CLP)',
  },
  'common.currency.PEN': {
    en: 'Peruvian sol (PEN)',
    es: 'Sol peruano (PEN)',
    pt: 'Sol peruano (PEN)',
  },
  'common.currency.PYG': {
    en: 'Paraguayan Guarani (PYG)',
    es: 'Guaraní Paraguayo (PYG)',
    pt: 'Guarani Paraguaio (PYG)',
  },
  'common.currency.UYU': {
    en: 'Uruguayan peso (UYU)',
    es: 'Peso uruguayo (UYU)',
    pt: 'Peso uruguaio (UYU)',
  },
  'common.currency.CRC': {
    en: 'Costa Rican Colon (CRC)',
    es: 'Colón costarricense (CRC)',
    pt: 'Cólon da Costa Rica (CRC)',
  },
  'common.currency.GTQ': {
    en: 'Quetzal (GTQ)',
    es: 'Quetzal (GTQ)',
    pt: 'Quetzal (GTQ)',
  },
  // DLGO-2205 - Monedas de los nuevos mercados
  'common.currency.XOF': {
    en: 'West African CFA franc (XOF)',
    es: 'Franco CFA de África Occidental (XOF)',
    pt: 'Franco CFA da África Ocidental (XOF)',
  },
  'common.currency.XAF': {
    en: 'Central African CFA franc (XAF)',
    es: 'Franco CFA de África Central (XAF)',
    pt: 'Franco CFA da África Central (XAF)',
  },
  'common.currency.MAD': {
    en: 'Moroccan dirham (MAD)',
    es: 'Dírham marroquí (MAD)',
    pt: 'Dirham marroquino (MAD)',
  },
  'common.currency.TRY': {
    en: 'Turkish lira (TRY)',
    es: 'Lira turca (TRY)',
    pt: 'Lira turca (TRY)',
  },
  'common.currency.ZAR': {
    en: 'South African rand (ZAR)',
    es: 'Rand sudafricano (ZAR)',
    pt: 'Rand sul-africano (ZAR)',
  },
  'common.currency.INR': {
    en: 'Indian rupee (INR)',
    es: 'Rupia india (INR)',
    pt: 'Rupia indiana (INR)',
  },
  'common.currency.NIO': {
    en: 'Nicaraguan córdoba (NIO)',
    es: 'Córdoba nicaragüense (NIO)',
    pt: 'Córdoba nicaraguense (NIO)',
  },
  'common.currency.HNL': {
    en: 'Honduran lempira (HNL)',
    es: 'Lempira hondureño (HNL)',
    pt: 'Lempira hondurenho (HNL)',
  },
  'common.currency.HKD': {
    en: 'Hong Kong dollar (HKD)',
    es: 'Dólar de Hong Kong (HKD)',
    pt: 'Dólar de Hong Kong (HKD)',
  },
  'common.currency.SGD': {
    en: 'Singapore dollar (SGD)',
    es: 'Dólar de Singapur (SGD)',
    pt: 'Dólar de Singapura (SGD)',
  },
  'common.currency.CNY': {
    en: 'Chinese yuan (CNY)',
    es: 'Yuan chino (CNY)',
    pt: 'Yuan chinês (CNY)',
  },
  'common.currency.CAD': {
    en: 'Canadian dollar (CAD)',
    es: 'Dólar canadiense (CAD)',
    pt: 'Dólar canadense (CAD)',
  },
  'common.currency.AED': {
    en: 'UAE dirham (AED)',
    es: 'Dírham de los EAU (AED)',
    pt: 'Dirham dos EAU (AED)',
  },
  'common.currency.PHP': {
    en: 'Philippine peso (PHP)',
    es: 'Peso filipino (PHP)',
    pt: 'Peso filipino (PHP)',
  },
  // DLGO-2353 - Monedas de nuevos mercados tanda 2
  'common.currency.GBP': {
    en: 'British pound (GBP)',
    es: 'Libra esterlina (GBP)',
    pt: 'Libra esterlina (GBP)',
  },
  'common.fraudReview.headline': {
    en: 'We are reviewing your information.',
    es: 'Estamos revisando tu información.',
    pt: 'Estamos analisando suas informações.',
  },
  'common.fraudReview.subheadline': {
    en: "While we complete this verification, you won't be able to process payments or withdraw money. For more details, check your email. If you have any questions or need help, ",
    es: 'Mientras completamos esta verificación, no vas a poder procesar pagos ni retirar dinero. Para más detalles, podés revisar tu correo. Si tenés alguna duda o necesitás ayuda, ',
    pt: 'Enquanto completamos esta verificação, você não poderá processar pagamentos ou sacar dinheiro. Para mais detalhes, verifique seu e-mail. Se tiver alguma dúvida ou precisar de ajuda, ',
  },
  'common.fraudReview.subheadline.settlement.enabled': {
    en: "Until we finish verifying it, you won't be able to process payments. If you have any questions, ",
    es: 'Hasta que terminemos de verificarla, no podrás procesar pagos. Si tienes alguna duda, ',
    pt: 'Até terminarmos a verificação, você não poderá processar pagamentos. Se tiver qualquer dúvida, ',
  },
  'common.fraudReview.subheadline.link': {
    en: 'we are here to help.',
    es: 'estamos para ayudarte.',
    pt: 'estamos aqui para ajudar.',
  },
  'common.fraudReview.kyc1Rejected.headline': {
    en: "We couldn't validate your data.",
    es: 'No pudimos validar tus datos',
    pt: 'Não foi possível validar seus dados',
  },
  'common.fraudReview.kyc1Rejected.subheadline': {
    en: "Your account verification was not successful, so your account was blocked. We have sent you an email with more details about the reason for the block. If you believe this is an error, please contact us through the platform's chat.",
    es: 'La verificación de tu cuenta no fue exitosa, por lo que tu cuenta quedó bloqueada. Te hemos enviado un correo con más detalles sobre el motivo del bloqueo. Si creés que se trata de un error, escribinos por el chat de la plataforma.',
    pt: 'A verificação da sua conta não foi bem-sucedida, portanto sua conta foi bloqueada. Enviamos um e-mail com mais detalhes sobre o motivo do bloqueio. Se você acredita que se trata de um erro, entre em contato conosco através do chat da plataforma.',
  },
  'common.fraudReview.kyc2Rejected.headline': {
    en: "We couldn't validate your data.",
    es: 'No pudimos validar tus datos',
    pt: 'Não foi possível validar seus dados',
  },
  'common.fraudReview.kyc2Rejected.subheadline': {
    en: "Your account verification was not successful, so your account was blocked. We have sent you an email with more details about the reason for the block. If you believe this is an error, please contact us through the platform's chat.",
    es: 'La verificación de tu cuenta no fue exitosa, por lo que tu cuenta quedó bloqueada. Te hemos enviado un correo con más detalles sobre el motivo del bloqueo. Si creés que se trata de un error, escribinos por el chat de la plataforma.',
    pt: 'A verificação da sua conta não foi bem-sucedida, portanto sua conta foi bloqueada. Enviamos um e-mail com mais detalhes sobre o motivo do bloqueio. Se você acredita que se trata de um erro, entre em contato conosco através do chat da plataforma.',
  },
  'common.fraudReview.preventive.headline': {
    en: 'Your account is temporarily blocked while we review your information.',
    es: 'Tu cuenta está temporalmente bloqueada mientras revisamos tu información.',
    pt: 'Sua conta está temporariamente bloqueada enquanto revisamos suas informações.',
  },
  'common.fraudReview.preventive.subheadline': {
    en: "During this process, you won't be able to process payments or withdraw money. For more details, check your email. If you have any questions or need help, ",
    es: 'Durante este proceso, no vas a poder procesar pagos ni retirar dinero. Para más detalles, podés revisar tu correo. Si tenés alguna duda o necesitás ayuda, ',
    pt: 'Durante este processo, você não poderá processar pagamentos ou sacar dinheiro. Para mais detalhes, verifique seu e-mail. Se tiver alguma dúvida ou precisar de ajuda, ',
  },
  'common.fraudReview.preventive.subheadline.link': {
    en: 'we are here to help.',
    es: 'estamos para ayudarte.',
    pt: 'estamos aqui para ajudar.',
  },
  'common.fraudReview.permanent.headline': {
    en: 'Your account has been permanently blocked.',
    es: 'Tu cuenta ha sido bloqueada de forma permanente.',
    pt: 'Sua conta foi bloqueada permanentemente.',
  },
  'common.fraudReview.permanent.subheadline': {
    en: 'For this reason, it is no longer possible to process payments or make withdrawals. For more details, check your email. If you have any questions, ',
    es: 'Por este motivo, ya no es posible procesar pagos ni realizar retiros. Para más detalles, podés revisar tu correo. Si tenés alguna duda, ',
    pt: 'Por esse motivo, não é mais possível processar pagamentos ou realizar saques. Para mais detalhes, verifique seu e-mail. Se tiver alguma dúvida, ',
  },
  'common.fraudReview.permanent.subheadline.link': {
    en: 'you can contact us and we will gladly help you.',
    es: 'podés contactarnos y con gusto te ayudamos.',
    pt: 'entre em contato conosco e teremos prazer em ajudar.',
  },
  'common.blockedReview.headline': {
    en: 'Your account was blocked.',
    es: 'Tu cuenta fue bloqueada.',
    pt: 'Sua conta foi bloqueada.',
  },
  'common.blockedReview.subheadline': {
    en: 'To unlock it and get back to managing your payments and withdrawals, ',
    es: 'Para desbloquearla y volver a gestionar tus pagos y retiros de dinero, ',
    pt: 'Para desbloquear e voltar a gerenciar os seus pagamentos e saques, ',
  },
  'common.blockedReview.subheadline.link': {
    en: 'contact us.',
    es: 'comunícate con nosotros.',
    pt: 'entre em contato conosco.',
  },
  'common.testMessage.label': {
    en: 'Test environment',
    es: 'Entorno de prueba',
    pt: 'Ambiente de teste',
  },
  'common.testMessage.authEntry': {
    en: '<b>Enter the test environment:</b> explore and validate dLocal Go features safely.',
    es: '<b>Ingreso a entorno de prueba:</b> explore y valide las funciones de dLocal Go de forma segura.',
    pt: '<b>Entrada no ambiente de teste:</b> explore e valide as funções do dLocal Go com segurança.',
  },
  'common.testMessage': {
    en: 'You are in a <b>test</b> environment.',
    es: 'Estás en un ambiente de <b>prueba</b>.',
    pt: 'Você está em um ambiente de <b>teste</b>.',
  },
  'common.kycMessage': {
    en: 'You only have one step left to finish setting up your dLocal Go account',
    es: 'Te falta solo un paso para terminar de configurar tu cuenta de dLocal Go',
    pt: 'Você só tem mais uma etapa para terminar de configurar sua conta dLocal Go',
  },
  'common.kycMessage.click': {
    en: 'Click here',
    es: 'Haz Click aquí',
    pt: 'Clique aqui',
  },
  'common.save': {
    en: 'Save',
    es: 'Guardar',
    pt: 'Salve',
  },
  'common.edit': {
    en: 'Edit',
    es: 'Editar',
    pt: 'Editar',
  },
  'common.rowsPerPage': {
    en: 'Rows per page',
    es: 'Filas por página',
    pt: 'Linhas por página',
  },
  'common.copy': {
    en: 'Copy',
    es: 'Copiar',
    pt: 'Copiar',
  },
  'common.copied': {
    en: 'Copied',
    es: 'Copiado',
    pt: 'Copiado',
  },
  'colorPicker.selectColor': {
    en: 'Select color',
    es: 'Seleccionar color',
    pt: 'Selecionar cor',
  },
  'helpButton.text': {
    en: 'Help',
    es: 'Ayuda',
    pt: 'Ajuda',
  },
  'name.label': {
    en: 'Full name',
    es: 'Nombre completo',
    pt: 'Nome completo',
  },
  'name.helpText': {
    en: 'As it appears on your identity document.',
    es: 'Tal como figura en tu documento de identidad.',
    pt: 'Tal como consta no seu documento de identidade.',
  },
  'functionalCurrency.label': {
    en: 'Balance currency',
    es: 'Moneda de balance',
    pt: 'Moeda de operação',
  },
  'accountCreatorRole.label': {
    en: 'Role',
    es: 'Rol',
    pt: 'Cargo',
  },
  'accountCreatorName.label': {
    en: 'Full name',
    es: 'Nombre Completo',
    pt: 'Nome completo',
  },
  'emailAddress.label': {
    en: 'Email address',
    es: 'Correo electrónico',
    pt: 'E-mail',
  },
  'password.label': {
    en: 'Password',
    es: 'Contraseña',
    pt: 'Senha',
  },
  'password.helpText': {
    en: 'It must contain a minimum of 8 characters, including at least one uppercase letter, one lowercase letter and one number.',
    es: 'Debe contener un mínimo de 8 caracteres, incluyendo al menos una letra mayúscula, una letra minúscula y un número.',
    pt: 'Deve conter um mínimo de 8 caracteres, incluindo pelo menos uma letra maiúscula, uma letra minúscula e um número.',
  },
  'passwordVerify.label': {
    en: 'Password verify',
    es: 'Confirmación de contraseña',
    pt: 'Confirmação de senha',
  },
  'country.label': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'businessCountry.label': {
    en: 'Country of origin of the company',
    es: 'País de origen de su negocio',
    pt: 'País de origem da empresa',
  },
  'businessCountry.tooltip': {
    en: 'If you are a legal person, complete this field with the country where your company is legally registered.<br/><br/>If you are a natural person, put the country from where you sell your products.',
    es: 'Si eres una persona jurídica, completa este campo con el país donde tu negocio está legalmente registrada.<br/><br/>Si eres una persona física, pon el país desde donde vendes tus productos.',
    pt: 'Se você é uma pessoa jurídica, complete este campo com o país onde sua empresa está legalmente cadastrada.<br/><br/>Se você é uma pessoa física, coloque o país de onde vende seus produtos.',
  },
  'countries.label': {
    en: 'Countries',
    es: 'Países',
    pt: 'Países',
  },
  'searchCountries.label': {
    en: 'Search countries',
    es: 'Buscar países',
    pt: 'Encontrar países',
  },
  'searchPaymentMethods.label': {
    en: 'Search payment method',
    es: 'Buscar método de pago',
    pt: 'Encontrar método de pagamento',
  },
  'marketingConsent.label': {
    en: 'I agree to receive promotional and news emails.',
    es: 'Acepto recibir correos electrónicos promocionales y de noticias.',
    pt: 'Aceito receber e-mails promocionais e de notícias',
  },
  'companyType.label': {
    en: 'Account type',
    es: 'Tipo de cuenta',
    pt: 'Tipo de conta',
  },
  'companyType.tooltip': {
    en: 'The option you choose (natural or legal person) must be the same one you use for legal and tax matters.',
    es: 'La opción que elijas (persona física o jurídica) debe ser la misma que utilizas para asuntos legales y fiscales.',
    pt: 'A opção que escolher (pessoa física ou jurídica) deve ser a mesma que você utiliza para assuntos legais e fiscais.',
  },
  'companyType.company': {
    en: 'Company - Legal person',
    es: 'Empresa - Persona jurídica',
    pt: 'Empresa - Pessoa jurídica',
  },
  'companyType.physical': {
    en: 'Individual entrepreneur - Natural person',
    es: 'Emprendedor individual - Persona física',
    pt: 'Empreendedor Autônomo - Pessoa física',
  },
  'notFound.title': {
    en: "Something's wrong here...",
    es: 'Hay algo mal aquí...',
    pt: 'Há algo errado aqui...',
  },
  'notFound.subtitle': {
    en: "We can't find the page you're looking for. You can either return to the previous page or visit our homepage.",
    es: 'No podemos encontrar la página que estas buscando. Por favor regresa a la página anterior o visita nuestra página principal.',
    pt: 'Não conseguimos encontrar a página que você está procurando. Por favor, volte à página anterior ou visite nossa página principal.',
  },
  'notFound.GoHome.btn': {
    en: 'Go to home page',
    es: 'Ir a la página de inicio',
    pt: 'Vá para a página inicial',
  },
  'form.input.required': {
    en: 'This field is required.',
    es: 'Este campo es requerido.',
    pt: 'Este campo é obrigatório.',
  },
  'form.input.invalid': {
    en: 'Invalid value',
    es: 'Valor inválido',
    pt: 'Valor inválido',
  },
  'form.input.name.invalid': {
    en: 'Please enter a valid name (letters, spaces, apostrophes, hyphens).',
    es: 'Por favor ingresa un nombre válido (letras, espacios, apóstrofes, guiones).',
    pt: 'Por favor, digite um nome válido (letras, espaços, apóstrofos, hífens).',
  },
  'form.input.passwordsNotMatch': {
    en: 'Passwords entered do not match.',
    es: 'Las contraseñas ingresadas no coinciden.',
    pt: 'As senhas inseridas não correspondem.',
  },
  'form.email.invalid': {
    en: 'Invalid email address.',
    es: 'Correo electrónico inválido.',
    pt: 'E-mail inválido.',
  },
  'form.input.password.invalid': {
    en: 'Password must contain upper case, lower case and numbers.',
    es: 'La contraseña debe contener mayúsculas, minúsculas y números.',
    pt: 'A senha deve conter letras maiúsculas, minúsculas e números.',
  },
  'form.input.password.invalidLength': {
    en: 'The password must be at least 8 characters.',
    es: 'La contraseña debe tener al menos 8 caracteres.',
    pt: 'A senha deve ter pelo menos 8 caracteres.',
  },
  'form.input.termsAndConditions.invalid': {
    en: 'You must accept the terms and conditions.',
    es: 'Debe aceptar los términos y condiciones.',
    pt: 'Você deve aceitar os termos e condições.',
  },
  'form.loading': {
    en: 'Loading',
    es: 'Cargando',
    pt: 'Carregando',
  },
  'form.sending': {
    en: 'Sending',
    es: 'Enviando',
    pt: 'Enviando',
  },
  'msgError.login.default': {
    en: 'You have typed wrong credentials, or the user is either locked or inactive.',
    es: 'Ha escrito credenciales incorrectas o el usuario está bloqueado o inactivo.',
    pt: 'Você inseriu credenciais incorretas ou o usuário está bloqueado ou inativo.',
  },
  'msgError.login.wrong.password.headline': {
    en: 'Incorrect password',
    es: 'Contraseña incorrecta',
    pt: 'Senha incorreta',
  },
  'msgError.login.wrong.password.subheadline': {
    en: 'Please, re-enter it.<br />If you forgot your password, <a href="/password-reset">request a new one</a>.',
    es: 'Por favor, vuelve a introducirla.<br />Si olvidaste tu contraseña, <a href="/password-reset">solicita una nueva</a>.',
    pt: 'Por favor, digite-o novamente.<br />Se você esqueceu sua senha, <a href="/password-reset">solicite uma nova</a>.',
  },
  'msgError.login.block.headline': {
    en: 'Your account is blocked',
    es: 'Tu cuenta está bloqueada',
    pt: 'Sua conta está bloqueada',
  },
  'msgError.login.block.subheadline': {
    en: 'Please <button class="link" onclick="{0}">contact us</button> to reactivate it.',
    es: 'Por favor, <button class="link" onclick="{0}">contáctenos</button> para volver a activarla.',
    pt: 'Entre em <button class="link" onclick="{0}">contato conosco</button> para reativá-la.',
  },
  'msgError.login.emailNotVerified': {
    en: 'Email not verified. Please check that you received the verification email and follow its instructions.',
    es: 'Correo electrónico no verificado. Por favor, compruebe que recibió el correo electrónico de verificación y siga sus instrucciones.',
    pt: 'E-mail não verificado. Verifique se você recebeu o e-mail de verificação e siga suas instruções.',
  },
  'login.signUp.label': {
    en: 'Want to join us?',
    es: '¿Quieres unirte a nosotros?',
    pt: 'Deseja se juntar a nós?',
  },
  'login.passwordReset.label': {
    en: 'Forgot your password?',
    es: '¿Olvidaste tu contraseña?',
    pt: 'Esqueceu sua senha?',
  },
  'login.title': {
    en: 'Welcome',
    es: 'Bienvenido',
    pt: 'Bem-vindo',
  },
  'login.btn': {
    en: 'Login',
    es: 'Iniciar sesión',
    pt: 'Iniciar sessão',
  },
  'login.signUp': {
    en: 'Sign up',
    es: 'Regístrate',
    pt: 'Inscrever-se',
  },
  'signup.dlocalCreateAccount': {
    en: 'Activate your account and start cashing in LATAM',
    es: 'Activá tu cuenta y empezá a cobrar en LATAM',
    pt: 'Ative sua conta e comece a ganhar dinheiro na LATAM',
  },
  'signup.sandbox.dlocalCreateAccount': {
    en: 'Access the dLocal Go sandbox environment to validate your integration',
    es: 'Accedé al ambiente sandbox de dLocal Go para validar tu integración',
    pt: 'Acesse o ambiente sandbox do dLocal Go para validar sua integração',
  },
  'signUp.personalInformation.label': {
    en: 'Personal information',
    es: 'Datos personales',
    pt: 'Dados pessoais',
  },
  'signUp.register.btn': {
    en: 'Create account',
    es: 'Crear cuenta',
    pt: 'Criar conta',
  },
  'signUp.alreadyHaveAccount': {
    en: 'Already have an account?',
    es: '¿Tenés una cuenta?',
    pt: 'Já tem uma conta?',
  },
  'signUp.functionalCurrency.description': {
    en: 'This value cannot be modified after the account is created. The selected currency will be used for balances and settlements.',
    es: 'Este valor no se puede modificar después de crear la cuenta. La moneda seleccionada se utilizará para saldos y liquidaciones.',
    pt: 'Este valor não pode ser modificado após a criação da conta. A moeda selecionada será usada para saldos e liquidações.',
  },
  'signUp.error': {
    en: 'Something went wrong. Please try again.',
    es: 'Algo no salió bien. Por favor, intenta nuevamente.',
    pt: 'Ocorreu um erro. Por favor, tente novamente.',
  },
  'msgError.signUp.emailAlreadyRegistered': {
    en: 'There is already a registered user with that email.',
    es: 'Ya existe un usuario registrado con ese email.',
    pt: 'Já existe um usuário registrado com esse e-mail.',
  },
  'signUp.termsAndConditions.label': {
    en: 'I accept the',
    es: 'Acepto los',
    pt: 'Eu aceito os',
  },
  'signUp.termsAndConditions': {
    en: 'terms and conditions',
    es: 'términos y condiciones',
    pt: 'termos e condições',
  },
  'signUp.policy.label': {
    en: 'and I agree with the',
    es: 'y estoy de acuerdo con las',
    pt: 'e concordo com as',
  },
  'signUp.policy': {
    en: 'privacy policies.',
    es: 'políticas de privacidad.',
    pt: 'políticas de privacidade.',
  },
  'signUp.termsAndConditions.title': {
    en: 'Terms and conditions',
    es: 'Términos y condiciones',
    pt: 'Termos e condições',
  },
  'signUp.successMessage.title': {
    en: 'Successful registration!',
    es: '¡Registro exitoso!',
    pt: 'Registro bem-sucedido!',
  },
  'signUp.successMessage.body': {
    en: 'To continue, login to your account.',
    es: 'Para continuar, ingrese a su cuenta.',
    pt: 'Para continuar, faça login na sua conta.',
  },
  'signUp.emailSent.message.title': {
    en: 'Check your email to continue',
    es: 'Verifica tu correo para continuar',
    pt: 'Verifique seu e-mail para continuar',
  },
  'signUp.emailSent.message.desc': {
    en: "<br>We've sent an email to <b>{0}</b> to verify your account.",
    es: '<br>Enviamos un email a <b>{0}</b> para verificar tu cuenta.',
    pt: '<br>Enviamos um e-mail para <b>{0}</b> para verificar sua conta.',
  },
  'signUp.emailSent.message.desc2': {
    en: "You can find it in your main inbox. <br> If it's not there, please check your Promotions or Spam folders.",
    es: 'Puedes encontrarlo en tu bandeja principal. <br> Si no aparece, revisa también Promociones o Spam.',
    pt: 'Você pode encontrá-lo na sua caixa de entrada principal. <br> Se não estiver lá, verifique também as abas Promoções ou Spam.',
  },
  'signUp.emailSent.message.tips.title': {
    en: "Can't find it?",
    es: '¿No lo encontrás?',
    pt: 'Não encontrou?',
  },
  'signUp.emailSent.message.tip1': {
    en: 'Check your Spam or Promotions folders.',
    es: 'Revisa Spam o Promociones.',
    pt: 'Verifique as abas Spam ou Promoções.',
  },
  'signUp.emailSent.message.tip2': {
    en: 'Search for "dLocal Go" in your email.',
    es: 'Busca "dLocal Go" en tu correo.',
    pt: 'Procure "dLocal Go" em seu e-mail.',
  },
  'signUp.emailSent.message.tip3': {
    en: 'It may take a few minutes to arrive.',
    es: 'Puede demorar unos minutos.',
    pt: 'Pode levar alguns minutos para chegar.',
  },
  'passwordReset.successMessage.title': {
    en: 'Successful password reset!',
    es: '¡Restablecimiento de contraseña exitoso!',
    pt: 'Senha redefinida com sucesso!',
  },
  'passwordReset.successMessage.body': {
    en: 'To continue, login to your account.',
    es: 'Para continuar, ingrese a su cuenta.',
    pt: 'Para continuar, faça login na sua conta.',
  },
  'signUp.goToLogin.btn': {
    en: 'Login',
    es: 'Iniciar sesión',
    pt: 'Iniciar sessão',
  },
  'signUp.intro': {
    en: 'Unlock the growth of <span>your business</span> by accepting local payments',
    es: 'Desbloqueá el crecimiento de <span>tu negocio</span> aceptando pagos locales',
    pt: 'Desbloqueie o crescimento de <span>sua empresa</span> aceitando pagamentos locais',
  },
  'signUp.intro.1.title': {
    en: 'Scale your business without friction',
    es: 'Escalá tu negocio sin fricción',
    pt: 'Amplie seus negócios sem atritos',
  },
  'signUp.intro.1.subtitle': {
    en: 'Centralize your collections in a single account, without unnecessary technical integrations.',
    es: 'Centralizá tus cobros en una sola cuenta, sin integraciones técnicas innecesarias.',
    pt: 'Centralize suas coleções em uma única conta, sem integrações técnicas desnecessárias.',
  },
  'signUp.intro.2.title': {
    en: 'Access to local payment methods without opening companies in each country',
    es: 'Accedé a medios de pago locales sin abrir empresas en cada país',
    pt: 'Acesso a meios de pagamento locais sem a necessidade de abrir empresas em cada país',
  },
  'signUp.intro.2.subtitle': {
    en: 'Connect with millions of shoppers with a single payment platform.',
    es: 'Conectá con millones de compradores con una sola plataforma de pagos.',
    pt: 'Conecte-se a milhões de compradores com uma única plataforma de pagamento.',
  },
  'signUp.intro.3.title': {
    en: 'Pay only when you sell',
    es: 'Pagá solo cuando vendés',
    pt: 'Pague somente quando você vender',
  },
  'signUp.intro.3.subtitle': {
    en: 'No set up fee or fixed costs. Invest only when you get results.',
    es: 'Sin fee de set up ni costos fijos. Invertí solo cuando tenés resultados.',
    pt: 'Sem taxa de instalação ou custos fixos. Invista somente quando obtiver resultados.',
  },
  'signUp.sandbox.intro': {
    en: 'Test your integration with dLocal Go before going live',
    es: 'Comprueba tu integración con dLocal Go antes de salir a producción',
    pt: 'Teste sua integração com o dLocal Go antes de ir para produção',
  },
  'signUp.sandbox.intro.subtitle': {
    en: 'Simulate the complete payment flow in a secure environment, without processing real money.',
    es: 'Simula el flujo completo de cobros en un ambiente seguro, sin procesar dinero real.',
    pt: 'Simule o fluxo completo de cobranças em um ambiente seguro, sem processar dinheiro real.',
  },
  'signUp.sandbox.intro.1.title': {
    en: 'Simulate local payment methods',
    es: 'Simula medios de pago locales',
    pt: 'Simule meios de pagamento locais',
  },
  'signUp.sandbox.intro.1.subtitle': {
    en: "Recreate transactions with each country's payment methods without the need for real funds.",
    es: 'Recrea transacciones con los métodos de pago de cada país sin necesidad de fondos reales.',
    pt: 'Recrie transações com os métodos de pagamento de cada país sem necessidade de fundos reais.',
  },
  'signUp.sandbox.intro.2.title': {
    en: 'Integrate and test your API',
    es: 'Integra y prueba tu API',
    pt: 'Integre e teste sua API',
  },
  'signUp.sandbox.intro.2.subtitle': {
    en: 'Generate test credentials and validate your end-to-end implementation before going to production.',
    es: 'Genera credenciales de test y valida tu implementación end-to-end antes de pasar a producción.',
    pt: 'Gere credenciais de teste e valide sua implementação end-to-end antes de ir para produção.',
  },
  'signUp.sandbox.intro.3.title': {
    en: 'Zero risk, zero friction',
    es: 'Cero riesgo, cero fricción',
    pt: 'Zero risco, zero fricção',
  },
  'signUp.sandbox.intro.3.subtitle': {
    en: 'No action in this environment affects your production account or generates real charges.',
    es: 'Ningún movimiento en este ambiente afecta tu cuenta de producción ni genera cobros reales.',
    pt: 'Nenhuma ação neste ambiente afeta sua conta de produção nem gera cobranças reais.',
  },
  'menu.item.viewLess': {
    en: 'View less',
    es: 'Ver menos',
    pt: 'Ver menos',
  },
  'menu.item.HOME': {
    en: 'Home',
    es: 'Inicio',
    pt: 'Inicio',
  },
  'menu.item.HOME.desc': {
    en: 'Status of your current level and balances.',
    es: 'Estado de su nivel actual y balances.',
    pt: 'Status do seu nível e saldos atuais.',
  },
  'menu.item.REPORTS': {
    en: 'Reports',
    es: 'Reportes',
    pt: 'Relatórios',
  },
  'menu.item.ACTIVATE_ACCOUNT': {
    es: 'Configuración de cuenta',
    en: 'Account settings',
    pt: 'Configuração da conta',
  },
  'menu.item.PAYMENT_INTEGRATION': {
    en: 'eCommerce',
    es: 'eCommerce',
    pt: 'eCommerce',
  },
  'menu.item.PAYMENT_INTEGRATION.desc': {
    en: `Find the information you need to integrate your site with ${brandName} checkout.`,
    es: `Encuentra la información que necesitas para integrar tu sitio con el checkout de ${brandName}.`,
    pt: `Encontre as informações necessárias para integrar seu site ao checkout ${brandName}.`,
  },
  'paymentIntegration.list.subheadline': {
    en: 'Connect your integration and manage credentials to start collecting payments from your system.',
    es: 'Conecta tu integración y gestiona credenciales para empezar a cobrar desde tu sistema.',
    pt: 'Conecte sua integração e gerencie credenciais para começar a cobrar pelo seu sistema.',
  },
  'menu.item.COMPANY_INFORMATION': {
    en: 'Company data',
    es: 'Datos de su negocio',
    pt: 'Dados da empresa',
  },
  'menu.item.COMPANY_INFORMATION.desc': {
    en: 'Information about your company and your account level.',
    es: 'Información de su negocio y del nivel de su cuenta.',
    pt: 'Informações sobre sua empresa e seu nível de conta.',
  },
  'companyInformation.list.subheadline': {
    en: "View and keep your business's commercial, legal, and contact information up to date.",
    es: 'Consulta y mantén actualizada la información comercial, legal y de contacto de tu negocio.',
    pt: 'Consulte e mantenha atualizadas as informações comerciais, legais e de contato da sua empresa.',
  },
  'menu.subItem.EMAIL_VALIDATION': {
    en: 'Email confirmation',
    es: 'Confirmación de correo electrónico',
    pt: 'Confirmação de e-mail',
  },
  'menu.subItem.EMAIL_VALIDATION.desc': {
    en: 'Please confirm your email.',
    es: 'Por favor, confirma tu correo electrónico.',
    pt: 'Por favor, confirme seu e-mail.',
  },
  'menu.item.PAYMENT_LINK': {
    en: 'Payment link',
    es: 'Link de pago',
    pt: 'Link de pagamento',
  },
  'menu.subItem.CREATE_PAYMENT_LINK': {
    en: 'Create a payment link',
    es: 'Crear link de pago',
    pt: 'Criar link de pagamento',
  },
  'menu.subItem.CREATED_PAYMENT_LINKS': {
    en: 'Your payments links',
    es: 'Tus links de pago',
    pt: 'Seus links de pagamento',
  },
  'menu.item.PAYMENT_METHODS': {
    en: 'Payment methods',
    es: 'Métodos de pago',
    pt: 'Métodos de pagamento',
  },
  'menu.item.SPLIT_PAYMENTS': {
    en: 'Split Payments',
    es: 'Split Payments',
    pt: 'Split Payments',
  },
  'menu.item.PAYMENT_METHODS.title': {
    en: 'Select countries and payments methods',
    es: 'Selecciona países y métodos de pago',
    pt: 'Selecione os países e métodos de pagamento',
  },
  'menu.item.PAYMENT_METHODS.desc': {
    en: 'Choose where and how you want to operate.',
    es: 'Elige dónde y cómo quieres operar.',
    pt: 'Escolha onde e como você desejar operar.',
  },
  'menu.item.TRANSACTIONS': {
    en: 'Transactions',
    es: 'Transacciones',
    pt: 'Transações',
  },
  'transactions.list.subheadline': {
    en: 'Check the status of your transactions and quickly access the key information for each one.',
    es: 'Consulta el estado de tus operaciones y accede rápidamente a la información clave de cada transacción.',
    pt: 'Consulte o status das suas operações e acesse rapidamente as informações mais importantes de cada transação.',
  },
  'menu.item.AFFILIATIONS': {
    en: 'Affiliations',
    es: 'Afiliaciones',
    pt: 'Afiliados',
  },
  'menu.item.TRANSACTIONS_AFFILIATIONS': {
    en: 'Invite and win',
    es: 'Invita y gana',
    pt: 'Convide e ganhe',
  },
  'menu.item.AFFILIATIONS.desc': {
    en: 'Invite, share, grow with dLocal Go.',
    es: 'Invita, comparte, crece con dLocal Go.',
    pt: 'Convide, compartilhe, cresça com dLocal Go.',
  },
  'menu.item.SETTLEMENTS': {
    en: 'Settlements',
    es: 'Retirar fondos',
    pt: 'Retirar fundos',
  },
  'menu.item.SETTLEMENTS.desc': {
    en: 'Information about your settlements.',
    es: 'Información de sus retiros.',
    pt: 'Informações sobre suas retiradas.',
  },
  'settlements.list.subheadline': {
    en: 'Withdraw your sales funds and manage your transfers easily.',
    es: 'Retira el dinero de tus ventas y gestiona tus transferencias de forma simple.',
    pt: 'Retire o dinheiro das suas vendas e gerencie suas transferências de forma simples.',
  },
  'menu.item.VIRTUAL_POS': {
    en: 'Virtual POS',
    es: 'POS Virtual',
    pt: 'POS Virtual',
  },
  'menu.item.VIRTUAL_POS.desc': {
    en: 'Create a new payment here.',
    es: 'Cree un nuevo pago aquí.',
    pt: 'Crie um novo pagamento aqui.',
  },
  'menu.item.PAYMENT_BUTTON': {
    en: 'Payment button',
    es: 'Botón de pago',
    pt: 'Botão de pagamento',
  },
  'paymentButton.list.subheadline': {
    en: "Add a payment button to your website to collect payments online in your customers' local currency.",
    es: 'Agrega un botón de pago a tu sitio para cobrar online en la moneda de tus clientes.',
    pt: 'Adicione um botão de pagamento ao seu site para cobrar online na moeda dos seus clientes.',
  },
  'menu.item.REFUNDS_TRANSACTION': {
    en: 'Refunds',
    es: 'Reembolsos',
    pt: 'Reembolsos',
  },
  'menu.item.REFUNDS_TRANSACTION.desc': {
    en: 'Information about your refunds.',
    es: 'Información de sus reembolsos.',
    pt: 'Informações sobre seus reembolsos.',
  },
  'refunds.list.subheadline': {
    en: 'Manage refunds and return payments to your customers easily.',
    es: 'Gestiona reembolsos y devuelve pagos a tus clientes de forma simple.',
    pt: 'Gerencie reembolsos e devolva pagamentos aos seus clientes com facilidade.',
  },
  'menu.item.REFUNDS': {
    en: 'Refunds',
    es: 'Reembolsos',
    pt: 'Reembolsos',
  },
  'menu.item.REFUNDS.desc': {
    en: 'Information about your refunds.',
    es: 'Información de sus reembolsos.',
    pt: 'Informações sobre seus reembolsos.',
  },
  'menu.item.PAYOUTS': {
    en: 'Payouts',
    es: 'Pagos',
    pt: 'Pagamentos',
  },
  'menu.item.PAYOUTS.subtitle': {
    en: 'Send funds to third-party bank accounts quickly and securely, using the balance available in your dLocal Go account.',
    es: 'Envía fondos a cuentas bancarias de terceros de forma rápida y segura, utilizando el saldo disponible en tu cuenta de dLocal Go.',
    pt: 'Envia fundos para contas bancárias de terceiros de forma rápida e segura, utilizando o saldo disponível na sua conta dLocal Go.',
  },
  'menu.item.PAYOUTS.desc': {
    en: 'Review all your payouts and check their status in real time.',
    es: 'Revisa todos los pagos creados y consulta su estado en tiempo real.',
    pt: 'Visualiza todos los pagos creados y consulta su estado en tiempo real.',
  },
  'menu.item.PAYOUT_CONTACTS': {
    en: 'Contacts',
    es: 'Contactos',
    pt: 'Contatos',
  },
  'menu.item.CLIENTS': {
    en: 'Clients',
    es: 'Clientes',
    pt: 'Clientes',
  },
  'menu.item.CLIENTS.desc': {
    en: 'Information from your clients.',
    es: 'Información de sus clientes.',
    pt: 'Informações de seus clientes.',
  },
  'clients.list.subheadline': {
    en: 'Get a complete view of your client base and access the most relevant metrics for your business.',
    es: 'Obtenga una visión completa de su base de clientes y acceda a los indicadores más relevantes para su negocio.',
    pt: 'Tenha uma visão completa da sua base de clientes e acesse os indicadores mais relevantes para o seu negócio.',
  },
  'menu.item.BANK_ACCOUNTS': {
    en: 'My bank accounts',
    es: 'Mis cuentas bancarias',
    pt: 'Minhas contas bancárias',
  },
  'bankAccounts.list.subheadline': {
    en: 'View and manage the banking information associated with your account from a single place.',
    es: 'Consulta y administra la información bancaria asociada a tu cuenta desde un único lugar.',
    pt: 'Consulte e gerencie as informações bancárias vinculadas à sua conta em um único lugar.',
  },
  'menu.item.CHARGEBACKS': {
    en: 'Chargebacks',
    es: 'Contracargos',
    pt: 'Chargebacks',
  },
  'menu.item.SUBSCRIPTIONS': {
    en: 'Subscriptions',
    es: 'Suscripciones',
    pt: 'Assinaturas',
  },
  'menu.item.CHECKOUT_THEMES': {
    en: 'Checkout themes',
    es: 'Temas Checkout',
    pt: 'Temas de checkout',
  },
  'menu.item.CHECKOUT_THEMES.desc': {
    en: 'Personalize your checkout page according to your brand.',
    es: 'Personalice su página de checkout de acuerdo a su marca.',
    pt: 'Personalize sua página de checkout de acordo com sua marca.',
  },
  'checkoutThemes.list.subheadline': {
    en: 'Customize your checkout with your brand to offer a consistent experience to your customers.',
    es: 'Personaliza tu checkout con tu marca para ofrecer una experiencia consistente a tus clientes.',
    pt: 'Personalize seu checkout com sua marca para oferecer uma experiência consistente aos seus clientes.',
  },
  'menu.item.MARKETING': {
    en: 'Marketing',
    es: 'Marketing',
    pt: 'Marketing',
  },
  'menu.item.MARKETING.title': {
    en: 'Connect your marketing tools',
    es: 'Conecta tus herramientas de marketing',
    pt: 'Conecte suas ferramentas de marketing',
  },
  'menu.item.MARKETING.subtitle': {
    en: 'Centralize and manage all your tracking pixels to optimize campaigns, measure results, and better understand your customers.',
    es: 'Centraliza y gestiona todos tus píxeles de seguimiento para optimizar campañas, medir resultados y conocer mejor a tus clientes.',
    pt: 'Centralize e gerencie todos os seus pixels de rastreamento para otimizar campanhas, medir resultados e conhecer melhor seus clientes.',
  },
  'menu.item.MARKETING.desc': {
    en: 'Measure, manage and optimize campaigns',
    es: 'Mide, gestiona y optimiza campañas',
    pt: 'Meça, gerencie e otimize campanhas',
  },
  'genericError.title': {
    en: 'An error has occurred!',
    es: '¡Ha ocurrido un error!',
    pt: 'Ocorreu um erro!',
  },
  'genericError.message': {
    en: 'Something went wrong. Please try again later.',
    es: 'Algo no salió bien. Por favor, intenta nuevamente más tarde.',
    pt: 'Ocorreu um erro. Por favor, tente novamente mais tarde.',
  },
  'genericError.section.message': {
    en: 'We are unable to display this section at this time.',
    es: 'No podemos mostrar esta sección en este momento.',
    pt: 'Não podemos exibir esta seção no momento.',
  },
  'signup.recaptcha.error.title': {
    en: 'We could not verify you are human',
    es: 'No pudimos verificar que sos una persona',
    pt: 'Não conseguimos verificar que você é uma pessoa',
  },
  'signup.recaptcha.error.message': {
    en: 'reCAPTCHA could not be loaded. Please reload the page and try again.',
    es: 'No se pudo cargar reCAPTCHA. Recargá la página e intentá nuevamente.',
    pt: 'Não foi possível carregar o reCAPTCHA. Recarregue a página e tente novamente.',
  },
  'paymentMethods.coverageSubtitle': {
    en: 'Countries',
    es: 'Países',
    pt: 'Países',
  },
  'paymentMethods.coverageDesc': {
    en: 'Choose the countries in which you want to operate',
    es: 'Elige los países en los que quieras operar',
    pt: 'Escolha os países onde deseja operar',
  },
  'paymentMethods.coverageSave': {
    en: 'Save changes',
    es: 'Guardar cambios',
    pt: 'Salvar alterações',
  },
  'paymentMethod.editCoverage': {
    en: 'Edit coverage',
    es: 'Editar cobertura',
    pt: 'Editar cobertura',
  },
  'paymentMethod.coverage': {
    en: 'Coverage',
    es: 'Cobertura',
    pt: 'Cobertura',
  },
  'paymentMethod.calculator': {
    en: 'Calculator',
    es: 'Calculadora',
    pt: 'Calculadora',
  },
  'paymentMethod.accreditation': {
    en: 'Accreditation Times',
    es: 'Tiempos de acreditación',
    pt: 'Tempos de acreditação',
  },
  'paymentMethods.accreditationSubtitle': {
    en: 'Accreditation times',
    es: 'Tiempos de acreditación',
    pt: 'Tempos de acreditação',
  },
  'paymentMethods.accreditationDesc': {
    en: 'Check accreditation times by payment method and country where you operate.',
    es: 'Consulta los tiempos de acreditación según el método de pago y el país donde operas.',
    pt: 'Consulte os tempos de acreditação de acordo com o método de pagamento e o país onde você opera.',
  },
  'paymentMethod.accreditation.footerNote': {
    en: 'The days shown are the estimated time until funds are available for withdrawal in your dLocal Go account.',
    es: 'Los días indicados corresponden al tiempo estimado hasta que los fondos estén disponibles para retirar en tu cuenta de dLocal Go.',
    pt: 'Os dias indicados correspondem ao tempo estimado até que os fundos estejam disponíveis para saque na sua conta dLocal Go.',
  },
  'paymentMethod.accreditation.days': {
    en: 'Days',
    es: 'Días',
    pt: 'Dias',
  },
  'paymentMethod.accreditation.card.title': {
    en: 'Cards',
    es: 'Tarjetas',
    pt: 'Cartões',
  },
  'paymentMethod.accreditation.card.description': {
    en: 'Funds from credit or debit card transactions will be available in your dLocal Go account 7 days after the transaction is completed.',
    es: 'Los fondos correspondientes a transacciones con tarjeta de crédito o débito quedaran disponibles en tu cuenta de dLocal Go después de 7 días de completada la transacción.',
    pt: 'Os fundos de transações com cartão de crédito ou débito estarão disponíveis na sua conta dLocal Go 7 dias após a conclusão da transação.',
  },
  'paymentMethod.accreditation.transfers.title': {
    en: 'Bank Transfers',
    es: 'Transferencias Bancarias',
    pt: 'Transferências Bancárias',
  },
  'paymentMethod.accreditation.transfers.description': {
    en: 'Funds for transactions completed via bank transfer will be available in your dLocal Go account 3 days after the transaction is completed.',
    es: 'Los fondos correspondientes a transacciones completadas mediante transferencias bancarias  quedaran disponibles en tu cuenta de dLocal Go después de 3 días de completada la transacción.',
    pt: 'Os fundos para transações concluídas por transferência bancária estarão disponíveis na sua conta dLocal Go 3 dias após a conclusão da transação.',
  },
  'paymentMethod.accreditation.cash.title': {
    en: 'Cash',
    es: 'Efectivo',
    pt: 'Dinheiro',
  },
  'paymentMethod.accreditation.cash.description': {
    en: 'The funds for transactions completed with cash will be available in your dLocal Go account 3 days after the transaction is completed.',
    es: 'Los fondos correspondientes a transacciones completadas mediante efectivo quedaran disponibles en tu cuenta de dLocal Go después de 3 días de completada la transacción.',
    pt: 'Os fundos para transações concluídas com dinheiro estarão disponíveis na sua conta dLocal Go 3 dias após a conclusão da transação.',
  },
  'paymentMethod.installments': {
    en: 'Installments',
    es: 'Cuotas',
    pt: 'Cuotas',
  },
  'paymentMethod.installments.subtitle': {
    en: 'Options for installments in dLocal Go',
    es: 'Opciones de cuotas en dLocal Go',
    pt: 'Opções de parcelamento no dLocal Go',
  },
  'paymentMethod.installments.pageSubtitle': {
    en: 'See in which countries you can offer installments, how much they cost and who pays them.',
    es: 'Consulta en qué países puedes ofrecer cuotas, cuánto cuestan y quién las paga.',
    pt: 'Consulte em quais países você pode oferecer parcelas, quanto custam e quem paga.',
  },
  'paymentMethod.installments.byCountry': {
    en: 'Installment conditions by country',
    es: 'Condiciones de cuotas por país',
    pt: 'Condições de parcelas por país',
  },
  'paymentMethod.installments.desc': {
    en: 'Check the availability, costs and payment responsible for each country',
    es: 'Consulta la disponibilidad, costos y responsable de pago para cada país',
    pt: 'Consulte a disponibilidade, custos e responsável pelo pagamento para cada país',
  },
  'paymentMethod.installments.inactive': {
    en: 'Inactive',
    es: 'Inactivo',
    pt: 'Inativo',
  },
  'paymentMethod.installments.noApply': {
    en: 'Not applicable',
    es: 'No aplica',
    pt: 'Não aplicável',
  },
  'paymentMethod.installments.clientCharge': {
    en: 'In charge of the buyer',
    es: 'A cargo del comprador',
    pt: 'Por conta do comprador',
  },
  'paymentMethod.installments.merchant': {
    en: 'Seller',
    es: 'Vendedor',
    pt: 'Vendedor',
  },
  'paymentMethod.installments.buyer': {
    en: 'Buyer',
    es: 'Comprador',
    pt: 'Comprador',
  },
  'paymentMethod.installments.merchantCharge': {
    en: 'In charge of the merchant',
    es: 'A cargo del comercio',
    pt: 'Por conta do comerciante',
  },
  'paymentMethod.installments.issuerCost': {
    en: 'Set by the card issuer',
    es: 'Establecido por el emisor de la tarjeta',
    pt: 'Estabelecido pelo emissor do cartão',
  },
  'paymentMethod.installments.merchantCost': {
    en: 'Check cost details',
    es: 'Ver detalles de costos',
    pt: 'Ver detalhes de custos',
  },
  'paymentMethod.installments.header.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'paymentMethod.installments.header.available': {
    en: 'Available',
    es: 'Cuotas disponibles',
    pt: 'Parcelas disponíveis',
  },
  'paymentMethod.installments.header.paymentResponsible': {
    en: 'Payment responsible',
    es: 'Responsable del pago',
    pt: 'Responsável pelo pagamento',
  },
  'paymentMethod.installments.header.cost': {
    en: 'Cost',
    es: 'Costo',
    pt: 'Custo',
  },
  'paymentMethod.installments.header.action': {
    en: 'Action',
    es: 'Acción',
    pt: 'Ação',
  },
  'paymentMethod.threedSecure.subtitle': {
    en: '3D Secure coverage and costs',
    es: 'Cobertura y Costos de 3D Secure',
    pt: 'Cobertura e custos de 3D Secure',
  },
  'paymentMethod.threedSecure.byCountry': {
    en: '3D Secure coverage and fees by country',
    es: 'Cobertura y tarifas de 3D Secure por país',
    pt: 'Cobertura e tarifas de 3D Secure por país',
  },
  'paymentMethod.threedSecure.desc': {
    en: 'Turn two-step verification on or off based on coverage level and the flat fee per region.',
    es: 'Activa o desactiva la verificación en dos pasos según el nivel de cobertura y tarifa plana por región.',
    pt: 'Ative ou desative a verificação em duas etapas de acordo com o nível de cobertura e a tarifa fixa por região.',
  },
  'paymentMethod.threedSecure.header.available': {
    en: 'Available',
    es: 'Disponible',
    pt: 'Disponível',
  },
  'paymentMethod.threedSecure.header.enabled': {
    en: 'Enabled',
    es: 'Habilitado',
    pt: 'Habilitado',
  },
  'paymentMethod.threedSecure.header.coverage': {
    en: 'Coverage',
    es: 'Cobertura',
    pt: 'Cobertura',
  },
  'paymentMethod.threedSecure.header.seeMore': {
    en: 'See more',
    es: 'Ver más',
    pt: 'Ver mais',
  },
  'paymentMethod.threedSecure.footer': {
    en: 'Discover how 3D Secure works.',
    es: 'Descubre cómo funciona 3D Secure.',
    pt: 'Descubra como funciona o 3D Secure.',
  },
  'paymentMethod.threedSecure.costTooltip': {
    en: 'Applies to each card authentication request processed.',
    es: 'Aplica por cada solicitud de autenticación procesada por tarjeta.',
    pt: 'Aplica-se a cada solicitação de autenticação processada por cartão.',
  },
  'paymentMethod.threedSecure.forcedTooltip': {
    en: '3D Secure is required by dLocal Go and cannot be turned off.',
    es: '3D Secure es requerido por dLocal Go y no se puede desactivar.',
    pt: 'O 3D Secure é exigido pela dLocal Go e não pode ser desativado.',
  },
  'paymentMethod.threedSecure.coverage.LOW': {
    en: 'Low',
    es: 'Baja',
    pt: 'Baixa',
  },
  'paymentMethod.threedSecure.coverage.MEDIUM': {
    en: 'Medium',
    es: 'Media',
    pt: 'Média',
  },
  'paymentMethod.threedSecure.coverage.HIGH': {
    en: 'High',
    es: 'Alta',
    pt: 'Alta',
  },
  'paymentMethod.payouts.subtitle': {
    en: 'Processing fees for Payouts',
    es: 'Comisiones de Procesamiento para Payouts',
    pt: 'Comissões de processamento para Payouts',
  },
  'paymentMethod.payouts.desc': {
    en: 'See the fixed cost that applies to each completed payout based on the destination country.',
    es: 'Conoce el costo fijo aplicable a cada pago completado según el país de destino.',
    pt: 'Conheça o custo fixo aplicável a cada pagamento concluído de acordo com o país de destino.',
  },
  'paymentMethod.payouts.header.rate': {
    en: 'Rate',
    es: 'Rate',
    pt: 'Rate',
  },
  'paymentMethod.payouts.header.usd': {
    en: 'USD available',
    es: 'USD disponible',
    pt: 'USD disponível',
  },
  'paymentMethod.payouts.header.usd.tooltip': {
    en: 'Available for payouts in USD',
    es: 'Disponible para realizar payouts en USD',
    pt: 'Disponível para realizar payouts em USD',
  },
  'paymentMethod.payouts.footerNote': {
    en: '* Rates do not include local processing taxes.',
    es: '* Las tarifas no incluyen impuestos locales de procesamiento.',
    pt: '* As tarifas não incluem impostos locais de processamento.',
  },
  'paymentMethod.installments.argentinaNote': {
    en: '* In Argentina, there are regulations and limits on offering installments for some industries.',
    es: '* En Argentina, existen regulaciones y límites para ofrecer cuotas en algunas industrias.',
    pt: '* Na Argentina, há regulamentações e limites para oferecer parcelamentos em algumas indústrias.',
  },
  'paymentMethod.installments.tooltip.argentina': {
    en: 'In Argentina, there are regulations and limits on offering installments for some industries.',
    es: 'En Argentina, existen regulaciones y límites para ofrecer cuotas en algunas industrias.',
    pt: 'Na Argentina, há regulamentações e limites para oferecer parcelamentos em algumas indústrias.',
  },
  'paymentMethod.installments.tooltip.uruguay': {
    en: 'In Uruguay, merchants bear the cost of installments. The table shows processing fees + financing fees.',
    es: 'En Uruguay, los comercios asumen el costo de las cuotas. La tabla muestra las comisiones de procesamiento + financiamiento.',
    pt: 'No Uruguai, os estabelecimentos comerciais assumem o custo das parcelas. A tabela mostra as comissões de processamento + financiamento.',
  },
  'paymentMethod.installments.tooltip.paymentResponsible': {
    en: 'Define who pays the fees in this country: Buyer, seller, or enable/disable them.',
    es: 'Define quién paga las cuotas en este país: Comprador, vendedor, o actívalas/desactívalas.',
    pt: 'Defina quem paga as taxas neste país: Comprador, vendedor ou ative/desative-as.',
  },
  'paymentMethod.coverage.allCountries': {
    en: 'All countries',
    es: 'Todos los países',
    pt: 'Todos os países',
  },
  'paymentMethod.confirmCoverage.title': {
    en: 'Do you want to confirm the changes?',
    es: '¿Desea confirmar los cambios?',
    pt: 'Deseja confirmar as alterações?',
  },
  'paymentMethod.confirmCoverage.msg': {
    en: 'You will be no longer operating in:',
    es: 'Dejarás de operar en:',
    pt: 'Você não estará mais operando em:',
  },
  'paymentMethods.pageTitle': {
    en: 'Payment methods',
    es: 'Métodos de pago',
    pt: 'Métodos de pagamento',
  },
  'paymentMethods.pageSubtitle': {
    en: 'Choose which payment methods to offer in each country and review their commissions.',
    es: 'Elige qué métodos de pago ofrecer en cada país y revisa sus comisiones.',
    pt: 'Escolha quais métodos de pagamento oferecer em cada país e revise as comissões.',
  },
  'paymentMethods.byCountry': {
    en: 'Payment methods by country',
    es: 'Métodos de pago por país',
    pt: 'Métodos de pagamento por país',
  },
  'paymentMethods.filterByCountry': {
    en: 'Filter by country',
    es: 'Filtrar por país',
    pt: 'Filtrar por país',
  },
  'paymentMethods.subtitle': {
    en: 'Payment methods',
    es: 'Métodos de pago',
    pt: 'Métodos de pagamento',
  },
  'paymentMethods.desc': {
    en: 'Choose which payment method you want to offer in each country',
    es: 'Elige qué método de pago deseas ofrecer en cada país',
    pt: 'Escolha os métodos de pagamento que você deseja habilitar em cada país',
  },
  'paymentMethods.noSelection.title': {
    en: 'You have not selected any payment methods. Click below to start setting up payment methods for your checkout',
    es: 'No ha seleccionado ningún método de pago. Haga clic debajo para comenzar a agregar métodos de pago a su checkout',
    pt: 'Você não selecionou nenhum método de pagamento. Clique abaixo para começar a configurar as formas de pagamento para seu checkout',
  },
  'paymentMethods.addOtherCoutries.title': {
    en: 'Add payment methods',
    es: 'Agregar métodos de pago',
    pt: 'Adicionar métodos de pagamento',
  },
  'paymentMethods.creditCard': {
    en: 'Credit card',
    es: 'Tarjeta de crédito',
    pt: 'Cartão de crédito',
  },
  'paymentMethods.debitCard': {
    en: 'Debit card',
    es: 'Tarjeta de débito',
    pt: 'Cartão de débito',
  },
  'paymentMethods.bankTransfer': {
    en: 'Bank transfer',
    es: 'Transferencia bancaria',
    pt: 'Transferência bancária',
  },
  'paymentMethods.cash': {
    en: 'Cash',
    es: 'Efectivo',
    pt: 'Dinheiro',
  },
  'paymentMethod.details': {
    en: 'Payment method detail',
    es: 'Detalle de método de pago',
    pt: 'Detalhe da forma de pagamento',
  },
  'paymentMethod.description.type': {
    en: 'Type:',
    es: 'Tipo:',
    pt: 'Tipo:',
  },
  'paymentMethod.description.provider': {
    en: 'Provider:',
    es: 'Proveedor:',
    pt: 'Fornecedor:',
  },
  'paymentMethod.description.more': {
    en: 'See details',
    es: 'Ver detalles',
    pt: 'Veja detalhes',
  },
  'paymentMethodList.message.title': {
    en: 'You already have chosen the countries in which you want to operate!',
    es: '¡Ya tenés elegidos los países en los que querés operar!',
    pt: 'Você já selecionou os países onde deseja operar!',
  },
  'paymentMethodList.message.body': {
    en: 'Continue by choosing the payment methods you want to offer.',
    es: 'Continúa eligiendo los métodos de pago que deseas ofrecer.',
    pt: 'Continue selecionando os métodos de pagamento que deseja habilitar',
  },
  'calculator.title': {
    en: 'Payment Calculator',
    es: 'Calculadora de Pagos',
    pt: 'Calculadora de Pagamentos',
  },
  'calculator.description': {
    en: "Easily calculate the amount you'll receive after processing fees or estimate currency conversions for international transactions. Enter the details to get accurate results instantly.",
    es: 'Calcula fácilmente el monto que recibirás después de las tarifas de procesamiento o estima las conversiones de moneda para transacciones internacionales. Ingresa los detalles para obtener resultados precisos al instante.',
    pt: 'Calcule facilmente o valor que você receberá após as taxas de processamento ou estime as conversões de moeda para transações internacionais. Insira os detalhes para obter resultados precisos instantaneamente.',
  },
  'calculator.calculate': {
    en: 'Calculate',
    es: 'Calcular',
    pt: 'Calcular',
  },
  'calculator.note': {
    en: 'Note: The amounts shown are estimates and may vary slightly from the final received amount.',
    es: 'Nota: Los montos mostrados son estimaciones y pueden variar ligeramente del monto final recibido.',
    pt: 'Nota: Os valores mostrados são estimativas e podem variar ligeiramente do valor final recebido.',
  },
  'calculator.error.amountRequired': {
    en: 'Amount is required',
    es: 'El monto es requerido',
    pt: 'O valor é obrigatório',
  },
  'calculator.error.lessThan1Usd': {
    en: 'Amount is less than 1 USD',
    es: 'Monto es menor a 1 USD',
    pt: 'Valor é menor que 1 USD',
  },
  'countryCode.AR': {
    en: 'Argentina',
    es: 'Argentina',
    pt: 'Argentina',
  },
  'countryCode.BO': {
    en: 'Bolivia',
    es: 'Bolivia',
    pt: 'Bolívia',
  },
  'countryCode.BR': {
    en: 'Brazil',
    es: 'Brasil',
    pt: 'Brasil',
  },
  'countryCode.CL': {
    en: 'Chile',
    es: 'Chile',
    pt: 'Chile',
  },
  'countryCode.CO': {
    en: 'Colombia',
    es: 'Colombia',
    pt: 'Colômbia',
  },
  'countryCode.CR': {
    en: 'Costa Rica',
    es: 'Costa Rica',
    pt: 'Costa Rica',
  },
  'countryCode.DO': {
    en: 'Dominican Republic',
    es: 'República Dominicana',
    pt: 'República Dominicana',
  },
  'countryCode.EC': {
    en: 'Ecuador',
    es: 'Ecuador',
    pt: 'Equador',
  },
  'countryCode.ES': {
    en: 'Spain',
    es: 'España',
    pt: 'Espanha',
  },
  'countryCode.GT': {
    en: 'Guatemala',
    es: 'Guatemala',
    pt: 'Guatemala',
  },
  'countryCode.ID': {
    en: 'Indonesia',
    es: 'Indonesia',
    pt: 'Indonésia',
  },
  'countryCode.KE': {
    en: 'Kenya',
    es: 'Kenia',
    pt: 'Quênia',
  },
  'countryCode.MX': {
    en: 'Mexico',
    es: 'México',
    pt: 'México',
  },
  'countryCode.MY': {
    en: 'Malaysia',
    es: 'Malasia',
    pt: 'Malásia',
  },
  'countryCode.NG': {
    en: 'Nigeria',
    es: 'Nigeria',
    pt: 'Nigéria',
  },
  'countryCode.PA': {
    en: 'Panama',
    es: 'Panamá',
    pt: 'Panamá',
  },
  'countryCode.PE': {
    en: 'Peru',
    es: 'Perú',
    pt: 'Peru',
  },
  'countryCode.PY': {
    en: 'Paraguay',
    es: 'Paraguay',
    pt: 'Paraguai',
  },
  'countryCode.US': {
    en: 'United States',
    es: 'Estados Unidos',
    pt: 'Estados Unidos',
  },
  'countryCode.UY': {
    en: 'Uruguay',
    es: 'Uruguay',
    pt: 'Uruguai',
  },
  'countryCode.UX': {
    en: 'Uruguay (USD)',
    es: 'Uruguay (USD)',
    pt: 'Uruguai (USD)',
  },
  'countryCode.IX': {
    en: 'International (USD)',
    es: 'Internacional (USD)',
    pt: 'Internacional (USD)',
  },
  // DLGO-2205 - Habilitar nuevos mercados
  'countryCode.AE': {
    en: 'United Arab Emirates',
    es: 'Emiratos Árabes Unidos',
    pt: 'Emirados Árabes Unidos',
  },
  'countryCode.CA': {
    en: 'Canada',
    es: 'Canadá',
    pt: 'Canadá',
  },
  'countryCode.CI': {
    en: 'Ivory Coast',
    es: 'Costa de Marfil',
    pt: 'Costa do Marfim',
  },
  'countryCode.CM': {
    en: 'Cameroon',
    es: 'Camerún',
    pt: 'Camarões',
  },
  'countryCode.CN': {
    en: 'China',
    es: 'China',
    pt: 'China',
  },
  'countryCode.HK': {
    en: 'Hong Kong SAR, China',
    es: 'Hong Kong RAE, China',
    pt: 'Hong Kong RAE, China',
  },
  'countryCode.HN': {
    en: 'Honduras',
    es: 'Honduras',
    pt: 'Honduras',
  },
  'countryCode.IN': {
    en: 'India',
    es: 'India',
    pt: 'Índia',
  },
  'countryCode.MA': {
    en: 'Morocco',
    es: 'Marruecos',
    pt: 'Marrocos',
  },
  'countryCode.NI': {
    en: 'Nicaragua',
    es: 'Nicaragua',
    pt: 'Nicarágua',
  },
  'countryCode.PH': {
    en: 'Philippines',
    es: 'Filipinas',
    pt: 'Filipinas',
  },
  'countryCode.SG': {
    en: 'Singapore',
    es: 'Singapur',
    pt: 'Singapura',
  },
  'countryCode.SN': {
    en: 'Senegal',
    es: 'Senegal',
    pt: 'Senegal',
  },
  'countryCode.SV': {
    en: 'El Salvador',
    es: 'El Salvador',
    pt: 'El Salvador',
  },
  'countryCode.TR': {
    en: 'Turkey',
    es: 'Turquía',
    pt: 'Turquia',
  },
  'countryCode.ZA': {
    en: 'South Africa',
    es: 'Sudáfrica',
    pt: 'África do Sul',
  },
  // DLGO-2353 - Habilitar nuevos mercados tanda 2
  'countryCode.DE': {
    en: 'Germany',
    es: 'Alemania',
    pt: 'Alemanha',
  },
  'countryCode.AT': {
    en: 'Austria',
    es: 'Austria',
    pt: 'Áustria',
  },
  'countryCode.CY': {
    en: 'Cyprus',
    es: 'Chipre',
    pt: 'Chipre',
  },
  'countryCode.EE': {
    en: 'Estonia',
    es: 'Estonia',
    pt: 'Estônia',
  },
  'countryCode.FR': {
    en: 'France',
    es: 'Francia',
    pt: 'França',
  },
  'countryCode.IE': {
    en: 'Ireland',
    es: 'Irlanda',
    pt: 'Irlanda',
  },
  'countryCode.NL': {
    en: 'Netherlands',
    es: 'Países Bajos',
    pt: 'Países Baixos',
  },
  'countryCode.PT': {
    en: 'Portugal',
    es: 'Portugal',
    pt: 'Portugal',
  },
  'countryCode.GB': {
    en: 'United Kingdom',
    es: 'Reino Unido',
    pt: 'Reino Unido',
  },
  'countryCode.CH': {
    en: 'Switzerland',
    es: 'Suiza',
    pt: 'Suíça',
  },
  'region.LA': {
    en: 'Latin America',
    es: 'América Latina',
    pt: 'América Latina',
  },
  'region.AF_ME': {
    en: 'Africa and Middle East',
    es: 'África y Medio Oriente',
    pt: 'África e Oriente Médio',
  },
  'region.AS': {
    en: 'Asia',
    es: 'Asia',
    pt: 'Ásia',
  },
  'paymentMethod.creditCardDisabled': {
    en: 'You cannot offer <b>cards</b> as a form of payment at your current level. For more information about your current level and how to increase it click',
    es: 'No puedes ofrecer <b>tarjetas</b> como forma de pago en tu nivel actual. Para más información sobre tu nivel actual y como incrementarlo haz clic',
    pt: 'Você não pode oferecer <b>cartões</b> como forma de pagamento em seu nível atual. Para obter mais informações sobre o seu nível atual e como aumentá-lo, clique',
  },
  'paymentMethod.creditCardDisabled.here': {
    en: 'here.',
    es: 'aquí.',
    pt: 'aqui.',
  },
  'paymentMethod.table.title': {
    en: 'Add payment methods',
    es: 'Agregar métodos de pago',
    pt: 'Adicionar formas de pagamento',
  },
  'paymentMethod.confirm.title': {
    en: 'Confirm',
    es: 'Confirmar',
    pt: 'Confirmar',
  },
  'paymentMethod.confirm.body': {
    en: 'Do you want to stop offering the selected payment method?',
    es: '¿Desea dejar de ofrecer el método de pago seleccionado?',
    pt: 'Deseja deixar de oferecer o método de pagamento selecionado?',
  },
  'paymentMethod.action': {
    en: 'Action',
    es: 'Acción',
    pt: 'Ação',
  },
  'paymentMethod.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'paymentMethod.name': {
    en: 'Name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'paymentMethod.type': {
    en: 'Type',
    es: 'Tipo',
    pt: 'Tipo',
  },
  'paymentMethod.commission': {
    en: 'Commission',
    es: 'Comisión',
    pt: 'Comissão',
  },
  'paymentMethod.provider': {
    en: 'Provider',
    es: 'Proveedor',
    pt: 'Fornecedor',
  },
  'paymentMethod.available': {
    en: 'Available',
    es: 'Disponible',
    pt: 'Disponível',
  },
  'paymentMethod.notAvailable': {
    en: 'Not available',
    es: 'No disponible',
    pt: 'Não disponível',
  },
  'paymentMethod.status': {
    en: 'Status',
    es: 'Estado',
    pt: 'Estado',
  },
  'paymentMethod.table.notAvailable': {
    en: 'Not available',
    es: 'No disponible',
    pt: 'Não disponível',
  },
  'paymentMethod.type.VOUCHER': {
    en: 'Cash',
    es: 'Efectivo',
    pt: 'Dinheiro',
  },
  'paymentMethod.type.BANK_TRANSFER': {
    en: 'Bank transfer',
    es: 'Transferencia bancaria',
    pt: 'Transferência bancária',
  },
  'paymentMethod.type.CREDIT_CARD': {
    en: 'Credit Card',
    es: 'Tarjeta de crédito',
    pt: 'Cartão de crédito',
  },
  'paymentMethod.type.DEBIT_CARD': {
    en: 'Debit Card',
    es: 'Tarjeta de débito',
    pt: 'Cartão de débito',
  },
  'paymentMethod.type.CARD': {
    en: 'Card',
    es: 'Tarjeta',
    pt: 'Cartão',
  },
  'paymentMethod.type.cardGroup': {
    en: 'Credit / Debit card',
    es: 'Tarjeta de Crédito / Débito',
    pt: 'Cartão de Crédito / Débito',
  },
  'paymentMethod.type.boleto': {
    en: 'Boleto Bancario',
    es: 'Boleto Bancario',
    pt: 'Boleto Bancário',
  },
  'paymentMethod.type.ONLINE_BANK_TRANSFER': {
    en: 'Online bank transfer',
    es: 'Transferencia bancaria en línea',
    pt: 'Transferência bancária online',
  },
  'paymentMethod.note': {
    en: '* Commissions do not include taxes.',
    es: '* Las comisiones no incluyen impuestos.',
    pt: '* As comissões não incluem impostos.',
  },
  'subscriptionForm.subtitle': {
    en: 'Please, complete the following information to enter your payment method.',
    es: 'Por favor, complete la siguiente información para ingresar su método de pago.',
    pt: 'Por favor, preencha as seguintes informações para inserir sua forma de pagamento.',
  },
  'subscriptionForm.subtitleUpdate': {
    en: 'Please, fill out the following information to update your payment method.',
    es: 'Por favor, complete la siguiente información para actualizar su método de pago.',
    pt: 'Por favor, preencha as seguintes informações para atualizar sua forma de pagamento.',
  },
  'subscriptionForm.btn': {
    en: 'Subscribe',
    es: 'Suscribirse',
    pt: 'Inscrever-se',
  },
  'subscriptionForm.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'subscriptionForm.name': {
    en: 'Name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'subscriptionForm.documentType': {
    en: 'Document type',
    es: 'Tipo de documento',
    pt: 'Tipo de documento',
  },
  'subscriptionForm.document': {
    en: 'Document',
    es: 'Documento',
    pt: 'Documento',
  },
  'smartField.cardField': {
    en: 'Credit card',
    es: 'Tarjeta de crédito',
    pt: 'Cartão de crédito',
  },
  'smartField.fees': {
    en: 'Fees to pay',
    es: 'Cuotas a pagar',
    pt: 'Parcelas a pagar',
  },
  'smartField.fees.MX': {
    en: 'Fees to pay',
    es: 'Meses a pagar',
    pt: 'Parcelas a pagar',
  },
  'smartField.defaultOptions': {
    en: 'Enter the card number first',
    es: 'Ingrese primero el número de tarjeta',
    pt: 'Insira o número do cartão primeiro',
  },
  'smartField.withInterest.singular': {
    en: ' installment - With interest of the issuing bank',
    es: ' cuota - Con interés del banco emisor.',
    pt: ' parcela - Com juros do banco emissor.',
  },
  'smartField.withInterest.prural': {
    en: ' installments - With interest of the issuing bank',
    es: ' cuotas - Con interés del banco emisor.',
    pt: ' parcelas - Com juros do banco emissor.',
  },
  'smartField.withInterest.singular.MX': {
    en: ' installment - With interest of the issuing bank',
    es: ' mes - Con interés del banco emisor.',
    pt: ' parcela - Com juros do banco emissor.',
  },
  'smartField.withInterest.prural.MX': {
    en: ' installments - With interest of the issuing bank',
    es: ' meses - Con interés del banco emisor.',
    pt: ' parcelas - Com juros do banco emissor.',
  },
  'paymentHistory.date': {
    en: 'Date',
    es: 'Fecha',
    pt: 'Data',
  },
  'paymentHistory.desc': {
    en: 'Description',
    es: 'Descripción',
    pt: 'Descrição',
  },
  'paymentHistory.period': {
    en: 'Period',
    es: 'Período',
    pt: 'Período',
  },
  'paymentHistory.paymentMethod': {
    en: 'Payment method',
    es: 'Método de pago',
    pt: 'Método de pagamento',
  },
  'paymentHistory.amount': {
    en: 'Amount',
    es: 'Monto',
    pt: 'Montante',
  },
  'companyInformation.levelOne.desc': {
    en: `Before you can accept payments with ${brandName}, we need to know more about you and your company. We collect this information to meet the requirements of regulatory authorities and our {0}.`,
    es: `Antes de que puedas aceptar pagos con ${brandName}, necesitamos saber más sobre ti y su negocio. Recogemos esta información para cumplir con los requisitos de las autoridades reguladoras y nuestros {0}.`,
    pt: `Antes de poder aceitar pagamentos com o ${brandName}, precisamos saber mais sobre você e sua empresa. Coletamos essas informações para atender aos requisitos das autoridades reguladoras e nossos {0}.`,
  },
  'companyInformation.needKnowMore.desc': {
    en: `Before you can continue accepting payments with <b>${brandName}</b>, we need to know more about you and your company. We collect this information to comply with the requirements of regulatory authorities and our {0}.`,
    es: `Antes de que puedas continuar aceptando pagos con <b>${brandName}</b>, necesitamos saber más sobre ti y su negocio. Recogemos esta información para cumplir con los requisitos de las autoridades reguladoras y nuestros {0}.`,
    pt: `Antes de continuar aceitando pagamentos com <b>${brandName}</b>, precisamos saber mais sobre você e sua empresa. Coletamos essas informações para cumprir os requisitos das autoridades regulatórias e de nossa {0}.`,
  },
  'companyInformation.levelTwo.btn': {
    en: 'Complete required information',
    es: 'Completar información requerida',
    pt: 'Preencha as informações necessárias',
  },
  'companyInformation.kyc.info': {
    en: '<b>IMPORTANT:</b> The data entered in this section will be used for withdrawals to your bank account.',
    es: '<b>IMPORTANTE:</b> Los datos ingresados en esta sección serán utilizados para los retiros a su cuenta bancaria.',
    pt: '<b>IMPORTANTE:</b> Os dados inseridos nesta seção serão usados ​​para saques em sua conta bancária.',
  },
  'companyInformation.kyc.required': {
    en: 'This field is required.',
    es: 'Este campo es requerido.',
    pt: 'Este campo é obrigatório.',
  },
  'companyInformation.kyc.invalid': {
    en: 'Invalid value',
    es: 'Valor inválido',
    pt: 'Valor inválido',
  },
  'companyInformation.kyc.documentAlreadyInUse': {
    en: 'Document registered in another account',
    es: 'Documento ingresado en otra cuenta',
    pt: 'Número de documento já registrado em outra conta',
  },
  'companyInformation.kyc.websiteAlreadyInUse': {
    en: 'Website registered into another account',
    es: 'Sitio web registrado en otra cuenta',
    pt: 'Site registrado em outra conta',
  },
  'companyInformation.kyc.websiteInvalid': {
    en: 'The URL entered is not valid.',
    es: 'La URL ingresada no es válida.',
    pt: 'A URL inserida não é válida.',
  },
  'companyInformation.kyc.tooShort': {
    en: 'The entered value is too short.',
    es: 'El valor ingresado es demasiado corto.',
    pt: 'O valor inserido é muito curto.',
  },
  'companyInformation.kyc.naturalPerson': {
    en: 'Natural person',
    es: 'Persona física',
    pt: 'Pessoa física',
  },
  'companyInformation.kyc.company': {
    en: 'Company',
    es: 'Persona jurídica',
    pt: 'Pessoa jurídica',
  },
  'companyInformation.kyc.lastName': {
    en: 'Last name',
    es: 'Apellido',
    pt: 'Sobrenome',
  },
  'companyInformation.kyc.name.company': {
    en: 'Entity name',
    es: 'Nombre legal de su negocio',
    pt: 'Nome da empresa',
  },
  'companyInformation.kyc.name.physical': {
    en: 'Name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'companyInformation.kyc.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'companyInformation.kyc.documentType': {
    en: 'Document type',
    es: 'Tipo de documento',
    pt: 'Tipo de documento',
  },
  'companyInformation.kyc.documentTypes.SSN': {
    en: 'Last 4 digits of Social Security Number',
    es: 'Últimos 4 dígitos del número de seguridad social',
    pt: 'Últimos 4 dígitos do número de segurança social',
  },
  'companyInformation.kyc.document': {
    en: 'Document number',
    es: 'Número de documento',
    pt: 'Número de documento',
  },
  'companyInformation.kyc.phone': {
    en: 'Mobile phone',
    es: 'Teléfono móvil',
    pt: 'Telefone celular',
  },
  'companyInformation.kyc.subIndustry': {
    en: 'Industry',
    es: 'Industria',
    pt: 'Indústria',
  },
  'companyInformation.kyc.subIndustry.company/physical': {
    en: 'Industry',
    es: 'Industria o rubro',
    pt: 'Indústria ou categoria',
  },
  'companyInformation.kyc.subIndustryNotSupported': {
    en: 'Industry not supported',
    es: 'Industria no soportada',
    pt: 'Indústria não suportado',
  },
  'companyInformation.kyc.markets': {
    en: 'Markets you are interested in targeting with us',
    es: 'Mercados que le interesa trabajar con nosotros',
    pt: 'Mercados em que você está interessado em trabalhar conosco',
  },
  'companyInformation.kyc.operationYears': {
    en: 'Years in operation',
    es: 'Cantidad de años operando',
    pt: 'Número de anos de operação',
  },
  'companyInformation.kyc.website.placeholder': {
    en: 'www.my-company.com',
    es: 'www.my-company.com',
    pt: 'www.my-company.com',
  },
  'companyInformation.kyc.website': {
    en: 'Website',
    es: 'Sitio web',
    pt: 'Website',
  },
  'companyInformation.kyc.website.description': {
    en: "The <b>Website</b> entered will be used to verify the origin when using plugin integrations. If you don't have a website, enter your company/marketplace page on social media (Facebook, Instagram, Twitter, etc.). It is <b>NOT</b> allowed to use personal social networks as a website.",
    es: 'El <b>Sitio web</b> ingresado se utilizará para verificar el origen al usar integraciones de complementos. Si no tiene un sitio web, ingrese la página de su negocio/marketplace en redes sociales (Facebook, Instagram, Twitter, etc.). <b>NO</b> se permite utilizar redes sociales personales como sitio web.',
    pt: 'O <b>Site</b> inserido será usado para verificar a origem ao usar integrações de plug-ins. Se você não possui um site, insira a página da sua empresa/marketplace nas redes sociais (Facebook, Instagram, Twitter, etc.). <b>NÃO</b> é permitido o uso de redes sociais pessoais como website.',
  },
  'companyInformation.kyc.important': {
    en: 'Important',
    es: 'Importante',
    pt: 'Importante',
  },
  'companyInformation.kyc.warning.functionalCurrency': {
    en: 'dLocal Go displays on your balance sheet all transactions made in different countries in a single currency, which can be in dollars or in your local currency, according to your preference. <b>Please note that this selection cannot be changed later.</b>',
    es: 'dLocal Go expone en tu balance todas las ventas realizadas en los diferentes países en una única moneda, que puede ser en dólares o en tu moneda local, lo que tú prefieras. <b>Ten en cuenta que esta elección no podrá modificarse luego.</b>',
    pt: 'A dLocal Go unifica em seu saldo todas as vendas realizadas nos diversos países em uma única moeda, que pode ser em dólares ou em sua moeda local, conforme sua preferência. <b>Observe que esta escolha não pode ser alterada posteriormente.</b>',
  },
  'companyInformation.kyc.warning.country': {
    en: 'Country where the company is registered and where you will receive your withdrawals.',
    es: 'País donde se encuentra registrado su negocio y donde recibirás tus retiros.',
    pt: 'País onde sua empresa está registrada e da conta bancária onde você receberá seu dinheiro.',
  },

  'companyInformation.kyc.companyForm.title': {
    en: 'Upload your company data',
    es: 'Carga los datos de su negocio',
    pt: 'Carregue os dados de sua empresa',
  },
  'companyInformation.kyc.companyForm.title.physical': {
    en: 'Complete your basic information',
    es: 'Completa tus datos básicos',
    pt: 'Adicione seus dados básicos',
  },

  'companyInformation.kyc.companyForm.description': {
    en: "Complete the form with the commercial and legal information of your company. Don't worry, the process is quick and we will guide you at all times.",
    es: 'Completa el formulario con la información comercial y legal de su negocio. No te preocupes, el proceso es rápido y te guiaremos en todo momento.',
    pt: 'Complete o formulário com a informação comercial e legal de sua empresa. Não se preocupe, o processo é rápido e vamos guiá-lo a todo momento.',
  },

  'companyInformation.kyc.companyForm.description.company/physical': {
    en: "This step won't take you more than 5 minutes.",
    es: 'Este paso no te llevará mas de 5 minutos.',
    pt: 'Este passo não irá demorar mais do que 5 minutos.',
  },

  'companyInformation.kyc.companyForm.businessType': {
    en: 'Choose your type of company',
    es: 'Elige tu tipo de negocio',
    pt: 'Escolha seu tipo de empresa',
  },

  'companyInformation.kyc.companyForm.businessData': {
    en: 'Company data',
    es: 'Datos de su negocio',
    pt: 'Dados de sua empresa',
  },

  'companyInformation.kyc.companyForm.allDataRequired': {
    en: 'All fields are required.',
    es: 'Todos los campos son obligatorios.',
    pt: 'Todos os campos são necessários.',
  },

  'companyInformation.kyc.companyForm.businessInformation': {
    en: 'Commercial information',
    es: 'Información Comercial',
    pt: 'Informação Comercial',
  },

  'companyInformation.kyc.companyForm.legalInformation': {
    en: 'Legal information',
    es: 'Información Legal',
    pt: 'Informação Legal',
  },

  'companyInformation.kyc.companyForm.contactInformation': {
    en: 'Contact information',
    es: 'Datos de Contacto',
    pt: 'Dados de Contato',
  },
  'companyInformation.kyc.companyForm.dataWhoRegistersAccount': {
    en: 'Contact information',
    es: 'Datos de quien registra la cuenta',
    pt: 'Dados de Contato',
  },
  'companyInformation.kyc.companyForm.roles.EMPLOYEE': {
    en: 'Employee',
    es: 'Empleado',
    pt: 'Funcionário',
  },
  'companyInformation.kyc.companyForm.roles.OWNER': {
    en: 'Owner',
    es: 'Dueño',
    pt: 'Proprietário',
  },
  'companyInformation.kyc.companyForm.roles.PARTNER': {
    en: 'Partner',
    es: 'Socio',
    pt: 'Parceiro',
  },
  'companyInformation.kyc.companyForm.roles.LEGAL_REPRESENTATIVE': {
    en: 'Legal Representative',
    es: 'Representante legal',
    pt: 'Representante legal',
  },
  'companyInformation.kyc.companyForm.roles.OTHER': {
    en: 'Other',
    es: 'Otro',
    pt: 'Outro',
  },
  'companyInformation.kyc.companyForm.roles.CFO': {
    en: 'CFO',
    es: 'CFO',
    pt: 'CFO',
  },
  'companyInformation.kyc.companyForm.roles.CTO': {
    en: 'CTO',
    es: 'CTO',
    pt: 'CTO',
  },
  'companyInformation.kyc.companyForm.roles.CCO': {
    en: 'CCO',
    es: 'CCO',
    pt: 'CCO',
  },
  'companyInformation.kyc.companyForm.roles.CIO': {
    en: 'CIO',
    es: 'CIO',
    pt: 'CIO',
  },
  'companyInformation.kyc.companyForm.roles.CMO': {
    en: 'CMO',
    es: 'CMO',
    pt: 'CMO',
  },
  'companyInformation.kyc.companyForm.roles.FINANCIAL_OFFICER_MANAGER': {
    en: 'Financial officer manager',
    es: 'Director financiero',
    pt: 'Diretor financeiro',
  },
  'companyInformation.kyc.companyForm.roles.TECHNOLOGY_OFFICER_MANAGER': {
    en: 'Technology officer manager',
    es: 'Director de tecnología',
    pt: 'Diretor de tecnologia',
  },
  'companyInformation.kyc.companyForm.roles.COMMERCIAL_MANAGER': {
    en: 'Commercial manager',
    es: 'Director comercial',
    pt: 'Diretor comercial',
  },
  'companyInformation.kyc.companyForm.roles.DIRECTOR_OF_OPERATIONS': {
    en: 'Director of operations',
    es: 'Director de operaciones',
    pt: 'Diretor de operações',
  },
  'companyInformation.kyc.companyForm.roles.MARKETING_MANAGER': {
    en: 'Marketing manager',
    es: 'Responsable de marketing',
    pt: 'Responsável de marketing',
  },
  'companyInformation.kyc.companyForm.roles.ECOMMERCE_MANAGER': {
    en: 'E-commerce manager',
    es: 'Responsable de e-commerce',
    pt: 'Responsável  de e-commerce',
  },
  'companyInformation.kyc.companyForm.roles.LEGAL_MANAGER': {
    en: 'Legal manager',
    es: 'Responsable legal',
    pt: 'Responsável legal',
  },
  'companyInformation.kyc.companyForm.roles.PROJECT_MANAGER': {
    en: 'Project manager',
    es: 'Responsable de proyecto (Project manager)',
    pt: 'Responsável  de projeto (Project manager)',
  },
  'companyInformation.kyc.companyNameOrBrand': {
    en: 'Trade name or company brand',
    es: 'Nombre comercial o marca de su negocio',
    pt: 'Nome comercial ou marca da empresa',
  },
  'companyInformation.kyc.companyNameOrBrand.physical': {
    en: 'Trade name or business brand',
    es: 'Nombre comercial o marca de tu negocio',
    pt: 'Nome comercial ou marca da empresa',
  },

  'companyInformation.kyc.companyOriginCountry': {
    en: 'Country of origin of the company',
    es: 'País de origen de su negocio',
    pt: 'País de origem da empresa',
  },
  'companyInformation.kyc.companyOriginCountry.physical': {
    en: 'Country of origin of your business',
    es: 'País de origen de tu negocio',
    pt: 'País de origem do seu negócio',
  },

  'companyInformation.kyc.infopopup.businessName': {
    en: 'This is the name of your brand, with which your company is publicly recognized by your customers.<br />Your clients will see the name of your brand in the communications sent when paying you.',
    es: 'Este es el nombre de tu marca, con el que tu negocio es reconocido públicamente por tus clientes.<br />Tus clientes verán el nombre de tu marca en las comunicaciones que enviemos al momento del pago.',
    pt: 'Este é o nome de sua marca, com o qual sua empresa é reconhecida publicamente por seus clientes.<br />Os clientes verão o nome ou marca da sua empresa nas comunicações que enviamos para eles.',
  },

  'companyInformation.kyc.infopopup.website.1': {
    en: "URL from which you make your sales. If you don't have your own website, enter the marketplace or social networks of your business (Facebook, Instagram, Twitter, etc.).",
    es: 'URL desde la que realizas tus ventas. Si no tienes un sitio propio, ingresa el marketplace o redes sociales de tu negocio (Facebook, Instagram, Twitter, etc.).',
    pt: 'URL a partir da qual você realiza suas vendas. Se não tiver um site próprio, acesse o marketplace ou redes sociais de seu negócio (Facebook, Instagram, Twitter, etc.).',
  },

  'companyInformation.kyc.infopopup.website.1.company/physical': {
    en: 'URL from which you make your sales. Make sure the website is current and is the one you actually use to sell your products or services.',
    es: 'URL desde la que realizas tus ventas. Asegúrate de que el sitio web esté vigente y sea el que realmente usas para vender tus productos o servicios.',
    pt: 'URL a partir da qual você realiza suas vendas. Certifique-se de que o site está vigente e seja aquele que realmente usa para vender seus produtos e serviços.',
  },

  'companyInformation.kyc.infopopup.website.2': {
    en: 'You may not use a personal social network as a website for your company.',
    es: 'No puedes usar una red social personal como sitio web para tu negocio.',
    pt: 'Você não pode usar uma rede social pessoal como website para seu negócio.',
  },

  'companyInformation.kyc.infopopup.legalName.company': {
    en: 'Name that you use for formal, legal and tax uses in front of control authorities.',
    es: 'Nombre que empleas para usos formales, jurídicos e impositivos frente a organismos de control.',
    pt: 'Nome que você utiliza para usos formais, jurídicos e impositivos frente aos organismos de controle.',
  },

  'companyInformation.kyc.infopopup.countryCompany': {
    en: 'Country where the company is legally constituted.',
    es: 'País dónde está constituida legalmente su negocio.',
    pt: 'País onde está constituída legalmente a empresa.',
  },

  'companyInformation.kyc.infopopup.functionalCurrency': {
    en: 'This is the currency you will use to view your balances.<br><br>dLocal Go unifies local and international sales in a single currency. You can choose to see your money in your local currency or US Dollars.',
    es: 'Esta es la moneda que usarás para ver tus balances.<br><br>dLocal Go unifica las ventas locales e internacionales en una única moneda. Puedes elegir ver tu dinero en tu moneda local o US Dólar.',
    pt: 'Esta é a moeda que você usará para ver seus balanços.<br><br>dLocal Go unifica as vendas locais e internacionais numa única moeda. Você pode escolher ver seu dinheiro em sua moeda local ou USD Dólar.',
  },

  'companyInformation.kyc.infopopup.legalName.physical': {
    en: 'Name as it appears on your identity document.',
    es: 'Nombre tal como figura en tu documento de identidad.',
    pt: 'Nome que você utiliza para usos formais, jurídicos e impositivos frente aos organismos de controle.',
  },

  'companyInformation.kyc.infopopup.legalSurnamePerson': {
    en: 'Surname as it appears on your identity document.',
    es: 'Apellido tal como figura en tu documento de identidad.',
    pt: 'Nome que você utiliza para usos formais, jurídicos e impositivos frente aos organismos de controle.',
  },

  'companyInformation.kyc.infopopup.countryPerson': {
    en: 'Country from which you sell your products.',
    es: 'País desde el cual vendes tus productos.',
    pt: 'País onde está constituída legalmente a empresa.',
  },

  'companyInformation.kyc.infopopup.country.physical': {
    en: 'Country where you founded your business',
    es: 'País donde fundaste tu negocio',
    pt: 'País onde você fundou seu negócio',
  },

  'companyInformation.kyc.infopopup.country.company': {
    en: 'Country where the company is legally constituted.',
    es: 'País dónde está constituida legalmente su negocio.',
    pt: 'País onde está constituída legalmente a empresa.',
  },

  'companyInformation.kyc.infopopup.BR.CPF': {
    en: '',
    es: 'El CPF  está compuesto por 11 números, sin caracteres especiales y sin espacios.',
    pt: 'O CPF é composto por 11 dígitos, sem caracteres especiais e sem espaços.',
  },
  'companyInformation.kyc.infopopup.BR.CNPJ': {
    en: '',
    es: 'El CNPJ está compuesto por 14 números, sin caracteres especiales y sin espacios.',
    pt: 'O CNPJ é composto por 14 dígitos, sem caracteres especiais e sem espaços.',
  },
  'companyInformation.kyc.infopopup.CO.CC': {
    en: '',
    es: 'El CC o la Cédula de Ciudadanía está compuesto de 6 a 10 números, sin caracteres especiales y sin espacios.',
    pt: '',
  },
  'companyInformation.kyc.infopopup.CO.NIT': {
    en: '',
    es: 'El NIT o Número de Identificación Tributaria está compuesto de 10 a 11 números, sin caracteres especiales ni espacios.',
    pt: '',
  },
  'companyInformation.kyc.infopopup.CO.PASS': {
    en: '',
    es: 'El pasaporte puede tener hasta 12 caracteres alfanuméricos y no debe incluir caracteres especiales ni espacios.',
    pt: '',
  },
  'companyInformation.kyc.infopopup.CO.CE': {
    en: '',
    es: 'El CE o la Cédula de Extranjería puede tener hasta 12 caracteres alfanuméricos y no debe incluir caracteres especiales ni espacios.',
    pt: '',
  },
  'companyInformation.kyc.infopopup.CO.PEP': {
    en: '',
    es: 'El PEP o Permiso Especial de Permanencia puede tener hasta 15 caracteres alfanuméricos y no debe incluir caracteres especiales ni espacios.',
    pt: '',
  },
  'companyInformation.kyc.infopopup.accountCreatorName': {
    en: 'We need the information about who creates dLocal Go account, whether they are the owner of the company or not.',
    es: 'Necesitamos los datos personales de quien crea la cuenta de dLocal Go, sea o no el dueño de su negocio.',
    pt: 'Precisamos dos dados da pessoa que cria a conta dLocal Go, seja ou não o proprietário da empresa.',
  },
  'companyInformation.kycOneMenu.introduction': {
    en: 'Introduction',
    es: 'Introducción',
    pt: 'Introdução',
  },
  'companyInformation.kycOneMenu.typeOfCompany': {
    en: 'Type of company',
    es: 'Tipo de negocio',
    pt: 'Tipo de empresa',
  },
  'companyInformation.kycOneMenu.companyData': {
    en: 'Company data',
    es: 'Datos de su negocio',
    pt: 'Dados da empresa',
  },
  'companyInformation.kycOneMenu.jumio': {
    en: 'Identity verification',
    es: 'Verificación de identidad',
    pt: 'Verificação de identidade',
  },
  'companyInformation.kycTwoMenu.introduction': {
    en: 'Introduction',
    es: 'Introducción',
    pt: 'Introdução',
  },
  'companyInformation.kycTwoMenu.documentation': {
    en: 'Documentation',
    es: 'Documentación',
    pt: 'Documentação',
  },
  'companyInformation.kycTwoMenu.documentation.desc': {
    en: 'In this section you can review your company documentation',
    es: 'En esta sección puedes revisar la documentación de tu empresa',
    pt: 'Nesta seção você pode revisar a documentação da sua empresa',
  },
  'companyInformation.kycTwoMenu.companyData': {
    en: 'Company data',
    es: 'Datos de su negocio',
    pt: 'Dados da empresa',
  },
  'companyInformation.kycTwoMenu.bankAccount': {
    en: 'Bank account',
    es: 'Cuenta bancaria',
    pt: 'Conta bancária',
  },
  'companyInformation.kycTwo.legalTalent.loading.title': {
    en: 'We are preparing your information',
    es: 'Estamos preparando tu información',
    pt: 'Estamos preparando sua informação',
  },
  'companyInformation.kycTwo.legalTalent.loading.subtitle': {
    en: 'In a few moments you will be able to continue with the next step',
    es: 'En breve podrás continuar con el siguiente paso',
    pt: 'Em breve você poderá continuar com o próximo passo',
  },
  'companyInformation.next': {
    en: 'CONTINUE',
    es: 'CONTINUAR',
    pt: 'CONTINUAR',
  },
  'companyInformation.send': {
    en: 'SAVE AND CONTINUE',
    es: 'GUARDAR Y CONTINUAR',
    pt: 'SALVAR E CONTINUAR',
  },
  'msgError.companyInformation.document': {
    en: 'The document entered is incorrect.',
    es: 'El documento ingresado es incorrecto.',
    pt: 'O documento digitado está incorreto.',
  },
  'msgError.companyInformation.countryIndicated': {
    en: 'The selected country is invalid for your functional currency.',
    es: 'El país seleccionado es inválido para su moneda operativa.',
    pt: 'O país selecionado é inválido para sua moeda operacional.',
  },
  'msgError.companyInformation.invalidDocument.headline': {
    en: 'The document entered is incorrect',
    es: 'El documento ingresado es incorrecto',
    pt: 'O documento digitado está incorreto',
  },
  'msgError.companyInformation.invalidDocument.subheadline': {
    en: 'Please enter a new one.',
    es: 'Por favor, ingresa uno nuevo.',
    pt: 'Por favor, insira um novo.',
  },
  'msgError.companyInformation.documentAlreadyInUse.headline': {
    en: 'This document was already registered in another account',
    es: 'Este documento ya fue registrado en otra cuenta',
    pt: 'Este número de documento já foi registrado em outra conta',
  },
  'msgError.companyInformation.documentAlreadyInUse.subheadline': {
    en: 'Please enter a new one.',
    es: 'Por favor, ingresa uno nuevo.',
    pt: 'Por favor, insira um novo.',
  },
  'msgError.companyInformation.websiteAlreadyInUse.headline': {
    en: 'This website was already registered into another account',
    es: 'Este sitio web ya fue registrado en otra cuenta',
    pt: 'Este site já foi registrado em outra conta',
  },
  'msgError.companyInformation.websiteAlreadyInUse.subheadline': {
    en: 'Please enter a different one.',
    es: 'Por favor, ingresa uno diferente.',
    pt: 'Insira um diferente.',
  },
  'msgError.companyInformation.websiteInvalid.headline': {
    en: 'The URL entered is not valid.',
    es: 'La URL ingresada no es válida.',
    pt: 'A URL inserida não é válida.',
  },
  'msgError.companyInformation.websiteInvalid.subheadline': {
    en: 'Please enter a valid website URL.',
    es: 'Por favor, ingresa una URL de sitio web válida.',
    pt: 'Insira uma URL de site válida.',
  },
  'msgError.companyInformation.websiteSocialNetwork': {
    en: "You can't use a social network as your business website on dLocal Go.",
    es: 'No puedes usar una red social como sitio web para tu negocio en dLocal Go.',
    pt: 'Você não pode usar uma rede social como site do seu negócio no dLocal Go.',
  },
  'msgError.companyInformation.kycTwo.fraudReview.headline': {
    en: 'There was an error sending the form.',
    es: 'Ha ocurrido un error al enviar el formulario.',
    pt: 'Ocorreu um erro ao enviar o formulário.',
  },
  'msgError.companyInformation.kycTwo.fraudReview.subheadline': {
    en: 'Your account is currently under review. Try again later.',
    es: 'Tu cuenta se encuentra actualmente en revisión. Intenta nuevamente más tarde.',
    pt: 'Sua conta está atualmente em revisão. Tente novamente mais tarde.',
  },
  'companyInformation.kycLevel.desc': {
    en: 'In order to move to <b>level {0}</b> please provide the following documentation:',
    es: 'Para pasar al <b>nivel {0}</b>, proporcione la siguiente documentación:',
    pt: 'Para passar para o <b>nível {0}</b>, forneça a seguinte documentação:',
  },
  'companyInformation.kycLevel.success': {
    en: 'Data received correctly!',
    es: '¡Datos recibidos correctamente!',
    pt: 'Dados recebidos corretamente!',
  },
  'companyInformation.kycTwo.sectionOne.title': {
    en: 'Make the most of dLocal Go.',
    es: 'Aprovecha al máximo dLocal Go.',
    pt: 'Aproveite ao máximo dLocal Go.',
  },
  'companyInformation.kycTwo.sectionOne.subtitle': {
    en: 'Send your company documentation to process unlimited payments and withdraw the money from your sales.',
    es: 'Envía la documentación de tu negocio para procesar pagos sin límite y retirar el dinero de tus ventas.',
    pt: 'Envie a documentação de sua empresa para processar pagamentos sem limite e sacar o dinheiro de suas vendas.',
  },
  'companyInformation.kycTwo.headline': {
    en: 'Send your company documentation',
    es: 'Envía la documentación de tu negocio',
    pt: 'Envie a documentação de sua empresa',
  },
  'companyInformation.kycTwo.headline.company': {
    en: 'Send your company documentation',
    es: 'Envía la documentación de tu negocio',
    pt: 'Envie a documentação de sua empresa',
  },
  'companyInformation.kycTwo.headline.physical': {
    en: 'Send your documentation',
    es: 'Envía tu documentación',
    pt: 'Envie sua documentação',
  },
  'companyInformation.kycTwo.subheadline': {
    en: "Upload the documentation to be able to process unlimited payments. You're almost done!",
    es: 'Carga la documentación para poder procesar pagos sin límites. ¡Ya casi terminas!',
    pt: 'Carregue a documentação para poder processar pagamentos sem limites. Já quase você termina!',
  },
  'companyInformation.kycTwo.subheadline.company': {
    en: 'Upload the documents of {0} that you registered in dLocal Go, to receive unlimited payments and withdraw your money.',
    es: 'Sube los documentos de {0} que registraste en dLocal Go, para recibir pagos sin límite y retirar tu dinero.',
    pt: 'Carregue os documentos de {0} que você registrou na dLocal Go para receber pagamentos sem limites e retirar seu dinheiro.',
  },
  'companyInformation.kycTwo.subheadline.physical': {
    en: 'Upload your documents to receive unlimited payments and withdraw the money from your sales.',
    es: 'Sube tus documentos para recibir pagos sin límite y retirar el dinero de tus ventas.',
    pt: 'Carregue seus documentos para receber pagamentos sem limites e retirar seu dinheiro.',
  },
  'companyInformation.kycTwo.companyOwnerDocuments': {
    en: "Company owner's documents",
    es: 'Documentos del dueño del negocio',
    pt: 'Documentos do dono da empresa',
  },
  'companyInformation.kycTwo.companyOwnerDocuments.physical': {
    en: 'Documentation of {0} {1}',
    es: 'Documentación de {0} {1}',
    pt: 'Documentação de {0} {1}',
  },
  'companyInformation.kycTwo.identityDocumentHelp': {
    en: 'It must match the document rused to register the account. The document file must be current and the copy must be in color.',
    es: 'Debe coincidir con el documento registrado en la cuenta. El documento debe estar vigente y la copia debe ser a color.',
    pt: 'Deve corresponder com o número de documento usado durante o registro da conta. O documento deve estar vigente e a foto/cópia deve ser colorida.',
  },
  'companyInformation.kycTwo.identityDocumentHelp.company': {
    es: `El documento debe: <ul>
      <li>Pertenecer al socio principal o dueño del negocio.</li>
      <li>Tener vigencia mayor a seis meses.</li>
      <li>Estar en buenas condiciones, ser legible y con fotografía nítida.</li>
    </ul>`,
    en: `The document must: <ul>
      <li>Belong to the main partner or owner of the company.</li>
      <li>Be valid for more than six months.</li>
      <li>Be in good condition, be legible and with a clear photograph.</li>
    </ul>`,
    pt: `O documento deve: <ul>
      <li>Pertencer ao sócio principal ou ao dono da empresa.</li>
      <li>Ter vigência maior do que seis meses.</li>
      <li>Estar em boas condições, ser legível e com foto nítida.</li>
    </ul>`,
  },
  'companyInformation.kycTwo.identityDocumentHelp.physical': {
    en: `The document must: <ul>
      <li>Be under the name of {0} {1} and include an identification number.</li>
      <li>Be valid for more than six months.</li>
      <li>Be in good condition, be legible and with a clear photograph.</li>
    </ul>`,
    es: `El documento debe: <ul>
      <li>Estar a nombre de {0} {1} e incluir número de identificación.</li>
      <li>Tener vigencia mayor a seis meses.</li>
      <li>Estar en buenas condiciones, ser legible y con fotografía nítida.</li>
    </ul>`,
    pt: `O documento deve: <ul>
      <li>Estar em nome de  {0} {1} e incluir número de identificação.</li>
      <li>Ter vigência maior do que seis meses.</li>
      <li>Estar em boas condições, ser legível e com foto nítida.</li>
    </ul>`,
  },
  'companyInformation.kycTwo.identityDocument.company/physical': {
    en: 'Identity document',
    es: 'Documento de identidad',
    pt: 'Documento de identidade',
  },

  'companyInformation.kycTwo.tooltip': {
    en: '<b>Tips to upload your documentation:</b><br/><br/><li>Make sure the document is legible and has good definition.</li><li>Maximum document size: {0}MB.</li><li>Allowed extensions: {1}.</li>',
    es: '<b>Recomendaciones para subir tu documentación:</b><br/><br/><li>Asegúrate que el documento sea legible y tenga buena definición.</li><li>Tamaño máximo de los documentos: {0}MB.</li><li>Extensiones permitidas: {1}.</li>',
    pt: '<b>Recomendações para subir sua documentação:</b><br/><br/><li>Assegure-se de que o documento seja legível e tenha boa definição.</li><li>Tamanho máximo dos documentos: {0}MB.</li><li>Extensões permitidas: {1}.</li>',
  },
  'companyInformation.kycTwo.proofOfAddressDocument': {
    en: 'Proof of address of the owner of the company not older than 3 months.',
    es: 'Constancia de domicilio del dueño mayoritario del negocio no mayor a 3 meses de antigüedad.',
    pt: 'Comprovante de residência de domicílio do dono da empresa não superior a 3 meses de antiguidade.',
  },
  'companyInformation.kycTwo.proofOfAddressDocument.company/physical': {
    en: 'Proof of address (utility bill or bank statement)',
    es: 'Constancia de domicilio (factura de servicio o extracto bancario)',
    pt: 'Comprovante de endereço (fatura de serviço ou extrato bancário)',
  },
  'companyInformation.kycTwo.proofOfAddressDocumentHelp.company': {
    en: `The proof must:<ul>
      <li>Be in the name of the main partner or owner of the company.</li>
      <li>Be valid for more than six months.</li></ul>`,
    es: `La constancia debe:<ul>
      <li>Estar a nombre del socio principal o dueño del negocio.</li>
      <li>Tener validez dentro de los últimos 6 meses.</li></ul>`,
    pt: `O comprovante deve:<ul>
      <li>Estar em nome do sócio principal ou dono da empresa.</li>
      <li>Ter validade dentro dos últimos 6 meses.</li></ul>`,
  },
  'companyInformation.kycTwo.proofOfAddressDocumentHelp.physical': {
    en: `The proof must:<ul>
    <li>Be under the name of {0} {1}.</li>
    <li>Be valid for more than six months.</li></ul>`,
    es: `La constancia debe:<ul>
    <li>Estar a nombre de {0} {1}.</li>
    <li>Tener validez dentro de los últimos 6 meses.</li></ul>`,
    pt: `O comprovante deve:<ul>
    <li>Estar em nome de {0} {1}.</li>
    <li>Ter validade dentro dos últimos 6 meses.</li></ul>`,
  },
  'companyInformation.kycTwo.proofOfAddressDocumentHelp': {
    en: 'It must be under the name of the majority owner of the company. It can be a service (electricity, water, taxes).',
    es: 'Debe estar a nombre del dueño mayoritario del negocio. Puede ser un servicio (luz, agua, impuesto).',
    pt: 'Deve conter o nome do sócio majoritário da empresa. Pode ser uma conta de serviço (luz, água, impostos).',
  },
  'companyInformation.kycTwo.proofOfAddressDocumentHelp.NG': {
    en: 'It must be under the name of the majority owner of the company. It can be a service (electricity, water, taxes, rent agreement).',
    es: 'Debe estar a nombre del dueño mayoritario del negocio. Puede ser un servicio (luz, agua, impuesto).',
    pt: 'Deve conter o nome do sócio majoritário da empresa. Pode ser uma conta de serviço (luz, água, impostos).',
  },
  'companyInformation.kycTwo.proofOfAddressDocumentPhysical': {
    en: 'Proof of address of the owner of the company not older than 3 months.',
    es: 'Constancia de domicilio del dueño del negocio no mayor a 3 meses de antigüedad.',
    pt: 'Comprovante de residência de domicílio do dono da empresa não superior a 3 meses de antiguidade.',
  },
  'companyInformation.kycTwo.proofOfAddressDocumentPhysicalHelp': {
    en: 'It must be under the name of the owner of the company. It can be a service (electricity, water, taxes).',
    es: 'Debe estar a nombre del dueño del negocio. Puede ser un servicio (luz, agua, impuesto).',
    pt: 'Deve conter o nome do sócio da empresa. Pode ser uma conta de serviço (luz, água, impostos).',
  },
  'companyInformation.kycTwo.proofOfAddressDocumentPhysicalHelp.NG': {
    en: 'It must be under the name of the owner of the company. It can be a service (electricity, water, taxes, rent agreement).',
    es: 'Debe estar a nombre del dueño del negocio. Puede ser un servicio (luz, agua, impuesto).',
    pt: 'Deve conter o nome do sócio da empresa. Pode ser uma conta de serviço (luz, água, impostos).',
  },
  'companyInformation.kycTwo.companyDocuments.company': {
    en: 'Company documents',
    es: 'Documentos del negocio',
    pt: 'Documentos da empresa',
  },
  'companyInformation.kycTwo.companyDocuments.physical': {
    en: 'Tax registration document',
    es: 'Documento de registro tributario',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.DO': {
    en: 'Tax registration document',
    es: 'Documento de registro tributario',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.MX': {
    en: 'Tax registration document',
    es: 'Constancia de Situación Fiscal del negocio emitido por SAT',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.CL': {
    en: 'Tax registration document',
    es: 'Constancia de RUT del negocio emitido por SII',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.AR': {
    en: 'Tax registration document',
    es: 'Constancia de CUIT',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.PE': {
    en: 'Tax registration document',
    es: 'Certificado Literal del Registro de Personas Jurídicas emitido por Sunarp',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.CO': {
    en: 'Tax registration document',
    es: 'Constancia de RUT emitido por la DIAN',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.CR': {
    en: 'Tax registration document',
    es: 'Documento de registro tributario',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.UY': {
    en: 'Tax registration document',
    es: 'Constancia de Registro Único Tributario (RUT) ',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.BO': {
    en: 'Tax registration document',
    es: 'Constancia de Número de Identificación Tributaria (NIT)',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.EC': {
    en: 'Tax registration document',
    es: 'Constancia de Registro Único del Contribuyente (RUC)',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.PY': {
    en: 'Tax registration document',
    es: 'Constancia de Registro Único del Contribuyente (RUC)',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.ES': {
    en: 'Tax registration document',
    es: 'Constancia de Código de Identificación Fiscal (CIF)',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.BR': {
    en: 'Tax registration document',
    es: 'Documento de registro tributario',
    pt: 'Cadastro nacional da pessoa jurídica (CNPJ)',
  },
  'companyInformation.kycTwo.taxCompliantDocument.US': {
    en: 'Tax registration document',
    es: 'Documento de registro tributario',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.NG': {
    en: 'Taxpayer identification number (TIN) emited by FIRS-Federal Inland Revenue Service',
    es: 'Documento de registro tributario',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.KE': {
    en: 'Taxpayer Registration Certificate emited by Kenya Revenue Authority',
    es: 'Documento de registro tributario',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocumentHelp.MX': {
    en: 'Official document that gathers all the data of a taxpayer such as RFC, tax regime, economic activities, etc.',
    es: 'Documento oficial que reúne todos los datos de un contribuyente como RFC, régimen fiscal, actividades económicas, etc.',
    pt: 'Documento oficial que reúne todos os dados de um contribuinte como RFC, regime tributário, atividades econômicas, etc.',
  },
  'companyInformation.kycTwo.taxCompliantDocumentHelp.CL': {
    en: 'Single Tax Role Document issued by the Internal Revenue Service.',
    es: 'Documento del Rol Único Tributario emitido por Servicio de Impuestos Internos.',
    pt: 'Documento Único de Função Fiscal emitido pela Receita Federal.',
  },
  'companyInformation.kycTwo.taxCompliantDocumentHelp.BR': {
    en: 'Tax registration document',
    es: 'Documento de registro tributario',
    pt: 'Comprovante de Inscrição e Situação Cadastral',
  },

  'companyInformation.kycTwo.taxCompliantDocumentHelp.company': {
    en: 'The document must match the {0} number you registered in dLocal Go.',
    es: 'El documento debe coincidir con el número de {0} que registraste en dLocal Go.',
    pt: 'O documento deve coincidir com o número de {0} que você registrou na dLocal Go.',
  },

  'companyInformation.kycTwo.taxCompliantDocumentHelp.physical': {
    en: `The document must: <ul>
      <li>Be under the name of {0} {1}</li>
      <li>Match the {2} number you registered in dLocal Go.</li>
    </ul>`,
    es: `El documento debe: <ul>
      <li>Estar a nombre de {0} {1}</li>
      <li>Coincidir con el número de {2} que registraste en dLocal Go.</li>
    </ul>`,
    pt: `O documento deve: <ul>
      <li>Estar em nome de {0} {1}</li>
      <li>Coincidir com o número de {2} que você registrou na dLocal Go.</li>
    </ul>`,
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.MX': {
    en: 'Tax registration document',
    es: 'Constancia de Situación Fiscal emitido por SAT',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.CL': {
    en: 'Tax registration document',
    es: 'Constancia de RUT emitido por SSI',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.AR': {
    en: 'Tax registration document',
    es: 'Constancia de CUIL emitido por AFIP',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.PE': {
    en: 'Tax registration document',
    es: 'Certificado literal de partida emitido por Sunarp',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.CO': {
    en: 'Tax registration document',
    es: 'Constancia de RUT o NIT emitido por la DIAN',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.CR': {
    en: 'Tax registration document',
    es: 'Documento de registro tributario',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.UY': {
    en: 'Tax registration document',
    es: 'Constancia de Registro Único Tributario (RUT)',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.BO': {
    en: 'Tax registration document',
    es: 'Constancia de Número de Identificación Tributaria (NIT)',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.EC': {
    en: 'Tax registration document',
    es: 'Constancia de Registro Único del Contribuyente (RUC)',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.PY': {
    en: 'Tax registration document',
    es: 'Constancia de Registro Único del Contribuyente (RUC)',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.ES': {
    en: 'Tax registration document',
    es: 'Constancia de Número de Identificación Fiscal (NIF)',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.BR': {
    en: 'Tax registration document',
    es: 'Documento de registro tributario',
    pt: 'Cadastro de Pessoas Físicas (CPF)',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.US': {
    en: 'Tax registration document',
    es: 'Documento de registro tributario',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.NG': {
    en: 'Taxpayer identification number (TIN) emited by FIRS-Federal Inland Revenue Service.',
    es: 'Documento de registro tributario',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical.KE': {
    en: 'PIN Certificate emited by Kenya Revenue Authority.',
    es: 'Documento de registro tributario',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.taxCompliantDocument.physical': {
    en: 'Tax registration document',
    es: 'Documento de registro tributario',
    pt: 'Documento de registro tributário',
  },
  'companyInformation.kycTwo.shareholdersDocument.MX': {
    en: 'Articles of incorporation',
    es: 'Boleta de inscripción de la sociedad',
    pt: 'Ata constitutiva da sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocument.CL': {
    en: 'Articles of incorporation',
    es: 'Certificado de Inscripción ante el Registro de Comercio',
    pt: 'Ata constitutiva da sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocument.AR': {
    en: 'Articles of incorporation',
    es: 'Constitución de Sociedad presentado ante IGJ',
    pt: 'Ata constitutiva da sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocument.PE': {
    en: 'Articles of incorporation',
    es: 'Estatuto de constitución del negocio',
    pt: 'Ata constitutiva da sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocument.CO': {
    en: 'Articles of incorporation',
    es: 'Certificado de existencia y representación legal emitido por la cámara de comercio',
    pt: 'Ata constitutiva da sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocument.CR': {
    en: 'Articles of incorporation',
    es: 'Inscripción en el Registro de Personas Jurídicas en el Registro Nacional de la República de Costa Rica',
    pt: 'Ata constitutiva da sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocument.ES': {
    en: 'Articles of incorporation',
    es: 'Acta de constitución',
    pt: 'Ata constitutiva da sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocument.BR': {
    en: 'Articles of incorporation',
    es: 'Acta de constitución',
    pt: 'Contrato de sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocument.NG': {
    en: 'Certificate of incorporation',
    es: 'Acta de constitución',
    pt: 'Contrato de sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocument.KE': {
    en: 'Certificate of registration',
    es: 'Acta de constitución',
    pt: 'Contrato de sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocumentHelp.MX': {
    en: 'Articles of incorporation',
    es: 'Documento generado por el sistema del Registro Público de Comercio al acta constitutivo de la sociedad',
    pt: 'Ata constitutiva da sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocumentHelp.AR': {
    en: 'Articles of incorporation',
    es: 'Instrumento Constitutivo presentando ante la Inspección General de Justicia',
    pt: 'Ata constitutiva da sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocumentHelp.BR': {
    en: 'Articles of incorporation',
    es: 'Instrumento Constitutivo presentando ante la Inspección General de Justicia',
    pt: 'É a certidão de nascimento da empresa',
  },
  'companyInformation.kycTwo.shareholdersDocumentHelp.NG': {
    en: '',
    es: 'Instrumento Constitutivo presentando ante la Inspección General de Justicia',
    pt: 'É a certidão de nascimento da empresa',
  },
  'companyInformation.kycTwo.shareholdersDocumentHelp.KE': {
    en: '',
    es: 'Instrumento Constitutivo presentando ante la Inspección General de Justicia',
    pt: 'É a certidão de nascimento da empresa',
  },
  'companyInformation.kycTwo.shareholdersDocumentHelp': {
    en: 'Articles of incorporation',
    es: 'Acta constitutiva de la sociedad',
    pt: 'Ata constitutiva da sociedade',
  },
  'companyInformation.kycTwo.shareholdersDocumentHelp.company/physical': {
    en: `The document must: <ul>
      <li>Be a copy of the original document and include all pages.</li>
      <li>Contain the personal information of the partners or owners of the company, including the document of the main partner or owner of the company.</li>
    </ul>`,
    es: `El documento debe: <ul>
      <li>Ser copia del documento original e incluir todas las páginas.</li>
      <li>Contener los datos personales de los socios o dueños del negocio, incluyendo el documento del socio principal o dueño del negocio..</li>
    </ul>`,
    pt: `O documento deve: <ul>
      <li>Ser uma cópia do documento original e conter todas as páginas.</li>
      <li>Conter os dados pessoais dos sócios e do sono da empresa, incluindo o documento do sócio principal ou dono da empresa.</li>
    </ul>`,
  },
  'companyInformation.kycTwo.sectionTwo.title': {
    en: 'Fill in your bank account details',
    es: 'Completa los datos de tu cuenta bancaria',
    pt: 'Complete os dados de sua conta bancária',
  },
  'companyInformation.kycTwo.sectionTwo.subtitle': {
    en: 'Here we will send you the money from your sales.',
    es: 'Aquí enviaremos el dinero de tus ventas.',
    pt: 'Aqui enviaremos o dinheiro de suas vendas.',
  },
  'companyInformation.kycTwo.companyOwnerLegalInformation': {
    en: "Company owner's legal information",
    es: 'Información legal del dueño del negocio',
    pt: 'Informação legal do dono da empresa',
  },
  'companyInformation.kycTwo.companyOwnerLegalInformation.subheadline': {
    en: 'This information is about the owner of the dLocal Go account and cannot be edited.',
    es: 'Esta información es sobre el propietario de la cuenta dLocal Go y no se puede editar.',
    pt: 'Esta informação é sobre o proprietário da conta dLocal Go e não pode ser editada.',
  },
  'companyInformation.kycTwo.bankAccountInformation': {
    en: 'Bank account information',
    es: 'Información de tu cuenta bancaria',
    pt: 'Informação de sua conta bancária',
  },
  'companyInformation.kycTwo.bankAccountInformation.subheadline': {
    en: 'You can only withdraw your money in your local currency. Add a bank account in {0}',
    es: 'Solo puedes retirar tu dinero en tu moneda local. Agrega una cuenta bancaria en {0}',
    pt: 'Você só pode sacar seu dinheiro em sua moeda local. Adicione uma conta bancária em {0}',
  },
  'companyInformation.kycTwo.bankAccountDocumentation.title': {
    en: 'Bank account documentation',
    es: 'Documentación de tu cuenta bancaria',
    pt: 'Documentação de sua conta bancária',
  },
  'companyInformation.kycTwo.bankAccountDocumentation': {
    en: 'Proof of bank account',
    es: 'Comprobante de cuenta bancaria',
    pt: 'Comprovante de conta bancaria',
  },
  'companyInformation.kycTwo.error.upload.title': {
    en: 'An error occurred while uploading.',
    es: 'Ocurrió un error en la carga.',
    pt: 'Ocorreu um erro durante o upload.',
  },
  'companyInformation.kycTwo.error.upload.message': {
    en: 'Please, refresh the page and upload the files again.',
    es: 'Por favor, actualiza la página y vuelve a cargar los documentos.',
    pt: 'Atualize a página e recarregue os documentos.',
  },
  'companyInformation.kycFour.bankAccountDocument.MX': {
    en: 'Proof of bank account.',
    es: 'Certificado de titularidad bancaria.',
    pt: 'Comprovante de conta bancaria.',
  },
  'companyInformation.kycFour.bankAccountDocument.PE': {
    en: 'Proof of bank account.',
    es: 'Hoja bancaria.',
    pt: 'Comprovante de conta bancaria.',
  },
  'companyInformation.kycFour.bankAccountDocument.CO': {
    en: 'Proof of bank account.',
    es: 'Certificado bancario.',
    pt: 'Comprovante de conta bancaria.',
  },
  'companyInformation.kycFour.bankAccountDocument.CR': {
    en: 'Proof of bank account.',
    es: 'Constancia de cuenta bancaria.',
    pt: 'Comprovante de conta bancaria.',
  },
  'companyInformation.kycFour.bankAccountDocument.EC': {
    en: 'Proof of bank account.',
    es: 'Certificado bancario.',
    pt: 'Comprovante de conta bancaria.',
  },
  'companyInformation.kycFour.bankAccountDocument.ES': {
    en: 'Proof of bank account.',
    es: 'Certificado de titularidad bancaria.',
    pt: 'Comprovante de conta bancaria.',
  },
  'companyInformation.kycFour.bankAccountDocument.NG': {
    en: 'Proof of Bank Verification Number (BVN).',
    es: 'Certificado de titularidad bancaria.',
    pt: 'Comprovante de conta bancaria.',
  },
  'companyInformation.kycFour.bankAccountDocument.KE': {
    en: 'Bank account statement.',
    es: 'Certificado de titularidad bancaria.',
    pt: 'Comprovante de conta bancaria.',
  },
  'companyInformation.kycFour.bankAccountDocument': {
    en: "It can be a bank statement or letter from the bank in PDF format. Remember that you can download the document from your bank's website.",
    es: 'Puede ser un estado de cuenta, extracto bancario o carta del banco en formato PDF. Recuerda que puedes descargar el documento desde el sitio web de tu banco.',
    pt: 'Pode ser um extrato de conta, extrato bancário ou carta do banco em formato PDF. Lembre-se de que você pode baixar o documento no site do seu banco.',
  },
  'companyInformation.kycFour.bankAccountDocumentHelp': {
    en: 'It must contain the name of the beneficiary and bank account number. It must match the beneficiary of the entered bank account.',
    es: 'Debe contener el nombre del titular y número de la cuenta bancaria, y coincidir con el titular de la cuenta bancaria ingresada.',
    pt: 'Deve conter o nome do titular e o número da conta bancária. Deve corresponder/coincidir ao titular da conta inserida.',
  },
  'companyInformation.kycFour.bankAccountDocumentHelp.bullet1': {
    en: 'Make sure the document is legible and has good definition.',
    es: 'Asegúrate de que el documento sea legible y tenga buena definición.',
    pt: 'Certifique-se de que o documento esteja legível e tenha boa definição.',
  },
  'companyInformation.kycFour.bankAccountDocumentHelp.bullet2': {
    en: 'Maximum document size: 10 MB',
    es: 'Tamaño máximo del documento: 10 MB',
    pt: 'Tamanho máximo do documento: 10 MB',
  },
  'companyInformation.kycFour.bankAccountDocumentHelp.bullet3': {
    en: 'Allowed extensions: pdf, png, jpg, doc, docx.',
    es: 'Extensiones permitidas: pdf, png, jpg, doc, docx.',
    pt: 'Extensões permitidas: pdf, png, jpg, doc, docx.',
  },
  'companyInformation.kycFour.bankAccountDocumentHelp.company': {
    en: `The proof must:<ul>
      <li>Include the name of the company {0}</li>
      <li>Include bank account number.</li>
      <li>Be issued by the bank (it cannot be a screenshot from the app).</li></ul>
  `,
    es: `El comprobante debe:<ul>
      <li>Incluir el nombre del negocio {0}</li>
      <li>Incluir número de la cuenta bancaria.</li>
      <li>Ser emitido por el banco (No puede ser una captura de pantalla de la aplicación).</li></ul>
    `,
    pt: `O comprovante deve:<ul>
      <li>Incluir o nome da empresa {0}</li>
      <li>Incluir o número da conta bancária.</li>
      <li>Ser emitido pelo banco (Não pode ser uma captura de tela ou do aplicativo).</li></ul>
  `,
  },
  'companyInformation.kycFour.bankAccountDocumentHelp.physical': {
    en: `The proof must:<ul>
      <li>Include the name of the company {0}</li>
      <li>Include bank account number.</li>
      <li>Be issued by the bank (it cannot be a screenshot from the app).</li></ul>
    `,
    es: `El comprobante debe:<ul>
      <li>Estar a nombre de {0} {1}</li>
      <li>Incluir número de la cuenta bancaria.</li>
      <li>Ser emitido por el banco (No puede ser una captura de pantalla de la aplicación).</li></ul>
    `,
    pt: `O comprovante deve:<ul>
      <li>Estar em nome de {0} {1}</li>
      <li>Incluir o número da conta bancária.</li>
      <li>Ser emitido pelo banco (Não pode ser uma captura de tela ou do aplicativo).</li></ul>
  `,
  },
  'companyInformation.level': {
    en: 'Level {0}',
    es: 'Nivel {0}',
    pt: 'Nível {0}',
  },
  'companyInformation.maxTransactions': {
    en: 'Maximum number of transactions: <b>{0}</b>.',
    es: 'Cantidad máxima de transacciones: <b>{0}</b>.',
    pt: 'Número máximo de transações: <b>{0}</b>.',
  },
  'companyInformation.maxTransactionAmount': {
    en: 'Maximum transaction amount: <b>USD {0}</b>.',
    es: 'Monto máximo de transacción: <b>USD {0}</b>.',
    pt: 'Valor máximo da transação: <b>USD {0}</b>.',
  },
  'companyInformation.maxTransactionAmount.withoutLimit': {
    en: 'Maximum transaction amount: <b>Unlimited</b>.',
    es: 'Monto máximo de transacción: <b>Sin límite</b>.',
    pt: 'Valor máximo da transação: <b>Sem limite</b>.',
  },
  'companyInformation.requiredTransactions': {
    en: 'You must complete at least {0} successful transactions before you can level up.',
    es: 'Debes completar al menos {0} transacciones exitosas para que puedas subir de nivel.',
    pt: 'Você deve concluir pelo menos {0} transações bem-sucedidas para poder subir de nível.',
  },
  'companyInformation.creditCardEnabled': {
    en: 'Enabled cards: <b>{0}</b>.',
    es: 'Tarjetas habilitadas: <b>{0}</b>.',
    pt: 'Cartões habilitados: <b>{0}</b>.',
  },
  'companyInformation.numberRequiredTransactions': {
    en: 'Number of transactions required to move to the next level: <b>{0}</b>.',
    es: 'Cantidad de transacciones requeridas para subir al siguiente nivel: <b>{0}</b>.',
    pt: 'Quantidade de transações necessárias para subir ao próximo nível: <b>{0}</b>.',
  },
  'companyInformation.increaseLevel': {
    en: 'Increase level',
    es: 'Subir de nivel',
    pt: 'Subir de nível',
  },
  'companyInformation.kycReview.headline': {
    en: 'We received your information',
    es: 'Recibimos tu información',
    pt: 'Recebemos sua informação',
  },
  'companyInformation.kycReview.subheadline': {
    en: 'In less than 24 business hours, we will finish verifying your documents so that you can process unlimited payments and withdraw your money.',
    es: 'En menos de 24 hs hábiles, terminaremos de verificar tus documentos para que puedas procesar pagos sin límite y retirar tu dinero.',
    pt: 'Em menos de 24 horas úteis, terminaremos de verificar seus documentos para que você possa processar pagamentos sem limite e sacar seu dinheiro.',
  },
  'companyInformation.kycReview.headline.website': {
    en: 'We are almost done!',
    es: '¡Ya casi terminamos!',
    pt: 'Estamos quase terminando!',
  },
  'companyInformation.kycReview.subheadline.website': {
    en: 'Please, complete the pending information from step 1.',
    es: 'Por favor, completa la información pendiente del paso 1.',
    pt: 'Por favor, preencha as informações pendentes da etapa 1.',
  },
  'companyInformation.kycReview.headline.industry': {
    en: 'We cannot offer you our services.',
    es: 'No podemos ofrecerte nuestros servicios.',
    pt: 'Não podemos te oferecer nossos serviços',
  },
  'companyInformation.kycReview.subheadline.industry': {
    en: 'The industry of your business is not compatible with dLocal Go.',
    es: 'La industria de tu negocio no es compatible con dLocal Go.',
    pt: 'A indústria do seu negócio não é compatível com a dLocal Go',
  },
  'companyInformation.requiredData.title': {
    en: 'Required data',
    es: 'Datos requeridos',
    pt: 'Dados necessários',
  },
  'companyInformation.requiredData': {
    en: 'Enter required data',
    es: 'Ingresar datos requeridos',
    pt: 'Insira os dados necessários',
  },
  'companyInformation.upLevel': {
    en: 'Up to level {0}',
    es: 'Subir a nivel {0}',
    pt: 'Chegue ao nível {0}',
  },
  'companyInformation.moreInfo': {
    en: 'More information',
    es: 'Más información',
    pt: 'Mais informação',
  },
  'companyInformation.basicInfo.title': {
    en: 'Basic information',
    es: 'Información básica',
    pt: 'Informação básica',
  },
  'companyInformation.basicInfo.commercialInformation': {
    en: 'Commercial information',
    es: 'Información Comercial',
    pt: 'Informação Comercial',
  },
  'companyInformation.basicInfo.legalInformation': {
    en: 'Legal information',
    es: 'Información Legal',
    pt: 'Informação legal',
  },
  'companyInformation.basicInfo.contactInformation': {
    en: 'Contact information',
    es: 'Datos de contacto',
    pt: 'Dados de contato',
  },
  'companyInformation.basicInfo.name': {
    en: 'Name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'companyInformation.basicInfo.documentType': {
    en: 'Document type',
    es: 'Tipo de documento',
    pt: 'Tipo de documento',
  },
  'companyInformation.basicInfo.document': {
    en: 'Document',
    es: 'Documento',
    pt: 'Documento',
  },
  'companyInformation.basicInfo.phone': {
    en: 'Phone',
    es: 'Teléfono',
    pt: 'Telefone',
  },
  'companyInformation.basicInfo.website': {
    en: 'Website',
    es: 'Sitio web',
    pt: 'Website',
  },
  'companyInformation.basicInfo.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'companyInformation.basicInfo.logo': {
    en: 'Company logo',
    es: 'Logo del negocio',
    pt: 'Logotipo da empresa',
  },
  'companyInformation.basicInfo.uploadLogo': {
    en: 'Upload',
    es: 'Subir',
    pt: 'Carregar',
  },
  'companyInformation.basicInfo.modifyLogo': {
    en: 'Modify',
    es: 'Modificar',
    pt: 'Modificar',
  },
  'companyInformation.headline.step1': {
    en: 'Account settings',
    es: 'Configuración de cuenta',
    pt: 'Configuração da conta',
  },
  'companyInformation.headlineCard.step1': {
    en: 'Tell us about your business',
    es: 'Cuéntanos sobre tu negocio',
    pt: 'Conte-nos sobre o seu negócio ',
  },
  'companyInformation.headlineCard.step1.company': {
    en: 'Tell us about your business',
    es: 'Cuéntanos sobre tu negocio',
    pt: 'Conte-nos sobre o seu negócio ',
  },
  'companyInformation.headlineCard.step1.physical': {
    en: 'Tell us about yourself',
    es: 'Cuéntanos sobre ti',
    pt: 'Conte-nos sobre você',
  },
  'companyInformation.subheadlineCard.step1': {
    en: 'In order for you to accept payments with dLocal Go, we need to know more about you and your business. We request this data to comply with the requirements of regulatory authorities and our ',
    es: 'Para que puedas aceptar pagos con dLocal Go, necesitamos saber más sobre ti y tu negocio. Solicitamos estos datos para cumplir con los requisitos de las autoridades reguladoras y nuestros ',
    pt: 'Para que você possa aceitar pagamentos com dLocal Go, precisamos saber mais sobre você e sua empresa. Solicitamos estes dados para cumprir com os requisitos das autoridades reguladoras e nossos ',
  },
  'companyInformation.subheadlineCard.step1.company': {
    en: 'In order for you to accept payments with dLocal Go, we need to know more about you and your business. We request this data to comply with the requirements of regulatory authorities and our ',
    es: 'Para que puedas aceptar pagos con dLocal Go, necesitamos saber más sobre ti y tu negocio. Solicitamos estos datos para cumplir con los requisitos de las autoridades reguladoras y nuestros ',
    pt: 'Para que você possa aceitar pagamentos com dLocal Go, precisamos saber mais sobre você e sua empresa. Solicitamos estes dados para cumprir com os requisitos das autoridades reguladoras e nossos ',
  },
  'companyInformation.subheadlineCard.step1.physical': {
    en: 'In order for you to accept payments with dLocal Go, we need to know more about you. We request this information to comply with regulatory requirements and our ',
    es: 'Para que puedas aceptar pagos con dLocal Go, necesitamos saber más sobre ti. Solicitamos estos datos para cumplir con los requisitos de las autoridades reguladoras y nuestros ',
    pt: 'Para que você possa aceitar pagamentos com dLocal Go, precisamos saber mais sobre você. Solicitamos estes dados para cumprir com os requisitos das autoridades reguladores e nostros ',
  },
  'companyInformation.headline.step2': {
    en: 'Company data',
    es: 'Datos de tu negocio',
    pt: 'Dados da empresa',
  },
  'companyInformation.headlineCard.step2': {
    en: 'Finish your account setup in a few minutes',
    es: 'Finaliza la configuración de tu cuenta en pocos minutos',
    pt: 'Finalize a configuração de sua conta em alguns minutos',
  },
  'companyInformation.subheadlineCard.step2.part1': {
    en: 'We request this data to comply with the requirements of regulatory authorities and our ',
    es: 'Solicitamos estos datos para cumplir con los requisitos de las autoridades reguladoras y nuestros ',
    pt: 'Solicitamos-lhe estes dados para cumprir com os requisitos das autoridades reguladoras e nossos ',
  },
  'companyInformation.subheadlineCard.step2.part2': {
    en: "We will guide you through the process, don't worry!",
    es: 'Te guiaremos en el proceso, ¡no te preocupes!',
    pt: 'Vamos guiá-lo no processo, não se preocupe!',
  },
  'companyInformation.headlineCard.stepsCompleted': {
    en: 'You have completed your account setup successfully.',
    es: 'Completaste la configuración de tu cuenta con éxito.',
    pt: '',
  },
  'companyInformation.subheadlineCard.stepsCompleted': {
    en: 'We approved the documentation you sent us. Now you can charge without limit and withdraw the money from your sales whenever you want.',
    es: 'Aprobamos la documentación que nos enviaste. Ya puedas facturar sin límite y retirar el dinero de tus ventas cuando quieras.',
    pt: '',
  },
  'companyInformation.termsAndConditions': {
    en: 'terms and conditions',
    es: 'términos y condiciones',
    pt: 'termos e condições',
  },
  'companyInformation.step1': {
    en: 'Step 1',
    es: 'Paso 1',
    pt: 'Passo 1',
  },
  'companyInformation.steps.tag.complete': {
    en: 'Complete',
    es: 'Completar',
    pt: 'Completar',
  },
  'companyInformation.steps.tag.completed': {
    en: 'Completed',
    es: 'Completo',
    pt: 'Completo',
  },
  'companyInformation.steps.tag.pending': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'companyInformation.steps.tag.reviewInformation.website': {
    en: 'Review information',
    es: 'Revisar información',
    pt: 'Revisar a informação',
  },
  'companyInformation.steps.tag.reviewInformation.industry': {
    en: 'Industry not supported',
    es: 'Industria no compatible',
    pt: 'Indústria não suportada',
  },
  'companyInformation.steps.tag.pendingApproval': {
    en: 'Pending approval',
    es: 'Pendiente de aprobación',
    pt: 'Pendente de aprovação',
  },
  'companyInformation.step1.headline.complete': {
    en: 'Upload your company data',
    es: 'Carga los datos de tu negocio',
    pt: 'Carregue os dados de sua empresa',
  },
  'companyInformation.step1.headline.complete.company/physical': {
    en: 'Complete the basic information',
    es: 'Completa los datos básicos',
    pt: 'Adicone os dados básicos',
  },
  'companyInformation.step1.subheadline.complete': {
    en: 'We will ask you for basic information to learn about your business.',
    es: 'Te pediremos la información básica para conocer de tu negocio.',
    pt: 'Solicitaremos informações básicas para conhecer melhor o seu negócio.',
  },
  'companyInformation.step1.subheadline.complete.load-data': {
    en: 'Upload data',
    es: 'Cargar datos',
    pt: 'Carregar informações',
  },
  'companyInformation.step1.estimated-time': {
    en: 'Estimated time',
    es: 'Tiempo estimado',
    pt: 'Tempo estimado',
  },
  'companyInformation.step1.estimated-time.minutes': {
    en: 'minutes',
    es: 'minutos',
    pt: 'minutos',
  },
  'companyInformation.step1.subheadline.complete.company': {
    en: 'We will ask you for the most relevant commercial and legal information about your company. You will not have to submit any documentation.',
    es: 'Te pediremos la información básica para conocer de tu negocio. No tendrás que presentar documentación.',
    pt: 'Pediremos as informações comerciais e legais mais relevantes da sua empresa. Não será necessário apresentar documentação.',
  },
  'companyInformation.step1.subheadline.complete.physical': {
    en: "We'll ask you for commercial and legal information about you and your business. You will not have to submit any documentation.",
    es: 'Te pediremos información comercial y legal sobre ti y tu negocio. No tendrás que presentar documentación.',
    pt: 'Pediremos informações comerciais e legais sobre seu negócio. Não é necessário apresentar documentação.',
  },
  'companyInformation.step1.content.complete': {
    en: 'This step will enable you to receive payments.',
    es: 'Este paso te habilitará a recibir pagos.',
    pt: 'Este passo o habilitará para receber pagamentos.',
  },
  'companyInformation.step1.content.complete.company': {
    en: 'This step will enable your company to receive payments.',
    es: 'Este paso habilitará a tu negocio a recibir pagos.',
    pt: 'Este passo irá habilitar sua empresa a receber pagamentos.',
  },
  'companyInformation.step1.content.complete.physical': {
    en: 'This step will enable your business to receive payments.',
    es: 'Este paso habilitará a tu negocio a recibir pagos.',
    pt: 'Este passo irá habilitar seu negócio a receber pagamentos.',
  },
  'companyInformation.step1.button.complete': {
    en: 'COMPLETE',
    es: 'COMPLETAR',
    pt: 'COMPLETAR',
  },
  'companyInformation.step2.headline.complete': {
    en: 'Send your documentation',
    es: 'Envía tu documentación',
    pt: 'Envie sua documentação',
  },
  'companyInformation.step2.subheadline.complete': {
    en: 'We will ask you for documents that prove the identity of the owner of the company, his address, the tax registry, the articles of incorporation of the company (only if you are a legal entity), and bank account information.',
    es: 'Te pediremos documentos que acrediten la identidad del dueño del negocio, su domicilio, el registro tributario, el acta constitutiva de la sociedad (solo si eres persona jurídica), y datos de la cuenta bancaria.',
    pt: 'Solicitaremos documentos que comprovem a identidade do proprietário da empresa, seu endereço, o registro fiscal, os estatutos da empresa (somente se você for uma pessoa jurídica) e dados bancários.',
  },
  'companyInformation.step2.subheadline.complete.company/physical': {
    en: 'We will ask you for documentation and the details of the bank account where you want to receive your money.',
    es: 'Te pediremos documentación y los datos de la cuenta bancaria donde quieres recibir tu dinero.',
    pt: 'Pediremos a documentação e os dados da conta bancária onde deseja receber seu dinheiro.',
  },
  'companyInformation.step2.content.complete': {
    en: 'This step will enable you to <b>withdraw money from your sales and process unlimited payments.</b>',
    es: 'Este paso te habilitará a <b>retirar el dinero de tus ventas y procesar pagos sin límite.</b>',
    pt: 'Este passo irá habilitar a <b>retirada do dinheiro das suas vendas e o processamento de pagamentos sem limites.</b>',
  },

  'companyInformation.step2.subheadline.completeFields.company': {
    en: `About the <b>company</b>:
    <ul><li>{0}</li>
    <li>{1}</li>
    <li>Proof and details of the bank account</li></ul>
    About the <b>main partner or owner of the company</b>:
    <ul><li>{2}</li>
    <li>Proof of address</li></ul>`,
    es: `Sobre el <b>negocio</b>:
    <ul><li>{0}</li>
    <li>{1}</li>
    <li>Comprobante y datos de la cuenta bancaria</li></ul>
    Sobre el <b>socio principal o dueño del negocio</b>:
    <ul><li>{2}</li>
    <li>Constancia de domicilio</li></ul>`,
    pt: `Sobre a <b>empresa</b>:
    <ul><li>{0}</li>
    <li>{1}</li>
    <li>Comprovante e dados da conta bancária</li></ul>
    Sobre o <b>sócio principal ou dono da empresa</b>:
    <ul><li>{2}</li>
    <li>Comprovante de endereço</li></ul>`,
  },
  'companyInformation.step2.subheadline.completeFields.physical': {
    en: `<ul><li>Identity document</li>
    <li>Proof of address</li>
    <li>{0}</li>
    <li>Proof and details of the bank account</li></ul>`,
    es: `<ul><li>Documento de identidad</li>
    <li>Constancia de domicilio</li>
    <li>{0}</li>
    <li>Comprobante y datos de la cuenta bancaria</li></ul>`,
    pt: `<ul><li>Documento de identidade</li>
    <li>Comprovante de endereço</li>
    <li>{0}</li>
    <li>Comprovante e dados da sua conta bancária</li></ul>`,
  },
  'companyInformation.step2.headline.pendingApproval': {
    en: 'Send your documentation',
    es: 'Envía tu documentación',
    pt: 'Envie sua documentação',
  },
  'companyInformation.step2.headline.reviewDocs': {
    en: 'Review your documentation',
    es: 'Revisá tu documentación',
    pt: 'Revise sua documentação',
  },
  'companyInformation.step2.subheadline.pendingApproval': {
    en: 'We are reviewing the documentation you sent us.',
    es: 'Estamos validando la documentación que nos enviaste.',
    pt: 'Estamos revisando a documentação que você nos enviou.',
  },
  'companyInformation.step2.subheadline.reviewDocs': {
    en: 'We noticed a detail in your documents that needs to be corrected.',
    es: 'Notamos un detalle en tus documentos que debe corregirse.',
    pt: 'Notamos um detalhe em seus documentos que precisa ser corrigido.',
  },
  'companyInformation.step2.content.pendingApproval': {
    en: 'Once we validate the information, you will be able <b>to process unlimited payments and withdraw the money from your sales.</b>',
    es: 'Una vez validada la información, podrás <b>facturar sin límite y retirar el dinero de tus ventas.</b>',
    pt: 'Assim que validarmos as informações, você poderá <b>processar pagamentos ilimitados e sacar o dinheiro das suas vendas.</b>',
  },
  'companyInformation.step2.content.reviewDocs': {
    en: 'Update them to complete the process and continue operating normally.',
    es: 'Actualízalos para completar el proceso y seguir operando con normalidad.',
    pt: 'Atualize-os para completar o processo e continuar operando normalmente.',
  },
  'companyInformation.step2.button.complete': {
    en: 'COMPLETE',
    es: 'COMPLETAR',
    pt: 'COMPLETAR',
  },
  'companyInformation.step2.button.reviewDocs': {
    en: 'Review and replace',
    es: 'Revisar y reemplazar',
    pt: 'Revisar e substituir',
  },
  'companyInformation.step1.headline.completed': {
    en: 'Company data',
    es: 'Datos de tu negocio',
    pt: 'Dados da empresa',
  },
  'companyInformation.step1.headline.completed.company': {
    en: 'Your company data has been verified',
    es: 'Los datos de tu negocio están verificados',
    pt: 'Os dados da sua empresa estão verificados',
  },
  'companyInformation.step1.headline.completed.physical': {
    en: 'Your data has been verified',
    es: 'Tus datos están verificados',
    pt: 'Seus dados estão verificados',
  },
  'companyInformation.step1.subheadline.completed': {
    en: 'Your information is already verified. You are ready to start processing payments.',
    es: 'Tu información ya está verificada. Estás listo para comenzar a procesar pagos.',
    pt: 'Sua informação já está verificada.<br>Você está pronto para começar a processar os pagamentos.',
  },
  'companyInformation.step1.subheadline.completed.company/physical': {
    en: 'You can now start receiving payments with any of the dLocal Go payment solutions.',
    es: 'Ya puedes empezar a recibir pagos con cualquiera de las soluciones de cobro de dLocal Go.',
    pt: 'Você já pode começar a receber pagamentos com quaisquer soluções de cobrança da dLocal Go.',
  },
  'companyInformation.step1.content.completed': {
    en: 'You can now receive payments and process up to <b>USD {0}.</b>',
    es: 'Ya puedes recibir pagos y procesar hasta <b>USD {0}.</b>',
    pt: 'Você já pode receber pagamentos e processar até USD <b>USD {0}.</b>',
  },
  'companyInformation.step1.content.completed.company/physical': {
    en: 'Sell and process up to <b>USD {0}.</b>',
    es: 'Vende y procesa hasta <b>USD {0}.</b>',
    pt: 'Venda e processe até <b>USD {0}.</b>',
  },
  'companyInformation.step1.headline.reviewInformation.website': {
    en: 'We are waiting for your answer',
    es: 'Estamos esperando tu respuesta',
    pt: 'Estamos aguardando sua resposta',
  },
  'companyInformation.step1.subheadline.reviewInformation.website': {
    en: "We couldn't verify your website. We sent you an email to finalize this validation. We await your reply.",
    es: 'No pudimos verificar tu sitio web. Te enviamos un mail para completar esta validación. Aguardamos tu respuesta.',
    pt: 'Não pudemos verificar seu website. Enviamos-lhe um e-mail para completar esta validação. Aguardamos sua resposta.',
  },
  'companyInformation.step1.headline.reviewInformation.industry': {
    en: 'Your business industry is not supported',
    es: 'La industria de tu negocio no es compatible',
    pt: 'A indústria do seu negócio não é suportada',
  },
  'companyInformation.step1.subheadline.reviewInformation.industry': {
    en: 'We cannot offer our services to you because your business industry is not allowed in our Terms and Conditions.',
    es: 'No podemos ofrecerte nuestros servicios porque la industria de tu negocio no está permitida en nuestros Términos y condiciones.',
    pt: 'Não podemos oferecer nossos serviços a você porque a indústria do seu negócio não é permitida em nossos Termos e Condições.',
  },
  'companyInformation.step2': {
    en: 'Step 2',
    es: 'Paso 2',
    pt: 'Passo 2',
  },
  'companyInformation.success.headline': {
    en: 'Congratulations! You completed step 1',
    es: '¡Felicitaciones! Completaste el paso 1',
    pt: 'Parabéns! Você completou o passo 1',
  },
  'companyInformation.success.subheadline': {
    en: 'Now you can start selling as you want.',
    es: 'Ya puedes empezar a vender de la forma que quieras.',
    pt: 'Você já pode começar a vender da forma que quiser.',
  },
  'companyInformation.onboarding.title.part1': {
    en: 'Account Settings',
    es: 'Configuración de cuenta',
    pt: 'Configuração da conta',
  },
  'companyInformation.onboarding.title.part2': {
    en: 'Company data',
    es: 'Datos de tu negocio',
    pt: 'Dados de sua empresa',
  },
  'companyInformation.onboarding.title.part2.physical': {
    en: 'Company data',
    es: 'Datos de tu negocio',
    pt: 'Dados do seu negócio',
  },

  'uploadLogo.allowedDesc': {
    en: 'Maximum size <b>{0}MB</b>.<br/>Allowed extensions: <b>{1}</b>.',
    es: 'Tamaño máximo <b>{0}MB</b>.<br/>Extensiones permitidas: <b>{1}</b>.',
    pt: 'Tamanho máximo <b>{0}MB</b>.<br/>Extensões permitidas: <b>{1}</b>.',
  },
  'uploadLogo.desc': {
    en: 'This image will be shown to your clients on the payment screen.',
    es: 'Esta imagen será mostrada a sus clientes en la pantalla de pago.',
    pt: 'Esta imagem será mostrada aos seus clientes na tela de pagamento.',
  },
  'uploadLogo.remove': {
    en: 'Remove',
    es: 'Eliminar',
    pt: 'Retirar',
  },
  'uploadLogo.update': {
    en: 'Update',
    es: 'Actualizar',
    pt: 'Atualizar',
  },
  'uploadLogo.saveLogo': {
    en: 'Save logo',
    es: 'Guardar logo',
    pt: 'Salvar logotipo',
  },
  'uploadLogo.deleteConfirm': {
    en: 'Are you sure you want to delete it?',
    es: '¿Estás seguro de que quieres eliminarlo?',
    pt: 'Tem certeza que deseja deletar?',
  },
  'uploadLogo.uploadSuccess': {
    en: 'Logo saved successfully!',
    es: '¡Logotipo guardado correctamente!',
    pt: 'Logotipo salvo com sucesso!',
  },
  'uploadLogo.deleteSuccess': {
    en: 'Logo removed successfully!',
    es: '¡Logotipo eliminado correctamente!',
    pt: 'Logotipo removido com sucesso!',
  },
  'transactions.headline': {
    en: 'Your transactions',
    es: 'Tus transacciones',
    pt: 'Suas transações',
  },
  'transactions.subheadline': {
    en: 'Find all the sales you have made, their status and the most important details.',
    es: 'Encuentra todas las ventas que has realizado, su estado y los detalles más importantes.',
    pt: 'Encontre todas as vendas que você realizou, seu status e os detalhes mais importantes.',
  },
  'transactions.searchBar': {
    en: 'Search transactions',
    es: 'Buscar transacciones',
    pt: 'Pesquisar transações',
  },
  'transactions.searchBar.helpText': {
    en: 'Search for a transaction by the name of your client, their email or the total amount they have paid you.',
    es: 'Busca una transacción por el nombre de tu cliente, su e-mail o el monto total que te ha pagado.',
    pt: 'Pesquise uma transação pelo nome do seu cliente, seu e-mail ou o valor total que ele pagou a você.',
  },
  'transactions.details': {
    en: 'Transaction details',
    es: 'Detalles de la transacción',
    pt: 'Detalhes da transação',
  },
  'transactions.details.orderId': {
    en: 'Order ID',
    es: 'Orden ID',
    pt: 'ID do pedido',
  },
  'transactions.details.paymentDate': {
    en: 'Payment date',
    es: 'Fecha de pago',
    pt: 'Data de pagamento',
  },
  'transactions.details.paymentAssociation.question': {
    en: 'Did your customer pay and the transaction shows as cancelled?',
    es: '¿Tu cliente pagó y la transacción figura como cancelada?',
    pt: 'Seu cliente pagou e a transação aparece como cancelada?',
  },
  'transactions.details.paymentAssociation.helpLink': {
    en: 'Learn why this happens and how to solve it',
    es: 'Conoce por qué sucede y cómo resolverlo',
    pt: 'Saiba por que isso acontece e como resolver',
  },
  'transactions.details.paymentAssociation.cta': {
    en: 'I have proof of payment',
    es: 'Tengo comprobante',
    pt: 'Tenho comprovante',
  },
  'transactions.details.paymentAssociation.success': {
    en: 'We received your request. Our team will review it shortly.',
    es: 'Recibimos tu solicitud. Nuestro equipo la revisará a la brevedad.',
    pt: 'Recebemos sua solicitação. Nossa equipe irá analisá-la em breve.',
  },
  'transactions.details.paymentAssociation.error': {
    en: 'We could not process your request. Please try again.',
    es: 'No pudimos procesar tu solicitud. Intenta nuevamente.',
    pt: 'Não foi possível processar sua solicitação. Tente novamente.',
  },
  'transactions.details.backBtn': {
    en: 'Back to transactions',
    es: 'Volver a transacciones',
    pt: 'Voltar para transações',
  },
  'transactions.details.amountPaid.tooltip': {
    en: 'Your client was charged in {0}, you´ll receive {1}.',
    es: 'Tu cliente pagó en {0}, tu recibirás {1}.',
    pt: 'Seu cliente foi cobrado em {0}, você receberá {1}.',
  },
  'transactions.details.installmentsFeeAmount.tooltip': {
    en: 'Fee for selected installments by the client.',
    es: 'Comisión por cuotas seleccionadas por el cliente.',
    pt: 'Taxa para parcelas selecionadas pelo cliente.',
  },
  'transactions.details.processingFee.tooltip': {
    en: 'dLocal Go processing fee according to payment methods.',
    es: 'Costo de procesamiento de dLocal Go según los métodos de pago.',
    pt: 'Taxa de processamento da dLocal Go de acordo com o método de pagamento.',
  },
  'transactions.details.collaboratorFee.tooltip': {
    en: 'Collaborator fee established in the contract configuration.',
    es: 'Comisión del colaborador establecida en la configuración del contrato.',
    pt: 'Taxa do colaborador estabelecida na configuração do contrato.',
  },
  'transactions.details.threeDSFeesAmount.tooltip': {
    en: '3DS fees amount for the cardholder verification attempts.',
    es: 'Costos de verificación 3DS por los intentos de verificación del titular de la tarjeta.',
    pt: 'Taxas de verificação 3DS por as tentativas de verificação do portador do cartão.',
  },
  'transactions.withholdings': {
    en: 'Withholdings',
    es: 'Retenciones',
    pt: 'Retenções',
  },
  'transactions.details.withholdings.tooltip': {
    en: 'Taxes and withholdings applied',
    es: 'Impuestos y retenciones aplicados',
    pt: 'Impostos e retenções aplicados',
  },
  'transactions.taxesAndRetentions': {
    en: 'Taxes & Retentions',
    es: 'Impuestos y retenciones',
    pt: 'Impostos e retenções',
  },
  'transactions.taxesAndRetentions.description': {
    en: 'Full breakdown of taxes and withholdings applied to this transaction, by jurisdiction.',
    es: 'Detalle completo de impuestos y retenciones aplicados a esta transacción, por jurisdicción.',
    pt: 'Detalhamento completo dos impostos e retenções aplicados a esta transação, por jurisdição.',
  },
  'transactions.taxesAndRetentions.descriptionColumn': {
    en: 'Description',
    es: 'Descripción',
    pt: 'Descrição',
  },
  'transactions.taxesAndRetentions.amountColumn': {
    en: 'Amount',
    es: 'Monto',
    pt: 'Valor',
  },
  'transactions.details.shopifyRefund.title': {
    en: 'Log in to Shopify to make a refund.',
    es: 'Ingresa a Shopify para realizar un reembolso.',
    pt: 'Faça login na Shopify para fazer um reembolso.',
  },
  'transactions.details.statusDetails': {
    en: 'Status Details',
    es: 'Detalles del estado',
    pt: 'Detalhes do status',
  },
  'transactions.details.nextAction': {
    en: 'Next Action',
    es: 'Próxima acción',
    pt: 'Próxima ação',
  },
  'transactions.details.nextAction.none': {
    en: '-',
    es: '-',
    pt: '-',
  },
  'transactions.details.needsAttention': {
    en: 'Needs Attention',
    es: 'Requiere atención',
    pt: 'Requer atenção',
  },
  'transactions.details.statusDetails.declinedFixable': {
    en: 'Declined, but fixable',
    es: 'Rechazada, pero corregible',
    pt: 'Recusada, mas corrigível',
  },
  'transactions.details.nextAction.checkHelpCenter': {
    en: 'Check the Help Center',
    es: 'Consulta el Centro de ayuda',
    pt: 'Consulte a Central de ajuda',
  },
  'transactions.details.statusDetails.CREATED': {
    en: 'Transaction Created',
    es: 'Transacción creada',
    pt: 'Transação criada',
  },
  'transactions.details.statusDetails.COMPLETED': {
    en: 'Transaction Completed',
    es: 'Transacción completada',
    pt: 'Transação concluída',
  },
  'transactions.details.statusDetails.PENDING': {
    en: 'Transaction Pending',
    es: 'Transacción pendiente',
    pt: 'Transação pendente',
  },
  'transactions.details.statusDetails.CANCELLED': {
    en: 'Transaction Cancelled',
    es: 'Transacción cancelada',
    pt: 'Transação cancelada',
  },
  'transactions.details.statusDetails.DECLINED': {
    en: 'Transaction Declined',
    es: 'Transacción rechazada',
    pt: 'Transação recusada',
  },
  'transactions.details.statusDetails.EXPIRED': {
    en: 'Transaction Expired',
    es: 'Transacción expirada',
    pt: 'Transação expirada',
  },
  'transactions.details.statusDetails.REFUNDED': {
    en: 'Transaction Refunded',
    es: 'Transacción reembolsada',
    pt: 'Transação reembolsada',
  },
  'transactions.details.statusDetails.FAILED': {
    en: 'Transaction Failed',
    es: 'Transacción fallida',
    pt: 'Transação falhou',
  },
  'transactions.noTransaction': {
    en: 'You have no transactions yet.',
    es: 'Aún no tienes transacciones.',
    pt: 'Você ainda não tem transações.',
  },
  'transactions.noTransaction.found': {
    en: 'We haven’t found any matches for your searched transaction.<br />Please, try again.',
    es: 'No hemos encontrado coincidencias para la transacción buscada.<br />Por favor, inténtalo de nuevo.',
    pt: 'Não encontramos nenhuma correspondência para sua transação pesquisada.<br />Por favor, tente novamente.',
  },
  'transactions.id': {
    en: 'ID',
    es: 'ID',
    pt: 'ID',
  },
  'transactions.createDate': {
    en: 'Creation date',
    es: 'Fecha de creación',
    pt: 'Data de criação',
  },
  'transactions.name': {
    en: 'Client name',
    es: 'Nombre del cliente',
    pt: 'Nome do cliente',
  },
  'transactions.date': {
    en: 'Date',
    es: 'Fecha',
    pt: 'Data',
  },
  'transactions.time': {
    en: 'Time',
    es: 'Hora',
    pt: 'Hora',
  },
  'transactions.invoiceId': {
    en: 'Order ID',
    es: 'ID de orden',
    pt: 'ID do pedido',
  },
  'transactions.paymentSolutionType': {
    en: 'Payment solution',
    es: 'Solución de cobro',
    pt: 'Solução de pagamento',
  },
  'transactions.paymentSolutionType.SUBSCRIPTION': {
    en: 'Subscription',
    es: 'Suscripción',
    pt: 'Assinatura',
  },
  'transactions.paymentSolutionType.SHOPIFY': {
    en: 'Shopify',
    es: 'Shopify',
    pt: 'Shopify',
  },
  'transactions.paymentSolutionType.PRESTASHOP': {
    en: 'Prestashop',
    es: 'Prestashop',
    pt: 'Prestashop',
  },
  'transactions.paymentSolutionType.WOO_COMMERCE': {
    en: 'WooCommerce',
    es: 'WooCommerce',
    pt: 'WooCommerce',
  },
  'transactions.paymentSolutionType.MAGENTO': {
    en: 'Magento',
    es: 'Magento',
    pt: 'Magento',
  },
  'transactions.paymentSolutionType.SHOPIFY_TRANSPARENT': {
    en: 'Shopify',
    es: 'Shopify',
    pt: 'Shopify',
  },
  'transactions.paymentSolutionType.PAYMENT_LINK': {
    en: 'Payment link',
    es: 'Link de pago',
    pt: 'Link de pagamento',
  },
  'transactions.paymentSolutionType.LINK': {
    en: 'Payment link',
    es: 'Link de pago',
    pt: 'Link de pagamento',
  },
  'transactions.paymentSolutionType.RECURRING_LINK': {
    en: 'Recurrent Payment link',
    es: 'Link de pago recurrente',
    pt: 'Link de pagamento recorrente',
  },
  'transactions.paymentSolutionType.PAYMENT_BUTTON': {
    en: 'Payment button',
    es: 'Botón de pago',
    pt: 'Botão de pagamento',
  },
  'transactions.paymentSolutionType.TRANSPARENT_CHECKOUT': {
    en: 'Transparent checkout',
    es: 'Pago transparente',
    pt: 'Checkout transparente',
  },
  'transactions.paymentSolutionType.BUY_BUTTON': {
    en: 'Payment button',
    es: 'Botón de pago',
    pt: 'Botão de pagamento',
  },
  'transactions.paymentSolutionType.BUTTON': {
    en: 'Payment button',
    es: 'Botón de pago',
    pt: 'Botão de pagamento',
  },
  'transactions.paymentSolutionType.DGO_API': {
    en: 'API',
    es: 'API',
    pt: 'API',
  },
  'transactions.paymentSolutionType.DP_API': {
    en: 'API',
    es: 'API',
    pt: 'API',
  },
  'transactions.paymentSolutionType.VIRTUAL_POS': {
    en: 'Virtual POS',
    es: 'POS Virtual',
    pt: 'POS Virtual',
  },
  'transactions.paymentSolutionType.OTHERS': {
    en: 'Others',
    es: 'Otros',
    pt: 'Outros',
  },
  'transactions.description': {
    en: 'Description',
    es: 'Descripción',
    pt: 'Descrição',
  },
  'transactions.externalId': {
    en: 'External ID',
    es: 'ID externo',
    pt: 'ID externo',
  },
  'transactions.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'transactions.paymentMethod': {
    en: 'Payment method',
    es: 'Método de pago',
    pt: 'Forma de pagamento',
  },
  'transactions.paymentMethod.type': {
    en: 'Payment method Type',
    es: 'Tipo de método de pago',
    pt: 'Tipo de forma de pagamento',
  },
  'transactions.balanceAmount': {
    en: 'Total balance amount',
    es: 'Monto total de balance',
    pt: 'Valor total de balance',
  },
  'transactions.balanceFee': {
    en: 'Fee',
    es: 'Comisión',
    pt: 'Taxas',
  },
  'transactions.clientId': {
    en: 'Client ID ',
    es: 'ID de cliente',
    pt: 'ID do cliente',
  },
  'transactions.clientName': {
    en: 'Client name',
    es: 'Nombre del cliente',
    pt: 'Nome do cliente',
  },
  'transactions.clientFirstName': {
    en: 'Client first name',
    es: 'Nombre del cliente',
    pt: 'Nome do cliente',
  },
  'transactions.clientLastName': {
    en: 'Client last name',
    es: 'Apellido del cliente',
    pt: 'Sobrenome do cliente',
  },
  'transactions.clientDocumentType': {
    en: 'Client document type',
    es: 'Tipo del documento del cliente',
    pt: 'Tipo de documento do cliente',
  },
  'transactions.clientDocument': {
    en: 'Client document',
    es: 'Documento del cliente',
    pt: 'Documento do cliente',
  },
  'transactions.clientEmail': {
    en: 'Client email',
    es: 'Correo electrónico del cliente',
    pt: 'E-mail do cliente',
  },
  'transactions.installments': {
    en: 'Installments',
    es: 'Cuotas',
    pt: 'Parcelas',
  },
  'transactions.installments.MX': {
    en: 'Installments',
    es: 'Meses',
    pt: 'Parcelas',
  },
  'transactions.amountPaid': {
    en: 'Amount paid',
    es: 'Monto pagado',
    pt: 'Valor pago',
  },
  'transactions.installmentsFeeAmount': {
    en: 'Installments fee amount',
    es: 'Comisión por cuotas',
    pt: 'Taxa de parcelamento',
  },
  'transactions.document': {
    en: 'Client document',
    es: 'No. documento',
    pt: 'Número do documento',
  },
  'transactions.txEmail': {
    en: 'Transaction email',
    es: 'Correo de la transacción',
    pt: 'E-mail de transação',
  },
  'transactions.clientMobilePhone': {
    en: 'Client mobile phone',
    es: 'Teléfono móvil del cliente',
    pt: 'Telefone celular do cliente',
  },
  'transactions.eciCode': {
    en: '3D Secure result',
    es: 'Resultado 3D Secure',
    pt: 'Resultado 3D Secure',
  },
  'transactions.eciCode.05.title': {
    en: 'ECI 05 – Fully authenticated',
    es: 'ECI 05 – Totalmente autenticado',
    pt: 'ECI 05 – Totalmente autenticado',
  },
  'transactions.eciCode.05.description': {
    en: 'Fully authenticated – The cardholder was successfully verified through 3DS. This provides the highest level of protection.',
    es: 'Totalmente autenticado – El titular de la tarjeta fue verificado exitosamente mediante 3DS. Esto proporciona el mayor nivel de protección.',
    pt: 'Totalmente autenticado – O portador do cartão foi verificado com sucesso através do 3DS. Isso fornece o maior nível de proteção.',
  },
  'transactions.eciCode.02.title': {
    en: 'ECI 02 – Fully authenticated',
    es: 'ECI 02 – Totalmente autenticado',
    pt: 'ECI 02 – Totalmente autenticado',
  },
  'transactions.eciCode.02.description': {
    en: 'Fully authenticated – The cardholder was successfully verified through 3DS. This provides the highest level of protection.',
    es: 'Totalmente autenticado – El titular de la tarjeta fue verificado exitosamente mediante 3DS. Esto proporciona el mayor nivel de protección.',
    pt: 'Totalmente autenticado – O portador do cartão foi verificado com sucesso através do 3DS. Isso fornece o maior nível de proteção.',
  },
  'transactions.eciCode.06.title': {
    en: 'ECI 06 – Authentication attempted',
    es: 'ECI 06 – Autenticación intentada',
    pt: 'ECI 06 – Autenticação tentada',
  },
  'transactions.eciCode.06.description': {
    en: 'Authentication attempted – 3DS authentication was attempted but not fully completed. Some protection still applies.',
    es: 'Autenticación intentada – Se intentó la autenticación 3DS pero no se completó totalmente. Aún se aplica cierta protección.',
    pt: 'Autenticação tentada – A autenticação 3DS foi tentada, mas não foi totalmente concluída. Alguma proteção ainda se aplica.',
  },
  'transactions.eciCode.01.title': {
    en: 'ECI 01 – Authentication attempted',
    es: 'ECI 01 – Autenticación intentada',
    pt: 'ECI 01 – Autenticação tentada',
  },
  'transactions.eciCode.01.description': {
    en: 'Authentication attempted – 3DS authentication was attempted but not fully completed. Some protection still applies.',
    es: 'Autenticación intentada – Se intentó la autenticación 3DS pero no se completó totalmente. Aún se aplica cierta protección.',
    pt: 'Autenticação tentada – A autenticação 3DS foi tentada, mas não foi totalmente concluída. Alguma proteção ainda se aplica.',
  },
  'transactions.eciCode.07.title': {
    en: 'ECI 07 – Not authenticated',
    es: 'ECI 07 – No autenticado',
    pt: 'ECI 07 – Não autenticado',
  },
  'transactions.eciCode.07.description': {
    en: 'Not authenticated – Authentication failed or was not performed.',
    es: 'No autenticado – La autenticación falló o no se realizó.',
    pt: 'Não autenticado – A autenticação falhou ou não foi realizada.',
  },
  'transactions.eciCode.00.title': {
    en: 'ECI 00 – Not authenticated',
    es: 'ECI 00 – No autenticado',
    pt: 'ECI 00 – Não autenticado',
  },
  'transactions.eciCode.00.description': {
    en: 'Not authenticated – Authentication failed or was not performed.',
    es: 'No autenticado – La autenticación falló o no se realizó.',
    pt: 'Não autenticado – A autenticação falhou ou não foi realizada.',
  },
  'transactions.processingFee': {
    en: 'Processing Fee',
    es: 'Tarifa de procesamiento',
    pt: 'Taxa de processamento',
  },
  'transactions.collaboratorPayedCommission': {
    en: 'Collaborator paid commission',
    es: 'Comisión pagada al colaborador',
    pt: 'Comissão paga ao colaborador',
  },
  'transactions.threeDSFeesAmount': {
    en: '3DS fees amount ({0} attempts)',
    es: 'Costos de verificación 3DS ({0} intentos)',
    pt: 'Taxas de verificação 3DS ({0} tentativas)',
  },
  'transactions.exchangeRate': {
    en: 'Exchange rate',
    es: 'Tipo de cambio',
    pt: 'Taxa de câmbio',
  },
  'transactions.amountReceived': {
    en: 'Amount received',
    es: 'Monto recibido',
    pt: 'Valor recebido',
  },
  'transactions.client_sent_chargeback_form': {
    en: 'Client sent chargeback form',
    es: 'El cliente envió formulario de contracargo',
    pt: 'O cliente enviou o formulário de chargeback',
  },
  'transactions.chargeback.iconTooltip': {
    en: 'This transaction has a chargeback.',
    es: 'Esta transacción tiene un contracargo.',
    pt: 'Esta transação tem um chargeback.',
  },
  'transactions.declined.fixTooltip': {
    en: 'The transaction was declined, but you still have time to fix it.',
    es: 'La transacción fue rechazada, pero aún tienes tiempo para corregirla.',
    pt: 'A transação foi recusada, mas você ainda tem tempo para corrigi-la.',
  },
  'transactions.amountInUSD': {
    en: 'Amount in USD',
    es: 'Monto en USD',
    pt: 'Valor em USD',
  },
  'transactions.paymentDetails': {
    en: 'Payment details',
    es: 'Detalles del pago',
    pt: 'Detalhes do pagamento',
  },
  'transactions.clientInformation': {
    en: 'Client information',
    es: 'Información del cliente',
    pt: 'Informação ao cliente',
  },
  'transactions.chargebackform': {
    en: 'Chargeback Submission Form',
    es: 'Formulario de presentación de contracargo',
    pt: 'Formulário de apresentação de chargeback',
  },
  'transactions.chargebackform.product': {
    en: 'Product',
    es: 'Producto',
    pt: 'Produto',
  },
  'transactions.chargebackform.problem': {
    en: 'Problem',
    es: 'Problema',
    pt: 'Problema',
  },
  'transactions.chargebackform.comments': {
    en: 'Comments',
    es: 'Comentarios',
    pt: 'Comentários',
  },
  'transactions.chargeback.title': {
    en: 'Related Chargeback',
    es: 'Contracargo relacionado',
    pt: 'Chargeback relacionado',
  },
  'transactions.relatedTransactions': {
    en: 'Related transactions',
    es: 'Transacciones relacionadas',
    pt: 'Transações relacionadas',
  },
  'transactions.refund': {
    en: 'Refund',
    es: 'Reembolso',
    pt: 'Reembolso',
  },
  'transactions.filter.status': {
    en: 'Payment status',
    es: 'Estado del pago',
    pt: 'Status do pagamento',
  },
  'transactions.filter.status.titleOptions': {
    en: 'Filter by payment status',
    es: 'Filtrar por estado del pago',
    pt: 'Filtrar por status de pagamento',
  },
  'transactions.filter.creationDate': {
    en: 'Creation date',
    es: 'Fecha de creación',
    pt: 'Data de criação',
  },
  'transactions.filter.creationDate.titleOptions': {
    en: 'Filter by creation date',
    es: 'Filtrar por fecha de creación',
    pt: 'Filtrar por data de criação',
  },
  'transactions.filter.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'transactions.filter.country.titleOptions': {
    en: 'Filter by country',
    es: 'Filtrar por país',
    pt: 'Filtrar por país',
  },
  'transactions.filter.paymentMethod': {
    en: 'Payment method',
    es: 'Método de pago',
    pt: 'Forma de pagamento',
  },
  'transactions.filter.paymentMethod.titleOptions': {
    en: 'Filter by payment method',
    es: 'Filtrar por método de pago',
    pt: 'Filtrar por forma de pagamento',
  },
  'transactions.filter.paymentMethod.descriptionOptions': {
    en: 'First, filter by country and then by payment method.',
    es: 'Primero, filtra por país y luego por método de pago.',
    pt: 'Primeiro, filtre por país e depois por forma de pagamento.',
  },
  'transactions.filter.paymentMethod.desc': {
    en: 'First, you must filter by country.',
    es: 'Primero, debes filtrar por país.',
    pt: 'Primeiro, você deve filtrar por país.',
  },
  'transactions.filter.appliedFilters': {
    en: 'Applied filters',
    es: 'Filtros aplicados',
    pt: 'Filtros aplicados',
  },
  'transactions.filter.clearFilters': {
    en: 'Clear all',
    es: 'Limpiar todo',
    pt: 'Limpar tudo',
  },
  'transactions.filter.chip.from': {
    en: 'From',
    es: 'Desde',
    pt: 'A partir de',
  },
  'transactions.filter.chip.to': {
    en: 'To',
    es: 'Hasta',
    pt: 'Até',
  },
  'transactions.rejectionReason.title': {
    en: 'Rejection reason',
    es: 'Motivo del rechazo',
    pt: 'Motivo da rejeição',
  },
  'transactions.status': {
    en: 'Payment status',
    es: 'Estado del pago',
    pt: 'Status do pagamento',
  },
  'transactions.status.CREATED': {
    en: 'Created',
    es: 'Creada',
    pt: 'Criado',
  },
  'transactions.status.COMPLETED': {
    en: 'Completed',
    es: 'Completada',
    pt: 'Concluído',
  },
  'transactions.status.PENDING': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'transactions.status.CANCELLED': {
    en: 'Cancelled',
    es: 'Cancelada',
    pt: 'Cancelada',
  },
  'transactions.status.DECLINED': {
    en: 'Declined',
    es: 'Rechazada',
    pt: 'Rejeitado',
  },
  'transactions.status.EXPIRED': {
    en: 'Expired',
    es: 'Expirado',
    pt: 'Expirado',
  },
  'transactions.status.REFUNDED': {
    en: 'Refunded',
    es: 'Reembolsada',
    pt: 'Reembolsada',
  },
  'transactions.status.review': {
    en: 'Review',
    es: 'Revisar',
    pt: 'Revisão',
  },
  'transactions.status.FAILED': {
    en: 'Failed',
    es: 'Fallido',
    pt: 'Falha',
  },
  'transactions.addRefund': {
    en: 'Request refund',
    es: 'Solicitar reembolso',
    pt: 'Solicitar reembolso',
  },
  'transactions.refunded': {
    en: 'Refunded',
    es: 'Reembolsado',
    pt: 'Reembolsado',
  },
  'exportTransactions.title': {
    en: 'Download report',
    es: 'Descargar reporte',
    pt: 'Baixar relatório',
  },
  'exportTransactions.open': {
    en: 'Export',
    es: 'Exportar',
    pt: 'Exportar',
  },
  'exportTransactions.exportBtn': {
    en: 'Download',
    es: 'Descargar',
    pt: 'Baixar',
  },
  'exportTransactions.range': {
    en: 'Select date range',
    es: 'Seleccione el rango de fechas',
    pt: 'Selecione o intervalo de datas',
  },
  'exportTransactions.successMessage': {
    en: 'If the file download does not start, check that your browser has not blocked it.',
    es: 'Si la descarga del archivo no se inicia, verifique que su navegador no lo haya bloqueado.',
    pt: 'Se o download do arquivo não iniciar, verifique se seu navegador não o bloqueou.',
  },
  'exportTransactions.downloadAgain': {
    en: 'You can try to download it again by clicking ',
    es: 'Puedes intentar descargarlo nuevamente haciendo clic ',
    pt: 'Você pode tentar baixá-lo novamente clicando ',
  },
  'exportTransactions.downloadAgain.here': {
    en: 'here.',
    es: 'aquí.',
    pt: 'aqui.',
  },
  'exportTransactions.invalidDates': {
    en: 'The selected dates are invalid.',
    es: 'Las fechas seleccionadas son inválidas.',
    pt: 'As datas selecionadas são inválidas.',
  },
  'exportTransactions.rangeError': {
    en: 'The date range cannot be greater than 31 days.',
    es: 'El rango de fechas no puede ser mayor a 31 días.',
    pt: 'O intervalo de datas não pode ser superior a 31 dias.',
  },
  'exportTransactions.empty': {
    en: 'No data to download found.',
    es: 'No se encontraron datos para descargar.',
    pt: 'Nenhum dado para download encontrado.',
  },
  'exportTransactions.otherFilters': {
    en: 'Optional filters',
    es: 'Filtros opcionales',
    pt: 'Filtros opcionais',
  },
  'exportTransactions.emailModal.title': {
    en: 'Export in progress',
    es: 'Exportación en progreso',
    pt: 'Exportação em andamento',
  },
  'exportTransactions.emailModal.message': {
    en: 'The generated report will be sent to your email when ready. If you do not see it, please check your spam or promotions folder.',
    es: 'El reporte generado se enviará a su casilla de correo cuando esté listo. En caso de no visualizarlo, recuerde revisar su carpeta de correo no deseado (spam) o promociones.',
    pt: 'O relatório gerado será enviado para seu e-mail quando estiver pronto. Caso não o visualize, lembre-se de verificar sua pasta de spam ou promoções.',
  },
  'transactions_statement.title': {
    en: 'Balance Details',
    es: 'Detalles del balance',
    pt: 'Detalhes do saldo',
  },
  'transactions_statement.subheadline': {
    en: 'Find your transactions statement, transactions details, refunds, chargebacks and more.',
    es: 'Encuentra tu estado de cuenta, detalles de transacciones, reembolsos, contracargos y más.',
    pt: 'Encontre seu estado de conta, detalhes de transações, reembolsos, chargebacks e mais.',
  },
  'transactions_statement.header': {
    en: 'Balance Details {0} to {1}',
    es: 'Estado de cuenta {0} a {1}',
    pt: 'Estado de conta {0} a {1}',
  },
  'transactions_statement.totalTransactions': {
    en: 'Total Transactions',
    es: 'Total de transacciones',
    pt: 'Total de transações',
  },
  'transactions_statement.totalCbksRefunds': {
    en: 'Total Cbks/Refunds',
    es: 'Total de contracargos/reembolsos',
    pt: 'Total de chargebacks/reembolsos',
  },
  'transactions_statement.totalSettlements': {
    en: 'Total Settlements',
    es: 'Total de retiros',
    pt: 'Total de retiradas',
  },
  'transactions_statement.totalCredits': {
    en: 'Total Credits',
    es: 'Total de créditos',
    pt: 'Total de créditos',
  },
  'transactions_statement.datetime': {
    en: 'Date/Time',
    es: 'Fecha/Hora',
    pt: 'Data/Hora',
  },
  'transactions_statement.operation': {
    en: 'Operation',
    es: 'Operación',
    pt: 'Operação',
  },
  'transactions_statement.identifier': {
    en: 'Identifier',
    es: 'Identificador',
    pt: 'Identificador',
  },
  'transactions_statement.credit': {
    en: 'Credit (Balance Currency)',
    es: 'Crédito (Moneda de Balance)',
    pt: 'Crédito (Moeda de Balance)',
  },
  'transactions_statement.debit': {
    en: 'Debit (Balance Currency)',
    es: 'Débito (Moneda de Balance)',
    pt: 'Débito (Moeda de Balance)',
  },
  'affiliations.affiliates.header': {
    en: `Earn <span>1%</span> of all your referrals' transactions during their first <span>90 days</span>.`,
    es: 'Gana el <span>1%</span> de todas las transacciones de tus referidos durante sus primeros <span>90 días</span>.',
    pt: 'Ganhe <span>1%</span> de todas as transações dos seus afiliados durante os primeiros <span>90 dias</span>.',
  },
  'affiliations.affiliates.desc': {
    en: 'Invite new clients to use dLocal Go. For each one that registers and starts transacting, you will receive <span>1% in credits</span> on the volume they generate during their first 90 days. <span>Invite and start earning with every transaction they make!</span>',
    es: 'Invita a nuevos clientes a usar dLocal Go. Por cada uno que se registre y comience a transaccionar, recibirás el <span>1% en créditos</span> sobre el volumen que generen durante sus primeros 90 días. <span>¡Invita y empieza a ganar con cada transacción que hagan!</span>',
    pt: 'Convide novos clientes para usar o dLocal Go. Para cada um que se registrar e começar a transacionar, você receberá <span>1% em créditos</span> sobre o volume que eles gerarem durante os primeiros 90 dias. <span>Convide e comece a ganhar com cada transação que eles fizerem!</span>',
  },
  'affiliations.affiliates.resume': {
    en: 'Resume',
    es: 'Resumen',
    pt: 'Resumo',
  },
  'affiliations.affiliates.resume.headers.totalReferrals': {
    en: 'Total referrals',
    es: 'Total Referidos',
    pt: 'Total de Referências',
  },
  'affiliations.affiliates.resume.headers.actives': {
    en: 'Active referrals',
    es: 'Activos',
    pt: 'Ativos',
  },
  'affiliations.affiliates.resume.headers.accumulatedCredits': {
    en: 'Accumulated credits',
    es: 'Créditos acumulados',
    pt: 'Créditos acumulados',
  },
  'affiliations.affiliates.resume.headers.availableCredits': {
    en: 'Available credits',
    es: 'Créditos disponibles',
    pt: 'Créditos disponíveis',
  },
  'affiliations.affiliates.resume.headers.creditsToExpire': {
    en: 'Credits to expire',
    es: 'Créditos por vencer',
    pt: 'Créditos a expirar',
  },
  'affiliations.affiliates.affiliatesTable': {
    en: 'Affiliates Table',
    es: 'Tabla de Afiliados',
    pt: 'Tabela de Afiliados',
  },
  'affiliations.affiliates.affiliatesTable.headers.number': {
    en: 'No.',
    es: 'No.',
    pt: 'No.',
  },
  'affiliations.affiliates.affiliatesTable.headers.email': {
    en: 'Referral email',
    es: 'Email de referido',
    pt: 'Email de referência',
  },
  'affiliations.affiliates.affiliatesTable.headers.accountStatus': {
    en: 'Account status',
    es: 'Estado de la cuenta',
    pt: 'Estado da conta',
  },
  'affiliations.affiliates.affiliatesTable.headers.firstTransactionDate': {
    en: 'First transaction date',
    es: 'Fecha 1° transacción',
    pt: 'Data da 1° transação',
  },
  'affiliations.affiliates.affiliatesTable.headers.90daysAmount': {
    en: '90 days amount',
    es: 'Monto 90 días',
    pt: 'Montante 90 dias',
  },
  'affiliations.affiliates.affiliatesTable.headers.earnedCredits': {
    en: 'Earned credits',
    es: 'Créditos ganados',
    pt: 'Créditos ganhos',
  },
  'affiliations.affiliates.affiliatesTable.headers.appliedCredits': {
    en: 'Applied credits',
    es: 'Bono aplicado',
    pt: 'Créditos aplicados',
  },
  'affiliations.affiliates.affiliatesTable.headers.totalCredits': {
    en: 'Total credits',
    es: 'Total ganado',
    pt: 'Total de créditos',
  },
  'affiliations.affiliates.affiliatesTable.headers.status': {
    en: 'Benefit status',
    es: 'Estado del beneficio',
    pt: 'Estado do benefício',
  },
  'affiliations.affiliates.affiliatesTable.headers.remainingTime': {
    en: 'Remaining time',
    es: 'Tiempo restante',
    pt: 'Tempo restante',
  },
  'affiliations.affiliates.affiliatesTable.ACTIVE': {
    en: 'Active',
    es: 'Activo',
    pt: 'Ativo',
  },
  'affiliations.affiliates.affiliatesTable.ENDED': {
    en: 'Ended',
    es: 'Finalizado',
    pt: 'Finalizado',
  },
  'affiliations.affiliates.affiliatesTable.PENDING': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'affiliations.affiliates.invite': {
    en: 'Invite',
    es: 'Invitar',
    pt: 'Convidar',
  },
  'affiliations.affiliates.yourStats': {
    en: 'Your Stats',
    es: 'Tus Estadísticas',
    pt: 'Suas Estatísticas',
  },
  'affiliations.affiliates.stats.activeAffiliates': {
    en: 'Active affiliates',
    es: 'Afiliados activos',
    pt: 'Afiliados ativos',
  },
  'affiliations.affiliates.stats.accumulate': {
    en: 'You have accumulated',
    es: 'Acumulaste',
    pt: 'Você acumulou',
  },
  'affiliations.affiliates.stats.usage': {
    en: 'You used',
    es: 'Usaste',
    pt: 'Você usou',
  },
  'affiliations.affiliates.noAffiliates': {
    en: 'Make your first transaction of over $100 USD on dLocal Go to generate your affiliate link from your account.',
    es: 'Realiza tu primera transacción de más de $100 USD en dLocal Go para generar tu enlace de afiliado desde tu cuenta.',
    pt: 'Realize sua primeira transação de mais de $100 USD no dLocal Go para gerar seu link de afiliado na sua conta.',
  },
  'affiliations.benefits': {
    en: 'Benefits of the program',
    es: 'Beneficios del programa',
    pt: 'Benefícios do programa',
  },
  'affiliations.benefits.example': {
    en: 'Example',
    es: 'Ejemplo',
    pt: 'Exemplo',
  },
  'affiliations.benefits.0.title': {
    en: 'Benefits of the program',
    es: 'Beneficios del programa',
    pt: 'Benefícios do programa',
  },
  'affiliations.benefits.0.helpText': {
    en: 'Commission credits based on the first 90 days',
    es: 'Créditos en comisiones basados en los primeros 90 Días',
    pt: 'Créditos em comissões baseados nos primeiros 90 Dias',
  },
  'affiliations.benefits.0.sections.0.title': {
    en: 'Commission credits based on the first 90 days',
    es: 'Créditos en comisiones basados en los primeros 90 Días',
    pt: 'Créditos em comissões baseados nos primeiros 90 Dias',
  },
  'affiliations.benefits.0.sections.0.description': {
    en: `<ul><li>Affiliates will receive commission credits equivalent to 1% of the total transaction volume of each referral.</li><li>The benefit will only be generated during the first 90 days from their signup.</li></ul>`,
    es: `<ul><li>Los afiliados recibirán créditos en comisiones equivalentes al 1% del volumen total de transacciones de cada referido.</li><li>El beneficio solo se generará durante los primeros 90 días desde su registro.</li></ul>`,
    pt: `<ul><li>Os afiliados receberão créditos em comissões equivalentes a 1% do volume total de transações de cada referência.</li><li>O benefício só será gerado durante os primeiros 90 dias a partir da inscrição.</li></ul>`,
  },
  'affiliations.benefits.0.sections.0.example': {
    en: `<ul><li>A referral transacts $10,000 USD in their first 90 days → the affiliate receives $100 in credits.</li><li>If the referral continues to transact after 90 days, they will no longer generate benefits for the affiliate.</li></ul>`,
    es: `<ul><li>Un referido transacciona $10,000 USD en sus primeros 90 días → el afiliado recibe $100 en créditos.</li><li>Si el referido sigue transaccionando después de 90 días, ya no generará más beneficios para el afiliado.</li></ul>`,
    pt: `<ul><li>Um indicado transaciona $10.000 USD nos primeiros 90 dias → o afiliado recebe $100 em créditos.</li><li>Se o indicado continuar transacionando após 90 dias, não gerará mais benefícios para o afiliado.</li></ul>`,
  },
  'affiliations.benefits.0.sections.1.title': {
    en: 'Credits usage',
    es: 'Uso de los créditos',
    pt: 'Uso dos créditos',
  },
  'affiliations.benefits.0.sections.1.description': {
    en: `<ul><li>Credits can be used exclusively to reduce fees on your own transactions within dLocal Go.</li><li>Credits must be used within 90 days of generation or they will be removed.</li></ul>`,
    es: `<ul><li>Los créditos pueden usarse exclusivamente para reducir las comisiones en sus propias transacciones dentro de dLocal Go.</li><li>Los créditos tienen 90 días de vigencia, pasado ese tiempo expiran y ya no pueden usarse.</li></ul>`,
    pt: `<ul><li>Os créditos podem ser usados exclusivamente para reduzir as taxas em suas próprias transações dentro do dLocal Go.</li><li>Devem ser usados dentro de 90 dias após sua geração ou serão removidos.</li></ul>`,
  },
  'affiliations.benefits.0.sections.2.title': {
    en: 'Bonuses for first use',
    es: 'Bonos por Primer Uso',
    pt: 'Bônus por Primeiro Uso',
  },
  'affiliations.benefits.0.sections.2.description': {
    en: `<ul><li>If a merchant transacts within the first 30 days, the affiliate receives an additional 50% bonus on the credits generated that month.</li></ul>`,
    es: `<ul><li>Si un merchant transacciona en los primeros 30 días, el afiliado obtiene un bono adicional del 50% sobre los créditos generados ese mes.</li></ul>`,
    pt: `<ul><li>Se um comerciante transacionar nos primeiros 30 dias, o afiliado obtém um bônus adicional de 50% sobre os créditos gerados nesse mês.</li></ul>`,
  },
  'affiliations.benefits.0.sections.2.example': {
    en: `<ul><li>An affiliate generates $100 in credits in their first month with a new referral.</li><li>They receive an extra $50 bonus, totaling $150 in credits.</li></ul>`,
    es: `<ul><li>Un afiliado genera $100 en créditos en su primer mes con un nuevo referido.</li><li>Obtiene un bono extra de $50, sumando $150 en créditos.</li></ul>`,
    pt: `<ul><li>Um afiliado gera $100 em créditos no seu primeiro mês com um novo indicado.</li><li>Recebe um bônus extra de $50, totalizando $150 em créditos.</li></ul>`,
  },
  'affiliations.benefits.0.sections.3.title': {
    en: 'Unlimited referrals',
    es: 'Sin límite de referidos',
    pt: 'Sem limite de referências',
  },
  'affiliations.benefits.0.sections.3.description': {
    en: `<ul><li>Affiliates can bring as many referrals as they want and accumulate credits without restrictions, but each referral will only generate benefits during their first 90 days.</li></ul>`,
    es: `<ul><li>Los afiliados pueden traer tantos referidos como quieran y acumular créditos sin restricciones, pero cada referido sólo generará beneficios durante sus primeros 90 días.</li></ul>`,
    pt: `<ul><li>Os afiliados podem trazer quantas referências quiserem e acumular créditos sem restrições, mas cada referência só gerará benefícios durante os primeiros 90 dias.</li></ul>`,
  },
  'affiliations.benefits.1.title': {
    en: 'Benefits for the Referrals',
    es: 'Beneficios para los Referidos',
    pt: 'Benefícios para os Referidos',
  },
  'affiliations.benefits.1.helpText': {
    en: 'Commission credits based on the first 90 days',
    es: 'Créditos en Comisiones Basados en los Primeros 90 Días',
    pt: 'Créditos em Comissões Baseados nos Primeiros 90 Dias',
  },
  'affiliations.benefits.1.sections.0.title': {
    en: 'Welcome Bonus: First $100 USD without Fees',
    es: 'Bono de Bienvenida: Primeros $100 USD sin Comisiones',
    pt: 'Bônus de Boas-Vindas: Primeiros $100 USD sem Taxas',
  },
  'affiliations.benefits.1.sections.0.description': {
    en: `<ul><li>New users who register with an affiliate link will receive a discount of up to $100 USD on fees.</li></ul>`,
    es: `<ul><li>Los nuevos usuarios que se registren con un link de afiliado recibirán un descuento de hasta $100 USD en comisiones.</li></ul>`,
    pt: `<ul><li>Novos usuários que se registrarem com um link de afiliado receberão um desconto de até $100 USD em taxas.</li></ul>`,
  },
  'affiliations.benefits.1.sections.0.example': {
    en: `<ul><li>If a new user transacts $2,000 USD and the standard fee is 3%, they would normally pay $60 in fees.</li><li>With this benefit, those fees are covered by the bonus.</li><li>If they transact more and exceed $100 in fees, they pay the excess as normal.</li></ul>`,
    es: `<ul><li>Si un nuevo usuario transacciona $2,000 USD y la comisión estándar es del 3%, debería pagar $60 en comisiones.</li><li>Con este beneficio, esas comisiones quedan cubiertas por el bono.</li><li>Si transacciona más y supera los $100 en comisiones, paga lo que exceda normalmente.</li></ul>`,
    pt: `<ul><li>Se um novo usuário transacionar $2.000 USD e a taxa padrão for de 3%, ele pagaria normalmente $60 em taxas.</li><li>Com esse benefício, essas taxas são cobertas pelo bônus.</li><li>Se transacionar mais e ultrapassar $100 em taxas, pagará o excedente normalmente.</li></ul>`,
  },
  'affiliations.benefits.1.sections.1.title': {
    en: 'Preferential Onboarding',
    es: 'Onboarding Preferencial',
    pt: 'Onboarding Preferencial',
  },
  'affiliations.benefits.1.sections.1.description': {
    en: `<ul><li>Specific onboarding to make it easier for your referrals to begin transacting.</li><li>Priority support from the support team during the first 30 days.</li></ul>`,
    es: `<ul><li>Onboarding específico para facilitar que tus referidos empiecen a transaccionar.</li><li>Atención prioritaria en el equipo de soporte durante los primeros 30 días.</li></ul>`,
    pt: `<ul><li>Integração específica para facilitar o início das transações por parte de suas indicações.</li><li>Atendimento prioritário da equipe de suporte durante os primeiros 30 dias.</li></ul>`,
  },
  'affiliations.benefits.2.title': {
    en: 'General Conditions',
    es: 'Condiciones Generales',
    pt: 'Condições Gerais',
  },
  'affiliations.benefits.2.helpText': {
    en: 'Commission credits based on the first 90 days',
    es: 'Créditos en Comisiones Basados en los Primeros 90 Días',
    pt: 'Créditos em Comissões Baseados nos Primeiros 90 Dias',
  },
  'affiliations.benefits.2.sections.0.title': {
    en: 'Benefits validity',
    es: 'Validez de los Beneficios',
    pt: 'Validade dos Benefícios',
  },
  'affiliations.benefits.2.sections.0.description': {
    en: `<ul><li>Commission credits will be generated only during the first 90 days from each referral's signup.</li><li>Credits must be used within 90 days of their generation or they will expire and can no longer be used.</li></ul>`,
    es: `<ul><li>Los créditos en comisiones se generarán solo durante los primeros 90 días desde su registro.</li><li>Los creditos tienen 90 días de vigencia, pasado ese tiempo expiran y ya no pueden usarse.</li></ul>`,
    pt: `<ul><li>Os créditos em taxas serão gerados apenas durante os primeiros 90 dias a partir da inscrição.</li><li>Os créditos devem ser usados dentro de 90 dias após sua geração ou expirarão e não poderão mais ser usados.</li></ul>`,
  },
  'affiliations.benefits.2.sections.1.title': {
    en: 'Legitimacy of the Referrals',
    es: 'Legitimidad de los Referidos',
    pt: 'Legitimidade dos Referidos',
  },
  'affiliations.benefits.2.sections.1.description': {
    en: `<ul><li>For a referral to be valid, they must successfully complete the onboarding process and make real transactions.</li><li>Potential fraud or abuse in the use of the program will be reviewed, which may nullify the benefit for the affiliate.</li></ul>`,
    es: `<ul><li>Para que un referido sea válido, debe completar exitosamente el proceso de onboarding y realizar transacciones reales.</li><li>Se revisarán posibles fraudes o abusos en el uso del programa que anularán el beneficio para el afiliado.</li></ul>`,
    pt: `<ul><li>Para que um indicado seja válido, ele deve concluir com sucesso o processo de onboarding e realizar transações reais.</li><li>Possíveis fraudes ou abusos no uso do programa serão revisados, o que poderá anular o benefício para o afiliado.</li></ul>`,
  },
  'affiliations.benefits.2.sections.2.title': {
    en: 'Restrictions',
    es: 'Restricciones',
    pt: 'Restrições',
  },
  'affiliations.benefits.2.sections.2.description': {
    en: `<ul><li>Commission credits are non-transferable and cannot be converted to cash as they are for exclusive use on the platform.</li><li>Only users with an active and available account (without active fraud review) can refer others.</li><li>Credits generated from chargeback transactions will be <span>automatically deducted</span>.</li></ul>`,
    es: `<ul><li>Los créditos en comisiones no son transferibles ni convertibles en dinero en efectivo ya que son para uso exclusivo para comisiones en plataforma.</li><li>Solo pueden referir los usuarios que tengan la cuenta activa y disponible (sin revisión de fraude activa)</li><li>Los créditos generados por transacciones con contracargos serán <span>descontados</span> automáticamente.</li></ul>`,
    pt: `<ul><li>Os créditos em comissões não são transferíveis e não podem ser convertidos em dinheiro, pois são para uso exclusivo na plataforma.</li><li>Apenas usuários com conta ativa e disponível (sem revisão de fraude ativa) podem referir outros.</li><li>Créditos gerados a partir de transações de chargeback serão <span>deduzidos automaticamente</span>.</li></ul>`,
  },
  'affiliations.benefits.2.sections.3.title': {
    en: 'Program Review',
    es: 'Revisión del Programa',
    pt: 'Revisão do Programa',
  },
  'affiliations.benefits.2.sections.3.description': {
    en: `<ul><li>dLocal Go reserves the right to modify or cancel the program at any time WITHOUT prior notice.</li><li>Any attempt to abuse the system may result in exclusion from the program and the loss of accumulated benefits.</li><li>For any questions, refer to the terms and conditions in this <a href="https://helpcenter.dlocalgo.com/en/articles/11525979-affiliate-program" target="_blank">link</a>.</li></ul>`,
    es: `<ul><li>dLocal Go se reserva el derecho de modificar o cancelar el programa en cualquier momento SIN previo aviso.</li><li>Cualquier intento de abuso del sistema puede resultar en la exclusión del programa y la pérdida de los beneficios acumulados.</li><li>En caso de tener dudas, consultar términos y condiciones en este <a href="https://helpcenter.dlocalgo.com/es/articles/11525979-programa-de-afiliados" target="_blank">enlace</a>.</li></ul>`,
    pt: `<ul><li>dLocal Go se reserva o direito de modificar ou cancelar o programa a qualquer momento sem aviso prévio.</li><li>Qualquer tentativa de abuso do sistema pode resultar na exclusão do programa e na perda dos benefícios acumulados.</li><li>Em caso de dúvidas, consulte os termos e condições neste <a href="https://helpcenter.dlocalgo.com/pt-BR/articles/11525979-programa-de-afiliados" target="_blank">link</a>.</li></ul>`,
  },
  'affiliations.affiliates.100UsdDialog.title': {
    en: 'This link is only available for users who have already transacted USD 100.',
    es: 'Este enlace está disponible únicamente para usuarios que ya han transaccionado USD 100.',
    pt: 'Este link está disponível apenas para usuários que já transacionaram USD 100.',
  },
  'affiliations.affiliates.100UsdDialog.description': {
    en: 'Make your first transaction to unlock this exclusive benefit and receive gift credits.',
    es: 'Haz tu primera transacción para desbloquear este beneficio exclusivo y recibir créditos de regalo.',
    pt: 'Faça sua primeira transação para desbloquear este benefício exclusivo e receber créditos de presente.',
  },
  'affiliations.affiliates.shareLinkModal.title': {
    en: "Earn 1% of all your customers' transactions!",
    es: 'Gana el 1% de todas las transacciones de tus clientes!',
    pt: 'Ganhe 1% de todas as transações de seus clientes!',
  },
  'affiliations.affiliates.shareLinkModal.description': {
    en: "Let's grow together with dlocal Go's limited-time referral campaign.",
    es: 'Crezcamos juntos con la campaña de referidos por tiempo limitado de dlocal Go.',
    pt: 'Vamos crescer juntos com a campanha de referências por tempo limitado do dlocal Go.',
  },
  'exportChargebacks.title': {
    en: 'Download report',
    es: 'Descargar reporte',
    pt: 'Baixar relatório',
  },
  'exportChargebacks.open': {
    en: 'Export',
    es: 'Exportar',
    pt: 'Exportar',
  },
  'exportChargebacks.exportBtn': {
    en: 'Download',
    es: 'Descargar',
    pt: 'Baixar',
  },
  'exportChargebacks.range': {
    en: 'Select date range',
    es: 'Seleccione el rango de fechas',
    pt: 'Selecione o intervalo de datas',
  },
  'exportChargebacks.successMessage': {
    en: 'If the file download does not start, check that your browser has not blocked it.',
    es: 'Si la descarga del archivo no se inicia, verifique que su navegador no lo haya bloqueado.',
    pt: 'Se o download do arquivo não iniciar, verifique se seu navegador não o bloqueou.',
  },
  'exportChargebacks.downloadAgain': {
    en: 'You can try to download it again by clicking ',
    es: 'Puedes intentar descargarlo nuevamente haciendo clic ',
    pt: 'Você pode tentar baixá-lo novamente clicando ',
  },
  'exportChargebacks.downloadAgain.here': {
    en: 'here.',
    es: 'aquí.',
    pt: 'aqui.',
  },
  'exportChargebacks.invalidDates': {
    en: 'The selected dates are invalid.',
    es: 'Las fechas seleccionadas son inválidas.',
    pt: 'As datas selecionadas são inválidas.',
  },
  'exportChargebacks.rangeError': {
    en: 'The date range cannot be greater than 31 days.',
    es: 'El rango de fechas no puede ser mayor a 31 días.',
    pt: 'O intervalo de datas não pode ser superior a 31 dias.',
  },
  'exportChargebacks.empty': {
    en: 'No data to download found.',
    es: 'No se encontraron datos para descargar.',
    pt: 'Nenhum dado para download encontrado.',
  },
  'exportChargebacks.otherFilters': {
    en: 'Optional filters',
    es: 'Filtros opcionales',
    pt: 'Filtros opcionais',
  },
  'chargebacks.chargeback': {
    en: 'Chargeback',
    es: 'Contracargo',
    pt: 'Chargeback',
  },
  'chargebacks.subheadline': {
    en: 'Find all the chargebacks that your clients have requested and their status.',
    es: 'Encuentra todos los contracargos que tus clientes han solicitado y su estado.',
    pt: 'Encontre todos os chargebacks que seus clientes solicitaram e seu status.',
  },
  'chargebacks.list.subheadline': {
    en: 'Manage chargebacks and respond to disputes to protect your payments.',
    es: 'Gestiona contracargos y responde a disputas para proteger tus cobros.',
    pt: 'Gerencie chargebacks e responda a disputas para proteger seus pagamentos.',
  },
  'chargebacks.searchBar': {
    en: 'Search chargebacks',
    es: 'Buscar contracargos',
    pt: 'Pesquisar chargebacks',
  },
  'chargebacks.invoiceId': {
    en: 'Chargeback ID',
    es: 'ID del contracargo',
    pt: 'ID da chargeback',
  },
  'chargebacks.amount': {
    en: 'Chargeback amount',
    es: 'Monto del Contracargo',
    pt: 'Valor da chargeback',
  },
  'chargebacks.filter.status': {
    en: 'Chargeback status',
    es: 'Estado del Contracargo',
    pt: 'Status do chargeback',
  },
  'chargebacks.filter.status.titleOptions': {
    en: 'Filter by chargeback status',
    es: 'Filtrar por estado del Contracargo',
    pt: 'Filtrar por status de chargeback',
  },
  'chargebacks.upload-doc.success.headline': {
    en: 'We received your document.',
    es: 'Recibimos su documento.',
    pt: 'Recebemos seu documento.',
  },
  'chargebacks.upload-doc.success.subheadline': {
    en: "The document is being reviewed. We'll let you know the result.",
    es: 'El documento está siendo revisado. Te informaremos el resultado de apelación.',
    pt: 'O documento está sendo revisado. Informaremos o resultado da apelação.',
  },
  'chargebacks.upload-doc.success.button': {
    en: 'CONTINUE',
    es: 'CONTINUAR',
    pt: 'CONTINUAR',
  },
  'chargebacks.upload-doc.error.headline': {
    en: 'There was an error',
    es: 'Hubo un error',
    pt: 'Houve um erro',
  },
  'chargebacks.upload-doc.error.subheadline': {
    en: "We couldn't process your document. Please try again later.",
    es: 'No pudimos procesar tu documento. Por favor, inténtalo de nuevo más tarde.',
    pt: 'Não conseguimos processar seu documento. Por favor, tente novamente mais tarde.',
  },
  'chargebacks.upload-doc.error.button': {
    en: 'CONTINUE',
    es: 'CONTINUAR',
    pt: 'CONTINUAR',
  },
  'chargebacks.status': {
    en: 'Status',
    es: 'Estado',
    pt: 'Status',
  },
  'chargebacks.status.COMPLETED': {
    en: 'Completed',
    es: 'Completada',
    pt: 'Concluído',
  },
  'chargebacks.status.PENDING': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'chargebacks.status.CANCELLED': {
    en: 'Cancelled',
    es: 'Cancelada',
    pt: 'Cancelada',
  },
  'chargebacks.status.REVERSAL': {
    en: 'Reversal',
    es: 'Revertida',
    pt: 'Reversão',
  },
  'chargebacks.createdDate': {
    en: 'Created date',
    es: 'Fecha de creación',
    pt: 'Data de criação',
  },
  'chargebacks.paymentMethod': {
    en: 'Payment Method',
    es: 'Método de pago',
    pt: 'Forma de pagamento',
  },
  'chargebacks.details': {
    en: 'Chargeback Details',
    es: 'Detalles del Contracargo',
    pt: 'Detalhes da chargeback',
  },
  'chargebacks.reference': {
    en: 'Reference',
    es: 'Referencia',
    pt: 'Referência',
  },
  'chargebacks.reasonDescription': {
    en: 'Reason Description',
    es: 'Descripción del Motivo',
    pt: 'Descrição do Motivo',
  },
  'chargebacks.feeAmount': {
    en: 'Fee Amount',
    es: 'Monto de la Comisión',
    pt: 'Valor da Taxa',
  },
  'chargebacks.localCurrency': {
    en: 'Local Currency',
    es: 'Moneda Local',
    pt: 'Moeda Local',
  },
  'chargebacks.countryCode': {
    en: 'Country Code',
    es: 'Código de País',
    pt: 'Código do País',
  },
  'chargebacks.dueDate': {
    en: 'Due Date',
    es: 'Fecha de Vencimiento',
    pt: 'Data de Vencimento',
  },
  'chargebacks.noChargebacks': {
    en: 'You have no chargebacks yet.',
    es: 'Aún no tienes contracargos.',
    pt: 'Você ainda não tem chargebacks.',
  },
  'chargebacks.noChargebacks.found': {
    en: 'We haven’t found any matches for your searched chargeback.<br />Please, try again.',
    es: 'No hemos encontrado coincidencias para el contracargo buscado.<br />Por favor, inténtalo de nuevo.',
    pt: 'Não encontramos nenhuma correspondência para sua chargeback pesquisada.<br />Por favor, tente novamente.',
  },
  'chargebacks.relatedTransactions': {
    en: 'Related Transactions',
    es: 'Transacciones Relacionadas',
    pt: 'Transações Relacionadas',
  },
  'chargebacks.resolution.amount': {
    en: 'Amount',
    es: 'Monto',
    pt: 'Valor',
  },
  'chargebacks.amountPaid': {
    en: 'Amount Paid',
    es: 'Monto Pagado',
    pt: 'Valor Pago',
  },
  'chargebacks.paymentType': {
    en: 'Payment Type',
    es: 'Tipo de Pago',
    pt: 'Tipo de Pagamento',
  },
  'chargebacks.clientName': {
    en: 'Client Name',
    es: 'Nombre del Cliente',
    pt: 'Nome do Cliente',
  },
  'chargebacks.chargebackResolution': {
    en: 'Chargeback Resolution',
    es: 'Resolución del Contracargo',
    pt: 'Resolução da Chargeback',
  },
  'chargebacks.resolution': {
    en: 'Resolution',
    es: 'Resolución',
    pt: 'Resolução',
  },
  'chargebacks.resolution.pending': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'chargebacks.resolution.against': {
    en: 'Against',
    es: 'En Contra',
    pt: 'Contra',
  },
  'chargebacks.resolution.inFavour': {
    en: 'In Favour',
    es: 'A Favor',
    pt: 'A Favor',
  },
  'chargebacks.uploadDocumentation': {
    en: 'Upload Documentation',
    es: 'Subir Documentación',
    pt: 'Enviar Documentação',
  },
  'chargebacks.uploadDocumentation.received': {
    en: 'Documentation Received',
    es: 'Documentación Recibida',
    pt: 'Documentação Recebida',
  },
  'chargebacks.uploader.title': {
    en: 'Upload File',
    es: 'Subir Archivo',
    pt: 'Enviar Arquivo',
  },
  'chargebacks.uploader.desc1': {
    en: 'Include all the information (rebuttal letter and compelling evidence).',
    es: 'Incluye toda la información (carta de apelación y pruebas convincentes).',
    pt: 'Inclua todas as informações (carta de contestação e evidências convincentes).',
  },
  'chargebacks.uploader.desc2': {
    en: 'Only support a single (1) PDF file. Maximum file size: 1MB.',
    es: 'Solo soporta un (1) archivo PDF. Tamaño máximo del archivo: 1MB.',
    pt: 'Suporta apenas um (1) arquivo PDF. Tamanho máximo do arquivo: 1MB.',
  },
  'chargebacks.uploader.selectFile': {
    en: 'Select a file to upload',
    es: 'Selecciona un archivo para subir',
    pt: 'Selecione um arquivo para enviar',
  },
  'chargebacks.uploader.docRequired': {
    en: 'Document Required',
    es: 'Documento Requerido',
    pt: 'Documento Necessário',
  },
  'chargebacks.uploader.exceedsSize': {
    en: 'Exceeds the maximum file size of 1MB.',
    es: 'Supera el tamaño máximo del archivo de 1MB.',
    pt: 'Excede o tamanho máximo do arquivo de 1MB.',
  },
  'chargebacks.uploader.commentsTitle': {
    en: 'Input any comments regarding the dispute:',
    es: 'Ingresa cualquier comentario relacionado con la disputa:',
    pt: 'Insira qualquer comentário relacionado à disputa:',
  },
  'chargebacks.uploader.comments': {
    en: 'Comments',
    es: 'Comentarios',
    pt: 'Comentários',
  },
  'chargebacks.uploader.comments.maxCharacters': {
    en: 'Maximum 250 characters',
    es: 'Máximo 250 caracteres',
    pt: 'Máximo 250 caracteres',
  },
  'chargebacks.uploader.disputeDocumentation': {
    en: 'Dispute Documentation',
    es: 'Documentación de la Disputa',
    pt: 'Documentação da Disputa',
  },
  'chargebacks.uploader.disputeDocumentation.desc': {
    en: 'The following documents will be uploaded for dispute.',
    es: 'Los siguientes documentos serán subidos para la disputa.',
    pt: 'Os seguintes documentos serão enviados para a disputa.',
  },
  'chargebacks.uploader.fileToUpload': {
    en: 'File to Upload:',
    es: 'Archivo a Subir:',
    pt: 'Arquivo para Enviar:',
  },
  'chargebacks.uploader.fileToUpload.noDoc': {
    en: 'No document uploaded.',
    es: 'Ningún documento para subir.',
    pt: 'Nenhum documento enviado.',
  },
  'checkout-logs.subheadline': {
    en: 'Find all the tries to pay that your clients have made.',
    es: 'Encuentra los intentos de pago con errores que tus clientes han realizado.',
    pt: 'Encontre os pagamentos que seus clientes tentaram fazer.',
  },
  'checkout-logs.createdDate': {
    en: 'Creation date',
    es: 'Fecha de creación',
    pt: 'Data de criação',
  },
  'checkout-logs.clientEmail': {
    en: 'Client E-mail',
    es: 'E-mail del cliente',
    pt: 'E-mail do cliente',
  },
  'checkout-logs.checkout-type': {
    en: 'Type',
    es: 'Tipo',
    pt: 'Tipo',
  },
  'checkout-logs.clientDocument': {
    en: 'Client Document',
    es: 'Documento',
    pt: 'Documento',
  },
  'checkout-logs.amount': {
    en: 'Amount',
    es: 'Monto',
    pt: 'Valor',
  },
  'checkout-logs.errorType': {
    en: 'Error type',
    es: 'Error',
    pt: 'Erro',
  },
  'checkout-logs.type.RISK_EMAIL': {
    en: 'Risk email',
    es: 'Correo riesgoso',
    pt: 'E-mail de risco',
  },
  'checkout-logs.type.DOCUMENT_INVALID': {
    en: 'Invalid document',
    es: 'Documento inválido',
    pt: 'Documento inválido',
  },
  'checkout-logs.type.RECAPTCHA_FAILED': {
    en: 'Recaptcha failed',
    es: 'Recaptcha fallido',
    pt: 'Recaptcha falhou',
  },
  'checkout-logs.type.REJECTED_BY_BANK': {
    en: 'Rejected by bank',
    es: 'Rechazado por el banco',
    pt: 'Rejeitado pelo banco',
  },
  'checkout-logs.type.INSUFFICIENT_FUNDS': {
    en: 'Insufficient funds',
    es: 'Fondos insuficientes',
    pt: 'Fundos insuficientes',
  },
  'checkout-logs.type.HIGH_RISK_TRANSACTION': {
    en: 'High risk transaction',
    es: 'Transacción de alto riesgo',
    pt: 'Transação de alto risco',
  },
  'checkout-logs.type.AUTHORIZATION_ERROR': {
    en: 'Authorization error',
    es: 'Error de autorización',
    pt: 'Erro de autorização',
  },
  'checkout-logs.type.BLACKLISTED_MERCHANT': {
    en: 'Merchant blacklisted',
    es: 'Comercio en lista negra',
    pt: 'Comerciante na lista negra',
  },
  'checkout-logs.type.GREYLISTED_MERCHANT': {
    en: 'Merchant greylisted',
    es: 'Comercio en lista gris',
    pt: 'Comerciante na lista cinza',
  },
  'checkout-logs.type.MERCHANT_IN_FRAUD_REVIEW': {
    en: 'Merchant in fraud review',
    es: 'Comercio en revisión de fraude',
    pt: 'Comerciante em revisão de fraude',
  },
  'checkout-logs.type.BLACKLISTED_CLIENT_IP': {
    en: 'Client with blacklisted IP',
    es: 'Cliente con IP en lista negra',
    pt: 'Cliente com IP na lista negra',
  },
  'checkout-logs.type.GREYLISTED_CLIENT_IP': {
    en: 'Client with greylisted IP',
    es: 'Cliente con IP en lista gris',
    pt: 'Cliente com IP na lista cinza',
  },
  'checkout-logs.type.AUTHORIZATION_PAYMENT_REJECTED': {
    en: 'Payment authorization rejected',
    es: 'Autorización de pago rechazada',
    pt: 'Autorização de pagamento rejeitada',
  },
  'checkout-logs.type.CARD_BLACKLISTED': {
    en: 'Card blacklisted',
    es: 'Tarjeta en lista negra',
    pt: 'Cartão na lista negra',
  },
  'checkout-logs.type.AUTHORIZATION_SCORE_VALIDATION': {
    en: 'Score validation required',
    es: 'Validación de puntuación requerida',
    pt: 'Validação de pontuação necessária',
  },
  'checkout-logs.type.AUTHORIZATION_TRY_AGAIN_LATER': {
    en: 'Authorization, try again later',
    es: 'Autorización, inténtelo más tarde',
    pt: 'Autorização, tente novamente mais tarde',
  },
  'checkout-logs.type.AUTHORIZATION_CALL_BANK': {
    en: 'Authorization, call bank',
    es: 'Autorización, llame al banco',
    pt: 'Autorização, ligue para o banco',
  },
  'checkout-logs.type.AUTHORIZATION_DUPLICATED': {
    en: 'Duplicated authorization',
    es: 'Autorización duplicada',
    pt: 'Autorização duplicada',
  },
  'checkout-logs.type.CREDIT_CARD_DISABLED': {
    en: 'Credit card disabled',
    es: 'Tarjeta de crédito desactivada',
    pt: 'Cartão de crédito desativado',
  },
  'checkout-logs.type.AUTHORIZATION_EXPIRED_CARD': {
    en: 'Expired card',
    es: 'Tarjeta vencida',
    pt: 'Cartão vencido',
  },
  'checkout-logs.type.CARD_REPORTED_LOST': {
    en: 'Card reported lost',
    es: 'Tarjeta reportada como perdida',
    pt: 'Cartão reportado como perdido',
  },
  'checkout-logs.type.CARD_REQUESTED_BY_THE_BANK': {
    en: 'Card requested by the bank',
    es: 'Tarjeta solicitada por el banco',
    pt: 'Cartão solicitado pelo banco',
  },
  'checkout-logs.type.CARD_RESTRICTED_BY_THE_BANK': {
    en: 'Card restricted by the bank',
    es: 'Tarjeta restringida por el banco',
    pt: 'Cartão restrito pelo banco',
  },
  'checkout-logs.type.AUTHORIZATION_INVALID_CARD': {
    en: 'Invalid card',
    es: 'Tarjeta inválida',
    pt: 'Cartão inválido',
  },
  'checkout-logs.type.AUTHORIZATION_INVALID_CARD_NUMBER': {
    en: 'Invalid card number',
    es: 'Número de tarjeta inválido',
    pt: 'Número de cartão inválido',
  },
  'checkout-logs.type.AUTHORIZATION_INVALID_SECURITY_CODE': {
    en: 'Invalid security code',
    es: 'Código de seguridad inválido',
    pt: 'Código de segurança inválido',
  },
  'checkout-logs.type.UNSUPPORTED_OPERATION': {
    en: 'Unsupported operation',
    es: 'Operación no soportada',
    pt: 'Operação não suportada',
  },
  'checkout-logs.type.AUTHORIZATION_INVALID_TRANSACTION': {
    en: 'Invalid transaction',
    es: 'Transacción inválida',
    pt: 'Transação inválida',
  },
  'checkout-logs.type.AUTHORIZATION_AMOUNT_EXCEEDED': {
    en: 'Authorization amount exceeded',
    es: 'Monto de autorización excedido',
    pt: 'Valor de autorização excedido',
  },
  'checkout-logs.type.AUTHORIZATION_3D_SECURE_REQUIRED': {
    en: '3D Secure required',
    es: 'Se requiere 3D Secure',
    pt: '3D Secure obrigatório',
  },
  'checkout-logs.type.ERROR_IN_ACQUIRER': {
    en: 'Error in acquirer',
    es: 'Error en el adquirente',
    pt: 'Erro no adquirente',
  },
  'checkout-logs.type.INVALID_USER_ACCOUNT': {
    en: 'Invalid user account',
    es: 'Cuenta de usuario inválida',
    pt: 'Conta de usuário inválida',
  },
  'checkout-logs.type.INVALID_PIN': {
    en: 'Invalid PIN',
    es: 'PIN inválido',
    pt: 'PIN inválido',
  },
  'checkout-logs.type.TRANSACTION_FREQUENCY_LIMIT_EXCEEDED': {
    en: 'Transaction frequency limit exceeded',
    es: 'Límite de frecuencia de transacciones excedido',
    pt: 'Limite de frequência de transações excedido',
  },
  'checkout-logs.type.USER_ACCOUNT_DISABLED': {
    en: 'User account disabled',
    es: 'Cuenta de usuario desactivada',
    pt: 'Conta de usuário desativada',
  },
  'checkout-logs.type.ERROR_IN_EXTERNAL_NETWORK': {
    en: 'Error in external network',
    es: 'Error en la red externa',
    pt: 'Erro na rede externa',
  },
  'checkout-logs.type.CARD_NOT_ENROLLED_3DS': {
    en: 'Card not enrolled in 3D Secure',
    es: 'Tarjeta no registrada en 3D Secure',
    pt: 'Cartão não inscrito no 3D Secure',
  },
  'checkout-logs.type.PAYMENT_WAS_EXPIRED': {
    en: 'Payment expired',
    es: 'Pago expirado',
    pt: 'Pagamento expirado',
  },
  'checkout-logs.type.CHALLENGE_3DS_NOT_COMPLETED': {
    en: '3D Secure challenge not completed',
    es: 'Desafío de 3D Secure no completado',
    pt: 'Desafio de 3D Secure não concluído',
  },
  'checkout-logs.type.MAX_TRANSACTION_AMOUNT_EXCEEDED': {
    en: 'The transaction exceeds the maximum amount for credit card payments.',
    es: 'La transacción supera el importe máximo para pagos con tarjeta de crédito.',
    pt: 'A transação excede o valor máximo para pagamentos com cartão de crédito.',
  },
  'checkout-logs.status.review': {
    en: 'Review',
    es: 'Revisar',
    pt: 'Revisão',
  },
  'checkout-logs.details.review.title': {
    en: 'Requires Attention',
    es: 'Requiere Atención',
    pt: 'Requer Atenção',
  },
  'checkout-logs.tooltip.title': {
    en: 'Transaction Details',
    es: 'Detalles de la Transacción',
    pt: 'Detalhes da Transação',
  },
  'checkout-logs.tooltip.status': {
    en: 'Status',
    es: 'Estado',
    pt: 'Status',
  },
  'checkout-logs.tooltip.transaction_id': {
    en: 'Transaction ID',
    es: 'ID Transacción',
    pt: 'ID Transação',
  },
  'checkout-logs.tooltip.document': {
    en: 'Document',
    es: 'Documento',
    pt: 'Documento',
  },
  'checkout-logs.tooltip.email': {
    en: 'Email',
    es: 'Correo',
    pt: 'E-mail',
  },
  'checkout-logs.tooltip.help': {
    en: 'What to do in this case?',
    es: '¿Qué hacer en este caso?',
    pt: 'O que fazer neste caso?',
  },
  'home.welcome.title': {
    en: 'Hi, {0}',
    es: 'Hola, {0}',
    pt: 'Oi, {0}',
  },
  'home.quickActions.title': {
    en: 'What would you like to do?',
    es: '¿Qué querés hacer hoy?',
    pt: 'O que você gostaria de fazer?',
  },
  'home.quickActions.desc': {
    en: 'Quick access to your most common actions.',
    es: 'Accedé rápido a tus acciones más habituales.',
    pt: 'Acesso rápido às suas ações mais comuns.',
  },
  'home.onboarding.title': {
    en: 'Setting up your account is now faster',
    es: 'Configurar tu cuenta ahora es más rápido',
    pt: 'Configurar sua conta agora é mais rápido',
  },
  'home.onboarding.desc': {
    en: 'We simplified the data request in just ',
    es: 'Simplificamos la solicitud de datos en solo ',
    pt: 'Simplificamos o pedido de dados em apenas ',
  },
  'home.onboarding.link': {
    en: '2 steps',
    es: '2 pasos',
    pt: '2 passos',
  },
  'home.onboarding.desc2': {
    en: ' so you can start selling as soon as possible.',
    es: ' para que empieces a vender cuanto antes.',
    pt: ' para que você possa começar a vender o mais rápido possível.',
  },
  'home.reminder.title': {
    en: 'Make the most of dLocal Go.',
    es: 'Aprovecha al máximo dLocal Go.',
    pt: 'Faça o máximo com dLocal Go.',
  },
  'home.reminder.link': {
    en: 'Complete step 2',
    es: 'Completa el paso 2',
    pt: 'Complete o passo 2',
  },
  'home.reminder.desc': {
    en: ' of your account setup to <b>process payments without limits</b> and <b>withdraw money from your account</b> whenever you want.',
    es: ' de la configuración de tu cuenta para <b>procesar pagos sin límite</b> y <b>retirar el dinero de tu cuenta</b> cuando quieras.',
    pt: ' da configuração da sua conta para <b>processar pagamentos sem limites</b> e <b>retirar dinheiro da sua conta</b> sempre que quiser.',
  },
  'home.pendingKyc2.title': {
    en: 'We have received your documentation.',
    es: 'Hemos recibido tu documentación.',
    pt: 'Recebemos sua documentação.',
  },
  'home.pendingKyc2.desc': {
    en: 'We are reviewing your documentation and will notify you as soon as it is processed.',
    es: 'Estamos revisando tu documentación y te notificaremos tan pronto como sea procesada.',
    pt: 'Estamos revisando sua documentação e te notificaremos assim que for processada.',
  },
  'home.migration.reminder.title': {
    en: 'Update your documents and keep using the full potential of dLocal Go.',
    es: 'Actualiza tus documentos y continúa utilizando todo el potencial de dLocal Go.',
    pt: 'Atualize seus documentos e continue aproveitando todo o potencial do dLocal Go.',
  },
  'home.migration.reminder.deadline': {
    en: '<span class="text-dgo-boldest">You have time until November 8th</span><br />We extended the deadline',
    es: '<span class="text-dgo-boldest">Tienes tiempo hasta el 8 de noviembre</span><br />Extendimos el plazo',
    pt: '<span class="text-dgo-boldest">Você tem tempo até 8 de novembro</span><br />Estendemos o prazo',
  },
  'home.migration.reminder.tooltip': {
    en: 'Update your documentation to keep your account operating without interruptions.',
    es: 'Actualiza tu documentación para mantener tu cuenta operativa sin interrupciones.',
    pt: 'Atualize sua documentação para manter sua conta operando sem interrupções.',
  },
  'home.migration.reminder.card.title': {
    en: 'Update your step 2 documents',
    es: 'Actualiza tus documentos del paso 2',
    pt: 'Atualize seus documentos do passo 2',
  },
  'home.migration.reminder.card.desc': {
    en: 'Upload your current documentation to keep processing payments without friction.',
    es: 'Sube tu documentación vigente para seguir procesando pagos sin fricciones.',
    pt: 'Envie sua documentação vigente para continuar processando pagamentos sem fricções.',
  },
  'home.migration.reminder.button': {
    en: 'Update now',
    es: 'Actualizar ahora',
    pt: 'Atualizar agora',
  },
  'companyInformation.migration.step2.title': {
    en: 'Update your step 2 documentation',
    es: 'Actualiza tu documentación del paso 2',
    pt: 'Atualize sua documentação do passo 2',
  },
  'companyInformation.migration.step2.desc': {
    en: 'Upload your current documentation to keep your account operating without interruptions.',
    es: 'Sube tu documentación vigente para mantener tu cuenta operativa sin interrupciones.',
    pt: 'Envie sua documentação vigente para manter sua conta operando sem interrupções.',
  },
  'home.reminder.limit.title': {
    en: 'You are reaching your billing limit',
    es: 'Estás llegando a tu límite de facturación',
    pt: 'Você está chegando ao seu limite de faturamento',
  },
  'home.reminder.limit.desc': {
    en: 'To be able to bill without limit and withdraw the money from your sales, you must ',
    es: 'Para poder facturar sin límite y retirar el dinero de tus ventas, debes ',
    pt: 'Para poder faturar sem limite e retirar o dinheiro das suas vendas, você deve ',
  },
  'home.reminder.limit.link': {
    es: 'completar el paso 2',
    en: 'complete step 2',
    pt: 'completar o passo 2',
  },
  'home.reminder.limit.desc2': {
    es: ' de la configuración de tu cuenta.',
    en: ' of your account setup.',
    pt: ' da configuração da sua conta.',
  },
  'home.product.payment.link': {
    en: 'Payment link',
    es: 'Link de pago',
    pt: 'Link de pagamento',
  },
  'home.product.payment.first-steps': {
    en: 'Getting started with dLocal Go',
    es: 'Primeros pasos en dLocal Go',
    pt: 'Primeiros passos com dLocal Go',
  },
  'home.product.payment.link.desc': {
    en: 'The simplest way to start getting paid. Create a payment link in 1 minute and share it with your clients.',
    es: 'La forma más simple de empezar a cobrar. Crea un link de pago en 1 minuto y compártelo con tus clientes.',
    pt: 'A maneira mais simples de começar a receber pagamentos. Crie um link de pagamento em 1 minuto e compartilhe com seus clientes.',
  },

  'home.product.payment.first-steps.desc': {
    en: 'Check out our getting started guide to make using dLocal Go a breeze.',
    es: 'Visita nuestra guía de primeros pasos para que empezar a usar dLocal Go sea simple.',
    pt: 'Confira nosso guia de introdução para facilitar o uso do dLocal Go.',
  },
  'home.product.payment.link.link': {
    en: 'Create payment link',
    es: 'Crear link de pago',
    pt: 'Criar link de pagamento',
  },
  'home.product.payment.commissions': {
    en: 'Pay per use',
    es: 'Pago por uso',
    pt: 'Pague por uso',
  },
  'home.product.payment.commissions.desc': {
    en: 'Learn about the payment methods available in each country and the transaction fee.',
    es: 'Conoce los métodos de pago disponibles en cada país y la comisión por transacciones.',
    pt: 'Conheça os métodos de pagamento disponíveis em cada país e a taxa de transação.',
  },
  'home.product.payment.commissions.link': {
    en: 'Check payment methods',
    es: 'Ver métodos de pago',
    pt: 'Veja formas de pagamento',
  },
  'home.product.payment.first-steps.link': {
    en: 'Start today',
    es: 'Empezar hoy',
    pt: 'Começa hoje',
  },
  'home.product.link': {
    es: 'Conoce los productos',
    en: 'Know our products',
    pt: 'Conheça nossos produtos',
  },
  'home.product.desc': {
    es: 'Ofrece métodos de pago locales y deja de perder ventas',
    en: 'Offer local payment methods and stop losing sales',
    pt: 'Ofereça métodos de pagamento locais e pare de perder vendas',
  },
  'home.balances.title': {
    en: 'Balances',
    es: 'Balances',
    pt: 'Saldos',
  },
  'home.balances.subtitle': {
    en: 'Track your latest sales and compare the most important indicators.',
    es: 'Realiza un seguimiento de tus últimas ventas y compara los indicadores más importantes.',
    pt: 'Acompanhe suas últimas vendas e compare os indicadores mais importantes.',
  },
  'home.balance.availableBalance': {
    en: 'Available balance',
    es: 'Saldo disponible',
    pt: 'Saldo disponível',
  },
  'balance.availableBalance.desc': {
    en: 'Available amount to transfer to your bank account.',
    es: 'Cantidad disponible para transferir a tu cuenta bancaria.',
    pt: 'Montante disponível para transferência para sua conta bancária.',
  },
  'home.balance.inTransitBalance': {
    en: 'In transit',
    es: 'En tránsito',
    pt: 'Em trânsito',
  },
  'balance.inTransitBalance.desc': {
    en: 'Sum of all completed transactions that have not yet cleared the settlement period.',
    es: 'Suma de todas las transacciones completadas que aún no han cumplido el período de liquidación.',
    pt: 'Soma de todas as transações concluídas que ainda não completaram o período de liquidação.',
  },
  'home.balance.currentBalance': {
    en: 'Current balance',
    es: 'Saldo actual',
    pt: 'Saldo atual',
  },
  'balance.currentBalance.desc': {
    en: 'Sum of available and in transit balances.',
    es: 'Suma de saldos disponibles y en tránsito.',
    pt: 'Soma dos saldos disponíveis e em trânsito.',
  },
  'home.balance.totalAccumulated': {
    en: 'Total accumulated',
    es: 'Total acumulado',
    pt: 'Total acumulado',
  },
  'balance.totalAccumulated.desc': {
    en: 'All-time accumulated total from all completed transactions minus all pending and completed settlements.',
    es: 'Total acumulado de todas las transacciones completadas menos todas las liquidaciones pendientes y completadas.',
    pt: 'Total acumulado de todas as transações concluídas menos todas as liquidações pendentes e concluídas.',
  },
  'home.balance.lastUpdate': {
    en: 'Last update:',
    es: 'Última actualización:',
    pt: 'Última atualização:',
  },
  'home.balance.withdrawing': {
    en: 'Withdrawing',
    es: 'Retirando',
    pt: 'Retirando',
  },
  'balance.withdrawing.desc': {
    en: 'Amount currently being withdrawn.',
    es: 'Monto que se está retirando actualmente.',
    pt: 'Valor que está sendo retirado no momento.',
  },
  'home.balances.credits': {
    en: 'Credits',
    es: 'Créditos',
    pt: 'Créditos',
  },
  'home.balances.downloadBalance': {
    en: 'BALANCE DETAILS',
    es: 'DETALLES DEL BALANCE',
    pt: 'DETALHES DO SALDO',
  },
  'home.balances.hide': {
    en: 'Hide balance',
    es: 'Ocultar balance',
    pt: 'Ocultar saldo',
  },
  'home.balances.show': {
    en: 'Show balance',
    es: 'Mostrar balance',
    pt: 'Mostrar saldo',
  },
  'balance.credits.desc': {
    en: 'Credits are benefits that you can use to pay platform fees. You earn credits by referring new users or completing challenges within dLocal Go.',
    es: 'Los <strong>créditos</strong> son beneficios que podés usar para pagar comisiones de la plataforma. Ganás créditos al referir nuevos usuarios o al completar desafíos dentro de dLocal Go.',
    pt: 'Os créditos são benefícios que você pode usar para pagar as taxas da plataforma. Você ganha créditos ao indicar novos usuários ou ao completar desafios dentro do dLocal Go.',
  },
  'balance.credits.link.text': {
    en: 'Learn more',
    es: 'Conocer más',
    pt: 'Saiba mais',
  },
  'balance.credits.button': {
    en: 'Invite and win',
    es: 'Invita y gana',
    pt: 'Convide e ganhe',
  },
  'home.readyMsg.subtitle': {
    en: 'Grow your business with dLocal Go',
    es: 'Hacé crecer tu negocio con dLocal Go',
    pt: 'Expanda seus negócios com dLocal Go',
  },
  'home.readyMsg.firstTime': {
    en: 'You are just <span class="text-dgo-primary text-dgo-boldest">one step</span> away from using the full potential of dLocal Go.',
    es: 'Te falta <span class="text-dgo-primary text-dgo-boldest">solo un paso</span> para utilizar todo el potencial de dLocal Go.',
    pt: 'Você está a apenas <span class="text-dgo-primary text-dgo-boldest">um passo</span> de usar todo o potencial do dLocal Go.',
  },
  'home.readyMsg.review-docs': {
    en: '<span class="text-dgo-primary text-dgo-boldest">We are almost ready:</span> review your documentation to enable your account.',
    es: '<span class="text-dgo-primary text-dgo-boldest">Estamos casi listos:</span> revisá tu documentación para habilitar tu cuenta.',
    pt: '<span class="text-dgo-primary text-dgo-boldest">Estamos quase prontos:</span> revise seus documentos para habilitar sua conta.',
  },
  'home.readyMsg.countries.title': {
    en: 'Countries and payment methods available',
    es: 'Países y medios de pago disponibles',
    pt: 'Países e métodos de pagamento disponíveis',
  },
  'home.complete-profile.kyc1.desc': {
    en: 'Complete your profile to be able to accept payments',
    es: 'Completa tu perfil para poder empezar a cobrar',
    pt: 'Complete seu perfil para começar a receber pagamentos',
  },
  'home.complete-profile.kyc2.desc': {
    en: 'Complete your profile to improve your experience',
    es: 'Completa tu perfil para mejorar tu experiencia',
    pt: 'Complete seu perfil para melhorar sua experiência',
  },
  'home.readyMsg.countries.foot.part1': {
    en: 'If you wish, ',
    es: 'Si lo deseas, ',
    pt: 'Se o desejas, ',
  },
  'home.readyMsg.countries.foot.link': {
    en: 'you can disable',
    es: 'puedes desactivar',
    pt: 'você pode desativar',
  },
  'home.readyMsg.countries.foot.part2': {
    en: ' a country or form of payment.',
    es: ' un país o forma de pago.',
    pt: ' um país ou forma de pagamento.',
  },
  'home.readyMsg.paso2.title': {
    en: 'Process payments up to USD {0}.',
    es: 'Procesa pagos hasta USD {0}.',
    pt: 'Processar pagamentos até USD {0}.',
  },
  'home.readyMsg.paso2.link': {
    en: 'Complete step 2',
    es: 'Completa el paso 2',
    pt: 'Complete o passo 2',
  },
  'home.readyMsg.paso2.desc': {
    en: ' to process payments without limit and withdraw the money from your sales.',
    es: ' para procesar pagos sin límite y retirar el dinero de tus ventas.',
    pt: ' para processar pagamentos sem limite e retirar o dinheiro das suas vendas.',
  },
  'home.readyMsg.reviewDocs.title': {
    en: 'Review your documents',
    es: 'Revisá tu documentación',
    pt: 'Revise seus documentos',
  },
  'home.readyMsg.reviewDocs.desc': {
    en: 'We noticed a detail in your documents that needs to be corrected. Please update them to complete the process and continue operating normally.',
    es: 'Notamos un detalle en tus documentos que debe corregirse. Actualízalos para completar el proceso y seguir operando con normalidad.',
    pt: 'Notamos um detalhe em seus documentos que precisa ser corrigido. Atualize-os para concluir o processo e continuar operando normalmente.',
  },
  'home.readyMsg.step2.tooltip.title': {
    en: 'Your current benefits',
    es: 'Tus beneficios actuales',
    pt: 'Seus benefícios atuais',
  },
  'home.readyMsg.step2.tooltip.item1': {
    en: 'Process payments up to USD 3000.',
    es: 'Procesa pagos hasta USD 3000.',
    pt: 'Processe pagamentos de até US$ 3.000.',
  },
  'home.readyMsg.step2.tooltip.item2': {
    en: 'Countries and payment methods available.',
    es: 'Países y medios de pago disponibles.',
    pt: 'Países e métodos de pagamento disponíveis.',
  },
  'home.readyMsg.step2.tooltip.desc1': {
    en: 'You can now sell in the region you want, with all the payment methods your clients use. If you wish, ',
    es: 'Ya puedes vender en la región que quieras, con todos los métodos de pago que usan tus clientes. Si lo deseas, ',
    pt: 'Agora você pode vender na região que desejar, com todos os métodos de pagamento que seus clientes utilizam. Se o desejas, ',
  },
  'home.readyMsg.step2.tooltip.disable': {
    en: 'you can disable',
    es: 'puedes desactivar',
    pt: 'você pode desativar',
  },
  'home.readyMsg.step2.tooltip.desc2': {
    en: ' a country or payment method.',
    es: ' un país o forma de pago.',
    pt: ' um país ou método de pagamento.',
  },
  'home.readyMsg.step2.complete-now': {
    en: 'Complete now',
    es: 'Completar Ahora',
    pt: 'Conclua agora',
  },
  'home.readyMsg.step2.review-docs': {
    en: 'Review and replace',
    es: 'Revisar y reemplazar',
    pt: 'Revisar e substituir',
  },
  'balances.noData': {
    en: 'There is no information to display.',
    es: 'No hay información para mostrar.',
    pt: 'Não há informações a serem exibidas.',
  },
  'emailValidation.description.message': {
    en: 'By clicking on the button below, we will send a confirmation email to <b>{0}</b>.',
    es: 'Haciendo clic en el siguiente botón, enviarémos un correo de confirmación a <b>{0}</b>.',
    pt: 'Ao clicar no botão abaixo, enviaremos um e-mail de confirmação para <b>{0}</b>.',
  },
  'emailValidation.send.btn': {
    en: 'Send email',
    es: 'Enviar correo electrónico',
    pt: 'Enviar e-mail',
  },
  'emailValidation.resend.btn': {
    en: 'Resend email',
    es: 'Reenviar correo electrónico',
    pt: 'Reenviar e-mail',
  },
  'emailValidation.success.title': {
    en: 'Email sent!',
    es: '¡Correo enviado!',
    pt: 'E-mail enviado!',
  },
  'emailValidation.success.message': {
    en: 'A confirmation email has been sent to <b>{0}</b>.',
    es: 'Un correo de confirmación ha sido enviado a <b>{0}</b>.',
    pt: 'Um e-mail de confirmação foi enviado para <b>{0}</b>.',
  },
  'emailValidation.success.resend.message': {
    en: 'Another confirmation email has been sent to <b>{0}</b>.',
    es: 'Otro correo de confirmación ha sido enviado a <b>{0}</b>.',
    pt: 'Outro e-mail de confirmação foi enviado para <b>{0}</b>.',
  },
  'msgError.emailValidation.invalidEmail': {
    en: 'There is no user with this email',
    es: 'No existe usuario con este email',
    pt: 'Não há usuário com esse e-mail',
  },
  'msgError.emailValidation.tokenExpired': {
    en: 'Token expired.',
    es: 'Token expirado.',
    pt: 'Token expirado.',
  },
  'settlements.details': {
    en: 'Settlement detail',
    es: 'Detalle de retiros',
    pt: 'Detalhe de retiros',
  },
  'settlements.status.PENDING': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'settlements.status.COMPLETED': {
    en: 'Completed',
    es: 'Completada',
    pt: 'Concluído',
  },
  'settlements.status.CANCELLED': {
    en: 'Cancelled',
    es: 'Cancelada',
    pt: 'Cancelada',
  },
  'settlements.status.FAILED': {
    en: 'Failed',
    es: 'Fallido',
    pt: 'Falhou',
  },
  'settlements.status.DELIVERED': {
    en: 'Delivered',
    es: 'Entregado',
    pt: 'Entregue',
  },
  'settlements.status.REJECTED': {
    en: 'Rejected',
    es: 'Rechazado',
    pt: 'Rejeitado',
  },
  'settlements.goto.bankAccounts.desc1': {
    en: 'If you want to add a new account, go to the',
    es: 'Si quieres agregar una nueva cuenta, dirígete a la sección',
    pt: 'Se você deseja adicionar uma nova conta, vá para a seção',
  },
  'settlements.goto.bankAccounts.link': {
    en: 'My bank accounts',
    es: 'Mis cuentas bancarias',
    pt: 'Minhas contas bancárias',
  },
  'settlements.goto.bankAccounts.desc2': {
    en: 'section.',
    es: '.',
    pt: '.',
  },
  'accountType.CHECKING': {
    en: 'Checking account',
    es: 'Cuenta corriente',
    pt: 'Conta corrente',
  },
  'accountType.SAVING': {
    en: 'Savings account',
    es: 'Cuenta de ahorro',
    pt: 'Conta poupança',
  },
  'accountType.SALARY': {
    en: 'Salary account',
    es: 'Cuenta de salario',
    pt: 'Conta salário',
  },
  'accountType.VISTA': {
    en: 'Vista',
    es: 'Vista',
    pt: 'Vista',
  },
  'accountType.MASTER': {
    en: 'Master',
    es: 'Master',
    pt: 'Master',
  },
  'settlements.button': {
    en: 'CREATE SETTLEMENT',
    es: 'CREAR RETIRO',
    pt: 'RETIRAR FUNDOS',
  },
  'settlements.noSettlements': {
    en: 'You have no settlements yet',
    es: 'No tienes ninguna liquidación aún',
    pt: 'Você ainda não tem liquidações',
  },
  'settlements.noSettlements.desc': {
    en: 'Before you can request settlements, we need to know more about you and your company. To complete the required information click',
    es: 'Antes de que puedas solicitar liquidaciones, necesitamos saber más sobre ti y tu negocio. Para completar la información requerida haz clic',
    pt: 'Antes que você possa solicitar liquidações, precisamos saber mais sobre você e sua empresa. Para preencher as informações necessárias clique',
  },
  'settlements.noSettlements.kycReviewDesc': {
    en: 'Before you can request settlements, we need to review the information submitted. For more information, click here',
    es: 'Antes de que puedes solicitar liquidaciones, necesitamos revisar la información enviada. Para más información haz clic',
    pt: 'Antes que você possa solicitar liquidações, precisamos revisar as informações enviadas. Para mais informações, clique',
  },
  'settlements.noSettlements.here': {
    en: 'here.',
    es: 'aquí.',
    pt: 'aqui.',
  },
  'settlements.creationDate': {
    en: 'Creation date',
    es: 'Fecha de creación',
    pt: 'Data de criação',
  },
  'settlements.date': {
    en: 'Date',
    es: 'Fecha',
    pt: 'Data',
  },
  'settlements.time': {
    en: 'Time',
    es: 'Hora',
    pt: 'Hora',
  },
  'settlements.id': {
    en: 'ID',
    es: 'ID',
    pt: 'ID',
  },
  'settlements.amountRequested': {
    en: 'Amount requested',
    es: 'Monto solicitado',
    pt: 'Quantidade solicitada',
  },
  'settlements.fee': {
    en: 'Fee',
    es: 'Tarifa',
    pt: 'Taxa',
  },
  'settlements.bank': {
    en: 'Bank',
    es: 'Banco',
    pt: 'Banco',
  },
  'settlements.paymentDate': {
    en: 'Payment date',
    es: 'Fecha de pago',
    pt: 'Data de pagamento',
  },
  'settlements.status': {
    en: 'Status',
    es: 'Estado',
    pt: 'Estado',
  },
  'settlements.filter.status': {
    en: 'Select state',
    es: 'Seleccione estado',
    pt: 'Selecione o estado',
  },
  'requestSettlement.title': {
    en: 'Request settlement',
    es: 'Solicitar liquidación',
    pt: 'Solicitar liquidação',
  },
  'requestSettlement.success': {
    en: 'Settlement request created successfully!',
    es: '¡Solicitud de liquidación creada con éxito!',
    pt: 'Solicitação de liquidação criada com sucesso!',
  },
  'requestSettlement.desc': {
    en: 'The minimum amount to request a settlement without additional charges is USD {0}, if you request a lower amount a charge of USD {1} or the equivalent in your functional currency will be charged.',
    es: 'El monto mínimo para solicitar una liquidación sin cargos adicionales es de USD {0}, si solicita un monto menor se cobrará un cargo de USD {1} o el equivalente en su moneda operativa.',
    pt: 'O valor mínimo para solicitar uma liquidação sem encargos adicionais é de USD {0}, se você solicitar um valor inferior, será cobrada uma taxa de USD {1} ou o equivalente em sua moeda operacional.',
  },
  'beneficiary.isRequired': {
    en: 'You must select a beneficiary.',
    es: 'Debe seleccionar un beneficiario.',
    pt: 'Você deve selecionar um beneficiário.',
  },
  'requestSettlement.sendRequest': {
    en: 'Send request',
    es: 'Enviar petición',
    pt: 'Enviar pedido',
  },
  'requestSettlement.amount': {
    en: 'Amount',
    es: 'Monto',
    pt: 'Valor',
  },
  'requestSettlement.amount.noAvailable': {
    en: 'You have no available balance.',
    es: 'No tienes saldo disponible.',
    pt: 'Você não tem saldo disponível.',
  },
  'requestSettlement.amount.exceedsAvailable': {
    en: 'The amount cannot exceed the available balance.',
    es: 'El monto no puede exceder el saldo disponible.',
    pt: 'O valor não pode exceder o saldo disponível.',
  },
  'requestSettlement.withdrawalsDisabled': {
    en: 'Withdrawals are disabled for this account.',
    es: 'Los retiros están deshabilitados para esta cuenta.',
    pt: 'As retiradas estão desativadas para esta conta.',
  },
  'requestSettlement.confirmMessage': {
    en: 'Since the request amount is less than USD {0}, a charge of <b>USD {1}</b> or the equivalent in your operating currency will be charged.',
    es: 'Dado que el monto de la solicitud es inferior a USD {0}, se cobrará un cargo de <b>USD {1}</b> o el equivalente en su moneda operativa.',
    pt: 'Como o valor da solicitação é inferior a USD {0}, será cobrada uma taxa de <b>USD {1}</b> ou o equivalente em sua moeda operacional.',
  },
  'msgError.settlementInProcess': {
    en: 'You already have a settlement request in process.',
    es: 'Ya tiene una solicitud de liquidación en proceso.',
    pt: 'Você já tem uma solicitação de liquidação em andamento.',
  },
  'msgError.amountExceedsBalance': {
    en: 'The indicated amount exceeds the available balance.',
    es: 'El monto indicado supera el balance disponible',
    pt: 'O valor indicado excede o saldo disponível',
  },
  'msgError.paymentProcessorError': {
    en: 'Could not generate settlement request in payment processor.',
    es: 'No se pudo generar la solicitud de liquidación en el procesador de pagos.',
    pt: 'Não foi possível gerar a solicitação de liquidação no processador de pagamentos.',
  },
  'selectBeneficiary.withoutData.title': {
    en: 'Please, enter a bank account.',
    es: 'Por favor, ingrese una cuenta bancaria.',
    pt: 'Por favor, insira uma conta bancária.',
  },
  'selectBeneficiary.titleWithData': {
    en: 'Select an existing bank account or enter a new one.',
    es: 'Seleccione una cuenta bancaria existente o ingresa una nueva.',
    pt: 'Selecione uma conta bancária existente ou insira uma nova.',
  },
  'selectBeneficiary.title': {
    en: 'Existing bank accounts',
    es: 'Cuentas bancarias existentes',
    pt: 'Contas bancárias existentes',
  },
  'beneficiary.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'beneficiary.name': {
    en: 'Legal entity name',
    es: 'Nombre legal del negocio',
    pt: 'Razão social',
  },
  'beneficiary.documentType': {
    en: 'Document type',
    es: 'Tipo de documento',
    pt: 'Tipo de documento',
  },
  'beneficiary.document': {
    en: 'Document',
    es: 'Documento',
    pt: 'Documento',
  },
  'beneficiary.phone': {
    en: 'Phone',
    es: 'Teléfono',
    pt: 'Telefone',
  },
  'beneficiary.address': {
    en: 'Address',
    es: 'Dirección',
    pt: 'Endereço',
  },
  'beneficiary.address.tooltip': {
    en: 'Address from where you registered your bank account.',
    es: 'Dirección desde donde registraste tu cuenta bancaria.',
    pt: 'Endereço de onde você registrou sua conta bancária.',
  },
  'beneficiary.city': {
    en: 'City',
    es: 'Ciudad',
    pt: 'Cidade',
  },
  'beneficiary.bankAccountLabel': {
    en: 'Bank account',
    es: 'Cuenta bancaria',
    pt: 'Conta  bancária',
  },
  'beneficiary.accountType': {
    en: 'Account type',
    es: 'Tipo de cuenta',
    pt: 'Tipo de conta',
  },
  'beneficiary.bankCode': {
    en: 'Bank',
    es: 'Banco',
    pt: 'Banco',
  },
  'beneficiary.bankAccount': {
    en: 'Bank account number',
    es: 'Número de cuenta bancaria',
    pt: 'Numero de conta bancária',
  },
  'beneficiary.confirmBankAccount': {
    en: 'Confirm bank account number',
    es: 'Confirmar número de cuenta bancaria',
    pt: 'Confirmar numero de conta bancária',
  },
  'beneficiary.notMatchBankAccount': {
    en: 'Bank account number entered do not match.',
    es: 'Número de cuenta bancaria ingresada no coincide.',
    pt: 'Numero de conta bancária inserida não corresponde.',
  },
  'beneficiary.branch': {
    en: 'Branch',
    es: 'Sucursal',
    pt: 'Agência',
  },
  'beneficiary.swiftCode': {
    en: 'SWIFT/BIC Code',
    es: 'Código SWIFT/BIC',
    pt: 'Código SWIFT/BIC',
  },
  'beneficiary.routingNumber': {
    en: 'Routing number',
    es: 'Routing number',
    pt: 'Routing number',
  },
  'beneficiary.confirmIBAN': {
    en: 'Confirm IBAN',
    es: 'Confirmar IBAN',
    pt: 'Confirmar IBAN',
  },
  'beneficiary.confirmAccount': {
    en: 'Confirm {0}',
    es: 'Confirmar {0}',
    pt: 'Confirmar {0}',
  },
  'beneficiary.notMatchIBAN': {
    en: 'IBAN entered do not match.',
    es: 'IBAN ingresados no coinciden.',
    pt: 'IBAN inseridas não correspondem.',
  },
  'beneficiary.noteRequiredfields': {
    en: '(*) Required fields.',
    es: '(*) Campos obligatórios.',
    pt: '(*) Campos obrigatórios.',
  },
  'msgError.addBeneficiary.invalidData': {
    en: 'The data entered contains errors, please check them.',
    es: 'Los datos ingresados ​​contienen errores, por favor verifíquelos.',
    pt: 'Os dados inseridos contêm erros, verifique-os.',
  },
  'msgError.addBeneficiary.document': {
    en: 'The document entered is incorrect.',
    es: 'El documento ingresado es incorrecto.',
    pt: 'O documento digitado está incorreto.',
  },
  'msgError.addBeneficiary.countryIndicated': {
    en: 'The selected country is invalid.',
    es: 'El país seleccionado es inválido.',
    pt: 'O país selecionado é inválido.',
  },
  'msgError.addBeneficiary.bankAccountNumber': {
    en: 'The bank account number entered is invalid.',
    es: 'El número de cuenta bancaria ingresado es inválido.',
    pt: 'O número da conta bancária inserido é inválido.',
  },
  'msgError.addBeneficiary.bankAccountBranch': {
    en: 'The entered branch is invalid.',
    es: 'La sucursal ingresada es inválida.',
    pt: 'A filial inserida é inválida.',
  },
  'msgError.addBeneficiary.bankAccountType': {
    en: 'The type of bank account entered is invalid.',
    es: 'El tipo de cuenta bancaria ingresado es inválido.',
    pt: 'O tipo de conta bancária inserido é inválido.',
  },
  'msgError.addBeneficiary.alreadyExists.headline': {
    en: 'There is a bank account already registered with this number.',
    es: 'Ya existe una cuenta bancaria registrada con este número.',
    pt: 'Já existe uma conta bancária cadastrada com este número.',
  },
  'msgError.addBeneficiary.alreadyExists.subheadline': {
    en: 'Delete the existing account and create a new one.',
    es: 'Elimina esta cuenta y crea una nueva.',
    pt: 'Exclua a conta existente e crie uma nova.',
  },
  'paymentLink.backBtn': {
    en: 'Back to payment links',
    es: 'Volver a links de pago',
    pt: 'Voltar para links de pagamento',
  },
  'paymentLink.title': {
    en: 'Payment link',
    es: 'Link de pago',
    pt: 'Link de pagamento',
  },
  'paymentLink.subtitle': {
    en: 'Create a new payment link',
    es: 'Crear un nuevo link de pago',
    pt: 'Criar um novo link de pagamento',
  },
  'paymentLink.list.subheadline': {
    en: 'Create and share payment links to collect in local currency.',
    es: 'Crea y comparte enlaces de pago para cobrar en moneda local.',
    pt: 'Crie e compartilhe links de pagamento para cobrar em moeda local.',
  },
  'paymentLink.recurring.subtitle': {
    en: 'Create a new recurring payment link',
    es: 'Crear un nuevo link de pago recurrente',
    pt: 'Criar um novo link de pagamento recorrente',
  },
  'paymentLink.noteRequiredfields': {
    en: '(*) Required fields.',
    es: '(*) Campos obligatórios.',
    pt: '(*) Campos obrigatórios.',
  },
  'paymentLink.noteDesc': {
    en: 'NOTE: If you check <b>Send Mail</b>, an email with the created payment link will automatically be sent to your client.',
    es: 'NOTA: Si marca <b>Enviar correo electrónico</b>, se enviará automáticamente a su cliente un correo electrónico con el link de pago creado.',
    pt: 'NOTA: Se você marcar <b>Enviar e-mail</b>, um e-mail com o link de pagamento criado será automaticamente enviado ao seu cliente.',
  },
  'paymentLink.sendEmailError': {
    en: 'The selected client does not have an associated email.',
    es: 'El cliente seleccionado no tiene un email asociado.',
    pt: 'O cliente selecionado não possui um e-mail associado.',
  },
  'paymentLink.existingClientError': {
    en: 'Please select a client.',
    es: 'Por favor, seleccione un cliente.',
    pt: 'Por favor, selecione um cliente.',
  },
  'paymentLink.existingClients.noClients': {
    en: 'You have no clients yet. Add them in the "New client" tab.',
    es: 'No tienes clientes aún. Agrégalos en la pestaña "Nuevo cliente".',
    pt: 'Você ainda não tem clientes. Adicione-os na guia "Novo cliente".',
  },
  'paymentLink.existingClients.noClientsCountry': {
    en: 'You don\'t have clients in the selected country yet. Add them in the "New client" tab.',
    es: 'Aún no tienes clientes en el país seleccionado. Agrégalos en la pestaña "Nuevo cliente".',
    pt: 'Você ainda não tem clientes no país selecionado. Adicione-os na guia "Novo cliente".',
  },
  'paymentLink.exceedsMaxTransactionAmountCc': {
    en: 'The amount you deposited exceeds the maximum of USD {0} that you are allowed in your account settings. To process unlimited payments, ',
    es: 'El monto que ingresaste supera el máximo de USD {0} que tienes permitido en la configuración de tu cuenta. Para procesar pagos sin límites, ',
    pt: 'O valor inserido excede o máximo de USD {0} permitido no nível atual da sua conta. Para processar pagamentos ilimitados, ',
  },
  'paymentLink.exceedsMaxTransactionAmountCc.here': {
    en: 'complete step 2 account settings.',
    es: 'completa el paso 2 de configuración.',
    pt: 'conclua o passo 2 da configuração de conta.',
  },
  'paymentLink.country': {
    en: "Buyer's country",
    es: 'País del comprador',
    pt: 'País do comprador',
  },
  'paymentLink.country.tooltip': {
    en: 'Country from where your customer will pay for the payment link.',
    es: 'País desde donde tu cliente pagará el link de pago.',
    pt: 'País de onde seu cliente pagará pelo link de pagamento.',
  },
  'paymentLink.country.error': {
    en: 'You have no payment methods configured for this country.',
    es: 'No tienes ningún método de pago configurado para este país.',
    pt: 'Você não tem métodos de pagamento configurados para este país.',
  },
  'paymentLink.currency': {
    en: 'Currency',
    es: 'Moneda',
    pt: 'Moeda',
  },
  'paymentLink.currency.tooltip': {
    en: 'Remember that your client will always pay in their local currency.',
    es: 'Recuerda que tu cliente siempre pagará en su moneda local.',
    pt: 'Lembre-se de que seu cliente sempre pagará na moeda local.',
  },
  'paymentLink.amount': {
    en: 'Amount',
    es: 'Total',
    pt: 'Total',
  },
  'currencySelector.title': {
    en: 'Currency to fix transaction',
    es: 'Moneda para fijar la transacción',
    pt: 'Moeda para corrigir a transação',
  },
  'currencySelector.tooltip': {
    en: 'Your client will pay in {0}.<br/>You will receive {1}.',
    es: 'Tu cliente pagará en {0}.<br/>Tu recibirás {1}.',
    pt: 'Seu cliente pagará em {0}.<br/>Você receberá {1}.',
  },
  'paymentLink.tooltip.sameCurrency': {
    en: 'Take in account that international transactions are fixed in USD. You will receive {0}.',
    es: 'Ten en cuenta que las transacciones internacionales son fijadas en USD. Tu recibirás {0}.',
    pt: 'Tenha em conta que as transacções internacionais são fixadas em USD. Você receberá {0}.',
  },
  'paymentLink.amountWantToCharge': {
    en: 'You want to charge',
    es: 'Tú quieres cobrar',
    pt: 'Você quer cobrar',
  },
  'paymentLink.amountYouWillReceive': {
    en: 'You will receive',
    es: 'Tu recibirás',
    pt: 'Você receberá',
  },
  'paymentLink.amountYourClientWillPay': {
    en: 'Your client will pay',
    es: 'Tu cliente pagará',
    pt: 'Seu cliente pagará',
  },
  'paymentLink.exchangeRate': {
    en: 'Exchange rate:',
    es: 'Tipo de cambio:',
    pt: 'Taxa de câmbio:',
  },
  'paymentLink.exchangeRate.fxMessage': {
    en: 'Slight FX variations may apply.',
    es: 'Pueden aplicarse pequeñas variaciones de FX.',
    pt: 'Pequenas variações de FX podem ser aplicadas.',
  },
  'paymentLink.amount.error': {
    en: 'This amount is less than the minimum allowed (USD 1)',
    es: 'Este monto es inferior al mínimo permitido (USD 1)',
    pt: 'Este valor é inferior ao mínimo permitido (USD 1)',
  },
  'paymentLink.description': {
    en: 'Name of product or service (Optional)',
    es: 'Nombre del producto o servicio (Opcional)',
    pt: 'Nome do produto ou serviço (Opcional)',
  },
  'paymentLink.description.tooltip': {
    en: 'Your clients will see this name when opening the payment link.',
    es: 'Tus clientes verán este nombre al abrir el link de pago.',
    pt: 'Seus clientes verão esse nome ao abrir o link de pagamento.',
  },
  'paymentLink.clientEmail': {
    en: 'Client e-mail (Optional)',
    es: 'Email del cliente (Opcional)',
    pt: 'E-mail do cliente (opcional)',
  },
  'paymentLink.redirectLink': {
    en: 'Redirect link (Optional)',
    es: 'Enlace de redirección (Opcional)',
    pt: 'Link de redirecionamento (Opcional)',
  },
  'paymentLink.notificationUrl': {
    en: 'Notification url (Optional)',
    es: 'URL de Notificación (Opcional)',
    pt: 'URL de notificação (Opcional)',
  },
  'virtualpost.clientEmail': {
    en: 'Client e-mail',
    es: 'Email del cliente',
    pt: 'E-mail do cliente',
  },
  'paymentLink.sendEmail': {
    en: 'Share the payment link with my client by email',
    es: 'Compartir el link de pago con mi cliente por email',
    pt: 'Compartilhar o link de pagamento com meu cliente por e-mail',
  },
  'paymentLink.addClientData': {
    en: 'Add more client information (Optional) ',
    es: 'Agregar más información del cliente (Opcional)',
    pt: 'Adicionar mais informações do cliente (opcional)',
  },
  'paymentLink.selectClient': {
    en: 'Select an already saved client or create a new one.',
    es: 'Seleccionar un cliente ya guardado o crear uno nuevo.',
    pt: 'Selecionar um cliente já salvo ou criar um novo.',
  },
  'paymentLink.newClient': {
    en: 'New client',
    es: 'Nuevo cliente',
    pt: 'Novo cliente',
  },
  'paymentLink.existingClient': {
    en: 'Clients',
    es: 'Clientes',
    pt: 'Clientes',
  },
  'paymentLink.create': {
    en: 'CREATE PAYMENT LINK',
    es: 'CREAR LINK DE PAGO',
    pt: 'CRIAR LINK DE PAGAMENTO',
  },
  'paymentLink.create.recurring': {
    en: 'CREATE RECURRING PAYMENT LINK',
    es: 'CREAR LINK DE PAGO RECURRENTE',
    pt: 'CRIAR LINK DE PAGAMENTO RECORRENTE',
  },
  'paymentLink.clientFirstName': {
    en: 'First name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'paymentLink.clientLastName': {
    en: 'Last name',
    es: 'Apellido',
    pt: 'Sobrenome',
  },
  'paymentLink.clientDocumentType': {
    en: 'Document type',
    es: 'Tipo de documento',
    pt: 'Tipo de documento',
  },
  'paymentLink.clientDocument': {
    en: 'Document number',
    es: 'Número de documento',
    pt: 'Número do Documento',
  },
  'paymentLink.document.error': {
    en: 'The document entered is incorrect',
    es: 'El documento ingresado es incorrecto',
    pt: 'O documento digitado está incorreto',
  },
  'paymentLink.shareLink.headline': {
    en: 'Payment link ready! Share it with your client',
    es: '¡Link de pago listo! Compártelo con tu cliente',
    pt: 'Link de pagamento pronto! Compartilhe com seu cliente',
  },
  'paymentLink.shareLink.recurring.headline': {
    en: 'Recurring payment link ready! Share it with your clients',
    es: '¡Link de pago recurrente listo! Compártelo con tus clientes',
    pt: 'Link de pagamento recorrente pronto! Compartilhe com seus clientes',
  },
  'paymentLink.shareLink.copyLink': {
    en: 'Copy link',
    es: 'Copiar link',
    pt: 'Copiar link',
  },
  'paymentLink.shareLink.field1': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'paymentLink.shareLink.field2': {
    en: 'Amount',
    es: 'Total',
    pt: 'Total',
  },
  'paymentLink.shareLink.field3': {
    en: 'Description',
    es: 'Descripción',
    pt: 'Descrição',
  },
  'paymentLink.shareLink.subheadline1': {
    en: 'Copy and share this link',
    es: 'Copia y pega este link',
    pt: 'Copie e cole este link',
  },
  'paymentLink.shareLink.subheadline2': {
    en: 'Or share this link via',
    es: 'O comparte el link a través de',
    pt: 'Ou compartilhe o link através',
  },
  'paymentLink.shareLink': {
    en: 'Enter the link, choose your payment method, and done!',
    es: 'Ingresa al link, elige tu forma de pago, ¡y listo!',
    pt: 'Insira o link, escolha sua forma de pagamento, e pronto!',
  },
  'affiliations.shareLink': {
    en: 'Register at the link, choose your payment method, and done!',
    es: 'Registrate en el link, elige tu forma de pago, ¡y listo!',
    pt: 'Registre-se no link, escolha sua forma de pagamento, e pronto!',
  },
  'openPaymentLink.shareLink': {
    en: 'Enter the link, enter the amount to be paid, choose your payment method, and done!',
    es: 'Ingresa al link, ingresa el monto a pagar, elige tu forma de pago, ¡y listo!',
    pt: 'Insira o link, insira o valor a ser pago, escolha sua forma de pagamento, e pronto!',
  },
  'paymentLink.shareLink.whatsapp': {
    en: 'WhatsApp',
    es: 'WhatsApp',
    pt: 'WhatsApp',
  },
  'paymentLink.shareLink.facebook': {
    en: 'Facebook',
    es: 'Facebook',
    pt: 'Facebook',
  },
  'paymentLink.shareLink.moreOptions': {
    en: 'More options',
    es: 'Más opciones',
    pt: 'Mais opções',
  },
  'paymentLink.quick.guide.tab': {
    en: 'QUICK GUIDE',
    es: 'GUÍA RÁPIDA',
    pt: 'GUIA RÁPIDO',
  },
  'paymentLink.quick.guide.headline': {
    en: 'How to create a payment link',
    es: 'Cómo crear un link de pago',
    pt: 'Como criar um link de pagamento',
  },
  'paymentLink.quick.guide.paragraph.1': {
    en: 'Fill in the country where you will collect the payment, the currency and the price of your product or service.',
    es: 'Ingresa el país donde cobrarás el pago, la moneda y el monto de tu producto o servicio.',
    pt: 'Preencha o país onde irá receber o pagamento, a moeda e o preço do seu produto ou serviço.',
  },
  'paymentLink.quick.guide.paragraph.2': {
    en: 'If you want to, fill in the name of your product or service and the data of your client.',
    es: 'Si quieres, ingresa el nombre de tu producto o servicio y los datos de tu cliente.',
    pt: 'Se desejar, preencha o nome do seu produto ou serviço e os dados do seu cliente.',
  },
  'paymentLink.quick.guide.paragraph.3': {
    en: "Share the link with your clients by WhatsApp, email or social networks and that's it!",
    es: 'Comparte el link con tus clientes por whatsapp, mail o redes sociales ¡y listo!',
    pt: 'Compartilhe o link com seus clientes por WhatsApp, e-mail ou redes sociais e pronto!',
  },
  'paymentLink.quick.guide.paragraph.4': {
    en: 'You can check the payment status of your links from the payment link panel.',
    es: 'Puedes revisar el estado del pago de tus links desde el panel de Link de pago.',
    pt: 'Você pode verificar o status de pagamento de seus links no painel de links de pagamento.',
  },
  'msgError.createPaymentLink.invalidData': {
    en: 'The data entered is invalid.',
    es: 'Los datos ingresados son inválidos.',
    pt: 'Os dados inseridos são inválidos.',
  },
  'msgError.createPaymentLink.currencyNotSupported': {
    en: 'Currency not supported in the selected country.',
    es: 'Moneda no soportada en el país seleccionado.',
    pt: 'Moeda não suportada no país selecionado.',
  },
  'msgError.createPaymentLink.invoiceAlreadyExists': {
    en: 'An invoice with the entered ID already exists (in created or completed state).',
    es: 'Ya existe una factura con el ID ingresado (en estado creado o completado).',
    pt: 'Já existe uma fatura com o ID inserido (em estado criado ou concluído).',
  },
  'msgError.createPaymentLink.transactionLimitReached': {
    en: 'The allowed transaction limit has been reached.',
    es: 'Se alcanzó el límite de transacciones permitido.',
    pt: 'O limite de transação permitido foi atingido.',
  },
  'msgError.createPaymentLink.billingLimitReached': {
    en: 'The allowed billing amount has been reached.',
    es: 'Se alcanzó el monto de facturación permitido.',
    pt: 'O valor de faturamento permitido foi atingido.',
  },
  'msgError.createPaymentLink.transactionAmountExceeded': {
    en: 'This amount you deposited exceeds the maximum of USD {0} that you are allowed in your account settings. To process unlimited payments, <a href="{1}">complete step 2 account settings.</a>',
    es: 'El monto que ingresaste super el máximo de USD {0} que tienes permitido en la configuración de tu cuenta. Para procesar pagos sin límites, <a href="{1}"">completa el paso 2 de configuración.</a>',
    pt: 'O valor inserido excede o máximo de USD {0} permitido no nível atual da sua conta.Para processar pagamentos ilimitados, <a href="{1}">conclua o passo 2 da configuração de conta.</a>',
  },
  'msgError.createPaymentLink.amountLessThanAllowed': {
    en: 'The amount entered is less than the minimum allowed.',
    es: 'El monto ingresado es menor que el mínimo permitido.',
    pt: 'O valor inserido é menor que o mínimo permitido.',
  },
  'msgError.createPaymentLink.accountIsNotOperational': {
    en: 'Your account is not operational.',
    es: 'Tu cuenta no está operativa.',
    pt: 'Sua conta não está operacional.',
  },
  'msgError.createPaymentLink.noPaymentMethodConfigured': {
    en: 'It does not have any configured and/or active payment method for the indicated country.',
    es: 'No tiene ningún método de pago configurado y/o activo para el país indicado.',
    pt: 'Não possui nenhum método de pagamento configurado e/ou ativo para o país indicado.',
  },
  'msgError.createPaymentLink.amountExceedsAllowedForCards': {
    en: 'The amount entered exceeds the maximum allowed for cards, and you do not have any local payment method configured and/or active for the indicated country. Please configure local payment methods for this country.',
    es: 'El monto ingresado excede el máximo permitido para tarjetas, y no tiene ningún método de pago local configurado y/o activo para el país indicado. Por favor, configura métodos de pagos locales para este país.',
    pt: 'O valor informado excede o máximo permitido para cartões, e você não possui nenhum meio de pagamento local configurado e/ou ativo para o país indicado. Configure os métodos de pagamento locais para este país.',
  },
  'msgError.createPaymentLink.clientEmailNotEntered': {
    en: 'The email cannot be sent because it was not entered.',
    es: 'No se puede enviar el correo electrónico porque no se ingresó.',
    pt: 'O e-mail não pode ser enviado porque não foi inserido.',
  },
  'msgError.createPaymentLink.duplicatedClientId': {
    en: 'The data entered is already associated with another client ID.',
    es: 'Los datos ingresados ya están asociados a otro ID de cliente.',
    pt: 'Os dados inseridos já estão associados a outro ID de cliente.',
  },
  'createdPaymentLink.subheadline': {
    en: 'Find all the payment links you have created, their status and the most important details.',
    es: 'Encuentra todos los links de pago que creaste, su estado y los detalles más importantes.',
    pt: 'Encontre todos os links de pagamento que você criou, seu status e os detalhes mais importantes.',
  },
  'oneTimePaymentLink.page.subheadline': {
    en: 'Create and share payment links with your customers, quick and easy to create, in less than 1 minute.',
    es: 'Crea y comparte enlaces de pago con tus clientes, rápidos y fáciles de crear, en menos de 1 minuto.',
    pt: 'Crie e compartilhe links de pagamento com seus clientes, rápidos e fáceis de criar, em menos de 1 minuto.',
  },
  'recurringPaymentLink.page.subheadline': {
    en: 'Share a link to charge one or many customers as many times as you want. It never expires, so you can always reuse it.',
    es: 'Comparte un link para cobrarle a uno o varios clientes las veces que quieras. No vence, así que lo puedes reutilizar siempre.',
    pt: 'Compartilhe um link para cobrar de um ou vários clientes quantas vezes quiser. Não expira, então você pode reutilizá-lo sempre.',
  },
  'recurringPaymentLink.page.cardDescription': {
    en: 'Find all the payment links you have created, their status and the most important details.',
    es: 'Encuentra todos los links de pago que creaste, su estado y los detalles más importantes.',
    pt: 'Encontre todos os links de pagamento que você criou, seu status e os detalhes mais importantes.',
  },
  'openPaymentLink.page.subheadline': {
    en: "Use it when you don't know the exact amount to charge or it varies depending on the customer.",
    es: 'Úsalo cuando no conoces el monto exacto a cobrar o varía según el cliente.',
    pt: 'Use quando você não sabe o valor exato a cobrar ou ele varia de acordo com o cliente.',
  },
  'qrPayment.page.subheadline': {
    en: 'Ideal for charging on the spot, at your physical point of sale.',
    es: 'Ideal para cobrar en el momento, en tu punto de venta físico.',
    pt: 'Ideal para cobrar na hora, no seu ponto de venda físico.',
  },
  'createdPaymentLink.redirectBtn': {
    en: 'CREATE PAYMENT LINK',
    es: 'CREAR LINK DE PAGO',
    pt: 'CRIAR LINK DE PAGAMENTO',
  },
  'createdPaymentLink.oneTime': {
    en: 'One-time payment link',
    es: 'Link de pago único',
    pt: 'Link de pagamento único',
  },
  'createdPaymentLink.recurring': {
    en: 'Recurring payment link',
    es: 'Link de pago recurrente',
    pt: 'Link de pagamento recorrente',
  },
  'createdPaymentLink.oneTimeLinks': {
    en: 'One-time payment links',
    es: 'Links de pago único',
    pt: 'Links de pagamento único',
  },
  'createdPaymentLink.recurringLinks': {
    en: 'Recurring payment links',
    es: 'Links de pago recurrente',
    pt: 'Links de pagamento recorrente',
  },
  'createdPaymentLink.openPaymentLink': {
    en: 'Open payment link',
    es: 'Link de pago abierto',
    pt: 'Link de pagamento aberto',
  },
  'createdPaymentLink.qrPay': {
    en: 'QR Payment',
    es: 'Pago por QR',
    pt: 'Pagamento QR',
  },
  'createdPaymentLink.link': {
    en: 'Payment link',
    es: 'Link de pago',
    pt: 'Link de pagamento',
  },
  'createdPaymentLink.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'createdPaymentLink.creationDate': {
    en: 'Creation date',
    es: 'Fecha de creación',
    pt: 'Data de criação',
  },
  'createdPaymentLink.expirationDate': {
    en: 'Expiration date',
    es: 'Fecha de expiración',
    pt: 'Data de validade',
  },
  'createdPaymentLink.description': {
    en: 'Description',
    es: 'Descripción',
    pt: 'Descrição',
  },
  'createdPaymentLink.amount': {
    en: 'Amount',
    es: 'Monto',
    pt: 'Total',
  },
  'createdPaymentLink.paymentStatus': {
    en: 'Payment status',
    es: 'Status del pago',
    pt: 'Status do pagamento',
  },
  'createdPaymentLink.status': {
    en: 'Status',
    es: 'Estado',
    pt: 'Status',
  },
  'createdPaymentLink.action': {
    en: 'Action',
    es: 'Acción',
    pt: 'Ação',
  },
  'createdPaymentLink.status.active': {
    en: 'Active',
    es: 'Activo',
    pt: 'Ativo',
  },
  'createdPaymentLink.status.inactive': {
    en: 'Inactive',
    es: 'Inactivo',
    pt: 'Inativo',
  },
  'createdPaymentLink.more.activate': {
    en: 'Activate',
    es: 'Activar',
    pt: 'Ativar',
  },
  'createdPaymentLink.more.deactivate': {
    en: 'Deactivate',
    es: 'Desactivar',
    pt: 'Desativar',
  },
  'createdPaymentLink.share': {
    en: 'Share',
    es: 'Compartir',
    pt: 'Compartilhar',
  },
  'createdPaymentLink.noOneTimePaymentLinks': {
    en: 'No payment links created yet',
    es: 'No hay links de pagos creados aún',
    pt: 'Nenhum link de pagamento criado ainda',
  },
  'createdPaymentLink.noRecurringPaymentLinks': {
    en: 'You don’t have recurring payment links created yet',
    es: 'Aún no creaste links de pago recurrentes',
    pt: 'Você ainda não criou links de pagamento recorrentes',
  },
  'createdPaymentLink.noPaymentLinkDesc.1': {
    en: 'Create a link',
    es: 'Crea un link',
    pt: 'Crie um link',
  },
  'createdPaymentLink.noPaymentLinkDesc.2': {
    en: ' and collect payments easily',
    es: ' y recibe pagos fácilmente',
    pt: ' e receba pagamentos facilmente',
  },
  'createdPaymentLink.copyLink': {
    en: 'Copy link',
    es: 'Copiar link',
    pt: 'Copiar link',
  },
  'createdPaymentLink.copiedLink': {
    en: 'Copied',
    es: 'Copiado',
    pt: 'Copiado',
  },
  'virtualPos.create': {
    en: 'Create payment',
    es: 'Crear pago',
    pt: 'Criar pagamento',
  },
  'virtualPos.subtitle': {
    en: 'To create a new payment, complete the following information.',
    es: 'Para crear un nuevo pago, complete la siguiente información.',
    pt: 'Para criar um novo pagamento, preencha as seguintes informações.',
  },
  'virtualPos.currency.message': {
    en: 'Remember that payment is always made in the local currency of the selected country.',
    es: 'Recuerda que el pago siempre se efectúa en moneda local del país seleccionado.',
    pt: 'Lembre-se que o pagamento é sempre feito na moeda local do país selecionado.',
  },
  'virtualPos.title': {
    en: 'Ready!',
    es: '¡Listo!',
    pt: 'Pronto!',
  },
  'virtualPos.clientData.creditCard': {
    en: 'Credit card',
    es: 'Tarjeta de crédito',
    pt: 'Cartão de crédito',
  },
  'virtualPos.clientData.title': {
    en: 'Enter your client data',
    es: 'Ingrese los datos de su cliente',
    pt: 'Insira seus dados de cliente',
  },
  'virtualPos.clientData.confirmPayment': {
    en: 'Confirm payment',
    es: 'Confirmar pago',
    pt: 'Confirme o pagamento',
  },
  'virtualPos.paymentCreated': {
    en: 'The new payment has been created successfully, you can see its details in your transaction list.',
    es: 'El nuevo pago se ha creado con éxito, puede ver sus detalles en su lista de transacciones.',
    pt: 'O novo pagamento foi criado com sucesso, você pode ver seus detalhes na sua lista de transações.',
  },
  'paymentIntegration.card.link': {
    en: 'View Integration',
    es: 'Ver Integración',
    pt: 'Ver Integração',
  },
  'paymentIntegration.card.integration.voting.link': {
    en: 'Vote for this integration',
    es: 'Votar por esta integración',
    pt: 'Votar por esta integração',
  },
  'paymentIntegration.card.commingSoon': {
    en: 'COMING SOON',
    es: 'PRÓXIMAMENTE',
    pt: 'EM BREVE',
  },
  'paymentIntegration.api.title': {
    en: 'API Integration',
    es: 'Integración por API',
    pt: 'Integração por API',
  },
  'paymentIntegration.api.page.title': {
    en: 'Payment API',
    es: 'API de pagos',
    pt: 'API de pagamentos',
  },
  'paymentIntegration.api.page.subtitle': {
    en: 'Integrate your business via API to collect payments in multiple markets, automate your operations and customize your experience',
    es: 'Integra tu negocio vía API para cobrar en múltiples mercados, automatizar tu operación y personalizar tu experiencia de uso',
    pt: 'Integre seu negócio via API para cobrar em múltiplos mercados, automatizar sua operação e personalizar sua experiência de uso',
  },
  'paymentIntegration.api.page.hero.headline': {
    en: 'Adapt dLocal Go to your business with our payment API.',
    es: 'Adapta dLocal Go a tu negocio con nuestra API de pagos.',
    pt: 'Adapte a dLocal Go ao seu negócio com nossa API de pagamentos.',
  },
  'paymentIntegration.api.page.hero.description': {
    en: 'Scale your business by unifying multiple markets with a single API that gives you access to +15 countries and +200 payment methods.',
    es: 'Escala tu negocio unificando múltiples mercados con una única API que te permite acceder a +15 países y +200 métodos de pago.',
    pt: 'Escale seu negócio unificando múltiplos mercados com uma única API que permite acessar +15 países e +200 métodos de pagamento.',
  },
  'paymentIntegration.api.page.hero.tag.automation': {
    en: 'Payment Automation',
    es: 'Automatización de pagos',
    pt: 'Automação de pagamentos',
  },
  'paymentIntegration.api.page.hero.tag.scalability': {
    en: 'Scalability',
    es: 'Escalabilidad',
    pt: 'Escalabilidade',
  },
  'paymentIntegration.api.page.hero.tag.dataControl': {
    en: 'Data Control',
    es: 'Control de datos',
    pt: 'Controle de dados',
  },
  'paymentIntegration.api.page.hero.cta.sandbox': {
    en: 'Go to test environment',
    es: 'Ir al entorno de prueba',
    pt: 'Ir para o ambiente de teste',
  },
  'paymentIntegration.api.page.hero.cta.docs': {
    en: 'View documentation',
    es: 'Ver documentación',
    pt: 'Ver documentação',
  },
  'paymentIntegration.api.page.solutions.title': {
    en: 'Discover the full power of our API',
    es: 'Conoce todo el poder de nuestra API',
    pt: 'Conheça todo o poder da nossa API',
  },
  'paymentIntegration.api.page.solutions.subtitle': {
    en: 'Multiple solutions in a single API designed to help you scale your business',
    es: 'Múltiples soluciones en una sola API pensada para ayudarte a escalar tu negocio',
    pt: 'Múltiplas soluções em uma única API pensada para ajudar você a escalar seu negócio',
  },
  'paymentIntegration.api.page.solutions.idealFor': {
    en: 'Ideal for:',
    es: 'Ideal para:',
    pt: 'Ideal para:',
  },
  'paymentIntegration.api.page.solutions.cta': {
    en: 'View documentation',
    es: 'Ver documentación',
    pt: 'Ver documentação',
  },
  'paymentIntegration.api.page.solutions.timeTooltip': {
    en: 'Integration time',
    es: 'Tiempo de integración',
    pt: 'Tempo de integração',
  },
  'paymentIntegration.api.page.solutions.levelTooltip': {
    en: 'Integration level',
    es: 'Nivel de integración',
    pt: 'Nível de integração',
  },
  'paymentIntegration.api.page.solutions.checkoutStandard.title': {
    en: 'Standard Checkout',
    es: 'Checkout estándar',
    pt: 'Checkout padrão',
  },
  'paymentIntegration.api.page.solutions.checkoutStandard.ideal': {
    en: 'your first steps with our API',
    es: 'tus primeros pasos con nuestra API',
    pt: 'seus primeiros passos com nossa API',
  },
  'paymentIntegration.api.page.solutions.checkoutStandard.description': {
    en: "Process your customers' payments in our secure checkout and receive notifications with your transaction results.",
    es: 'Procesa los pagos de tus clientes en nuestro checkout seguro y recibe notificaciones con el resultado de tus transacciones.',
    pt: 'Processe os pagamentos dos seus clientes em nosso checkout seguro e receba notificações com o resultado das suas transações.',
  },
  'paymentIntegration.api.page.solutions.checkoutStandard.audience': {
    en: 'Retail, physical product e-commerce, digital products and early-stage SaaS platforms.',
    es: 'Retail, E-commerce de productos físicos, infoproductos y plataformas SaaS iniciales.',
    pt: 'Varejo, e-commerce de produtos físicos, infoprodutos e plataformas SaaS iniciais.',
  },
  'paymentIntegration.api.page.solutions.checkoutStandard.time': {
    en: '3-4 days',
    es: '3-4 días',
    pt: '3-4 dias',
  },
  'paymentIntegration.api.page.solutions.payouts.title': {
    en: 'Payouts',
    es: 'Payouts',
    pt: 'Payouts',
  },
  'paymentIntegration.api.page.solutions.payouts.ideal': {
    en: 'Automating payments to multiple accounts',
    es: 'Automatizar pagos a múltiples cuentas',
    pt: 'Automatizar pagamentos para múltiplas contas',
  },
  'paymentIntegration.api.page.solutions.payouts.description': {
    en: 'Send funds to third-party bank accounts quickly and securely, using the available balance in your dLocal Go account.',
    es: 'Envía fondos a cuentas bancarias de terceros de forma rápida y segura, utilizando el saldo disponible en tu cuenta de dLocal Go.',
    pt: 'Envie fundos para contas bancárias de terceiros de forma rápida e segura, utilizando o saldo disponível na sua conta dLocal Go.',
  },
  'paymentIntegration.api.page.solutions.payouts.audience': {
    en: 'Marketplaces, platforms and companies with suppliers.',
    es: 'Marketplaces, plataformas y empresas con proveedores.',
    pt: 'Marketplaces, plataformas e empresas com fornecedores.',
  },
  'paymentIntegration.api.page.solutions.payouts.time': {
    en: '3-4 days',
    es: '3-4 días',
    pt: '3-4 dias',
  },
  'paymentIntegration.api.page.solutions.subscriptions.title': {
    en: 'Subscriptions',
    es: 'Suscripciones',
    pt: 'Assinaturas',
  },
  'paymentIntegration.api.page.solutions.subscriptions.ideal': {
    en: 'Fixed recurring charges',
    es: 'Cobros recurrentes fijos',
    pt: 'Cobranças recorrentes fixas',
  },
  'paymentIntegration.api.page.solutions.subscriptions.description': {
    en: "Automate your customers' payments with credit or debit cards.",
    es: 'Automatiza los pagos de tus clientes con tarjeta de crédito o débito',
    pt: 'Automatize os pagamentos dos seus clientes com cartão de crédito ou débito.',
  },
  'paymentIntegration.api.page.solutions.subscriptions.audience': {
    en: 'Streaming, gyms, digital academies and membership clubs.',
    es: 'Streaming, gimnasios, academias digitales y clubes de membresía.',
    pt: 'Streaming, academias, escolas digitais e clubes de assinatura.',
  },
  'paymentIntegration.api.page.solutions.subscriptions.time': {
    en: '5-6 days',
    es: '5-6 días',
    pt: '5-6 dias',
  },
  'paymentIntegration.api.page.solutions.splitPayments.title': {
    en: 'Split Payments',
    es: 'Split Payments',
    pt: 'Split Payments',
  },
  'paymentIntegration.api.page.solutions.splitPayments.ideal': {
    en: 'Collaborating with other people or companies',
    es: 'Colaborar con otras personas o empresas',
    pt: 'Colaborar com outras pessoas ou empresas',
  },
  'paymentIntegration.api.page.solutions.splitPayments.description': {
    en: 'Split transactions according to what you agreed with your collaborators.',
    es: 'Divide las transacciones de acuerdo a lo arreglado con tus colaboradores',
    pt: 'Divida as transações de acordo com o combinado com seus colaboradores.',
  },
  'paymentIntegration.api.page.solutions.splitPayments.audience': {
    en: 'Marketplaces, ride-hailing apps, delivery platforms and affiliates.',
    es: 'Marketplaces, apps de transporte, plataformas de entrega y afiliados.',
    pt: 'Marketplaces, apps de transporte, plataformas de entrega e afiliados.',
  },
  'paymentIntegration.api.page.solutions.splitPayments.time': {
    en: '4-5 days',
    es: '4-5 días',
    pt: '4-5 dias',
  },
  'paymentIntegration.api.page.solutions.oneClickUpsell.title': {
    en: 'One-Click Upsell',
    es: 'One-Click Upsell',
    pt: 'One-Click Upsell',
  },
  'paymentIntegration.api.page.solutions.oneClickUpsell.ideal': {
    en: 'Increasing your revenue',
    es: 'Aumentar tu revenue',
    pt: 'Aumentar seu revenue',
  },
  'paymentIntegration.api.page.solutions.oneClickUpsell.description': {
    en: 'Offer additional products after a successful card payment in just 1 click.',
    es: 'Ofrece productos adicionales luego de un pago exitoso con tarjeta en solo 1 clic.',
    pt: 'Ofereça produtos adicionais após um pagamento bem-sucedido com cartão em apenas 1 clique.',
  },
  'paymentIntegration.api.page.solutions.oneClickUpsell.audience': {
    en: 'Ticketing, hotel bookings, software add-ons and e-learning.',
    es: 'Venta de entradas (ticketing), reservas hoteleras, complementos de software y e-learning.',
    pt: 'Venda de ingressos (ticketing), reservas hoteleiras, complementos de software e e-learning.',
  },
  'paymentIntegration.api.page.solutions.oneClickUpsell.time': {
    en: '5-6 days',
    es: '5-6 días',
    pt: '5-6 dias',
  },
  'paymentIntegration.api.page.solutions.recurringPayment.title': {
    en: 'Recurring Payments',
    es: 'Recurring Payments',
    pt: 'Recurring Payments',
  },
  'paymentIntegration.api.page.solutions.recurringPayment.ideal': {
    en: 'Variable recurring charges',
    es: 'Cobros recurrentes variables',
    pt: 'Cobranças recorrentes variáveis',
  },
  'paymentIntegration.api.page.solutions.recurringPayment.description': {
    en: "Store your customer's payment details and charge them according to how they use your product or service.",
    es: 'Guarda los datos del pago de tu cliente y cobrale de acuerdo al uso que haga de tu producto o servicio.',
    pt: 'Guarde os dados de pagamento do seu cliente e cobre de acordo com o uso que ele fizer do seu produto ou serviço.',
  },
  'paymentIntegration.api.page.solutions.recurringPayment.audience': {
    en: 'Utilities, telecom, B2B software and credit-based education.',
    es: 'Servicios públicos, telecomunicaciones, software B2B y educación por créditos.',
    pt: 'Serviços públicos, telecomunicações, software B2B e educação por créditos.',
  },
  'paymentIntegration.api.page.solutions.recurringPayment.time': {
    en: '7-8 days',
    es: '7-8 días',
    pt: '7-8 dias',
  },
  'paymentIntegration.api.page.solutions.transparentCheckout.title': {
    en: 'Transparent Checkout',
    es: 'Checkout Transparente',
    pt: 'Checkout Transparente',
  },
  'paymentIntegration.api.page.solutions.transparentCheckout.ideal': {
    en: 'Products that prioritize UX',
    es: 'Productos que priorizan la UX',
    pt: 'Produtos que priorizam a UX',
  },
  'paymentIntegration.api.page.solutions.transparentCheckout.description': {
    en: 'Integrate the payment gateway directly into the design, code and domain of your own website to accept card payments.',
    es: 'Integrar la pasarela de pagos directamente dentro del diseño, código y dominio de su propio sitio web para recibir pagos con tarjetas.',
    pt: 'Integrar o gateway de pagamento diretamente no design, código e domínio do seu próprio site para receber pagamentos com cartões.',
  },
  'paymentIntegration.api.page.solutions.transparentCheckout.audience': {
    en: 'Corporate EdTech, airlines, travel agencies and native mobile apps.',
    es: 'EdTech corporativo, aerolíneas, agencias de viaje y aplicaciones móviles nativas.',
    pt: 'EdTech corporativo, companhias aéreas, agências de viagem e aplicativos móveis nativos.',
  },
  'paymentIntegration.api.page.solutions.transparentCheckout.time': {
    en: '7-8 days',
    es: '7-8 días',
    pt: '7-8 dias',
  },
  'paymentIntegration.api.page.keys.headline': {
    en: 'Integration keys',
    es: 'Claves de integración',
    pt: 'Chaves de integração',
  },
  'paymentIntegration.api.page.keys.description': {
    en: 'These credentials are the secure keys that link your website with dLocal Go.<br />There are three keys per account:',
    es: 'Estas credenciales son las llaves seguras que vinculan su sitio web con dLocal Go.<br />Existen tres claves por cuenta:',
    pt: 'Essas credenciais são as chaves seguras que vinculam seu site à dLocal Go.<br />Existem três chaves por conta:',
  },
  'paymentIntegration.api.page.keys.apiKey': {
    en: 'API Key',
    es: 'API Key',
    pt: 'API Key',
  },
  'paymentIntegration.api.page.keys.secretKey': {
    en: 'Secret key',
    es: 'Secret key',
    pt: 'Secret key',
  },
  'paymentIntegration.api.page.keys.smartFieldsApiKey': {
    en: 'SmartFields API Key',
    es: 'SmartFields API Key',
    pt: 'SmartFields API Key',
  },
  'paymentIntegration.api.page.keys.tip': {
    en: 'Protect these credentials; they validate the security of your transactions. Remember that test environment keys are different from production keys.',
    es: 'Resguarde estas credenciales; validan la seguridad de sus transacciones. Recuerde que las claves del entorno de prueba son distintas a las de producción.',
    pt: 'Proteja essas credenciais; elas validam a segurança das suas transações. Lembre-se de que as chaves do ambiente de teste são diferentes das de produção.',
  },
  'paymentIntegration.api.details.headline': {
    en: 'Install dLocal Go in your site',
    es: 'Instala dLocal Go en tu sitio',
    pt: 'Instale a dLocal Go no seu site',
  },
  'paymentIntegration.api.details.description': {
    en: "Integrate your site with dLocal Go through our REST API. No matter what platform you're on or what language is implemented, the integration is super flexible.<br /><br />For more information on how to integrate, ",
    es: 'Integra tu sitio con dLocal Go a través de nuestra API REST. No importa en qué plataforma estés o el lenguaje implementado, la integración es súper flexible.<br /><br />Para más información de cómo realizar la integración, ',
    pt: 'Integre seu site com dLocal Go através de nossa API REST. Não importa em qual plataforma você está ou qual idioma está implementado, a integração é super flexível.<br /><br />Para obter mais informações sobre como integrar, ',
  },
  'paymentIntegration.api.details.link': {
    en: 'visit our documentation.',
    es: 'visita nuestra documentación.',
    pt: 'visite nossa documentação.',
  },
  'paymentIntegration.api.details.key.headline': {
    en: 'Integrations keys',
    es: 'Claves de integración',
    pt: 'Chaves de integração',
  },
  'paymentIntegration.api.details.key.description': {
    en: 'The integration keys are the necessary credentials to integrate with dLocal Go.<br /><br />There are three keys per account:',
    es: 'Las claves de integración son las credenciales necesarias para realizar tu integración con dLocal Go.<br /><br />Existen tres claves por cuenta:',
    pt: 'As chaves de integração são as credenciais necessárias para a integração com dLocal Go.<br /><br />Existem três chaves por conta:',
  },
  'paymentIntegration.vtex.details.headline': {
    en: 'Vtex',
    es: 'Vtex',
    pt: 'Vtex',
  },
  'paymentIntegration.vtex.details.description': {
    en: 'Powerful Ecommerce platform focused on customized and scalable solutions for large brands. Ideal for international expansion. Would you like to see Vtex on our platform?',
    es: 'Potente plataforma de Ecommerce con foco en soluciones personalizadas y escalables para grandes marcas. Ideal para expansión internacional. ¿Quieres ver Vtex en nuestra plataforma?',
    pt: 'Plataforma de Ecommerce poderosa com foco em soluções personalizadas e escaláveis para grandes marcas. Ideal para expansão internacional. Gostaria de ver o Vtex na nossa plataforma?',
  },
  'paymentIntegration.vtex.details.button': {
    en: 'Vote for this integration',
    es: 'Votar por esta integración',
    pt: 'Votar por esta integración',
  },
  'paymentIntegration.wix.details.headline': {
    en: 'WIX',
    es: 'WIX',
    pt: 'WIX',
  },
  'paymentIntegration.wix.details.description': {
    en: 'Known for its ease of use, Wix allows you to create professional websites with integrated Ecommerce solutions for small and medium-sized businesses. Would you like to use WIX with us?',
    es: 'Conocido por su facilidad de uso, Wix permite crear sitios web profesionales con soluciones integradas de Ecommerce para pequeñas y medianas empresas. ¿Te gustaría usar WIX con nosotros?',
    pt: 'Conhecido pela sua facilidade de uso, o Wix permite criar sites profissionais com soluções integradas de Ecommerce para pequenas e médias empresas. Gostaria de usar o WIX conosco?',
  },
  'paymentIntegration.wix.details.button': {
    en: 'Vote for this integration',
    es: 'Votar por esta integración',
    pt: 'Votar por esta integración',
  },
  'paymentIntegration.billowshop.details.headline': {
    en: 'Billowshop',
    es: 'Billowshop',
    pt: 'Billowshop',
  },
  'paymentIntegration.billowshop.details.description': {
    en: 'It allows entrepreneurs and small businesses to launch their digital stores quickly, focusing on simplicity and personalized support for those who want to sell online without technical complications. Would you like to see Billowshop on our platform?',
    es: 'Permite a los emprendedores y pequeños negocios lanzar sus tiendas digitales rápidamente, con foco en la simplicidad y soporte personalizado para quienes buscan vender online sin complicaciones técnicas. ¿Quieres ver Billowshop en nuestra plataforma?',
    pt: 'Permite que empreendedores e pequenos negócios lancem suas lojas digitais rapidamente, com foco na simplicidade e suporte personalizado para aqueles que desejam vender online sem complicações técnicas. Gostaria de ver Billowshop na nossa plataforma?',
  },
  'paymentIntegration.billowshop.details.button': {
    en: 'Vote for this integration',
    es: 'Votar por esta integración',
    pt: 'Votar por esta integración',
  },
  'paymentIntegration.jumpseller.details.headline': {
    en: 'Jumpseller',
    es: 'Jumpseller',
    pt: 'Jumpseller',
  },
  'paymentIntegration.jumpseller.details.description': {
    en: 'Friendly and accessible platform for small and medium-sized businesses looking to sell online quickly and easily, with multi-channel support. Would you like to integrate Jumpseller?',
    es: 'Plataforma amigable y accesible para pequeñas y medianas empresas que desean vender online de forma rápida y sencilla, con soporte multicanal. ¿Te gustaría integrar Jumpseller?',
    pt: 'Plataforma amigável e acessível para pequenas e médias empresas que desejam vender online de forma rápida e fácil, com suporte multicanal. Gostaria de integrar o Jumpseller?',
  },
  'paymentIntegration.jumpseller.details.button': {
    en: 'Vote for this integration',
    es: 'Votar por esta integración',
    pt: 'Votar por esta integração',
  },
  'paymentIntegration.bigcommerce.details.headline': {
    en: 'BigCommerce',
    es: 'BigCommerce',
    pt: 'BigCommerce',
  },
  'paymentIntegration.bigcommerce.details.description': {
    en: 'With advanced tools for SEO, security, and performance, BigCommerce is ideal for companies looking to grow and optimize their online sales. Do you think BigCommerce is key for you?',
    es: 'Con herramientas avanzadas para SEO, seguridad y rendimiento, Bigcommerce es ideal para empresas que buscan crecer y optimizar sus ventas online. ¿Crees que Bigcommerce es clave para ti?',
    pt: 'Com ferramentas avançadas para SEO, segurança e desempenho, o BigCommerce é ideal para empresas que procuram crescer e otimizar suas vendas online. Você acha que o BigCommerce é essencial para você?',
  },
  'paymentIntegration.bigcommerce.details.button': {
    en: 'Vote for this integration',
    es: 'Votar por esta integración',
    pt: 'Votar por esta integração',
  },
  'paymentIntegration.opencart.details.headline': {
    en: 'OpenCart',
    es: 'OpenCart',
    pt: 'OpenCart',
  },
  'paymentIntegration.opencart.details.description': {
    en: 'An open-source platform with great flexibility for Ecommerce management, ideal for those seeking unlimited customization. Would you like OpenCart to be part of our solution?',
    es: 'Plataforma de código abierto y gran flexibilidad para la gestión de Ecommerce, ideal para aquellos que buscan personalización sin límites. ¿Quieres que OpenCart sea parte de nuestra solución?',
    pt: 'Plataforma de código aberto e grande flexibilidade para a gestão de Ecommerce, ideal para quem procura personalização sem limites. Gostaria que o OpenCart fizesse parte da nossa solução?',
  },
  'paymentIntegration.opencart.details.button': {
    en: 'Vote for this integration',
    es: 'Votar por esta integración',
    pt: 'Votar por esta integração',
  },
  'paymentIntegration.virtuemart.details.headline': {
    en: 'Virtuemart',
    es: 'Virtuemart',
    pt: 'Virtuemart',
  },
  'paymentIntegration.virtuemart.details.description': {
    en: 'A Joomla extension for Ecommerce, offering a flexible solution for those already using this CMS and wanting to sell products online. Do you think VirtueMart is the best option?',
    es: 'Extensión de Joomla para Ecommerce, ofrece una solución flexible para quienes ya usan este CMS y desean vender productos online. ¿Crees que VirtueMart es la mejor opción?',
    pt: 'Extensão do Joomla para Ecommerce, oferece uma solução flexível para quem já usa este CMS e deseja vender produtos online. Você acha que o VirtueMart é a melhor opção?',
  },
  'paymentIntegration.virtuemart.details.button': {
    en: 'Vote for this integration',
    es: 'Votar por esta integración',
    pt: 'Votar por esta integração',
  },
  'paymentIntegration.fenicio.details.headline': {
    en: 'Fenicio',
    es: 'Fenicio',
    pt: 'Fenicio',
  },
  'paymentIntegration.fenicio.details.description': {
    en: 'The Ecommerce platform for Uruguay and Latin America, focused on maximizing the revenues of your online channel. Are you interested in seeing Fenicio as an option?',
    es: 'La plataforma de comercio electrónico para Uruguay y América Latina enfocada en maximizar los ingresos de tu canal online. ¿Te interesa ver Fenicio como opción?',
    pt: 'A plataforma de comércio eletrônico para o Uruguai e América Latina focada em maximizar os seus rendimentos online. Gostaria de ver o Fenicio como uma opção?',
  },
  'paymentIntegration.fenicio.details.button': {
    en: 'Vote for this integration',
    es: 'Votar por esta integración',
    pt: 'Votar por esta integração',
  },
  'paymentIntegration.shopify.title': {
    en: 'Shopify',
    es: 'Shopify',
    pt: 'Shopify',
  },
  'paymentIntegration.shopify.details.headline': {
    en: 'Install dLocal Go in your Shopify Store',
    es: 'Instala dLocal Go en tu tienda de Shopify',
    pt: 'Instale a dLocal Go em sua loja da Shopify',
  },
  'paymentIntegration.shopify.details.description': {
    en: 'Use dLocal Go to accept payments in your Shopify store. Just click the button below to add dLocal Go payment app to your store and start accepting payments easily, quickly and safely!<br /><br />For more information on how to integrate, ',
    es: 'Usa dLocal Go para aceptar pagos en tu tienda Shopify. Solo haz click en el botón para agregar la aplicación de pago dLocal Go a tu tienda ¡y empieza a aceptar pagos de manera fácil, rápida y segura!<br /><br />Para más información de cómo realizar la integración, ',
    pt: 'Use a dLocal Go para aceitar pagamentos em sua loja da Shopify. Basta clicar no botão para adicionar o aplicativo de pagamento dLocal Go à sua loja e começar a aceitar pagamentos de forma fácil, rápida e segura!<br /><br />Para obter mais informações sobre como integrar, ',
  },
  'paymentIntegration.shopify.details.link': {
    en: 'visit our documentation.',
    es: 'visita nuestra documentación.',
    pt: 'visite nossa documentação.',
  },
  'paymentIntegration.shopify.details.button': {
    en: 'Install dLocal Go in Shopify',
    es: 'Instalar dLocal Go en Shopify',
    pt: 'Instalar dLocal Go em Shopify',
  },
  'paymentIntegration.shopify.details.transparent.description': {
    en: 'Use dLocal Go to accept payments in your Shopify store, offering a transparent experience to your brazilian customers and a redirect experience to your international customers.<br /><br /> Just click the button below to add dLocal Go to your store and start accepting payments easily, quickly and safely!<br /><br />For more information on how to integrate, ',
    es: '',
    pt: 'Use dLocal Go para aceitar pagamentos em sua loja Shopify, oferecendo uma experiência transparente para seus clientes brasileiros e uma experiência de redirecionamento para seus clientes internacionais.<br /><br /> Basta clicar no botão abaixo para adicionar a dLocal Go à sua loja e começar a aceitar pagamentos de forma fácil, rápida e segura!<br /><br />Para mais informações sobre como integrar, ',
  },
  'paymentIntegration.shopify.details.transparent.link': {
    en: 'visit our documentation.',
    es: '',
    pt: 'visite nossa documentação.',
  },
  'paymentIntegration.shopify.details.transparent.installed.headline': {
    en: 'You already have dLocal Go installed on your Shopify Store',
    es: '',
    pt: 'Você já tem a dLocal Go instalada em sua loja da Shopify.',
  },
  'paymentIntegration.shopify.details.transparent.installed.description': {
    en: 'If you want to make a test payment before going live, enable test mode.',
    es: '',
    pt: 'Se você quiser fazer um pagamento de teste antes de começar a vender, habilite o modo de teste.',
  },
  'paymentIntegration.shopify.details.transparent.installed.toggle': {
    en: 'test mode toggle',
    es: '',
    pt: 'test mode toggle',
  },
  'paymentIntegration.shopify.details.transparent.installed.description2': {
    en: 'Make sure test mode is enabled in your Shopify dashboard by following',
    es: '',
    pt: 'Certifique-se de que o modo de teste esteja ativado em seu painel da Shopify seguindo',
  },
  'paymentIntegration.shopify.details.transparent.installed.link': {
    en: ' these steps.',
    es: '',
    pt: ' estas etapas.',
  },
  'paymentIntegration.shopify.details.transparent.installed.description3': {
    en: "After you check the test mode, don't forget to deactivate it to be able to go live.",
    es: '',
    pt: 'Depois de verificar o modo de teste, não se esqueça de desativá-lo para poder processar pagamentos reais.',
  },
  'paymentIntegration.woo.title': {
    en: 'WooCommerce',
    es: 'WooCommerce',
    pt: 'WooCommerce',
  },
  'paymentIntegration.woo.details.headline': {
    en: 'Install dLocal Go in your WooCommerce Store',
    es: 'Instala dLocal Go en su tienda de WooCommerce',
    pt: 'Instale o dLocal Go em sua loja WooCommerce',
  },
  'paymentIntegration.woo.details.description': {
    en: 'Install dLocal Go checkout in your WooCommerce store and start receiving payments today.',
    es: 'Instala el checkout de dLocal Go en tu tienda WooCommerce y comienza a recibir pagos hoy mismo.',
    pt: 'Instale o checkout dLocal Go em sua loja WooCommerce e comece a receber pagamentos hoje.',
  },
  'paymentIntegration.woo.details.link': {
    en: 'Follow the step by step guide',
    es: 'Sigue la guía paso a paso',
    pt: '	Siga o passo-a-passo',
  },
  'paymentIntegration.woo.details.description2': {
    en: ' and your site will be ready to sell safely.',
    es: ' y tu sitio ya estará listo para vender de forma segura.',
    pt: ' e o seu site estará pronto para vender forma segura.',
  },
  'paymentIntegration.woo.details.link2': {
    en: 'Click here',
    es: 'Haz click aquí',
    pt: 'Clique aqui',
  },
  'paymentIntegration.woo.details.description3': {
    en: ' if you want to test the plugin.',
    es: ' si quieres probar el plugin.',
    pt: ' se quiser testar o plugin.',
  },
  'paymentIntegration.woo.details.key.headline': {
    en: 'Integration key',
    es: 'Clave de integración',
    pt: 'Chave de integração',
  },
  'paymentIntegration.woo.details.key.description': {
    en: 'Integration keys are credentials you need to integrate with dLocal Go.<br /><br />There are two keys per account:',
    es: 'La clave de integración es la credencial necesaria para realizar tu integración con dLocal Go.<br /><br />Existen dos claves por cuenta:',
    pt: 'As chaves de integração são credenciais que você precisa para integrar com dLocal Go.<br /><br />Existem duas chaves por conta:',
  },
  'paymentIntegration.woo.details.button': {
    en: 'Install dLocal Go in WooCommerce',
    es: 'Instalar dLocal Go en WooCommerce',
    pt: 'Instalar dLocal Go em WooCommerce',
  },
  'paymentIntegration.magento.title': {
    en: 'Magento',
    es: 'Magento',
    pt: 'Magento',
  },
  'paymentIntegration.magento.details.headline': {
    en: 'Install dGo in your Magento Store',
    es: 'Instala dGo en su tienda de Magento',
    pt: 'Instale o dLocal Go em sua loja Magento',
  },
  'paymentIntegration.magento.details.description': {
    en: 'Install dLocal Go checkout in your Magento store and start receiving payments today.',
    es: 'Instala el checkout de dLocal Go en tu tienda Magento y comienza a recibir pagos hoy mismo.',
    pt: 'Instale o checkout dLocal Go em sua loja Magento e comece a receber pagamentos hoje.',
  },
  'paymentIntegration.magento.details.link': {
    en: 'Follow the three installation steps',
    es: 'Sigue los tres pasos de instalación',
    pt: 'Siga as três etapas de instalação',
  },
  'paymentIntegration.magento.details.description2': {
    en: ' and your site will be ready to sell safely.',
    es: ' y tu sitio ya estará listo para vender de forma segura.',
    pt: ' e seu site estará pronto para vender com segurança.',
  },
  'paymentIntegration.magento.details.key.headline': {
    en: 'Integration key',
    es: 'Clave de integración',
    pt: 'Chave de integração',
  },
  'paymentIntegration.magento.details.key.description': {
    en: 'The integration keys are the necessary credentials to integrate with dLocal Go.<br /><br />There are two keys per account:',
    es: 'Las claves de integración son las credenciales necesarias para realizar tu integración con dLocal Go.<br /><br />Existen dos claves por cuenta:',
    pt: 'As chaves de integração são as credenciais necessárias para a integração com dLocal Go.<br /><br />Existem duas chaves por conta:',
  },
  'paymentIntegration.magento.details.button': {
    en: 'Install dLocal Go in Magento',
    es: 'Instalar dLocal Go en Magento',
    pt: 'Instalar dLocal Go em Magento',
  },
  'paymentIntegration.prestashop.title': {
    en: 'Presta Shop',
    es: 'Presta Shop',
    pt: 'Presta Shop',
  },
  'paymentIntegration.prestashop.details.headline': {
    en: 'Install dLocal Go in your PrestaShop store',
    es: 'Instala dLocal Go en tu tienda de PrestaShop',
    pt: 'Instale a dLocal Go em sua loja PrestaShop',
  },
  'paymentIntegration.prestashop.details.key.headline': {
    en: 'Integration key',
    es: 'Clave de integración',
    pt: 'Chave de integração',
  },
  'paymentIntegration.prestashop.details.description': {
    en: 'Install dLocal Go checkout in your Presta Shop store and start receiving payments today.',
    es: 'Instala el checkout de dLocal Go en tu tienda Presta Shop y comienza a recibir pagos hoy mismo.',
    pt: 'Instale o checkout dLocal Go em sua loja PrestaShop e comece a receber pagamentos hoje.',
  },
  'paymentIntegration.prestashop.details.key.description': {
    en: 'The integration keys are the necessary credentials to integrate with dLocal Go.<br /><br />There are two keys per account:',
    es: 'Las claves de integración son las credenciales necesarias para realizar tu integración con dLocal Go.<br /><br />Existen dos claves por cuenta:',
    pt: 'As chaves de integração são as credenciais necessárias para a integração com dLocal Go.<br /><br />Existem duas chaves por conta:',
  },
  'paymentIntegration.prestashop.download': {
    en: 'Download plugin',
    es: 'Descargar plugin',
    pt: 'Baixar plugin',
  },
  'paymentIntegration.prestashop.details.button': {
    en: 'Install dLocal Go in PrestaShop',
    es: 'Instalar dLocal Go en PrestaShop',
    pt: 'Instalar dLocal Go em PrestaShop',
  },
  'paymentIntegration.hostinger.title': {
    en: 'Hostinger Website Builder',
    es: 'Hostinger Website Builder',
    pt: 'Hostinger Website Builder',
  },
  'paymentIntegration.vtex.title': {
    en: 'VTEX',
    es: 'VTEX',
    pt: 'VTEX',
  },
  'paymentIntegration.wix.title': {
    en: 'WIX',
    es: 'WIX',
    pt: 'WIX',
  },
  'paymentIntegration.billowshop.title': {
    en: 'Billowshop',
    es: 'Billowshop',
    pt: 'Billowshop',
  },
  'paymentIntegration.jumpseller.title': {
    en: 'Jumpseller',
    es: 'Jumpseller',
    pt: 'Jumpseller',
  },
  'paymentIntegration.bigcommerce.title': {
    en: 'BigCommerce',
    es: 'BigCommerce',
    pt: 'BigCommerce',
  },
  'paymentIntegration.opencart.title': {
    en: 'OpenCart',
    es: 'OpenCart',
    pt: 'OpenCart',
  },
  'paymentIntegration.virtuemart.title': {
    en: 'VirtueMart',
    es: 'VirtueMart',
    pt: 'VirtueMart',
  },
  'paymentIntegration.fenicio.title': {
    en: 'Fenicio',
    es: 'Fenicio',
    pt: 'Fenicio  ',
  },
  'paymentIntegration.hostinger.details.headline': {
    en: 'Install dLocal Go in your Hostinger Website Builder eCommerce store',
    es: 'Instala dLocal Go en tu tienda eCommerce de Hostinger Website Builder',
    pt: 'Instale o dLocal Go na sua loja de comércio eletrônico Hostinger Website Builder',
  },
  'paymentIntegration.hostinger.details.key.headline': {
    en: 'Integration key',
    es: 'Clave de integración',
    pt: 'Chave de integração',
  },
  'paymentIntegration.hostinger.details.description': {
    en: 'Install dLocal Go checkout in your Hostinger Website Builder eCommerce store and start receiving payments today.',
    es: 'Instala el checkout de dLocal Go en tu tienda eCommerce Hostinger Website Builder y comienza a recibir pagos hoy mismo.',
    pt: 'Instale o checkout dLocal Go em sua loja de comércio eletrônico Hostinger Website Builder e comece a receber pagamentos hoje mesmo.',
  },
  'paymentIntegration.hostinger.details.follow': {
    en: 'Follow the step by step guide',
    es: 'Sigue la guía paso a paso',
    pt: 'Siga o passo-a-passo',
  },
  'paymentIntegration.hostinger.details.description2': {
    en: ' and your site will be ready to sell safely.',
    es: ' y su sitio estará listo para venderse de forma segura.',
    pt: ' e seu site estará pronto para vender com segurança.',
  },
  'paymentIntegration.hostinger.details.key.description': {
    en: 'The integration keys are the necessary credentials to integrate with dLocal Go.<br /><br />There are two keys per account:',
    es: 'Las claves de integración son las credenciales necesarias para realizar tu integración con dLocal Go.<br /><br />Existen dos claves por cuenta:',
    pt: 'As chaves de integração são as credenciais necessárias para a integração com dLocal Go.<br /><br />Existem duas chaves por conta:',
  },
  'paymentIntegration.moreInfo': {
    en: 'For more information on how to integrate, visit',
    es: 'Para más información de cómo realizar la integración, visite',
    pt: 'Para obter mais informações sobre como integrar, visite',
  },
  'paymentIntegration.moreInfo.ourDocumentation': {
    en: 'our documentation.',
    es: 'nuestra documentación.',
    pt: 'nossa documentação.',
  },
  'paymentIntegration.commingSoon': {
    en: 'COMING SOON',
    es: 'PRÓXIMAMENTE',
    pt: 'EM BREVE',
  },
  'paymentIntegration.desc': {
    en: `In this section you will find the necessary information to integrate with <b>${brandName}</b>.`,
    es: `En esta sección encontrará la información necesaria para realizar su integración con <b>${brandName}</b>.`,
    pt: `Nesta seção, você encontrará as informações necessárias para a integração com <b>${brandName}</b>.`,
  },
  'paymentIntegration.keysDesc': {
    en: `The integration keys are the necessary credentials to integrate with ${brandName}. There are two keys per account:`,
    es: `Las claves de integración son las credenciales necesarias para realizar su integración con ${brandName}. Existen dos claves por cuenta:`,
    pt: `As chaves de integração são as credenciais necessárias para a integração com ${brandName}. Existem duas chaves por conta:`,
  },
  'paymentIntegration.keysDesc.1': {
    en: '<b>API key</b>: Required for integration using our API and e-commerce integrations.',
    es: '<b>API key</b>: Necesaria para la integración utilizando nuestra API e integraciones de e-commerce.',
    pt: '<b>API key</b>: necessária para integração usando nossa API e integrações de comércio eletrônico.',
  },
  'paymentIntegration.keysDesc.2': {
    en: '<b>Secret key</b>: Required for API integration.',
    es: '<b>Secret key</b>: Necesaria para la integración por API.',
    pt: '<b>Secret key</b>: Necessária para integração com API.',
  },
  'paymentIntegration.apiKeyLabel': {
    en: 'API key',
    es: 'API key',
    pt: 'API key',
  },
  'paymentIntegration.secretKeyLabel': {
    en: 'Secret key',
    es: 'Secret key',
    pt: 'Secret key',
  },
  'paymentIntegration.createPaymentButton': {
    en: 'Create payment button',
    es: 'Crear botón de pago',
    pt: 'Criar botão de pagamento',
  },
  'paymentIntegration.copyApiKey': {
    en: 'Copy API key',
    es: 'Copiar API key',
    pt: 'Copiar API key',
  },
  'paymentIntegration.copySecretKey': {
    en: 'Copy Secret key',
    es: 'Copiar Secret key',
    pt: 'Copiar Secret key',
  },
  'paymentIntegration.addToShopify': {
    en: 'Shopify',
    es: 'Shopify',
    pt: 'Shopify',
  },
  'paymentIntegration.shopify.desc': {
    en: `Use ${brandName} to accept payments in your Shopify store. Just click the button below to add ${brandName} to your store and start accepting payments easily, quickly and safely!`,
    es: `Use ${brandName} para aceptar pagos en su tienda de Shopify. Simplemente haga click en el botón de abajo para agregar ${brandName} a su tienda y comenzar a aceptar pagos de forma sencilla, rápida y segura!`,
    pt: `Use ${brandName} para aceitar pagamentos em sua loja Shopify. Basta clicar no botão abaixo para adicionar ${brandName} à sua loja e começar a aceitar pagamentos de forma fácil, rápida e segura!`,
  },
  'paymentIntegration.shopify.desc.transparent': {
    es: 'Instala el checkout de dLocal Go en tu tienda Shopify y comienza a recibir pagos hoy mismo.',
    en: 'Install dLocal Go checkout in your Shopify store and start accepting payments today.',
    pt: 'Instale o checkout dLocal Go na sua loja Shopify e comece a receber pagamentos hoje.',
  },
  'paymentIntegration.shopify.desc.installed.transparent': {
    en: 'You already have dLocal Go installed on your Shopify store.<br/><br/>If you want to make a test payment before going live, enable test mode.',
    es: 'Ya tienes instalado dLocal Go en tu tienda Shopify.<br/><br/>Si quieres hacer un pago de prueba antes de ir a producción, activa el modo de prueba.',
    pt: 'Você já tem o dLocal Go instalado em sua loja da Shopify.<br/><br/>Se você quiser fazer um pagamento de teste antes de entrar no ar, habilite o modo de teste.',
  },
  'paymentIntegration.moreInfo.ourDocumentation.transparent': {
    en: 'Follow the installation steps',
    es: 'Sigue los pasos de instalación',
    pt: 'Siga as etapas de instalação',
  },
  'paymentIntegration.moreInfo.transparent': {
    en: ' and your site will be ready to sell safely.',
    es: ' y tu sitio ya estará listo para vender de forma segura.',
    pt: ' e seu site estará pronto para vender com segurança.',
  },
  'paymentIntegration.shopify.test.docs.text.installed.transparent': {
    en: 'Also make sure test mode is enabled in your Shopify dashboard by following',
    es: 'También asegúrate que el modo de prueba esté activado en tu panel de Shopify siguiendo',
    pt: 'Além disso, certifique-se de que o modo de teste esteja ativado em seu painel da Shopify seguindo',
  },
  'paymentIntegration.shopify.test.docs.installed.transparent': {
    en: 'these steps.',
    es: 'Estos pasos.',
    pt: 'estas etapas.',
  },
  'paymentIntegration.shopify.test.reminder.installed.transparent': {
    en: "After you check the test mode, don't forget to deactivate it to be able to go live.",
    es: 'Después de activar el modo de prueba, no olvides desactivarlo para poder ir a producción.',
    pt: 'Depois de verificar o modo de teste, não se esqueça de desativá-lo para poder processar pagamentos reais.',
  },
  'paymentIntegration.shopify.add': {
    en: `Install ${brandName} in Shopify`,
    es: `Instalar ${brandName} en Shopify`,
    pt: `Instale o ${brandName} no Shopify`,
  },
  'paymentIntegration.shopify.environment.testing': {
    en: 'Test mode',
    es: 'Modo de prueba',
    pt: 'Modo de teste',
  },
  'paymentIntegration.addToMagento': {
    en: 'Magento',
    es: 'Magento',
    pt: 'Magento',
  },
  'paymentIntegration.magento.desc': {
    en: `Install ${brandName} checkout in your Magento store and start receiving payments today.`,
    es: `Instala el checkout de ${brandName} en tu tienda Magento y comienza a recibir pagos hoy mismo.`,
    pt: `Instale o checkout ${brandName} em sua loja Magento e comece a receber pagamentos hoje.`,
  },
  'paymentIntegration.magento.link': {
    en: 'Follow the three installation steps',
    es: 'Sigue los tres pasos de instalación',
    pt: 'Siga as três etapas de instalação',
  },
  'paymentIntegration.magento.desc2': {
    en: ' and your site will be ready to sell safely.',
    es: ' y tu sitio ya estará listo para vender de forma segura.',
    pt: ' e seu site estará pronto para vender com segurança.',
  },
  'paymentIntegration.magento.add': {
    en: `Install ${brandName} in Magento`,
    es: `Instalar ${brandName} en Magento`,
    pt: `Instalar ${brandName} em Magento`,
  },
  'paymentIntegration.addToWooCommerce': {
    en: 'WooCommerce',
    es: 'WooCommerce',
    pt: 'WooCommerce',
  },
  'paymentIntegration.woocommerce.desc': {
    en: `Install ${brandName} checkout in your WooCommerce store and start receiving payments today.`,
    es: `Instala el checkout de ${brandName} en tu tienda WooCommerce y comienza a recibir pagos hoy mismo.`,
    pt: `Instale o checkout ${brandName} em sua loja WooCommerce e comece a receber pagamentos hoje.`,
  },
  'paymentIntegration.woocommerce.link': {
    en: 'Follow the three installation steps',
    es: 'Sigue los tres pasos de instalación',
    pt: 'Siga as três etapas de instalação',
  },
  'paymentIntegration.woocommerce.desc2': {
    en: ' and your site will be ready to sell safely.',
    es: ' y tu sitio ya estará listo para vender de forma segura.',
    pt: ' e seu site estará pronto para vender com segurança.',
  },
  'paymentIntegration.woocommerce.add': {
    en: `Install ${brandName} in WooCommerce`,
    es: `Instalar ${brandName} en WooCommerce`,
    pt: `Instalar ${brandName} em WooCommerce`,
  },
  'paymentIntegration.apiIntegration': {
    en: 'API integration',
    es: 'Integración por API',
    pt: 'Integração por API',
  },
  'paymentIntegration.apiIntegration.desc': {
    en: `If you have programming knowledge or access to a development team, you can integrate through our API REST. The integration through API offers greater flexibility so that you can integrate your system with ${brandName}, no matter what platform it is on or in what language it is implemented.`,
    es: `Si tiene conocimientos de programación o acceso a un equipo de desarrollo, puedes integrarte a través de nuestra API REST. La integración mediante API ofrece mayor flexibilidad para que puedas integrar tu sistema con ${brandName}, sin importar en qué plataforma se encuentre o en que lenguaje esté implementado.`,
    pt: `Se você tem conhecimento de programação ou acesso a uma equipe de desenvolvimento, pode integrar através de nossa API REST. A integração através de API oferece maior flexibilidade para que você possa integrar seu sistema com o ${brandName}, não importando em que plataforma esteja ou em que idioma esteja implementado.`,
  },
  'uploadFile.label': {
    en: 'UPLOAD FILE',
    es: 'SUBIR ARCHIVO',
    pt: 'SUBIR ARQUIVO',
  },
  'uploadFile.sizeExceeds': {
    en: 'The attached file size exceeds the maximum allowed.',
    es: 'El tamaño del archivo adjunto supera el máximo permitido.',
    pt: 'O tamanho do arquivo anexado excede o máximo permitido.',
  },
  'uploadFile.notSupported': {
    en: 'Format not supported.',
    es: 'Formato no soportado.',
    pt: 'Formato não suportado.',
  },
  'uploadFile.error': {
    en: 'Error loading the file. Try again.',
    es: 'Error al cargar el archivo. Inténtalo de nuevo.',
    pt: 'Erro ao carregar o arquivo. Tente novamente.',
  },
  'uploadFile.noFiles': {
    en: 'No files have been uploaded.',
    es: 'No se han cargado archivos.',
    pt: 'Nenhum arquivo foi carregado.',
  },
  'uploadFile.desc': {
    en: 'Maximum size {0}MB.<br/>Allowed extensions: <b>{1}</b>.',
    es: 'Tamaño máximo {0}MB.<br/>Extensiones permitidas: <b>{1}</b>.',
    pt: 'Tamanho máximo {0}MB.<br/>Extensões permitidas: <b>{1}</b>.',
  },
  'uploadFile.success': {
    en: 'The document was uploaded successfully.',
    es: 'El documento fue subido correctamente.',
    pt: 'O documento foi carregado com sucesso.',
  },
  'kycUploadFile.documentApproved': {
    en: 'The uploaded document was approved',
    es: 'El documento cargado fue aprobado',
    pt: 'O documento carregado foi aprovado',
  },
  'kycUploadFile.documentRejected': {
    en: 'The uploaded document was rejected by',
    es: 'El documento cargado fue rechazado por',
    pt: 'O documento carregado foi rejeitado por',
  },
  'kycUploadFile.documentRejected.reason.BANK_ACCOUNT_SCREENSHOT_FROM_BANK_APP': {
    en: "Screenshot from the bank's app",
    es: 'El documento es una captura de pantalla de la aplicación del banco',
    pt: 'Captura de tela do aplicativo do banco',
  },
  'kycUploadFile.documentRejected.reason.BANK_ACCOUNT_ANOTHER_BANK_ACCOUNT': {
    en: 'The submitted bank account does not match the provided document.',
    es: 'La cuenta bancaria ingresada no corresponde con el comprobante enviado.',
    pt: 'A conta bancária informada não corresponde ao comprovante enviado.',
  },
  'kycUploadFile.documentRejected.reason.BANK_ACCOUNT_WRONG_DOCUMENT': {
    en: 'The submitted bank account proof is invalid. You can review valid documents in our <a href="https://helpcenter.dlocalgo.com/en/articles/9567053-what-documents-do-i-need-to-submit-to-set-up-my-account" target="_blank">help center</a>.',
    es: 'El comprobante de cuenta bancaria enviado es inválido. Puedes revisar los documentos válidos en nuestro <a href="https://helpcenter.dlocalgo.com/es/articles/9567053-que-documentos-debo-presentar-para-configurar-mi-cuenta" target="_blank">centro de ayuda</a>.',
    pt: 'O comprovante de conta bancária enviado é inválido. Você pode revisar os documentos válidos no nosso <a href="https://helpcenter.dlocalgo.com/pt-BR/articles/9567053-que-documentos-tenho-de-apresentar-para-criar-a-minha-conta" target="_blank">centro de ajuda</a>.',
  },
  'kycUploadFile.documentRejected.reason.BANK_ACCOUNT_DOCUMENT_REQUIRES_PASSWORD': {
    en: 'The submitted bank account document requires a password to view.',
    es: 'El comprobante de cuenta bancaria enviado requiere contraseña para visualizarlo.',
    pt: 'O comprovante de conta bancária enviado requer senha para visualização.',
  },
  'kycUploadFile.documentRejected.reason.BANK_ACCOUNT_ACCOUNT_IN_USD': {
    en: 'The submitted bank account is in USD; it must be in local currency.',
    es: 'La cuenta bancaria ingresada corresponde a USD, la misma debe ser en moneda local.',
    pt: 'A conta bancária informada está em USD; deve estar em moeda local.',
  },
  'kycUploadFile.documentRejected.reason.IDENTITY_NOT_LEGIBLE': {
    en: 'The submitted identity document is not legible.',
    es: 'El documento de identidad enviado no es legible.',
    pt: 'O documento de identidade enviado não é legível.',
  },
  'kycUploadFile.documentRejected.reason.IDENTITY_NO_MATCH': {
    en: 'The identity document does not match the registered account data.',
    es: 'El documento de identidad enviado no corresponde a los datos registrados en la cuenta.',
    pt: 'O documento de identidade enviado não corresponde aos dados registrados na conta.',
  },
  'kycUploadFile.documentRejected.reason.IDENTITY_NOT_OVER_18': {
    en: 'The identity document belongs to a person under 18 years old.',
    es: 'El documento de identidad corresponde a una persona menor de 18 años.',
    pt: 'O documento de identidade pertence a uma pessoa menor de 18 anos.',
  },
  'kycUploadFile.documentRejected.reason.IDENTITY_WRONG_DOCUMENT': {
    en: 'The submitted identity document is invalid. You can review valid documents in our <a href="https://helpcenter.dlocalgo.com/en/articles/9567053-what-documents-do-i-need-to-submit-to-set-up-my-account" target="_blank">help center</a>.',
    es: 'El documento de identidad enviado es inválido. Puedes revisar los documentos válidos en nuestro <a href="https://helpcenter.dlocalgo.com/es/articles/9567053-que-documentos-debo-presentar-para-configurar-mi-cuenta" target="_blank">centro de ayuda</a>.',
    pt: 'O documento de identidade enviado é inválido. Você pode revisar os documentos válidos no nosso <a href="https://helpcenter.dlocalgo.com/pt-BR/articles/9567053-que-documentos-tenho-de-apresentar-para-criar-a-minha-conta" target="_blank">centro de ajuda</a>.',
  },
  'kycUploadFile.documentRejected.reason.IDENTITY_DOCUMENT_REQUIRES_PASSWORD': {
    en: 'The submitted identity document requires a password to view.',
    es: 'El documento de identidad enviado requiere contraseña para visualizarlo.',
    pt: 'O documento de identidade enviado requer senha para visualização.',
  },
  'kycUploadFile.documentRejected.reason.ADDRESS_NO_MATCH_NAME': {
    en: 'The owner of the address document does not match the registered account data.',
    es: 'El propietario del comprobante de domicilio no corresponde a los datos registrados en la cuenta.',
    pt: 'O proprietário do comprovante de endereço não corresponde aos dados registrados na conta.',
  },
  'kycUploadFile.documentRejected.reason.ADDRESS_WRONG_DOCUMENT': {
    en: 'The submitted address document is invalid. You can review valid documents in our <a href="https://helpcenter.dlocalgo.com/en/articles/9567053-what-documents-do-i-need-to-submit-to-set-up-my-account" target="_blank">help center</a>.',
    es: 'El comprobante de domicilio enviado es inválido. Puedes revisar los documentos válidos en nuestro <a href="https://helpcenter.dlocalgo.com/es/articles/9567053-que-documentos-debo-presentar-para-configurar-mi-cuenta" target="_blank">centro de ayuda</a>.',
    pt: 'O comprovante de endereço enviado é inválido. Você pode revisar os documentos válidos no nosso <a href="https://helpcenter.dlocalgo.com/pt-BR/articles/9567053-que-documentos-tenho-de-apresentar-para-criar-a-minha-conta" target="_blank">centro de ajuda</a>.',
  },
  'kycUploadFile.documentRejected.reason.ADDRESS_DOCUMENT_REQUIRES_PASSWORD': {
    en: 'The submitted address document requires a password to view.',
    es: 'El comprobante de domicilio enviado requiere contraseña para visualizarlo.',
    pt: 'O comprovante de endereço enviado requer senha para visualização.',
  },
  'kycUploadFile.documentRejected.reason.ADDRESS_SIX_MONTHS_OLD': {
    en: 'The address document is 6 months old or more.',
    es: 'El comprobante de domicilio tiene una antigüedad mayor o igual a 6 meses.',
    pt: 'O comprovante de endereço tem 6 meses ou mais de validade.',
  },
  'kycUploadFile.documentRejected.reason.SHAREHOLDERS_ANOTHER_DOCUMENT': {
    en: 'The submitted company resolution is invalid. You can review valid documents in our <a href="https://helpcenter.dlocalgo.com/en/articles/9567053-what-documents-do-i-need-to-submit-to-set-up-my-account" target="_blank">help center</a>.',
    es: 'El acta de empresa enviado es inválido. Puedes revisar los documentos válidos en nuestro <a href="https://helpcenter.dlocalgo.com/es/articles/9567053-que-documentos-debo-presentar-para-configurar-mi-cuenta" target="_blank">centro de ayuda</a>.',
    pt: 'A ata da empresa enviada é inválida. Você pode revisar os documentos válidos no nosso <a href="https://helpcenter.dlocalgo.com/pt-BR/articles/9567053-que-documentos-tenho-de-apresentar-para-criar-a-minha-conta" target="_blank">centro de ajuda</a>.',
  },
  'kycUploadFile.documentRejected.reason.SHAREHOLDERS_DOCUMENT_REQUIRES_PASSWORD': {
    en: 'The submitted company resolution requires a password to view.',
    es: 'El acta de empresa enviado requiere contraseña para visualizarlo.',
    pt: 'A ata da empresa enviada requer senha para visualização.',
  },
  'kycUploadFile.documentRejected.reason.TAX_COMPLIANCE_INVALID_DOCUMENT': {
    en: 'The submitted tax compliance document is invalid. You can review valid documents in our <a href="https://helpcenter.dlocalgo.com/en/articles/9567053-what-documents-do-i-need-to-submit-to-set-up-my-account" target="_blank">help center</a>.',
    es: 'El comprobante tributario enviado es inválido. Puedes revisar los documentos válidos en nuestro <a href="https://helpcenter.dlocalgo.com/es/articles/9567053-que-documentos-debo-presentar-para-configurar-mi-cuenta" target="_blank">centro de ayuda</a>.',
    pt: 'O comprovante tributário enviado é inválido. Você pode revisar os documentos válidos no nosso <a href="https://helpcenter.dlocalgo.com/pt-BR/articles/9567053-que-documentos-tenho-de-apresentar-para-criar-a-minha-conta" target="_blank">centro de ajuda</a>.',
  },
  'kycUploadFile.documentRejected.reason.TAX_COMPLIANCE_WRONG_DOCUMENT': {
    en: 'The submitted tax compliance document is invalid. You can review valid documents in our <a href="https://helpcenter.dlocalgo.com/en/articles/9567053-what-documents-do-i-need-to-submit-to-set-up-my-account" target="_blank">help center</a>.',
    es: 'El comprobante tributario enviado es inválido. Puedes revisar los documentos válidos en nuestro <a href="https://helpcenter.dlocalgo.com/es/articles/9567053-que-documentos-debo-presentar-para-configurar-mi-cuenta" target="_blank">centro de ayuda</a>.',
    pt: 'O comprovante tributário enviado é inválido. Você pode revisar os documentos válidos no nosso <a href="https://helpcenter.dlocalgo.com/pt-BR/articles/9567053-que-documentos-tenho-de-apresentar-para-criar-a-minha-conta" target="_blank">centro de ajuda</a>.',
  },
  'kycUploadFile.documentRejected.reason.TAX_COMPLIANCE_DOCUMENT_REQUIRES_PASSWORD': {
    en: 'The submitted tax compliance document requires a password to view.',
    es: 'El comprobante tributario enviado requiere contraseña para visualizarlo.',
    pt: 'O comprovante tributário enviado requer senha para visualização.',
  },
  'kycUploadFile.documentSubmitted': {
    en: 'The uploaded document is in review',
    es: 'El documento cargado está en revisión',
    pt: 'O documento carregado está em revisão',
  },
  'refunds.status.CREATED': {
    en: 'Created',
    es: 'Creado',
    pt: 'Criado',
  },
  'refunds.details': {
    en: 'Refunds detail',
    es: 'Detalle de reembolso',
    pt: 'Detalhe de reembolso',
  },
  'refunds.details.backBtn': {
    en: 'Back to refunds',
    es: 'Volver a reembolsos',
    pt: 'Voltar para reembolsos',
  },
  'refunds.details.amountPaid': {
    en: 'Amount paid',
    es: 'Monto pagado',
    pt: 'Valor pago',
  },
  'refunds.transactionId': {
    en: 'Transaction ID',
    es: 'ID de Transacción',
    pt: 'ID da Transação',
  },
  'refunds.details.issuedBy': {
    en: 'Refund issued by',
    es: 'Reembolso emitido por',
    pt: 'Reembolso emitido por',
  },
  'refunds.details.paidTo': {
    en: 'Refund paid to',
    es: 'Reembolso pagado a',
    pt: 'Reembolso pago a',
  },
  'refunds.status.PENDING': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'refunds.status.ON_HOLD': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'refunds.status.COMPLETED': {
    en: 'Completed',
    es: 'Completado',
    pt: 'Concluído',
  },
  'refunds.status.CANCELLED': {
    en: 'Cancelled',
    es: 'Cancelado',
    pt: 'Cancelado',
  },
  'refunds.status.DECLINED': {
    en: 'Declined',
    es: 'Declinado',
    pt: 'Recusado',
  },
  'refunds.status.REJECTED': {
    en: 'Rejected',
    es: 'Rechazado',
    pt: 'Rejeitado',
  },
  'refunds.status.FAILED': {
    en: 'Failed',
    es: 'Fallido',
    pt: 'Falhado',
  },
  'refunds.noRefunds': {
    en: 'You have no refunds yet',
    es: 'No tienes ningún reembolso aún',
    pt: 'Você ainda não tem reembolsos',
  },
  'refunds.id': {
    en: 'Refund ID',
    es: 'ID de reembolso',
    pt: 'ID de reembolso',
  },
  'refunds.createDate': {
    en: 'Creation date',
    es: 'Fecha de creación',
    pt: 'Data de criação',
  },
  'refunds.date': {
    en: 'Date',
    es: 'Fecha',
    pt: 'Data',
  },
  'refunds.time': {
    en: 'Time',
    es: 'Hora',
    pt: 'Hora',
  },
  'refunds.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'refunds.paymentMethod': {
    en: 'Payment method',
    es: 'Método de pago',
    pt: 'Forma de pagamento',
  },
  'refunds.localAmount': {
    en: 'Local amount',
    es: 'Monto local',
    pt: 'Valor local',
  },
  'refunds.balanceAmount': {
    en: 'Balance',
    es: 'Balance',
    pt: 'Saldo',
  },
  'refunds.balanceFee': {
    en: 'Fee',
    es: 'Comisión',
    pt: 'Taxa',
  },
  'refunds.status': {
    en: 'Status',
    es: 'Estado',
    pt: 'Estado',
  },
  'refunds.filter.status': {
    en: 'Select state',
    es: 'Seleccione estado',
    pt: 'Selecione o estado',
  },
  'refunds.filter.country': {
    en: 'Select country',
    es: 'Seleccione país',
    pt: 'Selecione o pais',
  },
  'refunds.filter.paymentMethod': {
    en: 'Select payment method',
    es: 'Seleccione un método de pago',
    pt: 'Selecione uma forma de pagamento',
  },
  'refunds.filter.paymentMethod.desc': {
    en: 'First, you must filter by country.',
    es: 'Primero, debes filtrar por país.',
    pt: 'Primeiro, você deve filtrar por país.',
  },
  'exportRefunds.title': {
    en: 'Download report',
    es: 'Descargar reporte',
    pt: 'Baixar relatório',
  },
  'exportRefunds.open': {
    en: 'Export Refunds',
    es: 'Exportar Reembolsos',
    pt: 'Exportar Reembolsos',
  },
  'exportRefunds.exportBtn': {
    en: 'Download',
    es: 'Descargar',
    pt: 'Baixar',
  },
  'exportRefunds.range': {
    en: 'Select date range',
    es: 'Seleccione el rango de fechas',
    pt: 'Selecione o intervalo de datas',
  },
  'exportRefunds.successMessage': {
    en: 'If the file download does not start, check that your browser has not blocked it.',
    es: 'Si la descarga del archivo no se inicia, verifique que su navegador no lo haya bloqueado.',
    pt: 'Se o download do arquivo não iniciar, verifique se seu navegador não o bloqueou.',
  },
  'exportRefunds.downloadAgain': {
    en: 'You can try to download it again by clicking ',
    es: 'Puedes intentar descargarlo nuevamente haciendo clic ',
    pt: 'Você pode tentar baixá-lo novamente clicando ',
  },
  'exportRefunds.downloadAgain.here': {
    en: 'here.',
    es: 'aquí.',
    pt: 'aqui.',
  },
  'exportRefunds.invalidDates': {
    en: 'The selected dates are invalid.',
    es: 'Las fechas seleccionadas son inválidas.',
    pt: 'As datas selecionadas são inválidas.',
  },
  'exportRefunds.rangeError': {
    en: 'The date range cannot be greater than 31 days.',
    es: 'El rango de fechas no puede ser mayor a 31 días.',
    pt: 'O intervalo de datas não pode ser superior a 31 dias.',
  },
  'exportRefunds.empty': {
    en: 'No data to download found.',
    es: 'No se encontraron datos para descargar.',
    pt: 'Nenhum dado para download encontrado.',
  },
  'exportRefunds.otherFilters': {
    en: 'Optional filters',
    es: 'Filtros opcionales',
    pt: 'Filtros opcionais',
  },
  'addRefund.title': {
    en: 'Request refund',
    es: 'Solicitar reembolso',
    pt: 'Pedido de reembolso',
  },
  'addRefund.error.amountExceeds': {
    en: 'The entered value exceeds the transaction amount.',
    es: 'El valor ingresado supera el monto de la transacción.',
    pt: 'O valor inserido excede o valor da transação.',
  },
  'addRefund.desc': {
    en: 'Please complete the following information to create the refund request.',
    es: 'Por favor, complete la siguiente información para crear la solicitud de reembolso.',
    pt: 'Por favor, complete as seguintes informações para criar a solicitação de reembolso.',
  },
  'addRefund.timeToProcess': {
    en: 'Refunds for bank transfers and cash payments can take up to 7 business days to process.',
    es: 'Los reembolsos por transferencias bancarias y pagos en efectivo pueden demorar hasta 7 días hábiles en procesarse.',
    pt: 'Reembolsos para transferências bancárias e pagamentos em dinheiro podem levar até 7 dias úteis para serem processados.',
  },
  'addRefund.accountType': {
    en: 'Account type *',
    es: 'Tipo de cuenta *',
    pt: 'Tipo de conta *',
  },
  'addRefund.bankAccount.title': {
    en: 'Bank account',
    es: 'Cuenta bancaria',
    pt: 'Conta bancária',
  },
  'addRefund.amount': {
    en: 'Amount to refund *',
    es: 'Monto a reembolsar *',
    pt: 'Valor à reembolsar *',
  },
  'addRefund.beneficiary': {
    en: 'Name of the Beneficiary',
    es: 'Nombre del beneficiario',
    pt: 'Nome do beneficiário',
  },
  'addRefund.bankCode': {
    en: 'Bank *',
    es: 'Banco *',
    pt: 'Banco *',
  },
  'addRefund.bankAccount': {
    en: 'Bank account number *',
    es: 'Número de cuenta bancaria *',
    pt: 'Numero de conta bancária *',
  },
  'addRefund.bankAccount.message': {
    en: 'The owner of the account entered must coincide with the beneficiary.',
    es: 'El titular de la cuenta ingresada debe coincidir con el beneficiario.',
    pt: 'O titular da conta inserida deve coincidir com o beneficiário.',
  },
  'addRefund.bankBranch': {
    en: 'Branch *',
    es: 'Sucursal *',
    pt: 'Agência *',
  },
  'addRefund.btn': {
    en: 'Send request',
    es: 'Enviar solicitud',
    pt: 'Enviar solicitação',
  },
  'addRefund.success': {
    en: 'Successful refund request!',
    es: '¡Solicitud de reembolso exitosa!',
    pt: 'Solicitação de reembolso bem-sucedida!',
  },
  'addRefund.note': {
    en: 'Note: Refund fees apply.',
    es: 'Nota: Se aplican tarifas de reembolso.',
    pt: 'Nota: Taxas de reembolso aplicáveis.',
  },
  'addRefund.noteRequiredfields': {
    en: '(*) Required fields.',
    es: '(*) Campos obligatórios.',
    pt: '(*) Campos obrigatórios.',
  },
  'msgError.requestRefund.dataProvided': {
    en: 'It was not possible to create the refund with the data provided.',
    es: 'No fue posible crear el reembolso con los datos proporcionados.',
    pt: 'Não foi possível fazer o reembolso com os dados fornecidos.',
  },
  'msgError.requestRefund.amountEntered': {
    en: 'The amount entered exceeds the available balance in the selected transaction.',
    es: 'El monto ingresado excede el saldo disponible en la transacción seleccionada.',
    pt: 'O valor inserido excede o saldo disponível na transação selecionada.',
  },
  'msgError.requestRefund.insufficientBalance': {
    en: 'Insufficient available balance.',
    es: 'Saldo disponible insuficiente.',
    pt: 'Saldo disponível insuficiente.',
  },
  'msgError.requestRefund.amountLess': {
    en: 'The refund amount is less than the minimum allowed.',
    es: 'El monto del reembolso es menor que el mínimo permitido.',
    pt: 'O valor do reembolso é inferior ao mínimo permitido.',
  },
  'msgError.requestRefund.chargebackInPlace': {
    en: 'A refund cannot be requested because this transaction has an associated chargeback.',
    es: 'No es posible solicitar un reembolso porque esta transacción tiene un contracargo asociado.',
    pt: 'Não é possível solicitar um reembolso porque esta transação possui um chargeback associado.',
  },
  'payouts.status.CREATED': {
    en: 'Created',
    es: 'Creado',
    pt: 'Criado',
  },
  'payouts.drawer.title': {
    en: 'Payout detail',
    es: 'Detalle del pago',
    pt: 'Detalhe do pagamento',
  },
  'payouts.drawer.payoutId': {
    en: 'Payout ID',
    es: 'ID del pago',
    pt: 'ID do pagamento',
  },
  'payouts.drawer.creationDate': {
    en: 'Creation date',
    es: 'Fecha de creación',
    pt: 'Data de criação',
  },
  'payouts.drawer.estimatedDate': {
    en: 'Estimated date',
    es: 'Fecha estimada',
    pt: 'Data estimada',
  },
  'payouts.drawer.paymentDetail': {
    en: 'Payment detail',
    es: 'Detalle del pago',
    pt: 'Detalhe do pagamento',
  },
  'payouts.drawer.amountSent': {
    en: 'Amount sent',
    es: 'Monto enviado',
    pt: 'Valor enviado',
  },
  'payouts.drawer.currency': {
    en: 'Currency',
    es: 'Moneda',
    pt: 'Moeda',
  },
  'payouts.drawer.fee': {
    en: 'Fee',
    es: 'Comisión',
    pt: 'Taxa',
  },
  'payouts.drawer.exchangeRate': {
    en: 'Exchange rate',
    es: 'Tipo de cambio',
    pt: 'Taxa de câmbio',
  },
  'payouts.drawer.purpose': {
    en: 'Purpose',
    es: 'Propósito',
    pt: 'Propósito',
  },
  'payouts.drawer.description': {
    en: 'Description',
    es: 'Descripción',
    pt: 'Descrição',
  },
  'payouts.drawer.recipientDetail': {
    en: 'Recipient detail',
    es: 'Detalle del destinatario',
    pt: 'Detalhe do destinatário',
  },
  'payouts.drawer.accountType': {
    en: 'Account type',
    es: 'Tipo de cuenta',
    pt: 'Tipo de conta',
  },
  'payouts.drawer.accountHolder': {
    en: 'Account holder',
    es: 'Titular de la cuenta',
    pt: 'Titular da conta',
  },
  'payouts.drawer.accountNumber': {
    en: 'Account number',
    es: 'Número de cuenta',
    pt: 'Número da conta',
  },
  'payouts.drawer.beneficiaryDocument': {
    en: 'Beneficiary document',
    es: 'Documento del beneficiario',
    pt: 'Documento do beneficiário',
  },
  'payouts.drawer.email': {
    en: 'Email',
    es: 'Correo electrónico',
    pt: 'E-mail',
  },
  'payouts.drawer.downloadReceipt': {
    en: 'Download receipt',
    es: 'Descargar recibo',
    pt: 'Baixar recibo',
  },
  'payouts.newPayout': {
    en: 'New Payout',
    es: 'Nuevo Pago',
    pt: 'Novo Pagamento',
  },
  'payouts.status.PENDING': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'payouts.status.COMPLETED': {
    en: 'Completed',
    es: 'Completado',
    pt: 'Concluído',
  },
  'payouts.status.CANCELLED': {
    en: 'Cancelled',
    es: 'Cancelado',
    pt: 'Cancelado',
  },
  'payouts.status.DECLINED': {
    en: 'Declined',
    es: 'Declinado',
    pt: 'Recusado',
  },
  'payouts.status.REJECTED': {
    en: 'Rejected',
    es: 'Rechazado',
    pt: 'Rejeitado',
  },
  'payouts.status.FAILED': {
    en: 'Failed',
    es: 'Fallido',
    pt: 'Falhou',
  },
  'payouts.status.ON_HOLD': {
    en: 'On hold',
    es: 'En espera',
    pt: 'Em espera',
  },
  'payouts.status.PROCESSING': {
    en: 'Processing',
    es: 'Procesando',
    pt: 'Processando',
  },
  'payouts.noPayouts': {
    en: 'You have no payouts yet',
    es: 'No tienes ningún pago aún',
    pt: 'Você ainda não tem pagamentos',
  },
  'payouts.id': {
    en: 'Payout ID',
    es: 'ID de pago',
    pt: 'ID de pagamento',
  },
  'payouts.createDate': {
    en: 'Creation date',
    es: 'Fecha de creación',
    pt: 'Data de criação',
  },
  'payouts.creationDate': {
    en: 'Creation date',
    es: 'Fecha de creación',
    pt: 'Data de criação',
  },
  'payouts.completedDate': {
    en: 'Completed date',
    es: 'Fecha de completado',
    pt: 'Data de conclusão',
  },
  'payouts.bankName': {
    en: 'Bank name',
    es: 'Nombre del banco',
    pt: 'Nome do banco',
  },
  'payouts.paidAmount': {
    en: 'Paid amount',
    es: 'Monto pagado',
    pt: 'Valor pago',
  },
  'payouts.balanceAmount': {
    en: 'Balance amount',
    es: 'Monto de balance',
    pt: 'Valor de balance',
  },
  'payouts.date': {
    en: 'Date',
    es: 'Fecha',
    pt: 'Data',
  },
  'payouts.time': {
    en: 'Time',
    es: 'Hora',
    pt: 'Hora',
  },
  'payouts.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'payouts.paymentMethod': {
    en: 'Payment method',
    es: 'Método de pago',
    pt: 'Forma de pagamento',
  },
  'payouts.localAmount': {
    en: 'Local amount',
    es: 'Monto local',
    pt: 'Valor local',
  },
  'payouts.balanceFee': {
    en: 'Fee',
    es: 'Comisión',
    pt: 'Taxa',
  },
  'payouts.status': {
    en: 'Status',
    es: 'Estado',
    pt: 'Estado',
  },
  'payouts.filter.status': {
    en: 'Select state',
    es: 'Seleccione estado',
    pt: 'Selecione o estado',
  },
  'payouts.filter.country': {
    en: 'Select country',
    es: 'Seleccione país',
    pt: 'Selecione o pais',
  },
  'payouts.filter.search.payoutId': {
    en: 'Payout ID',
    es: 'ID de pago',
    pt: 'ID de pagamento',
  },
  'payouts.filter.search.beneficiaryFirstName': {
    en: 'Beneficiary first name',
    es: 'Nombre del beneficiario',
    pt: 'Nome do beneficiário',
  },
  'payouts.filter.search.beneficiaryLastName': {
    en: 'Beneficiary last name',
    es: 'Apellido del beneficiario',
    pt: 'Sobrenome do beneficiário',
  },
  'payouts.filter.search.beneficiaryDocument': {
    en: 'Beneficiary document',
    es: 'Documento del beneficiario',
    pt: 'Documento do beneficiário',
  },
  'payouts.filter.search.placeholder': {
    en: 'Search by payout ID, beneficiary...',
    es: 'Buscar por ID de pago, beneficiario...',
    pt: 'Pesquisar por ID de pagamento, beneficiário...',
  },
  'payoutContacts.subtitle': {
    en: "Manage your saved contacts along with each one's identity verification status.",
    es: 'Gestione sus contactos agendados junto con el estado de verificación de identidad de cada uno.',
    pt: 'Gerencie seus contatos salvos junto com o status de verificação de identidade de cada um.',
  },
  'payoutContacts.desc': {
    en: 'Review your contacts or add new ones so they are ready before your next payout.',
    es: 'Revise sus contactos o añada nuevos para tenerlos listos antes de su próximo pago.',
    pt: 'Revise seus contatos ou adicione novos para tê-los prontos antes do seu próximo pagamento.',
  },
  'payoutContacts.add': {
    en: 'Add contact',
    es: 'Añadir contacto',
    pt: 'Adicionar contato',
  },
  'payoutContacts.create.title': {
    en: 'Create contact',
    es: 'Crear contacto',
    pt: 'Criar contato',
  },
  'payoutContacts.create.submit': {
    en: 'Create contact',
    es: 'Crear contacto',
    pt: 'Criar contato',
  },
  'payoutContacts.create.error.emailAlreadyExists': {
    en: 'A contact with this email already exists.',
    es: 'Ya existe un contacto con este correo electrónico.',
    pt: 'Já existe um contato com este e-mail.',
  },
  'payoutContacts.addAccount.title': {
    en: 'Add bank account',
    es: 'Añadir cuenta bancaria',
    pt: 'Adicionar conta bancária',
  },
  'payoutContacts.addAccount.submit': {
    en: 'Add bank account',
    es: 'Añadir cuenta bancaria',
    pt: 'Adicionar conta bancária',
  },
  'payoutContacts.editAccount.title': {
    en: 'Edit bank account',
    es: 'Editar cuenta bancaria',
    pt: 'Editar conta bancária',
  },
  'payoutContacts.editAccount.submit': {
    en: 'Save changes',
    es: 'Guardar cambios',
    pt: 'Salvar alterações',
  },
  'payoutContacts.relationship.SUPPLIER': {
    en: 'Supplier',
    es: 'Proveedor',
    pt: 'Fornecedor',
  },
  'payoutContacts.relationship.EMPLOYEE': {
    en: 'Employee',
    es: 'Empleado',
    pt: 'Funcionário',
  },
  'payoutContacts.relationship.CONTRACTOR': {
    en: 'Contractor',
    es: 'Contratista',
    pt: 'Contratado',
  },
  'payoutContacts.relationship.FAMILY': {
    en: 'Family',
    es: 'Familiar',
    pt: 'Familiar',
  },
  'payoutContacts.relationship.FRIEND': {
    en: 'Friend',
    es: 'Amigo',
    pt: 'Amigo',
  },
  'payoutContacts.relationship.OTHER': {
    en: 'Other',
    es: 'Otro',
    pt: 'Outro',
  },
  'payoutContacts.search.placeholder': {
    en: 'Search by name or email',
    es: 'Buscar por nombre o correo',
    pt: 'Pesquisar por nome ou e-mail',
  },
  'payoutContacts.downloadHistory': {
    en: 'Download history',
    es: 'Descargar historial',
    pt: 'Baixar histórico',
  },
  'payoutContacts.export.title': {
    en: 'Download history',
    es: 'Descargar historial',
    pt: 'Baixar histórico',
  },
  'payoutContacts.export.createdRange': {
    en: 'Created date range',
    es: 'Rango de alta',
    pt: 'Intervalo de cadastro',
  },
  'payoutContacts.export.expiresRange': {
    en: 'Expiration date range',
    es: 'Rango de expiración',
    pt: 'Intervalo de expiração',
  },
  'payoutContacts.column.contact': {
    en: 'Contact',
    es: 'Contacto',
    pt: 'Contato',
  },
  'payoutContacts.column.createdAt': {
    en: 'Created date',
    es: 'Fecha de alta',
    pt: 'Data de cadastro',
  },
  'payoutContacts.column.expiresAt': {
    en: 'Expiration date',
    es: 'Fecha de expiración',
    pt: 'Data de expiração',
  },
  'payoutContacts.column.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'payoutContacts.column.verificationLink': {
    en: 'Verification link',
    es: 'Link de verificación',
    pt: 'Link de verificação',
  },
  'payoutContacts.column.verificationStatus': {
    en: 'Verification status',
    es: 'Estado de verificación',
    pt: 'Status de verificação',
  },
  'payoutContacts.status.PENDING': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'payoutContacts.status.PROCESSING': {
    en: 'Processing',
    es: 'Procesando',
    pt: 'Processando',
  },
  'payoutContacts.status.REJECTED': {
    en: 'Rejected',
    es: 'Rechazado',
    pt: 'Rejeitado',
  },
  'payoutContacts.status.VERIFIED': {
    en: 'Verified',
    es: 'Verificado',
    pt: 'Verificado',
  },
  'payoutContacts.status.EXPIRED': {
    en: 'Expired',
    es: 'Expirado',
    pt: 'Expirado',
  },
  'payoutContacts.status.BLOCKED': {
    en: 'Blocked',
    es: 'Bloqueado',
    pt: 'Bloqueado',
  },
  'payoutContacts.menu.viewDetail': {
    en: 'See details',
    es: 'Ver detalle',
    pt: 'Ver detalhes',
  },
  'payoutContacts.menu.delete': {
    en: 'Delete',
    es: 'Eliminar',
    pt: 'Excluir',
  },
  'payoutContacts.menu.revalidate': {
    en: 'Revalidate identity',
    es: 'Revalidar identidad',
    pt: 'Revalidar identidade',
  },
  'payoutContacts.revalidate.confirm.title': {
    en: 'Revalidate contact identity',
    es: 'Revalidar identidad del contacto',
    pt: 'Revalidar identidade do contato',
  },
  'payoutContacts.revalidate.confirm.body': {
    en: 'The verification link will be sent again to the beneficiary so they can validate their identity.',
    es: 'Se enviará nuevamente el enlace de verificación al beneficiario para revalidar su identidad.',
    pt: 'O link de verificação será enviado novamente ao beneficiário para revalidar sua identidade.',
  },
  'payoutContacts.revalidate.confirm.fee': {
    en: 'This revalidation has an additional fee of USD {0}.',
    es: 'Esta revalidación tiene un cargo adicional de USD {0}.',
    pt: 'Esta revalidação tem uma taxa adicional de USD {0}.',
  },
  'payoutContacts.revalidate.sent.title': {
    en: 'Verification sent',
    es: 'Verificación enviada',
    pt: 'Verificação enviada',
  },
  'payoutContacts.revalidate.sent.body': {
    en: '{0} must complete the identity verification sent to their email address before it expires.',
    es: '{0} debe completar la verificación de identidad enviada a su correo antes de que expire.',
    pt: '{0} deve concluir a verificação de identidade enviada para seu e-mail antes que ela expire.',
  },
  'payoutContacts.revalidate.sent.helper': {
    en: 'Once verification is complete, the status will change to Verified. You can check the status from the contacts section.',
    es: 'Una vez completada la verificación, su estado cambiará a Verificado. Puedes consultar el estado desde la sección de contactos.',
    pt: 'Após a conclusão da verificação, o status mudará para Verificado. Você pode consultar o status na seção de contatos.',
  },
  'payoutContacts.revalidate.sent.moreInformation': {
    en: 'More information',
    es: 'Más información',
    pt: 'Mais informações',
  },
  'payoutContacts.detail.back': {
    en: 'Back to contacts',
    es: 'Volver a contactos',
    pt: 'Voltar para contatos',
  },
  'payoutContacts.detail.createdAt': {
    en: 'Created',
    es: 'Fecha de alta',
    pt: 'Data de cadastro',
  },
  'payoutContacts.detail.expiresAt': {
    en: 'Expiration',
    es: 'Expiración',
    pt: 'Expiração',
  },
  'payoutContacts.detail.status': {
    en: 'Status',
    es: 'Estado',
    pt: 'Status',
  },
  'payoutContacts.detail.beneficiaryInfo': {
    en: 'Beneficiary information',
    es: 'Información del beneficiario',
    pt: 'Informações do beneficiário',
  },
  'payoutContacts.detail.identification': {
    en: 'Identification',
    es: 'Identificación',
    pt: 'Identificação',
  },
  'payoutContacts.detail.relationship': {
    en: 'Reason / Relationship',
    es: 'Motivo / Relación',
    pt: 'Motivo / Relação',
  },
  'payoutContacts.detail.flowType': {
    en: 'Beneficiary type',
    es: 'Tipo de beneficiario',
    pt: 'Tipo de beneficiário',
  },
  'payoutContacts.detail.flowType.B2C': {
    en: 'Individual',
    es: 'Persona',
    pt: 'Pessoa física',
  },
  'payoutContacts.detail.flowType.B2B': {
    en: 'Business',
    es: 'Empresa',
    pt: 'Empresa',
  },
  'payoutContacts.detail.verificationAttempts': {
    en: 'Verification attempts',
    es: 'Intentos de verificación',
    pt: 'Tentativas de verificação',
  },
  'payoutContacts.detail.bankAccounts': {
    en: 'Bank account details',
    es: 'Datos de la cuenta bancaria',
    pt: 'Dados da conta bancária',
  },
  'payoutContacts.detail.account.preferred': {
    en: 'Primary',
    es: 'Principal',
    pt: 'Principal',
  },
  'payoutContacts.detail.account.preferred.success': {
    en: 'Primary bank account updated successfully.',
    es: 'Cuenta bancaria principal actualizada con éxito.',
    pt: 'Conta bancária principal atualizada com sucesso.',
  },
  'payoutContacts.detail.account.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'payoutContacts.detail.account.name': {
    en: 'Name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'payoutContacts.detail.account.documentType': {
    en: 'Document type',
    es: 'Tipo de documento',
    pt: 'Tipo de documento',
  },
  'payoutContacts.detail.account.document': {
    en: 'Document',
    es: 'Documento',
    pt: 'Documento',
  },
  'payoutContacts.detail.account.bank': {
    en: 'Bank',
    es: 'Banco',
    pt: 'Banco',
  },
  'payoutContacts.detail.account.number': {
    en: 'Account number',
    es: 'Número de cuenta',
    pt: 'Número da conta',
  },
  'payoutContacts.detail.account.details': {
    en: 'Account type / Branch',
    es: 'Tipo de cuenta / Sucursal',
    pt: 'Tipo de conta / Agência',
  },
  'payoutContacts.detail.account.empty': {
    en: 'This contact does not have bank accounts yet.',
    es: 'Este contacto todavía no tiene cuentas bancarias.',
    pt: 'Este contato ainda não possui contas bancárias.',
  },
  'payoutContacts.detail.account.edit': {
    en: 'Edit account',
    es: 'Editar cuenta',
    pt: 'Editar conta',
  },
  'payoutContacts.detail.account.actions': {
    en: 'Actions',
    es: 'Acciones',
    pt: 'Ações',
  },
  'payoutContacts.detail.account.delete': {
    en: 'Delete',
    es: 'Eliminar',
    pt: 'Excluir',
  },
  'payoutContacts.detail.account.delete.confirm.title': {
    en: 'Delete bank account?',
    es: '¿Eliminar cuenta bancaria?',
    pt: 'Excluir conta bancária?',
  },
  'payoutContacts.detail.account.delete.confirm.body': {
    en: 'This bank account will be permanently removed from the contact. This action cannot be undone.',
    es: 'Esta cuenta bancaria se eliminará permanentemente del contacto. Esta acción no se puede deshacer.',
    pt: 'Esta conta bancária será removida permanentemente do contato. Esta ação não pode ser desfeita.',
  },
  'payoutContacts.detail.verification': {
    en: 'Beneficiary verification',
    es: 'Verificación del beneficiario',
    pt: 'Verificação do beneficiário',
  },
  'payoutContacts.detail.lastVerifiedAt': {
    en: 'Last verification',
    es: 'Última verificación',
    pt: 'Última verificação',
  },
  'payoutContacts.detail.revalidationFee': {
    en: 'Revalidation fee',
    es: 'Costo de revalidación',
    pt: 'Taxa de revalidação',
  },
  'payoutContacts.empty.title': {
    en: "You don't have contacts yet",
    es: 'Aún no tienes contactos',
    pt: 'Você ainda não tem contatos',
  },
  'payoutContacts.empty.body': {
    en: 'Add a contact with their bank details so they are ready and validated when you need to make a payout.',
    es: 'Añade un contacto con sus datos bancarios para tenerlo listo y validado cuando necesites realizar un pago.',
    pt: 'Adicione um contato com os dados bancários para tê-lo pronto e validado quando precisar realizar um pagamento.',
  },
  'payoutContacts.empty.notFound': {
    en: "We haven't found any matches for your search.<br />Please, try again.",
    es: 'No hemos encontrado coincidencias para tu búsqueda.<br />Por favor, inténtalo de nuevo.',
    pt: 'Não encontramos nenhuma correspondência para sua pesquisa.<br />Por favor, tente novamente.',
  },
  'payouts.create.title': {
    en: 'New payout',
    es: 'Nuevo pago',
    pt: 'Novo pagamento',
  },
  'payouts.create.menu.accountData': {
    en: 'Account data',
    es: 'Datos de la cuenta',
    pt: 'Dados da conta',
  },
  'payouts.create.menu.payoutData': {
    en: 'Payout data',
    es: 'Datos del pago',
    pt: 'Dados do pagamento',
  },
  'payouts.create.menu.review': {
    en: 'Review',
    es: 'Revisar',
    pt: 'Revisar',
  },
  'payouts.create.accountData.menuTitle': {
    en: 'Add recipient bank account',
    es: 'Añadir datos de la cuenta bancaria',
    pt: 'Adicionar dados da conta bancaria',
  },
  'payouts.create.accountData.title': {
    en: 'Recipient bank account',
    es: 'Cuenta bancaria del destinatario',
    pt: 'Conta bancária do destinatário',
  },
  'payouts.create.accountData.subtitle': {
    en: 'Select the country and beneficiary type to continue with the loading of their data.',
    es: 'Selecciona el país y el tipo de destinatario para continuar con la carga de sus datos.',
    pt: 'Selecione o país e o tipo de beneficiário para continuar com o carregamento de seus dados.',
  },
  'payouts.create.accountData.countrySection': {
    en: 'Select country',
    es: 'Selecciona su país',
    pt: 'Selecione o pais',
  },
  'payouts.create.accountData.flowTypeSection': {
    en: 'Who is the beneficiary?',
    es: '¿Quién es el beneficiario?',
    pt: 'Quem e o beneficiario?',
  },
  'payouts.create.accountData.bankDataTitle': {
    en: 'Enter beneficiary account details',
    es: 'Introduce los datos de la cuenta del destinatario',
    pt: 'Insira os dados da conta do destinatario',
  },
  'payouts.create.accountData.bankData': {
    en: 'Bank account details',
    es: 'Datos de la cuenta bancaria',
    pt: 'Dados da conta bancaria',
  },
  'payouts.create.accountData.bankDataSubtitle': {
    en: 'Complete all required fields to continue.',
    es: 'Completa todos los campos requeridos para continuar.',
    pt: 'Preencha todos os campos obrigatorios para continuar.',
  },
  'payouts.create.flow.person': {
    en: 'Other person',
    es: 'Otra persona',
    pt: 'Outra pessoa',
  },
  'payouts.create.flow.business': {
    en: 'Business',
    es: 'Empresa o negocio',
    pt: 'Empresa ou negocio',
  },
  'payouts.create.flow.personDescription': {
    en: 'Use this option to pay an individual beneficiary.',
    es: 'Para enviar dinero a una persona. Necesitas sus datos personales y bancarios.',
    pt: 'Use esta opcao para pagar uma pessoa fisica.',
  },
  'payouts.create.flow.businessDescription': {
    en: 'Use this option to pay a company using commercial and banking details.',
    es: 'Para pagar a una empresa o negocio usando sus datos comerciales y bancarios.',
    pt: 'Use esta opcao para pagar uma empresa com dados comerciais e bancarios.',
  },
  'payouts.create.field.country': {
    en: 'Country',
    es: 'País',
    pt: 'Pais',
  },
  'payouts.create.field.countryPlaceholder': {
    en: 'Select a country',
    es: 'Selecciona un país',
    pt: 'Selecione um pais',
  },
  'payouts.create.field.selectPlaceholder': {
    en: 'Select an option',
    es: 'Selecciona una opción',
    pt: 'Selecione uma opcao',
  },
  'payouts.create.field.firstName': {
    en: 'First name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'payouts.create.field.lastName': {
    en: 'Last name',
    es: 'Apellido',
    pt: 'Sobrenome',
  },
  'payouts.create.field.email': {
    en: 'Beneficiary email',
    es: 'Correo electrónico del beneficiario',
    pt: 'E-mail do beneficiário',
  },
  'payouts.create.field.phone': {
    en: 'Beneficiary phone',
    es: 'Teléfono del beneficiario',
    pt: 'Telefone do beneficiário',
  },
  'payouts.create.field.purpose': {
    en: 'Purpose of the payout',
    es: 'Propósito del pago',
    pt: 'Finalidade do pagamento',
  },
  'payouts.create.field.bankName': {
    en: 'Bank',
    es: 'Banco',
    pt: 'Banco',
  },
  'payouts.create.field.bankBranch': {
    en: 'Bank branch',
    es: 'Sucursal del banco',
    pt: 'Sucursal do banco',
  },
  'payouts.create.field.beneficiaryAddress': {
    en: 'Beneficiary address',
    es: 'Dirección del beneficiario',
    pt: 'Endereco do beneficiario',
  },
  'payouts.create.field.businessName': {
    en: 'Business name',
    es: 'Nombre del negocio',
    pt: 'Nome do negocio',
  },
  'payouts.create.field.beneficiaryAddressCity': {
    en: 'Beneficiary city',
    es: 'Ciudad del beneficiario',
    pt: 'Cidade do beneficiario',
  },
  'payouts.create.field.remitterFirstName': {
    en: 'Remitter first name',
    es: 'Nombre del remitente',
    pt: 'Nome do remitente',
  },
  'payouts.create.field.remitterLastName': {
    en: 'Remitter last name',
    es: 'Apellido del remitente',
    pt: 'Sobrenome do remitente',
  },
  'payouts.create.field.remitterDocument': {
    en: 'Remitter document',
    es: 'Documento del remitente',
    pt: 'Documento do remitente',
  },
  'payouts.create.field.remitterNationality': {
    en: 'Remitter nationality',
    es: 'Nacionalidad del remitente',
    pt: 'Nacionalidade do remitente',
  },
  'payouts.create.field.remitterBirthDate': {
    en: 'Remitter birth date',
    es: 'Fecha de nacimiento del remitente',
    pt: 'Data de nascimento do remitente',
  },
  'payouts.create.field.accountType': {
    en: 'Account type',
    es: 'Tipo de cuenta',
    pt: 'Tipo de conta',
  },
  'payouts.create.field.accountNumber': {
    en: 'Account number',
    es: 'Número de cuenta',
    pt: 'Numero da conta',
  },
  'payouts.create.field.documentType': {
    en: 'Document type',
    es: 'Tipo de documento',
    pt: 'Tipo de documento',
  },
  'payouts.create.field.document': {
    en: 'Beneficiary document',
    es: 'Documento del beneficiario',
    pt: 'Documento do beneficiario',
  },
  'payouts.create.field.currency': {
    en: 'Currency',
    es: 'Moneda',
    pt: 'Moeda',
  },
  'payouts.create.field.amount': {
    en: 'Amount',
    es: 'Monto',
    pt: 'Valor',
  },
  'payouts.create.field.description': {
    en: 'Description',
    es: 'Descripción',
    pt: 'Descrição',
  },
  'payouts.create.field.flowType': {
    en: 'Beneficiary type',
    es: 'Tipo de destinatario',
    pt: 'Tipo de beneficiario',
  },
  'payouts.create.error.maxLength': {
    en: 'Maximum length is %s characters.',
    es: 'La longitud máxima es de %s caracteres.',
    pt: 'O tamanho maximo e de %s caracteres.',
  },
  'payouts.create.error.phoneInternationalFormat': {
    en: 'Enter the phone in international format with country code, e.g. +91...',
    es: 'Ingresá el teléfono en formato internacional con código de país, ej. +91...',
    pt: 'Informe o telefone no formato internacional com código do país, ex. +91...',
  },
  'payouts.create.accountData.phoneInternationalTooltip': {
    en: 'Enter the phone in international format, including the country code (e.g. +91 for India, +63 for the Philippines).',
    es: 'Ingresá el teléfono en formato internacional, incluyendo el código de país (ej. +91 para India, +63 para Filipinas).',
    pt: 'Informe o telefone no formato internacional, incluindo o código do país (ex. +91 para a Índia, +63 para as Filipinas).',
  },
  'payouts.create.purpose.familyMaintenance': {
    en: 'Family maintenance',
    es: 'Mantenimiento familiar',
    pt: 'Manutenção familiar',
  },
  'payouts.create.purpose.medicalCare': {
    en: 'Medical care',
    es: 'Cuidado médico',
    pt: 'Cuidado medico',
  },
  'payouts.create.purpose.tuitionCosts': {
    en: 'Tuition costs',
    es: 'Costos de matrícula',
    pt: 'Custos de matricula',
  },
  'payouts.create.purpose.charityDonation': {
    en: 'Charity donation',
    es: 'Donación de caridad',
    pt: 'Doacao de caridade',
  },
  'payouts.create.purpose.propertyPurchase': {
    en: 'Property purchase',
    es: 'Compra de propiedad',
    pt: 'Compra de propriedade',
  },
  'payouts.create.purpose.shares': {
    en: 'Shares',
    es: 'Acciones',
    pt: 'Ações',
  },
  'payouts.create.purpose.investment': {
    en: 'Investment',
    es: 'Inversión',
    pt: 'Investimento',
  },
  'payouts.create.purpose.utilityProvider': {
    en: 'Utility provider',
    es: 'Proveedor de utilidades',
    pt: 'Fornecedor de utilidades',
  },
  'payouts.create.purpose.taxes': {
    en: 'Taxes',
    es: 'Impuestos',
    pt: 'Impostos',
  },
  'payouts.create.purpose.tourismExpense': {
    en: 'Tourism expense',
    es: 'Gasto de turismo',
    pt: 'Gasto de turismo',
  },
  'payouts.create.purpose.travel': {
    en: 'Travel',
    es: 'Viaje',
    pt: 'Viagem',
  },
  'payouts.create.purpose.savingsRetirement': {
    en: 'Savings retirement',
    es: 'Retiro de ahorros',
    pt: 'Retiro de ahorros',
  },
  'payouts.create.purpose.pension': {
    en: 'Pension',
    es: 'Pensión',
    pt: 'Pensão',
  },
  'payouts.create.purpose.payroll': {
    en: 'Payroll',
    es: 'Nómina',
    pt: 'Folha de pagamento',
  },
  'payouts.create.purpose.physicalGoods': {
    en: 'Physical goods',
    es: 'Bienes físicos',
    pt: 'Bens físicos',
  },
  'payouts.create.purpose.digitalGoods': {
    en: 'Digital goods',
    es: 'Bienes digitales',
    pt: 'Bens digitais',
  },
  'payouts.create.purpose.supplier': {
    en: 'Supplier',
    es: 'Proveedor',
    pt: 'Fornecedor',
  },
  'payouts.create.purpose.capitalContribution': {
    en: 'Capital contribution',
    es: 'Contribución de capital',
    pt: 'Contribuição de capital',
  },
  'payouts.create.purpose.propertyRental': {
    en: 'Property rental',
    es: 'Renta de propiedad',
    pt: 'Aluguel de propriedade',
  },
  'payouts.create.purpose.logistics': {
    en: 'Logistics',
    es: 'Logística',
    pt: 'Logística',
  },
  'payouts.create.purpose.investmentInterest': {
    en: 'Investment interest',
    es: 'Interés de inversión',
    pt: 'Juros de investimento',
  },
  'payouts.create.purpose.availability': {
    en: 'Availability',
    es: 'Disponibilidad',
    pt: 'Disponibilidade',
  },
  'payouts.create.purpose.insurance': {
    en: 'Insurance',
    es: 'Seguro',
    pt: 'Seguro',
  },
  'payouts.create.purpose.rewards': {
    en: 'Rewards',
    es: 'Recompensas',
    pt: 'Recompensas',
  },
  'payouts.create.purpose.entertainment': {
    en: 'Entertainment',
    es: 'Entretenimiento',
    pt: 'Entretenimento',
  },
  'payouts.create.purpose.publicServices': {
    en: 'Public services',
    es: 'Servicios públicos',
    pt: 'Servicos publicos',
  },
  'payouts.create.purpose.affiliationPrograms': {
    en: 'Affiliation programs',
    es: 'Programas de afiliación',
    pt: 'Programas de afiliacao',
  },
  'payouts.create.purpose.remittances': {
    en: 'Remittances',
    es: 'Remesas',
    pt: 'Remessas',
  },
  'payouts.create.purpose.otherServices': {
    en: 'Other services',
    es: 'Otros servicios',
    pt: 'Outros servicos',
  },
  'payouts.create.payoutData.menuTitle': {
    en: 'Payout data',
    es: 'Datos del pago',
    pt: 'Dados do pagamento',
  },
  'payouts.create.payoutData.payoutTitle': {
    en: 'Pay to a third party bank account',
    es: 'Pagar a la cuenta bancaria de un tercero',
    pt: 'Pagar para a conta bancária de um terceiro',
  },
  'payouts.create.payoutData.payoutSubtitle': {
    en: "Create a simple single payout to transfer funds to the beneficiary's account.",
    es: 'Crea de forma sencilla un único pago para transferir fondos a la cuenta de un beneficiario.',
    pt: 'Crie de forma simples um único pagamento para transferir fundos para a conta de um beneficiário.',
  },
  'payouts.create.payoutData.title': {
    en: 'Payout details',
    es: 'Datos del pago',
    pt: 'Dados do pagamento',
  },
  'payouts.create.payoutData.description': {
    en: "Enter the recipient's account details",
    es: 'Introduce los datos de la cuenta del destinatario',
    pt: 'Introduza os dados do pagamento',
  },
  'payouts.create.payoutData.payFrom': {
    en: 'Pay from',
    es: 'Pagar de',
    pt: 'Pagar de',
  },
  'payouts.create.payoutData.payTo': {
    en: 'Pay to',
    es: 'Pagar a',
    pt: 'Pagar para',
  },
  'payouts.create.payoutData.selectBeneficiary': {
    en: 'Select beneficiary',
    es: 'Seleccionar destinatario',
    pt: 'Selecionar destinatário',
  },
  'payouts.create.payoutData.addBankAccount': {
    en: 'Add bank account',
    es: 'Añadir cuenta bancaria',
    pt: 'Adicionar conta bancária',
  },
  'payouts.create.payoutData.totalFees': {
    en: 'Total fees',
    es: 'Comisiones totales',
    pt: 'Taxas totais',
  },
  'payouts.create.payoutData.balanceTooltip': {
    en: 'Payouts are debited from your available balance.',
    es: 'Los pagos se debitan de tu balance disponible.',
    pt: 'Pagamentos sao debitados do seu saldo disponivel.',
  },
  'payouts.create.payoutData.availableBalance': {
    en: 'Available balance',
    es: 'Balance disponible',
    pt: 'Saldo disponivel',
  },
  'payouts.create.payoutData.availableBalanceTooltip': {
    en: "Payouts are debited from your available balance in dLocal Go. If you don't have enough balance, you won't be able to create the payout.",
    es: 'Los pagos se debitan de tu balance disponible en dLocal Go. Si no tienes saldo suficiente, no podrás crear el pago.',
    pt: 'Os pagamentos são debitados do seu saldo disponível no dLocal Go. Se você não tiver saldo suficiente, não poderá criar o pagamento.',
  },
  'payouts.create.payoutData.changeBeneficiary': {
    en: 'Change',
    es: 'Cambiar',
    pt: 'Alterar',
  },
  'payouts.create.payoutData.selectCurrency': {
    en: 'Select currency',
    es: 'Selecciona la moneda',
    pt: 'Selecione a moeda',
  },
  'payouts.create.payoutData.selectCurrencyTooltip': {
    en: 'Select the currency in which the recipient will receive the payout. The amount is entered in that currency and debited from your available balance.',
    es: 'Seleccioná la moneda en la que el destinatario recibirá el pago. El monto se ingresa en esa moneda y se debita de tu balance disponible.',
    pt: 'Selecione a moeda em que o destinatário receberá o pagamento. O valor é inserido nessa moeda e debitado do seu saldo disponível.',
  },
  'payouts.create.payoutData.recipientReceives': {
    en: 'Recipient receives',
    es: 'El destinatario recibe',
    pt: 'O destinatario recebe',
  },
  'payouts.create.payoutData.youPay': {
    en: 'You pay',
    es: 'Tu pagas',
    pt: 'Voce paga',
  },
  'payouts.create.payoutData.exchangeRate': {
    en: 'Exchange rate:',
    es: 'Tipo de cambio:',
    pt: 'Taxa de cambio:',
  },
  'payouts.create.payoutData.transactionDescription': {
    en: 'Transaction description',
    es: 'Descripción de la transacción',
    pt: 'Descrição da transação',
  },
  'payouts.create.payoutData.descriptionPlaceholder': {
    en: 'It will be shown in the transaction details of dLocal Go',
    es: 'Se verá en los detalles de la transacción de dLocal Go',
    pt: 'Será exibido nos detalhes da transação do dLocal Go',
  },
  'payouts.create.payoutData.feesIncludedTooltip': {
    en: 'Fees are already included in the amount to pay.',
    es: 'Las comisiones ya están incluidas en el importe a pagar.',
    pt: 'As taxas já estão incluídas no valor a pagar.',
  },
  'payouts.create.payoutData.feesIncludedSubtitle': {
    en: 'Included in the amount in {0}',
    es: 'Se incluyen en la cantidad en {0}',
    pt: 'Incluídas no valor em {0}',
  },
  'payouts.create.payoutData.continue': {
    en: 'Continue',
    es: 'Continuar',
    pt: 'Continuar',
  },
  'payouts.create.payoutData.insufficientBalance': {
    en: 'Insufficient available balance for this payout.',
    es: 'Balance disponible insuficiente para este pago.',
    pt: 'Saldo disponivel insuficiente para este pagamento.',
  },
  'payouts.create.review.recipientReceives': {
    en: 'Recipient receives',
    es: 'El destinatario recibe',
    pt: 'O destinatario recebe',
  },
  'payouts.create.review.localAmount': {
    en: 'Amount in local currency',
    es: 'Monto en moneda local',
    pt: 'Monto em moeda local',
  },
  'payouts.create.review.menuTitle': {
    en: 'Confirm and pay',
    es: 'Confirmar y pagar',
    pt: 'Confirmar e pagar',
  },
  'payouts.create.review.title': {
    en: 'Confirm and pay',
    es: 'Confirmar y pagar',
    pt: 'Confirmar e pagar',
  },
  'payouts.create.review.paymentMethod': {
    en: 'Payment method',
    es: 'Método de pago',
    pt: 'Metodo de pagamento',
  },
  'payouts.create.review.availableBalance': {
    en: 'Available balance',
    es: 'Balance disponible',
    pt: 'Saldo disponivel',
  },
  'payouts.create.review.payoutData': {
    en: 'Payout data',
    es: 'Datos del pago',
    pt: 'Dados do pagamento',
  },
  'payouts.create.review.accountData': {
    en: 'Beneficiary account data',
    es: 'Datos de la cuenta bancaria del destinatario',
    pt: 'Dados da conta bancaria do destinatario',
  },
  'payouts.create.review.confirmAndPay': {
    en: 'Confirm and pay',
    es: 'Confirmar y pagar',
    pt: 'Confirmar e pagar',
  },
  'payouts.create.success.title': {
    en: 'Payment created successfully!',
    es: '¡Pago creado con éxito!',
    pt: 'Pagamento criado com sucesso!',
  },
  'payouts.create.success.body': {
    en: '{0} must verify their identity with {1} before receiving the payment.',
    es: '{0} debe verificar su identidad con {1} antes de recibir el pago.',
    pt: '{0} deve verificar sua identidade com {1} antes de receber o pagamento.',
  },
  'payouts.create.success.serviceName': {
    en: brandName,
    es: brandName,
    pt: brandName,
  },
  'payouts.create.success.helper': {
    en: 'The amount will be debited from your balance only once validation is complete. You can follow the status from the Payouts section.',
    es: 'Recién cuando la validación esté completa, el monto será debitado de su balance. Podrá seguir el estado desde la sección Actividad de pagos.',
    pt: 'O valor só será debitado do seu saldo quando a validação estiver concluída. Você poderá acompanhar o status na seção Atividade de pagamentos.',
  },
  'payouts.create.success.moreInformation': {
    en: 'More information',
    es: 'Más información',
    pt: 'Mais informações',
  },
  'payouts.create.otp.title': {
    en: 'Identity verification',
    es: 'Verifica tu identidad',
    pt: 'Verificar identidade',
  },
  'payouts.create.otp.description': {
    en: 'Enter the 6-digit one-time code generated by your authentication application to confirm the payout.',
    es: 'Ingresa el código de un solo uso de 6 dígitos que genera tu aplicación de autenticación para confirmar el pago.',
    pt: 'Digite o código de um único uso de 6 dígitos que gera sua aplicação de autenticação para confirmar o pagamento.',
  },
  'payouts.create.otp.inputLabel': {
    en: 'One-time code',
    es: 'Código de un solo uso',
    pt: 'Codigo de um único uso',
  },
  'payouts.create.otp.error': {
    en: 'OTP must have 6 digits.',
    es: 'El OTP debe tener 6 dígitos.',
    pt: 'OTP deve ter 6 digitos.',
  },
  'payouts.create.otp.confirm': {
    en: 'Confirm payout',
    es: 'Confirmar pago',
    pt: 'Confirmar pagamento',
  },
  'payouts.create.error.invalidPayoutParam': {
    en: 'There was an error with the payout parameters. Please try again. Error: {0}',
    es: 'Uno o más de los parámetros del pago son inválidos. Por favor, inténtelo de nuevo. Error: {0}',
    pt: 'Houve um erro com os parâmetros do pagamento. Por favor, tente novamente. Error: {0}',
  },
  'payouts.create.error.countryCurrencyNotEnabled': {
    en: 'Payouts are not available for the selected country and currency.',
    es: 'Los pagos no están disponibles para el país y la moneda seleccionados.',
    pt: 'Pagamentos não estão disponíveis para o país e a moeda selecionados.',
  },
  'payouts.create.error.internal': {
    en: 'An internal error occurred while processing the payout. Please try again later.',
    es: 'Ocurrió un error interno al procesar el pago. Por favor, intenta nuevamente más tarde.',
    pt: 'Ocorreu um erro interno ao processar o pagamento. Por favor, tente novamente mais tarde.',
  },
  'payouts.create.error.providerRejected': {
    en: 'We could not process the payout. Reason: {0}',
    es: 'No pudimos procesar el pago. Motivo: {0}',
    pt: 'Nao foi possivel processar o pagamento. Motivo: {0}',
  },
  'payouts.create.error.unexpected': {
    en: 'An unexpected error occurred while processing the payout. Please try again later.',
    es: 'Ocurrió un error inesperado al procesar el pago. Por favor, intenta nuevamente más tarde.',
    pt: 'Ocorreu um erro inesperado ao processar o pagamento. Por favor, tente novamente mais tarde.',
  },
  'payouts.create.error.dailyPayoutLimitExceeded': {
    en: 'The daily payout limit has been exceeded. Please try again tomorrow or try with a different amount.',
    es: 'El límite de pago diario ha sido superado. Por favor, inténtelo de nuevo mañana o intente con un monto diferente.',
    pt: 'O limite de pagamento diário foi excedido. Por favor, tente novamente amanhã ou tente com um valor diferente.',
  },
  'payouts.create.error.amountExceedsAvailableBalance': {
    en: 'The amount entered exceeds the available balance.',
    es: 'El monto ingresado excede el saldo disponible.',
    pt: 'O valor inserido excede o saldo disponível.',
  },
  'payouts.create.error.payoutFieldMaxLengthExceeded': {
    en: 'A field value has exceeded the maximum length. Error: {0}',
    es: 'Un atributo del pago ha excedido la longitud máxima. Error: {0}',
    pt: 'O campo excedeu o comprimento máximo. Error: {0}',
  },
  'payouts.create.error.payoutFieldRegexValidationFailed': {
    en: 'A field value has an invalid format. Error: {0}',
    es: 'Un atributo del pago tiene un formato inválido. Error: {0}',
    pt: 'O campo tem um formato inválido. Error: {0}',
  },
  'payouts.create.error.payoutMinimumAmountNotReached': {
    en: 'The amount entered is less than the minimum allowed. Please try again with a greater amount (1 USD minimum).',
    es: 'El monto ingresado es menor que el mínimo permitido. Por favor, inténtelo de nuevo con un monto mayor (mínimo 1 USD).',
    pt: 'O valor inserido é inferior ao mínimo permitido. Por favor, tente novamente com um valor maior (mínimo 1 USD).',
  },
  'payouts.create.error.validationFailed': {
    en: 'Validation failed: {0}. Please review your data and try again.',
    es: 'Error de validación: {0}. Por favor revise sus datos e intente nuevamente.',
    pt: 'Falha na validação: {0}. Por favor revise seus dados e tente novamente.',
  },
  'payouts.create.error.missingRequiredField': {
    en: 'A required field is missing: {0}. Please go back and complete your payout information.',
    es: 'Falta un campo obligatorio: {0}. Por favor regresa y completa la información del pago.',
    pt: 'Um campo obrigatório está faltando: {0}. Volte e complete as informações do pagamento.',
  },
  'exportPayouts.title': {
    en: 'Download report',
    es: 'Descargar reporte',
    pt: 'Baixar relatório',
  },
  'exportPayouts.open': {
    en: 'Export Payouts',
    es: 'Exportar Pagos',
    pt: 'Exportar Pagamentos',
  },
  'exportPayouts.exportBtn': {
    en: 'Download',
    es: 'Descargar',
    pt: 'Baixar',
  },
  'exportPayouts.range': {
    en: 'Select date range',
    es: 'Seleccione el rango de fechas',
    pt: 'Selecione o intervalo de datas',
  },
  'exportPayouts.successMessage': {
    en: 'If the file download does not start, check that your browser has not blocked it.',
    es: 'Si la descarga del archivo no se inicia, verifique que su navegador no lo haya bloqueado.',
    pt: 'Se o download do arquivo não iniciar, verifique se seu navegador não o bloqueou.',
  },
  'exportPayouts.downloadAgain': {
    en: 'You can try to download it again by clicking ',
    es: 'Puedes intentar descargarlo nuevamente haciendo clic ',
    pt: 'Você pode tentar baixá-lo novamente clicando ',
  },
  'exportPayouts.downloadAgain.here': {
    en: 'here.',
    es: 'aquí.',
    pt: 'aqui.',
  },
  'exportPayouts.invalidDates': {
    en: 'The selected dates are invalid.',
    es: 'Las fechas seleccionadas son inválidas.',
    pt: 'As datas selecionadas são inválidas.',
  },
  'exportPayouts.rangeError': {
    en: 'The date range cannot be greater than 31 days.',
    es: 'El rango de fechas no puede ser mayor a 31 días.',
    pt: 'O intervalo de datas não pode ser superior a 31 dias.',
  },
  'exportPayouts.empty': {
    en: 'No data to download found.',
    es: 'No se encontraron datos para descargar.',
    pt: 'Nenhum dado para download encontrado.',
  },
  'exportPayouts.otherFilters': {
    en: 'Optional filters',
    es: 'Filtros opcionales',
    pt: 'Filtros opcionais',
  },
  'addPayout.title': {
    en: 'Request payout',
    es: 'Solicitar pago',
    pt: 'Pedido de pagamento',
  },
  'addPayout.error.amountExceeds': {
    en: 'The entered value exceeds the transaction amount.',
    es: 'El valor ingresado supera el monto de la transacción.',
    pt: 'O valor inserido excede o valor da transação.',
  },
  'addPayout.desc': {
    en: 'Please complete the following information to create the payout request.',
    es: 'Por favor, complete la siguiente información para crear la solicitud de pago.',
    pt: 'Por favor, complete as seguintes informações para criar a solicitação de pagamento.',
  },
  'addPayout.timeToProcess': {
    en: 'Payouts for bank transfers and cash payments can take up to 7 business days to process.',
    es: 'Los pagos por transferencias bancarias y pagos en efectivo pueden demorar hasta 7 días hábiles en procesarse.',
    pt: 'Pagamentos para transferências bancárias e pagamentos em dinheiro podem levar até 7 dias úteis para serem processados.',
  },
  'addPayout.accountType': {
    en: 'Account type *',
    es: 'Tipo de cuenta *',
    pt: 'Tipo de conta *',
  },
  'addPayout.bankAccount.title': {
    en: 'Bank account',
    es: 'Cuenta bancaria',
    pt: 'Conta bancária',
  },
  'addPayout.amount': {
    en: 'Amount to pay *',
    es: 'Monto a pagar *',
    pt: 'Valor a pagar *',
  },
  'addPayout.beneficiary': {
    en: 'Name of the Beneficiary',
    es: 'Nombre del beneficiario',
    pt: 'Nome do beneficiário',
  },
  'addPayout.bankCode': {
    en: 'Bank *',
    es: 'Banco *',
    pt: 'Banco *',
  },
  'addPayout.bankAccount': {
    en: 'Bank account number *',
    es: 'Número de cuenta bancaria *',
    pt: 'Numero de conta bancária *',
  },
  'addPayout.bankAccount.message': {
    en: 'The owner of the account entered must coincide with the beneficiary.',
    es: 'El titular de la cuenta ingresada debe coincidir con el beneficiario.',
    pt: 'O titular da conta inserida deve coincidir com o beneficiário.',
  },
  'addPayout.bankBranch': {
    en: 'Branch *',
    es: 'Sucursal *',
    pt: 'Agência *',
  },
  'addPayout.btn': {
    en: 'Send request',
    es: 'Enviar solicitud',
    pt: 'Enviar solicitação',
  },
  'addPayout.success': {
    en: 'Successful payout request!',
    es: '¡Solicitud de pago exitosa!',
    pt: 'Solicitação de pagamento bem-sucedida!',
  },
  'addPayout.note': {
    en: 'Note: Payout fees apply.',
    es: 'Nota: Se aplican tarifas de pago.',
    pt: 'Nota: Taxas de pagamento aplicáveis.',
  },
  'addPayout.noteRequiredfields': {
    en: '(*) Required fields.',
    es: '(*) Campos obligatórios.',
    pt: '(*) Campos obrigatórios.',
  },
  'payouts.create.otp.notSet.title': {
    en: 'Two-factor authentication not set',
    es: 'Autenticación de dos factores no configurada',
    pt: 'Autenticação de dois fatores não configurada',
  },
  'payouts.create.otp.notSet.description': {
    en: 'The two-factor authentication is not set for your account. Please set it up before creating a payout.',
    es: 'La autenticación de dos factores no está configurada para tu cuenta. Por favor, configúrala antes de crear un pago.',
    pt: 'A autenticação de dois fatores não está configurada para sua conta. Por favor, configure-a antes de fazer um pagamento.',
  },
  'payouts.create.otp.notSet.confirm': {
    en: 'Configure OTP',
    es: 'Configurar OTP',
    pt: 'Configurar OTP',
  },
  'payouts.create.otp.notSet.cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    pt: 'Cancelar',
  },
  'msgError.requestPayout.dataProvided': {
    en: 'It was not possible to create the payout with the data provided.',
    es: 'No fue posible crear el pago con los datos proporcionados.',
    pt: 'Não foi possível fazer o pagamento com os dados fornecidos.',
  },
  'msgError.requestPayout.amountEntered': {
    en: 'The amount entered exceeds the available balance in the selected transaction.',
    es: 'El monto ingresado excede el saldo disponible en la transacción seleccionada.',
    pt: 'O valor inserido excede o saldo disponível na transação selecionada.',
  },
  'msgError.requestPayout.insufficientBalance': {
    en: 'Insufficient available balance.',
    es: 'Saldo disponible insuficiente.',
    pt: 'Saldo disponível insuficiente.',
  },
  'msgError.requestPayout.amountLess': {
    en: 'The payout amount is less than the minimum allowed.',
    es: 'El monto del pago es menor que el mínimo permitido.',
    pt: 'O valor do pagamento é inferior ao mínimo permitido.',
  },
  'passwordReset.desc': {
    en: "Enter the email address associated with your account and we'll send you a link to reset your password.",
    es: 'Introduce la dirección de correo electrónico asociada a tu cuenta y te enviaremos un link para restablecer tu contraseña.',
    pt: 'Informe o e-mail associado à sua conta para receber um link de redefinição de senha.',
  },
  'passwordReset.back': {
    en: 'Return to sign in',
    es: 'Volver a inicio de sesión',
    pt: 'Voltar para o login',
  },
  'passwordReset.btn': {
    en: 'Continue',
    es: 'Continuar',
    pt: 'Continuar',
  },
  'passwordReset.sent.message': {
    en: 'Check to see if you have received an email with instructions to reset your password.',
    es: 'Comprueba si has recibido un correo electrónico con las instrucciones para restablecer la contraseña.',
    pt: 'Verifique se recebeu um e-mail com instruções para redefinir sua senha.',
  },
  'passwordReset.confirmDesc': {
    en: 'Reset your account password.',
    es: 'Restablece la contraseña de tu cuenta.',
    pt: 'Redefina a senha da sua conta.',
  },
  'msgError.passwordReset.waitToResend': {
    en: "Didn't you get the email? Look in your spam folder or wait a few minutes and try again.",
    es: '¿No recibiste el correo electrónico? Mira en tu carpeta de correo no deseado o espera unos minutos e intenta nuevamente.',
    pt: 'Você não recebeu o e-mail? Procure na sua pasta de spam ou espere alguns minutos e tente novamente.',
  },
  'msgError.passwordReset.invalidOrExpired': {
    en: 'Token is invalid or expired.',
    es: 'Token inválido o expirado.',
    pt: 'Token inválido ou expirado.',
  },
  'newPassword.label': {
    en: 'New Password',
    es: 'Nueva contraseña',
    pt: 'Nova senha',
  },
  'createPaymentBtn.desc': {
    en: 'Get paid using a payment button in your website in two simple steps:',
    es: 'Reciba pagos mediante un botón de pago en su sitio web en dos simples pasos:',
    pt: 'Receba pagamentos usando um botão de pagamento em seu site em duas etapas simples:',
  },
  'createPaymentBtn.desc.stepOne': {
    en: '1. Fill in the required information and click the <b>Create</b> button.',
    es: '1. Complete la información requerida y haga clic en el botón <b>Crear</b>.',
    pt: '1. Preencha as informações necessárias e clique no botão <b>Criar</b>.',
  },
  'createPaymentBtn.desc.stepTwo': {
    en: '2. Copy the generated code and paste it into the HTML of your page.',
    es: '2. Copie el código generado y péguelo en el HTML de su página.',
    pt: '2. Copie o código gerado e cole-o no HTML da sua página.',
  },
  'createPaymentBtn.amount': {
    en: 'Amount *',
    es: 'Monto *',
    pt: 'Valor *',
  },
  'createPaymentBtn.text': {
    en: 'Button text',
    es: 'Texto del botón',
    pt: 'Texto do botão',
  },
  'createPaymentBtn.text.placeholder': {
    en: 'Default text: Pay',
    es: 'Texto predeterminado: Pagar',
    pt: 'Texto padrão: Pagar',
  },
  'createPaymentBtn.currency': {
    en: 'Currency *',
    es: 'Moneda *',
    pt: 'Moeda *',
  },
  'createPaymentBtn.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'createPaymentBtn.langBtn': {
    en: 'Button text language',
    es: 'Idioma del texto del botón',
    pt: 'Idioma do texto do botão',
  },
  'createPaymentBtn.langBtn.auto': {
    en: 'Browser language browser',
    es: 'Idioma del navegador',
    pt: 'Idioma do navegador',
  },
  'createPaymentBtn.withBrand': {
    en: 'Marca',
    es: 'Brand',
    pt: 'Marca',
  },
  'createPaymentBtn.noteRequiredfields': {
    en: '(*) Required fields.',
    es: '(*) Campos obligatórios.',
    pt: '(*) Campos obrigatórios.',
  },
  'createPaymentBtn.btn': {
    en: 'Create',
    es: 'Crear',
    pt: 'Criar',
  },
  'createPaymentBtn.copyCode': {
    en: 'Copy code',
    es: 'Copiar código',
    pt: 'Copiar código',
  },
  'createPaymentBtn.forDevelopers': {
    en: 'Note: If you have programming knowledge you can also create our button manually, for more information visit',
    es: 'Nota: Si tienes conocimiento en programación también puedes crear nuestro botón de forma manual, para más información visita',
    pt: 'Nota: Se você tiver conhecimento de programação, você também pode criar nosso botão manualmente, para mais informações visite',
  },
  'createPaymentBtn.forDevelopers.clickHere': {
    en: 'our documentation.',
    es: 'nuestra documentación.',
    pt: 'nossa documentação.',
  },
  'personalInfo.title': {
    en: 'Personal information',
    es: 'Información personal',
    pt: 'Informação pessoal',
  },
  'personalInfo.name': {
    en: 'User name',
    es: 'Nombre de usuario',
    pt: 'Nome do usuário',
  },
  'personalInfo.email': {
    en: 'Email',
    es: 'Correo electrónico',
    pt: 'E-mail',
  },
  'personalInfo.language': {
    en: 'Language',
    es: 'Idioma',
    pt: 'Língua',
  },
  'personalInfo.marketingConsent': {
    en: 'Agree to receive news and promotions',
    es: 'Acepta recibir noticias y promociones',
    pt: 'Aceite receber novidades e promoções',
  },
  'personalInfo.cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    pt: 'Cancelar',
  },
  'personalInfo.save': {
    en: 'Save',
    es: 'Guardar',
    pt: 'Salve',
  },
  'personalInfo.edit': {
    en: 'Edit',
    es: 'Editar',
    pt: 'Editar',
  },
  'profile.updateSuccess': {
    en: 'Data updated successfully!',
    es: '¡Datos actualizados con éxito!',
    pt: 'Dados atualizados com sucesso!',
  },
  'avatarOptions.profile': {
    en: 'Profile',
    es: 'Perfil',
    pt: 'Perfil',
  },
  'avatarOptions.logout': {
    en: 'Logout',
    es: 'Cerrar sesión',
    pt: 'Sair',
  },
  'avatarOptions.help': {
    en: 'Help',
    es: 'Ayuda',
    pt: 'Ajuda',
  },
  'avatarOptions.FAQ': {
    en: 'Help Center',
    es: 'Ayuda',
    pt: 'Ajuda',
  },
  'avatarOptions.feedback': {
    en: 'Feedback',
    es: 'Feedback',
    pt: 'Feedback',
  },
  'avatarOptions.impersonate': {
    en: 'Impersonate',
    es: 'Impersonar',
    pt: 'Impersonar',
  },
  'impersonation.title': {
    en: 'Impersonate merchant',
    es: 'Impersonar merchant',
    pt: 'Impersonar merchant',
  },
  'impersonation.merchantUserEmail': {
    en: 'Merchant email',
    es: 'Email del merchant',
    pt: 'Email do merchant',
  },
  'impersonation.button': {
    en: 'Impersonate',
    es: 'Impersonar',
    pt: 'Impersonar',
  },
  'impersonation.merchantUserEmailRequired': {
    en: 'Enter a valid email',
    es: 'Ingresa un email valido',
    pt: 'Informe um email valido',
  },
  'impersonation.error': {
    en: 'Could not start impersonation',
    es: 'No se pudo iniciar la impersonación',
    pt: 'Nao foi possivel iniciar a impersonacao',
  },
  'impersonation.banner.message': {
    en: 'Impersonated session of merchant {0}',
    es: 'Sesión impersonada del merchant {0}',
    pt: 'Sessao impersonada do merchant {0}',
  },
  'impersonation.banner.exit': {
    en: 'Close session',
    es: 'Cerrar sesión',
    pt: 'Fechar sessao',
  },
  'impersonation.exitError': {
    en: 'Could not exit impersonation',
    es: 'No se pudo salir de la impersonación',
    pt: 'Nao foi possivel sair da impersonacao',
  },
  'changePassword.title': {
    en: 'Security',
    es: 'Seguridad',
    pt: 'Segurança',
  },
  'twoFactor.title': {
    en: 'Two-factor authentication',
    es: 'Autenticación de dos factores',
    pt: 'Autenticação de dois fatores',
  },
  'twoFactor.statusLabel': {
    en: 'Status:',
    es: 'Estado:',
    pt: 'Status:',
  },
  'twoFactor.status.enabled': {
    en: 'Enabled',
    es: 'Habilitado',
    pt: 'Ativado',
  },
  'twoFactor.status.disabled': {
    en: 'Disabled',
    es: 'Deshabilitado',
    pt: 'Desativado',
  },
  'twoFactor.setupButton': {
    en: 'Set up',
    es: 'Configurar',
    pt: 'Configurar',
  },
  'twoFactor.resumeButton': {
    en: 'Continue setup',
    es: 'Continuar configuración',
    pt: 'Continuar configuração',
  },
  'twoFactor.modal.title': {
    en: 'Set up two-factor authentication',
    es: 'Configura la autenticación de dos factores',
    pt: 'Configurar autenticação de dois fatores',
  },
  'twoFactor.modal.qrInstruction': {
    en: 'Scan this QR code with your authenticator app.',
    es: 'Escanea este código QR con tu aplicación de autenticación.',
    pt: 'Escaneie este código QR com seu aplicativo autenticador.',
  },
  'twoFactor.modal.manualCode': {
    en: 'Manual setup code',
    es: 'Código manual',
    pt: 'Código manual',
  },
  'twoFactor.modal.codeLabel': {
    en: 'Verification code',
    es: 'Código de verificación',
    pt: 'Código de verificação',
  },
  'twoFactor.modal.helper': {
    en: 'Enter the 6-digit code from your app to finish setup.',
    es: 'Ingresa el código de 6 dígitos de tu app para finalizar la configuración.',
    pt: 'Digite o código de 6 dígitos do seu app para finalizar a configuração.',
  },
  'twoFactor.modal.copy': {
    en: 'Copy',
    es: 'Copiar',
    pt: 'Copiar',
  },
  'twoFactor.modal.copied': {
    en: 'Copied',
    es: 'Copiado',
    pt: 'Copiado',
  },
  'twoFactor.modal.confirm': {
    en: 'Confirm',
    es: 'Confirmar',
    pt: 'Confirmar',
  },
  'twoFactor.modal.cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    pt: 'Cancelar',
  },
  'twoFactor.disable.title': {
    en: 'Disable two-factor authentication',
    es: 'Desactivar autenticación de dos factores',
    pt: 'Desativar autenticação de dois fatores',
  },
  'twoFactor.disable.helper': {
    en: 'Enter a valid code from your authenticator app to disable 2FA.',
    es: 'Ingresa un código válido de tu app para desactivar 2FA.',
    pt: 'Digite um código válido do seu app para desativar o 2FA.',
  },
  'twoFactor.disable.codeLabel': {
    en: 'Verification code',
    es: 'Código de verificación',
    pt: 'Código de verificação',
  },
  'twoFactor.disable.confirm': {
    en: 'Disable',
    es: 'Desactivar',
    pt: 'Desativar',
  },
  'twoFactor.disable.cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    pt: 'Cancelar',
  },
  'twoFactor.error.alreadyEnabled': {
    en: 'Two-factor authentication is already enabled.',
    es: 'La autenticación de dos factores ya está habilitada.',
    pt: 'A autenticação de dois fatores já está ativada.',
  },
  'twoFactor.error.notEnabled': {
    en: 'Two-factor authentication is not enabled.',
    es: 'La autenticación de dos factores no está habilitada.',
    pt: 'A autenticação de dois fatores não está ativada.',
  },
  'twoFactor.error.notConfigured': {
    en: 'Two-factor authentication is not configured.',
    es: 'La autenticación de dos factores no está configurada.',
    pt: 'A autenticação de dois fatores não está configurada.',
  },
  'twoFactor.error.invalidCode': {
    en: 'Invalid verification code. Please try again.',
    es: 'Código inválido. Inténtalo nuevamente.',
    pt: 'Código inválido. Tente novamente.',
  },
  'twoFactor.error.expiredChallenge': {
    en: 'Verification expired. Reload the page.',
    es: 'La verificación expiró. Recarga la página.',
    pt: 'A verificação expirou. Recarregue a página.',
  },
  'twoFactor.error.rateLimited': {
    en: 'Too many failed attempts. Try again in {0} minutes.',
    es: 'Demasiados intentos fallidos. Intentá nuevamente en {0} minutos.',
    pt: 'Muitas tentativas falhadas. Tente novamente em {0} minutos.',
  },
  'twoFactor.error.generic': {
    en: 'Something went wrong. Please try again later.',
    es: 'Ocurrió un error. Inténtalo más tarde.',
    pt: 'Ocorreu um erro. Tente novamente mais tarde.',
  },
  'changePassword.edit': {
    en: 'Change Password',
    es: 'Cambiar contraseña',
    pt: 'Mudar senha',
  },
  'changePassword.equalsError': {
    en: 'The password entered must be different from the current one.',
    es: 'La contraseña ingresada debe ser diferente a la actual',
    pt: 'A senha inserida deve ser diferente da atual.',
  },
  'changePassword.oldPassword': {
    en: 'Current password',
    es: 'Contraseña actual',
    pt: 'Senha atual',
  },
  'changePassword.newPassword': {
    en: 'New Password',
    es: 'Nueva contraseña',
    pt: 'Nova senha',
  },
  'changePassword.cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    pt: 'Cancelar',
  },
  'changePassword.save': {
    en: 'Save',
    es: 'Guardar',
    pt: 'Salve',
  },
  'changePassword.updateSuccess': {
    en: 'Password updated successfully!',
    es: '¡Contraseña actualizada con éxito!',
    pt: 'Senha atualizada com sucesso!',
  },
  'msgError.changePassword': {
    en: 'The current password entered is incorrect.',
    es: 'La contraseña actual ingresada es incorrecta.',
    pt: 'A senha atual inserida está incorreta.',
  },
  'msgError.checkoutThemes.not_approved.title': {
    en: 'There was an error',
    es: 'Hubo un error',
    pt: 'Houve um erro',
  },
  'msgError.checkoutThemes.not_approved': {
    en: 'The checkout theme has not been approved.',
    es: 'El tema de checkout no ha sido aprobado.',
    pt: 'O tema de checkout não foi aprovado.',
  },
  'msgError.splitPayments.collaboratorEmailInvalid': {
    en: 'The collaborator email is not a valid user in the platform.',
    es: 'El correo electrónico del colaborador no es un usuario válido en la plataforma.',
    pt: 'O e-mail do colaborador não é um usuário válido na plataforma.',
  },
  'clients.details': {
    en: 'client detail',
    es: 'Detalle del cliente',
    pt: 'Detalhe do cliente',
  },
  'clients.noClients': {
    en: 'You have no clients yet',
    es: 'No tienes clientes aún',
    pt: 'Você ainda não tem clientes',
  },
  'clients.merchantClientId': {
    en: 'ID',
    es: 'ID',
    pt: 'ID',
  },
  'clients.client': {
    en: 'Client',
    es: 'Cliente',
    pt: 'Cliente',
  },
  'clients.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'clients.firstTransaction': {
    en: 'First transaction',
    es: 'Primera transacción',
    pt: 'Primeira transação',
  },
  'clients.lastTransaction': {
    en: 'Last transaction',
    es: 'Última transacción',
    pt: 'Última transação',
  },
  'clients.transactedAmount': {
    en: 'Transacted amount',
    es: 'Monto transaccionado',
    pt: 'Valor transacionado',
  },
  'clients.status': {
    en: 'Status',
    es: 'Status',
    pt: 'Status',
  },
  'clients.status.NEW': {
    en: 'New',
    es: 'Nuevo',
    pt: 'Novo',
  },
  'clients.status.ACTIVE': {
    en: 'Active',
    es: 'Activo',
    pt: 'Ativo',
  },
  'clients.status.INACTIVE': {
    en: 'Inactive',
    es: 'Inactivo',
    pt: 'Inativo',
  },
  'clients.firstName': {
    en: 'First name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'clients.lastName': {
    en: 'Last name',
    es: 'Apellido',
    pt: 'Sobrenome',
  },
  'clients.fullName': {
    en: 'Full name',
    es: 'Nombre completo',
    pt: 'Nome Completo',
  },
  'clients.email': {
    en: 'Email',
    es: 'Email',
    pt: 'Email',
  },
  'clients.viewDetail': {
    en: 'Client detail',
    es: 'Detalle del cliente',
    pt: 'Detalhe do cliente',
  },
  'clients.deleteClient': {
    en: 'Delete client',
    es: 'Eliminar cliente',
    pt: 'Excluir cliente',
  },
  'clients.delete.confirm.headline': {
    en: 'Delete client?',
    es: '¿Eliminar cliente?',
    pt: 'Excluir cliente?',
  },
  'clients.delete.confirm.subheadline': {
    en: 'This action cannot be undone.',
    es: 'Esta acción no se puede deshacer.',
    pt: 'Esta ação não pode ser desfeita.',
  },
  'clients.delete.confirm.cancel.button': {
    en: 'Cancel',
    es: 'Cancelar',
    pt: 'Cancelar',
  },
  'clients.delete.confirm.confirmed.button': {
    en: 'Delete',
    es: 'Eliminar',
    pt: 'Excluir',
  },
  'clients.backToClients': {
    en: 'Back to clients',
    es: 'Volver a clientes',
    pt: 'Voltar para clientes',
  },
  'clients.downloadHistory': {
    en: 'Download history',
    es: 'Descargar historial',
    pt: 'Baixar histórico',
  },
  'clients.transactedVolume': {
    en: 'Transacted volume',
    es: 'Volumen transaccionado',
    pt: 'Volume transacionado',
  },
  'clients.activeClients': {
    en: 'Active clients',
    es: 'Clientes activos',
    pt: 'Clientes ativos',
  },
  'clients.averageClientValue': {
    en: 'Average client value',
    es: 'Valor promedio del cliente',
    pt: 'Valor médio do cliente',
  },
  'clients.stats.total.tooltip': {
    en: 'Number of unique clients with at least one transaction. Distinct IDs are counted, regardless of how many purchases they made.',
    es: 'Cantidad de clientes únicos con al menos una transacción. Se cuentan IDs distintos, sin importar cuántas compras realizaron.',
    pt: 'Quantidade de clientes únicos com pelo menos uma transação. São contados IDs distintos, independentemente de quantas compras realizaram.',
  },
  'clients.stats.active.tooltip': {
    en: 'Number of unique clients who completed at least one transaction in the last 30 days.',
    es: 'Cantidad de clientes únicos que realizaron al menos una transacción en los últimos 30 días.',
    pt: 'Quantidade de clientes únicos que realizaram pelo menos uma transação nos últimos 30 dias.',
  },
  'clients.stats.volume.tooltip': {
    en: 'Total amount of sales processed on the platform. Shows the historical cumulative total and the comparison with the last 30 days.',
    es: 'Monto total de ventas procesadas en la plataforma. Se muestra el acumulado histórico y la comparación con los últimos 30 días.',
    pt: 'Valor total de vendas processadas na plataforma. Mostra o acumulado histórico e a comparação com os últimos 30 dias.',
  },
  'clients.stats.average.tooltip': {
    en: 'Average sales per client: total sold divided by the number of clients in the period. Compared with the previous 30 days.',
    es: 'Promedio de ventas por cliente: total vendido dividido la cantidad de clientes en el período. Comparado con los 30 días anteriores.',
    pt: 'Média de vendas por cliente: total vendido dividido pela quantidade de clientes no período. Comparado com os 30 dias anteriores.',
  },
  'clients.stats.volume.trend': {
    en: 'Last 30 days vs previous 30 days',
    es: 'Últimos 30 días vs 30 días anteriores',
    pt: 'Últimos 30 dias vs 30 dias anteriores',
  },
  'clients.stats.average.trend': {
    en: 'Last 30 days vs previous 30 days',
    es: 'Últimos 30 días vs 30 días anteriores',
    pt: 'Últimos 30 dias vs 30 dias anteriores',
  },
  'clients.purchasesCount': {
    en: 'Number of purchases',
    es: 'Cantidad de compras',
    pt: 'Quantidade de compras',
  },
  'clients.averageTicket': {
    en: 'Client average ticket',
    es: 'Ticket promedio del cliente',
    pt: 'Ticket médio do cliente',
  },
  'clients.completedDate': {
    en: 'Completed date',
    es: 'Fecha completada',
    pt: 'Data de conclusão',
  },
  'clients.transactionStatus.completed': {
    en: 'Completed',
    es: 'Completado',
    pt: 'Concluído',
  },
  'clients.copyId': {
    en: 'Copy ID',
    es: 'Copiar ID',
    pt: 'Copiar ID',
  },
  'clients.copyEmail': {
    en: 'Email',
    es: 'E-mail',
    pt: 'E-mail',
  },
  'clients.filter.search.placeholder': {
    en: 'Search clients by name or email',
    es: 'Buscar clientes por nombre o email',
    pt: 'Buscar clientes por nome ou email',
  },
  'clients.filter.sortDirection': {
    en: 'Value + a -',
    es: 'Valor + a -',
    pt: 'Valor + a -',
  },
  'clients.filter.sortDirection.asc': {
    en: 'Value - to +',
    es: 'Valor - a +',
    pt: 'Valor - a +',
  },
  'clients.filter.sortDirection.desc': {
    en: 'Value + to -',
    es: 'Valor + a -',
    pt: 'Valor + a -',
  },
  'clients.filter.sortBy': {
    en: 'Sort by',
    es: 'Ordenar por',
    pt: 'Ordenar por',
  },
  'clients.filter.sortBy.merchantClientId': {
    en: 'Client ID',
    es: 'ID de cliente',
    pt: 'ID do cliente',
  },
  'clients.filter.sortBy.firstName': {
    en: 'First name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'clients.filter.sortBy.lastName': {
    en: 'Last name',
    es: 'Apellido',
    pt: 'Sobrenome',
  },
  'clients.filter.sortBy.email': {
    en: 'Email',
    es: 'Email',
    pt: 'Email',
  },
  'clients.filter.sortBy.createdAt': {
    en: 'Created date',
    es: 'Fecha de creación',
    pt: 'Data de criação',
  },
  'clients.filter.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'clients.filter.status': {
    en: 'Status',
    es: 'Estado',
    pt: 'Status',
  },
  'clients.export.title': {
    en: 'EXPORT CLIENTS',
    es: 'EXPORTAR CLIENTES',
    pt: 'EXPORTAR CLIENTES',
  },
  'clients.export.format': {
    en: 'Format',
    es: 'Formato',
    pt: 'Formato',
  },
  'clients.export.modal.title': {
    en: 'Export clients',
    es: 'Exportar clientes',
    pt: 'Exportar clientes',
  },
  'clients.export.empty': {
    en: 'No clients found with the selected filters.',
    es: 'No se encontraron clientes con los filtros seleccionados.',
    pt: 'Nenhum cliente encontrado com os filtros selecionados.',
  },
  'clients.noClients.found': {
    en: 'No clients found with the selected filters.',
    es: 'No se encontraron clientes con los filtros seleccionados.',
    pt: 'Nenhum cliente encontrado com os filtros selecionados.',
  },
  'clients.documentType': {
    en: 'Document type',
    es: 'Tipo de documento',
    pt: 'Tipo de documento',
  },
  'clients.document': {
    en: 'Document',
    es: 'Documento',
    pt: 'Documento',
  },
  'bankAccounts.backBtn': {
    en: 'Back to my bank accounts',
    es: 'Volver a mis cuentas bancarias',
    pt: 'Voltar para minhas contas bancárias',
  },
  'bankAccounts.subheadline': {
    en: 'Review and manage the bank accounts where you want to receive the money from your sales.',
    es: 'Revisa y gestiona las cuentas bancarias donde quieres recibir el dinero de tus ventas.',
    pt: 'Revise e gerencie as contas bancárias onde deseja receber o dinheiro de suas vendas.',
  },
  'bankAccounts.details': {
    en: 'Bank account detail',
    es: 'Detalle de cuenta bancaria',
    pt: 'Detalhe da conta bancária',
  },
  'bankAccounts.empty.desc1': {
    en: 'To withdraw money from your sales, fill in your bank account details in the ',
    es: 'Para retirar el dinero de tus ventas, completa los datos de tu cuenta bancaria en la sección ',
    pt: 'Para retirar o dinheiro de suas vendas, preencha os dados de sua conta bancária na seção ',
  },
  'bankAccounts.empty.link': {
    en: 'Company data',
    es: 'Datos de su negocio',
    pt: 'Dados da empresa',
  },
  'bankAccounts.empty.desc2': {
    en: ' section.',
    es: ' .',
    pt: ' .',
  },
  'bankAccounts.callToAction': {
    en: '+ ADD A BANK ACCOUNT',
    es: '+ AGREGAR UNA CUENTA BANCARIA',
    pt: '+ ADICIONE UMA CONTA BANCÁRIA',
  },
  'bankAccounts.callToAction.tooltip.disabled': {
    en: 'You exceeded the maximum number of bank accounts allowed. To add a new one, please delete an existing account.',
    es: 'Superaste el número máximo de cuentas bancarias permitidas. Para agregar una nueva, elimina una cuenta existente.',
    pt: 'Você excedeu o número máximo de contas bancárias permitidas. Para adicionar uma nova, exclua uma conta existente.',
  },
  'bankAccounts.status.APPROVED': {
    en: 'Active',
    es: 'Activo',
    pt: 'Ativo',
  },
  'bankAccounts.status.IN_REVIEW': {
    en: 'In review',
    es: 'En revisión',
    pt: 'Em revisão',
  },
  'bankAccounts.status.REJECTED': {
    en: 'Rejected',
    es: 'Rechazado',
    pt: 'Rejeitado',
  },
  'bankAccounts.status.tooltip.APPROVED': {
    en: "We've verified your bank account information. You can receive the money from your sales here.",
    es: 'Ya verificamos la información de tu cuenta bancaria. Puedes recibir el dinero de tus ventas aquí.',
    pt: 'Verificamos as informações da sua conta bancária. Você pode receber o dinheiro de suas vendas aqui.',
  },
  'bankAccounts.status.tooltip.IN_REVIEW': {
    en: "We're verifying your bank account information.We'll let you know when we're done.",
    es: 'Estamos verificando la información de tu cuenta bancaria. Te avisaremos cuando hayamos finalizado.',
    pt: 'Estamos verificando as informações da sua conta bancária. Avisaremos quando terminarmos.',
  },
  'bankAccounts.status.tooltip.REJECTED': {
    en: "We couldn't approve your bank account. Please delete this account and add a new one.",
    es: 'No pudimos aprobar tu cuenta bancaria. Elimina esta cuenta y agrega una nueva.',
    pt: 'Não foi possível aprovar sua conta bancária. Exclua esta conta e adicione uma nova.',
  },
  'bankAccounts.status.tooltip.starred': {
    en: 'This is the bank account you submitted in step 2 of your account setup.',
    es: 'Esta es la cuenta bancaria que cargaste en el paso 2 de la configuración de tu cuenta.',
    pt: 'Esta é a conta bancária que você enviou no passo 2 da configuração de sua conta.',
  },
  'bankAccounts.number': {
    en: 'Bank account number: Ending in ',
    es: 'Número de cuenta bancaria: termina en ',
    pt: 'Número da conta bancária: terminado em ',
  },
  'bankAccounts.type.CHECKING': {
    en: 'Checking account',
    es: 'Cuenta corriente',
    pt: 'Conta corrente',
  },
  'bankAccounts.type.SAVING': {
    en: 'Savings account',
    es: 'Cuenta de ahorro',
    pt: 'Conta poupança ',
  },
  'bankAccounts.type.SALARY': {
    en: 'Salary account',
    es: 'Cuenta de salario',
    pt: 'Conta salário',
  },
  'bankAccounts.type.VISTA': {
    en: 'Vista',
    es: 'Vista',
    pt: 'Vista',
  },
  'bankAccounts.type.MASTER': {
    en: 'Master',
    es: 'Master',
    pt: 'Master',
  },
  'bankAccounts.starred': {
    en: 'Starred',
    es: 'Favorito',
    pt: 'Preferido',
  },
  'bankAccounts.noAccounts': {
    en: 'To withdraw money from your sales, you must fill in your bank account details in the ',
    es: 'Para retirar dinero de tus ventas, debes completar los datos de tu cuenta bancaria en la sección ',
    pt: 'Para retirar o dinheiro da suas vendas, você deve (preencher/completar) os dados de sua conta bancária na seção ',
  },
  'bankAccounts.noAccounts.link': {
    en: 'Company data',
    es: 'Datos de su negocio',
    pt: 'Dados da empresa',
  },
  'bankAccounts.noAccounts2': {
    en: ' section.',
    es: '.',
    pt: '.',
  },
  'bankAccounts.delete': {
    en: 'DELETE BANK ACCOUNT',
    es: 'ELIMINAR CUENTA BANCARIA',
    pt: 'EXCLUIR CONTA BANCÁRIA',
  },
  'bankAccounts.delete.confirm.headline': {
    en: 'Are you sure you want to delete this bank account?',
    es: '¿Estás seguro de que quieres eliminar esta cuenta bancaria?',
    pt: 'Tem certeza de que deseja excluir esta conta bancária?',
  },
  'bankAccounts.delete.confirm.subheadline': {
    en: 'You will no longer have this account to withdraw the money from your sales.',
    es: 'Ya no tendrás disponible esta cuenta para retirar el dinero de tus ventas.',
    pt: 'Você não terá mais esta conta para sacar o dinheiro de suas vendas.',
  },
  'bankAccounts.delete.confirm.cancel.button': {
    en: 'CANCEL',
    es: 'CANCELAR',
    pt: 'CANCELAR',
  },
  'bankAccounts.delete.confirm.confirmed.button': {
    en: 'CONTINUE',
    es: 'CONTINUAR',
    pt: 'CONTINUAR',
  },
  'bankAccounts.delete.error.headline': {
    en: "We couldn't delete your bank account",
    es: 'No se pudo eliminar tu cuenta bancaria',
    pt: 'Não foi possível excluir sua conta bancária',
  },
  'bankAccounts.delete.error.subheadline': {
    en: 'An error occurred during the process. Please try deleting your account later.',
    es: 'Ocurrió un error en el proceso. Por favor, intenta eliminar tu cuenta más tarde.',
    pt: 'Ocorreu um erro durante o processo. Por favor, tente excluir sua conta mais tarde.',
  },
  'bankAccounts.delete.error.718.headline': {
    en: "At the moment, you can't delete this bank account",
    es: 'Por el momento, no puedes eliminar esta cuenta bancaria',
    pt: 'No momento, você não pode excluir esta conta bancária',
  },
  'bankAccounts.delete.error.718.subheadline': {
    en: "You have a pending withdrawal request. Once the withdrawal is completed, you'll be able to delete this account.",
    es: 'Tienes un retiro de dinero en proceso. Una vez que el retiro se complete, podrás eliminar esta cuenta.',
    pt: 'Você tem uma solicitação de saque pendente. Assim que o saque for concluído, você poderá excluir esta conta.',
  },
  'bankAccounts.new.sucess.headline': {
    en: "We're verifying your bank account information",
    es: 'Estamos verificando la información de tu cuenta bancaria',
    pt: 'Estamos verificando as informações da sua conta bancária',
  },
  'bankAccounts.new.sucess.subheadline': {
    en: "Approval is pending until we're done with the review.This will take us 1 business day.",
    es: 'La aprobación está pendiente hasta que terminemos con la revisión. Esto nos llevará 1 día hábil.',
    pt: 'A aprovação está pendente até terminarmos a revisão. Isso nos levará 1 dia útil.',
  },
  'bankAccounts.new.sucess.button': {
    en: 'CONTINUE',
    es: 'CONTINUAR',
    pt: 'CONTINUAR',
  },
  'bankAccounts.________': {
    en: '',
    es: '',
    pt: '',
  },
  'bankAccounts.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'bankAccounts.name': {
    en: 'Name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'bankAccounts.documentType': {
    en: 'Document type',
    es: 'Tipo de documento',
    pt: 'Tipo de documento',
  },
  'bankAccounts.document': {
    en: 'Document',
    es: 'Documento',
    pt: 'Documento',
  },
  'bankAccounts.bankName': {
    en: 'Bank',
    es: 'Banco',
    pt: 'Banco',
  },
  'bankAccounts.bankAccount': {
    en: 'Bank account number',
    es: 'Número de cuenta bancaria',
    pt: 'Numero de conta bancária',
  },
  'bankAccounts.accountType': {
    en: 'Account type',
    es: 'Tipo de cuenta',
    pt: 'Tipo de conta',
  },
  'bankAccounts.currency': {
    en: 'Account currency',
    es: 'Moneda de la cuenta',
    pt: 'Moeda da conta',
  },
  'bankAccounts.bankBranch': {
    en: 'Branch',
    es: 'Sucursal',
    pt: 'Agência',
  },
  'bankAccounts.phone': {
    en: 'Phone',
    es: 'Teléfono',
    pt: 'Telefone',
  },
  'bankAccounts.address': {
    en: 'Address',
    es: 'Dirección',
    pt: 'Endereço',
  },
  'bankAccounts.city': {
    en: 'City',
    es: 'Ciudad',
    pt: 'Cidade',
  },
  'bankAccounts.IBAN': {
    en: 'IBAN',
    es: 'IBAN',
    pt: 'IBAN',
  },
  'bankAccounts.addBankAccount': {
    en: 'ADD BANK ACCOUNT',
    es: 'AGREGAR CUENTA BANCARIA',
    pt: 'ADICIONAR CONTA BANCÁRIA',
  },
  'filter.btn': {
    en: 'Filter {0}',
    es: 'Filtrar {0}',
    pt: 'Filtrar {0}',
  },
  'filter.title': {
    en: 'Filter by:',
    es: 'Filtrar por:',
    pt: 'Filtrar por:',
  },
  'filter.cleanFilter': {
    en: 'Clean filters',
    es: 'Limpiar filtros',
    pt: 'Filtros limpos',
  },
  'datepicker.from': {
    en: 'From',
    es: 'Desde',
    pt: 'A partir de',
  },
  'datepicker.to': {
    en: 'To',
    es: 'Hasta',
    pt: 'Até',
  },
  'datepicker.placeholder': {
    en: 'dd/mm/yyyy',
    es: 'dd/mm/aaaa',
    pt: 'dd/mm/aaaa',
  },
  'selectDateRange.today': {
    en: 'Today',
    es: 'Hoy',
    pt: 'Hoje',
  },
  'selectDateRange.lastWeek': {
    en: 'Last week',
    es: 'Semana pasada',
    pt: 'Semana Anterior',
  },
  'selectDateRange.lastMonth': {
    en: 'Last month',
    es: 'Mes pasado',
    pt: 'Mês passado',
  },
  'selectDateRange.specificDateRange': {
    en: 'Specific date range',
    es: 'Intervalo de fechas específico',
    pt: 'Intervalo de datas específico',
  },
  'linkDocs.levels': {
    en: 'What documents must I present',
    es: 'Qué documentos debo presentar',
    pt: 'Que documentos devo apresentar',
  },
  'linkDocs.integrations': {
    en: `How to integrate my website to ${brandName}?`,
    es: `¿Cómo integrar mi sitio web a ${brandName}?`,
    pt: `Como faço para integrar meu site ao ${brandName}?`,
  },
  'linkDocs.paymentLink': {
    en: 'How to charge with a payment link?',
    es: '¿Cómo cobrar con link de pago?',
    pt: 'Como cobrar com link de pagamento?',
  },
  localCurrencyWarning: {
    en: 'Your client will always pay in their local currency.',
    es: 'Tu cliente pagará siempre en su moneda local.',
    pt: 'Seu cliente sempre pagará na moeda local dele.',
  },
  localCurrencyInfo: {
    en: "Submit the amount in USD, your client will pay in their local currency and you'll receive it in {0}.",
    es: 'Ingresa el monto en USD, tu cliente pagará en moneda local, y tu recibirás en {0}.',
    pt: 'Insira o valor em USD, seu cliente pagará na moeda local dele, e você receberá {0}.',
  },
  'reports.headline': {
    en: 'Reports',
    es: 'Reportes',
    pt: 'Relatórios',
  },
  'reports.list.subheadline': {
    en: 'View reports and key data on your business performance.',
    es: 'Consulta reportes y datos clave sobre el rendimiento de tu negocio.',
    pt: 'Consulte relatórios e dados-chave sobre o desempenho do seu negócio.',
  },
  'reports.subheadline': {
    en: 'Your business metrics',
    es: 'Tus métricas de negocio',
    pt: 'Suas métricas de negócios',
  },
  'reports.description': {
    en: 'Track your latest sales and compare the most important indicators.',
    es: 'Realiza un seguimiento de tus últimas ventas y compara los indicadores más importantes.',
    pt: 'Acompanhe suas últimas vendas e compare os indicadores mais importantes.',
  },
  'reports.tag.last_7_days': {
    en: 'Last 7 days',
    es: 'Últimos 7 días',
    pt: 'Últimos 7 dias',
  },
  'reports.tag.current_month': {
    en: 'Current Month',
    es: 'Mes actual',
    pt: 'Mês atual',
  },
  'reports.tag.last_month': {
    en: 'Last month',
    es: 'Mes pasado',
    pt: 'Mês passado',
  },
  'reports.card1.headline': {
    en: 'Payment volume',
    es: 'Volumen de ventas',
    pt: 'Volume de vendas',
  },
  'reports.card1.last_7_days.tooltip': {
    en: 'Amount of money you received from your clients in the last 7 days.',
    es: 'Cantidad de dinero que recibiste de tus clientes en los últimos 7 días.',
    pt: 'Quantidade de dinheiro que você recebeu de seus clientes nos últimos 7 dias.',
  },
  'reports.card1.last_7_days.description': {
    en: '・Last week it was {0} {1}',
    es: '・La semana pasada fue {0} {1}',
    pt: '・Semana passada foi {0} {1}',
  },
  'reports.card1.current_month.tooltip': {
    en: 'Amount of money you received from your clients in the current month.',
    es: 'Cantidad de dinero que recibiste de tus clientes en el mes actual.',
    pt: 'Quantidade de dinheiro que você recebeu de seus clientes no mês atual.',
  },
  'reports.card1.current_month.description': {
    en: '・Current month it is {0} {1}',
    es: '・El mes actual ha sido {0} {1}',
    pt: '・Mês atual é {0} {1}',
  },
  'reports.card1.last_month.tooltip': {
    en: 'Amount of money you received from your clients in the last month.',
    es: 'Cantidad de dinero que recibiste de tus clientes en el mes pasado.',
    pt: 'Quantidade de dinheiro que você recebeu de seus clientes no mês passado.',
  },
  'reports.card1.last_month.description': {
    en: '・Last month it was {0} {1}',
    es: '・El mes pasado fue {0} {1}',
    pt: '・Mês passado foi {0} {1}',
  },
  'reports.card2.headline': {
    en: 'Number of transactions',
    es: 'Número de transacciones',
    pt: 'Número de transações',
  },
  'reports.card2.last_7_days.tooltip': {
    en: 'Number of approved payments you had in the last 7 days.',
    es: 'Número de pagos aprobados que tuviste en los últimos 7 días.',
    pt: 'Número de pagamentos aprovados que você teve nos últimos 7 dias.',
  },
  'reports.card2.last_7_days.description': {
    en: '・Last week it was {0}',
    es: '・La semana pasada fue {0}',
    pt: '・Semana passada foi {0}',
  },
  'reports.card2.current_month.tooltip': {
    en: 'Number of approved payments you had in the current month.',
    es: 'Número de pagos aprobados que tuviste en el mes actual.',
    pt: 'Número de pagamentos aprovados que você teve no mês atual.',
  },
  'reports.card2.current_month.description': {
    en: '・Current month it is {0}',
    es: '・El mes corriente es {0}',
    pt: '・Mês atual é {0}',
  },
  'reports.card2.last_month.tooltip': {
    en: 'Number of approved payments you had in the last month.',
    es: 'Número de pagos aprobados que tuviste en el mes pasado.',
    pt: 'Número de pagamentos aprovados que você teve no mês passado.',
  },
  'reports.card2.last_month.description': {
    en: '・Last month it was {0}',
    es: '・El mes pasado fue {0}',
    pt: '・Mês passado foi {0}',
  },
  'reports.card3.headline': {
    en: 'Average ticket',
    es: 'Ticket promedio',
    pt: 'Ticket médio',
  },
  'reports.card3.last_7_days.tooltip': {
    en: 'The average ticket is the result of your payment volume divided by your number of transactions in the last 7 days.',
    es: 'El ticket promedio es el resultado del volumen de ventas dividido por el número de transacciones en los últimos 7 días.',
    pt: 'O ticket médio é o resultado do volume de vendas dividido pelo número de transações nos últimos 7 dias.',
  },
  'reports.card3.last_7_days.description': {
    en: '・Last week it was {0} {1}',
    es: '・La semana pasada fue {0} {1}',
    pt: '・Semana passada foi {0} {1}',
  },
  'reports.card3.current_month.tooltip': {
    en: 'The average ticket is the result of your payment volume divided by your number of transactions in the current month.',
    es: 'El ticket promedio es el resultado del volumen de ventas dividido por el número de transacciones en el mes actual.',
    pt: 'O ticket médio é o resultado do volume de vendas dividido pelo número de transações no mês atual.',
  },
  'reports.card3.current_month.description': {
    en: '・Current month it is {0} {1}',
    es: '・El mes actual ha sido {0} {1}',
    pt: '・Mês atual é {0} {1}',
  },
  'reports.card3.last_month.tooltip': {
    en: 'The average ticket is the result of your payment volume divided by your number of transactions in the last month.',
    es: 'El ticket promedio es el resultado del volumen de ventas dividido por el número de transacciones el mes pasado.',
    pt: 'O ticket médio é o resultado do volume de vendas dividido pelo número de transações no mês passado.',
  },
  'reports.card3.last_month.description': {
    en: '・Last month it was {0} {1}',
    es: '・El mes pasado fue {0} {1}',
    pt: '・Mês passado foi {0} {1}',
  },
  'reports.error.message': {
    en: 'Your business information couldn’t be loaded.<br />Please reload the page.',
    es: 'No se pudo cargar la información de tu negocio.<br />Por favor, actualiza la página.',
    pt: 'Não foi possível carregar as informações da sua empresa.<br />Por favor, atualize a página.',
  },
  'reports.error.button': {
    en: 'Reload',
    es: 'Actualizar',
    pt: 'Atualizar',
  },
  'reports.paymentVolume.title': {
    en: 'Payment volume',
    es: 'Volumen de ventas',
    pt: 'Volume de vendas',
  },
  'reports.paymentVolume.last_7_days.tooltip': {
    en: 'Amount of money you received from your clients in the last 7 days.',
    es: 'Cantidad de dinero que recibiste de tus clientes en los últimos 7 días.',
    pt: 'Quantidade de dinheiro que você recebeu de seus clientes nos últimos 7 dias.',
  },
  'reports.paymentVolume.current_month.tooltip': {
    en: 'Amount of money you received from your clients in the current month.',
    es: 'Cantidad de dinero que recibiste de tus clientes en el mes actual.',
    pt: 'Quantidade de dinheiro que você recebeu de seus clientes no mês atual.',
  },
  'reports.paymentVolume.last_month.tooltip': {
    en: 'Amount of money you received from your clients in the last month.',
    es: 'Cantidad de dinero que recibiste de tus clientes en el mes pasado.',
    pt: 'Quantidade de dinheiro que você recebeu de seus clientes no mês passado.',
  },
  'reports.transactionCount': {
    en: 'transaction',
    es: 'transacción',
    pt: 'transação',
  },
  'reports.transactionsCount': {
    en: 'transactions',
    es: 'transacciones',
    pt: 'transações',
  },
  'reports.transactionsByCountry.title': {
    en: 'Transactions by country',
    es: 'Transacciones por país',
    pt: 'Transações por país',
  },
  'reports.transactionsByCountry.tooltip': {
    en: 'Your percentage of sales distributed by country.',
    es: 'Tu porcentaje de ventas distribuido por país.',
    pt: 'Sua porcentagem de vendas distribuídas por país.',
  },
  'reports.transactionsBy.empty': {
    en: 'No transactions',
    es: 'Sin transacciones',
    pt: 'Sem transações',
  },
  'reports.transactionsByPaymentSolution.title': {
    en: 'Transactions by payment solution',
    es: 'Transacciones por solución de cobro',
    pt: 'Transações por solução de pagamento',
  },
  'reports.transactionsByPaymentSolution.tooltip': {
    en: 'Your percentage of sales distributed by payment solution.',
    es: 'Tu porcentaje de ventas distribuido por solución de cobro.',
    pt: 'Sua porcentagem de vendas distribuída por solução de pagamento.',
  },
  'reports.transactionsByPaymentSolution.type.SHOPIFY': {
    en: 'Shopify',
    es: 'Shopify',
    pt: 'Shopify',
  },
  'reports.transactionsByPaymentSolution.type.PAYMENT_LINK': {
    en: 'Payment link',
    es: 'Link de pago',
    pt: 'Link de pagamento',
  },
  'reports.transactionsByPaymentSolution.type.PAYMENT_BUTTON': {
    en: 'Payment button',
    es: 'Botón de pago',
    pt: 'Botão de pagamento',
  },
  'reports.transactionsByPaymentSolution.type.VIRTUAL_POS': {
    en: 'Virtual POS',
    es: 'POS Virtual',
    pt: 'POS Virtual',
  },
  'reports.transactionsByPaymentSolution.type.SUBSCRIPTION': {
    en: 'Subscription',
    es: 'Suscripción',
    pt: 'Assinatura',
  },
  'reports.transactionsByPaymentSolution.type.OTHERS': {
    en: 'Others',
    es: 'Otros',
    pt: 'Outros',
  },
  'reports.transactionsByPaymentMethod.title': {
    en: 'Transactions by payment method',
    es: 'Transacciones por método de pago',
    pt: 'Transações por forma de pagamento',
  },
  'reports.transactionsByPaymentMethod.tooltip': {
    en: 'Your percentage of sales distributed by payment method.',
    es: 'Tu porcentaje de ventas distribuido por método de pago.',
    pt: 'Sua porcentagem de vendas distribuída por forma de pagamento.',
  },
  'kyc_step1.message.completed.headline': {
    en: 'Congratulations!<br />You completed step 1',
    es: '¡Felicitaciones!<br />Completaste el paso 1',
    pt: 'Parabéns!<br />Você concluiu o passo 1',
  },
  'kyc_step1.message.completed.subheadline': {
    en: 'Now you can start selling how you want, where you want.',
    es: 'Ahora puedes empezar a vender como quieras, donde quieras.',
    pt: 'Agora, você pode começar a vender como e onde quiser.',
  },
  'kyc_step1.message.completed.button': {
    en: 'CONTINUE',
    es: 'CONTINUAR',
    pt: 'CONTINUAR',
  },
  'kyc_step1.message.warning.headline': {
    en: "We couldn't verify your identity",
    es: 'No pudimos verificar tu identidad',
    pt: 'Não foi possível verificar sua identidade',
  },
  'kyc_step1.message.warning.subheadline': {
    en: 'Please complete the step 1 of your account setup again.',
    es: 'Por favor, vuelve a completar el paso 1 de configuración de tu cuenta.',
    pt: 'Conclua o passo 1 da configuração da sua conta novamente.',
  },
  'kyc_step1.message.warning.button': {
    en: 'CONTINUE',
    es: 'CONTINUAR',
    pt: 'CONTINUAR',
  },
  'companyInformation.steps.tag.retryValidation': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendiente',
  },
  'companyInformation.step1.headline.retryValidation': {
    en: 'Re-verify your identity',
    es: 'Vuelve a verificar tu identidad',
    pt: 'Verifique novamente sua identidade',
  },
  'companyInformation.step1.subheadline.retryValidation': {
    en: 'You will be asked to submit an image of your ID document, which will be checked to ensure it is legitimate',
    es: 'Se le pedirá que envíe una imagen de su documento de identidad, que se verificará para asegurarnos de que es legítima y no se ha alterado ni manipulado.',
    pt: 'Ser-lhe-á solicitado, preencher uma imagem do seu documento de identificação, que será verificado para garantir que é legítimo e não foi alterado ou manipulado.',
  },
  'companyInformation.step1.content.retryValidation': {
    en: 'This step will enable you to receive payments.',
    es: 'Este paso te habilitará a recibir pagos.',
    pt: 'Este passo te habilitará a receber pagamentos.',
  },
  'companyInformation.step1.button.retryValidation': {
    en: 'COMPLETE VERIFICATION',
    es: 'COMPLETAR VERIFICACIÓN',
    pt: 'FINALIZAR VERIFICAÇÃO',
  },
  'companyInformation.steps.tag.missingValidation': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendiente',
  },
  'companyInformation.step1.headline.missingValidation': {
    en: 'Verify your identity',
    es: 'Verifica tu identidad',
    pt: 'Verifique sua identidade',
  },
  'companyInformation.step1.subheadline.missingValidation': {
    en: 'You will be asked to submit an image of your ID document, which will be checked to ensure it is legitimate',
    es: 'Se le pedirá que envíe una imagen de su documento de identidad, que se verificará para asegurarnos de que es legítima y no se ha alterado ni manipulado.',
    pt: 'Ser-lhe-á solicitado, preencher uma imagem do seu documento de identificação, que será verificado para garantir que é legítimo e não foi alterado ou manipulado.',
  },
  'companyInformation.step1.content.missingValidation': {
    en: 'This step will enable you to receive payments.',
    es: 'Este paso te habilitará a recibir pagos.',
    pt: 'Este passo te habilitará a receber pagamentos.',
  },
  'companyInformation.step1.button.missingValidation': {
    en: 'COMPLETE VERIFICATION',
    es: 'COMPLETAR VERIFICACIÓN',
    pt: 'FINALIZAR VERIFICAÇÃO',
  },
  'companyInformation.steps.tag.errorValidation': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendiente',
  },
  'companyInformation.step1.headline.errorValidation': {
    en: 'Contact us to verify your identity',
    es: 'Contáctanos para verificar tu identidad',
    pt: 'Entre em contato conosco para verificar a sua identidade',
  },
  'companyInformation.step1.subheadline.errorValidation': {
    en: 'There was a problem verifying your data. Contact us so we can help you.',
    es: 'Hubo un problema en el proceso de verificación de tus datos. Escríbenos para que podamos ayudarte.',
    pt: 'Ocorreu um problema ao verificar seus dados. Escreva-nos para que possamos ajudá-lo.',
  },
  'companyInformation.step1.link.errorValidation': {
    en: 'Contact support',
    es: 'Contactar a soporte',
    pt: 'Contatar suporte',
  },
  'companyInformation.message.confirm.leave.headline': {
    en: 'Do you want to leave the setup process?',
    es: '¿Aceptas salir del proceso?',
    pt: 'Deseja sair do processo de configuração?',
  },
  'companyInformation.message.confirm.leave.subheadline': {
    en: 'This step is necessary for us to verify your identity and allow you to receive payments.',
    es: 'Este paso es necesario para que podamos verificar tu identidad y permitirte recibir pagos.',
    pt: 'Este passo é necessário para verificarmos sua identidade e permitir que você receba pagamentos.',
  },
  'companyInformation.message.confirm.leave.cancel.button': {
    en: 'STAY',
    es: 'CANCELAR',
    pt: 'FICAR',
  },
  'companyInformation.message.confirm.leave.confirmed.button': {
    en: 'LEAVE',
    es: 'ACEPTAR',
    pt: 'SAIR',
  },
  'expirationBox.headline': {
    en: 'Set expiration date',
    es: 'Establecer fecha de expiración',
    pt: 'Definir data de expiração',
  },
  'expirationBox.headline.optional': {
    en: '(Optional)',
    es: '(Opcional)',
    pt: '(Opcional)',
  },
  'expirationBox.subheadline': {
    en: 'Disable this link on a specific date. By default, it will expire in 15 days.',
    es: 'Deshabilita este link en una fecha específica. Por defecto, expirará en 15 días.',
    pt: 'Desative este link numa data específica. Por padrão, expirará em 15 dias.',
  },
  'expirationBox.expirationDate': {
    en: 'Expiration date',
    es: 'Fecha de expiración',
    pt: 'Data de expiração',
  },
  'expirationBox.minimumValue': {
    en: 'The minimum expiration time is 5 minutes',
    es: 'El tiempo mínimo de expiración son 5 minutos',
    pt: 'O tempo mínimo de expiração é de 5 minutos',
  },
  'expirationBox.DAYS': {
    en: 'Days',
    es: 'Días',
    pt: 'Dias',
  },
  'expirationBox.HOURS': {
    en: 'Hours',
    es: 'Horas',
    pt: 'Horas',
  },
  'expirationBox.MINUTES': {
    en: 'Minutes',
    es: 'Minutos',
    pt: 'Minutos',
  },
  'expirationBox.MONTHS': {
    en: 'Month',
    es: 'Mes',
    pt: 'Mês',
  },
  'expirationBox.YEARS': {
    en: 'Year',
    es: 'Año',
    pt: 'Ano',
  },
  'subscriptions.subheadline': {
    en: 'Find all your subscribers, the plans you created, and their status.',
    es: 'Encuentra todos los suscriptores que tienes, los planes que creaste y su estado.',
    pt: 'Encontre todos os seus assinantes, os planos que você criou e o status deles.',
  },
  'subscriptions.list.subheadline': {
    en: 'Get paid automatically with subscription plans tailored to your business.',
    es: 'Cobra automáticamente con planes de suscripción adaptados a tu negocio.',
    pt: 'Receba pagamentos automaticamente com planos de assinatura adaptados ao seu negócio.',
  },
  'subscriptions.createPlan': {
    en: 'Create a plan',
    es: 'Crear un plan',
    pt: 'Criar um plano',
  },
  'subscriptions.subscriptors': {
    en: 'Subscribers',
    es: 'Suscriptores',
    pt: 'Assinantes',
  },
  'subscriptions.plans': {
    en: 'Plans',
    es: 'Planes',
    pt: 'Planos',
  },
  'subscriptions.startDate': {
    en: 'Subscription start date',
    es: 'Inicio de suscripción',
    pt: 'Início da assinatura',
  },
  'subscriptions.clientName': {
    en: 'Client name',
    es: 'Nombre del cliente',
    pt: 'Nome do cliente',
  },
  'subscriptions.planName': {
    en: 'Plan name',
    es: 'Nombre del plan',
    pt: 'Nome do plano',
  },
  'subscriptions.country': {
    en: 'Country',
    es: 'País',
    pt: 'País',
  },
  'subscriptions.allCountries': {
    en: 'All countries',
    es: 'Todos los países',
    pt: 'Todos os países',
  },
  'subscriptions.amountToCharge': {
    en: 'Amount to charge',
    es: 'Monto a cobrar',
    pt: 'Valor a cobrar',
  },
  'subscriptions.status': {
    en: 'Subscription status',
    es: 'Estado de la suscripción',
    pt: 'Status da assinatura',
  },
  'subscriptions.lastPaymentStatus': {
    en: 'Last payment status',
    es: 'Estado de último pago',
    pt: 'Estado do último pagamento',
  },
  'subscriptions.executionStatus.PENDING': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'subscriptions.executionStatus.COMPLETED': {
    en: 'Completed',
    es: 'Completada',
    pt: 'Concluído',
  },
  'subscriptions.executionStatus.DECLINED': {
    en: 'Declined',
    es: 'Rechazada',
    pt: 'Rejeitado',
  },
  'subscriptions.active': {
    en: 'Active',
    es: 'Activa',
    pt: 'Ativa',
  },
  'subscriptions.inactive': {
    en: 'Inactive',
    es: 'Inactiva',
    pt: 'Inativa',
  },
  'subscriptions.seeDetails': {
    en: 'See details',
    es: 'Ver detalles',
    pt: 'Ver detalhes',
  },
  'subscriptions.seeEdit': {
    en: 'Edit plan',
    es: 'Editar plan',
    pt: 'Editar plano',
  },
  'subscriptions.emptySubscriptions.title': {
    en: 'You don’t have subscribers yet',
    es: 'Aún no tienes suscriptores',
    pt: 'Você ainda não tem assinantes',
  },
  'subscriptions.emptySubscriptions.body': {
    en: 'Create or share an existing plan and collect payments easily.',
    es: 'Crea o comparte un plan existente y recibe pagos fácilmente.',
    pt: 'Crie ou compartilhe um plano existente e receba pagamentos facilmente.',
  },
  'subscriptions.details': {
    en: 'Subscriptions details',
    es: 'Detalles de las suscripciones',
    pt: 'Detalhes das assinaturas',
  },
  'subscriptions.details.subheadline': {
    en: 'Subscriptions details',
    es: 'Detalles de las suscripciones',
    pt: 'Detalhes das assinaturas',
  },
  'subscriptions.details.backBtn': {
    en: 'Back to your subscriptions',
    es: 'Volver a tus suscripciones',
    pt: 'Voltar para suas assinaturas',
  },
  'subscriptions.details.cancel': {
    en: 'Cancel subscription',
    es: 'Cancelar suscripción',
    pt: 'Cancelar assinatura',
  },
  'subscriptions.details.cancelPlan': {
    en: 'Cancel plan',
    es: 'Cancelar plan',
    pt: 'Cancelar plano',
  },
  'subscriptions.details.activePlan': {
    en: 'Active plan',
    es: 'Plan activo',
    pt: 'Plano ativo',
  },
  'subscriptions.details.inactivePlan': {
    en: 'Inactive plan',
    es: 'Plan inactivo',
    pt: 'Plano inativo',
  },
  'subscriptions.subscriptionDate': {
    en: 'Subscription date',
    es: 'Fecha de la suscripción',
    pt: 'Data de assinatura',
  },
  'subscriptions.paymentFrequency': {
    en: 'Payment frequency',
    es: 'Frecuencia de cobro',
    pt: 'Frequência de pagamento',
  },
  'subscriptions.frequency.DAILY': {
    en: 'Day',
    es: 'Día',
    pt: 'Dia',
  },
  'subscriptions.frequency.DAILY.plural': {
    en: 'Days',
    es: 'Días',
    pt: 'Dias',
  },
  'subscriptions.frequency.WEEKLY': {
    en: 'Week',
    es: 'Semana',
    pt: 'Semana',
  },
  'subscriptions.frequency.WEEKLY.plural': {
    en: 'Weeks',
    es: 'Semanas',
    pt: 'Semanas',
  },
  'subscriptions.frequency.MONTHLY': {
    en: 'Month',
    es: 'Mes',
    pt: 'Mes',
  },
  'subscriptions.frequency.MONTHLY.plural': {
    en: 'Months',
    es: 'Meses',
    pt: 'Meses',
  },
  'subscriptions.frequency.YEARLY': {
    en: 'Year',
    es: 'Año',
    pt: 'Ano',
  },
  'subscriptions.frequency.YEARLY.plural': {
    en: 'Years',
    es: 'Años',
    pt: 'Anos',
  },
  'subscriptions.frequency.QUARTERLY': {
    en: 'Quarterly',
    es: 'Trimestral',
    pt: 'Trimestral',
  },
  'subscriptions.frequency.SEMI_ANNUALLY': {
    en: 'Semi-annual',
    es: 'Semestral',
    pt: 'Semestral',
  },
  'subscriptions.frequency.ANNUALLY': {
    en: 'Yearly',
    es: 'Anual',
    pt: 'Anual',
  },
  'subscriptions.frequency.CUSTOM': {
    en: 'Custom',
    es: 'Personalizado',
    pt: 'Personalizado',
  },
  'subscriptions.customFrequency.WEEKLY': {
    en: 'Weekly',
    es: 'Semanal',
    pt: 'Semanal',
  },
  'subscriptions.customFrequency.MONTHLY': {
    en: 'Monthly',
    es: 'Mensual',
    pt: 'Mensal',
  },
  'subscriptions.subscribersCountry': {
    en: "Subscribers' country",
    es: 'País de los suscriptores',
    pt: 'País dos assinantes',
  },
  'subscriptions.paymentMethod': {
    en: 'Payment method',
    es: 'Método de pago',
    pt: 'Método de pagamento',
  },
  'subscriptions.clientInformation': {
    en: 'Client information',
    es: 'Información del cliente',
    pt: 'Informações do cliente',
  },
  'subscriptions.clientEmail': {
    en: 'Client email',
    es: 'Email del cliente',
    pt: 'E-mail do cliente',
  },
  'subscriptions.clientDocument': {
    en: 'Client document',
    es: 'Documento del cliente',
    pt: 'Documento do cliente',
  },
  'subscriptions.clientId': {
    en: 'Client id',
    es: 'ID del cliente',
    pt: 'ID do cliente',
  },
  'subscriptions.paymentDetails': {
    en: 'Payment details',
    es: 'Detalles del pago',
    pt: 'Detalhes do pagamento',
  },
  'subscriptions.nextPaymentDate': {
    en: 'Next payment date',
    es: 'Próxima fecha de pago',
    pt: 'Próxima data de pagamento',
  },
  'subscriptions.executions.date': {
    en: 'Date',
    es: 'Fecha',
    pt: 'Data',
  },
  'subscriptions.executions.transactionID': {
    en: 'Transaction ID',
    es: 'ID de transacción',
    pt: 'ID da transação',
  },
  'subscriptions.executions.amountPaid': {
    en: 'Amount paid',
    es: 'Total pagado',
    pt: 'Valor pago',
  },
  'subscriptions.executions.amountReceived': {
    en: 'Amount received',
    es: 'Total recibido',
    pt: 'Valor recebido',
  },
  'subscriptions.executions.paymentStatus': {
    en: 'Payment status',
    es: 'Estado del pago',
    pt: 'Status do pagamento',
  },
  'subscriptions.plan.subscriptions': {
    es: 'Suscripciones',
    pt: 'Assinaturas',
    en: 'Subscriptions',
  },
  'subscriptions.plan.backToSubscriptions': {
    es: 'Volver a tus suscripciones',
    pt: 'Voltar para suas assinaturas',
    en: 'Back to your subscriptions',
  },
  'subscriptions.plan.createPlan': {
    es: 'Crear un nuevo plan',
    pt: 'Criar um novo plano',
    en: 'Create a new plan',
  },
  'subscriptions.plan.editPlan': {
    es: 'Editar tu plan de suscripción',
    pt: 'Editar seu plano de assinatura',
    en: 'Edit your subscription plan',
  },
  'subscriptions.plan.createPlanDescription': {
    es: 'Un plan te permitirá empezar a recibir pagos de tus clientes de forma recurrente.',
    pt: 'Um plano permitirá que você comece a receber pagamentos dos seus clientes de forma recorrente.',
    en: 'A plan will allow you to start receiving payments from your clients on a recurring basis.',
  },
  'subscriptions.plan.editPlanDescription': {
    es: 'Aquí puedes actualizar la información de tu plan de suscripción.',
    pt: 'Here you can update your subscription information.',
    en: 'Aqui você pode atualizar as informações da sua assinatura.',
  },
  'subscriptions.plan.card1.cardTitle': {
    es: 'Completa el nombre del producto o servicio que quieres ofrecer',
    pt: 'Preencha o nome do produto ou serviço que você deseja oferecer.',
    en: 'Fill in the name of the product or service you want to offer.',
  },
  'subscriptions.plan.card1.planName': {
    es: 'Nombre del plan',
    pt: 'Nome do plano',
    en: 'Plan name',
  },
  'subscriptions.plan.card1.planNameTooltip': {
    es: 'Tus clientes verán este nombre cuando realicen el pago de la suscripción.',
    pt: 'Seus clientes verão este nome quando fizerem o pagamento da assinatura.',
    en: 'Your customers will see this name when they make the subscription payment.',
  },
  'subscriptions.plan.card1.planDescription': {
    es: 'Descripción',
    pt: 'Descrição',
    en: 'Description',
  },
  'subscriptions.plan.card1.planDescriptionTooltip': {
    es: 'Tus clientes verán esta descripción cuando realicen el pago de la suscripción.',
    pt: 'Seus clientes verão essa descrição quando fizerem o pagamento da assinatura.',
    en: 'Your clients will see this description when they make the subscription payment.',
  },
  'subscriptions.plan.card2.cardTitle': {
    es: 'Agrega los detalles del pago',
    pt: 'Adicione os detalhes de pagamento',
    en: 'Add the payment details',
  },
  'subscriptions.plan.card2.paymentDetailsDescription': {
    es: 'Tu cliente solo podrá pagarte con tarjeta de débito o crédito.',
    pt: 'Seu cliente só poderá pagar com cartão de débito ou crédito.',
    en: 'Your client will only be able to pay you with a debit or credit card.',
  },
  'subscriptions.plan.card2.subscribersCountry': {
    es: 'País de los suscriptores',
    pt: 'País dos assinantes',
    en: "Subscribers' country",
  },
  'subscriptions.plan.card2.subscribersCountryTooltip': {
    es: 'Si la suscripción es para todos los países, el cliente podrá elegir su país de origen al momento del pago.',
    pt: 'Se a assinatura for para todos os países, o cliente poderá escolher seu país de origem no momento do pagamento.',
    en: 'If the subscription is for all countries, the client will be able to choose their country of origin at the time of payment.',
  },
  'subscriptions.plan.card2.chargeAmount': {
    es: 'Cantidad que deseas cobrar.',
    pt: 'Valor que deseja cobrar.',
    en: 'You want to charge',
  },
  'subscriptions.plan.card3.cardTitle': {
    es: 'Define la frecuencia de pago de la suscripción',
    pt: 'Defina a frequência de pagamento da assinatura.',
    en: 'Define the payment frequency of the subscription.',
  },
  'subscriptions.plan.card3.frequency': {
    es: 'Frecuencia',
    pt: 'Frequência',
    en: 'Frequency',
  },
  'subscriptions.plan.summaryCard.cardTitle': {
    es: 'Resumen del plan',
    pt: 'Resumo do plano',
    en: 'Plan summary',
  },
  'subscriptions.plan.summaryCard.planName': {
    es: 'Nombre del plan',
    pt: 'Nome do plano',
    en: 'Plan name',
  },
  'subscriptions.plan.summaryCard.planDescription': {
    es: 'Descripción',
    pt: 'Descrição',
    en: 'Description',
  },
  'subscriptions.plan.summaryCard.subscribersCountry': {
    es: 'País de los suscriptores',
    pt: 'País dos assinantes',
    en: "Subscribers' country",
  },
  'subscriptions.plan.summaryCard.paymentAmount': {
    es: 'Tu cliente pagará',
    pt: 'Seu cliente irá pagar',
    en: 'Your client will pay',
  },
  'subscriptions.plan.summaryCard.paymentFrequency': {
    es: 'Frecuencia de cobro',
    pt: 'Frequência de pagamento',
    en: 'Payment frequency',
  },
  'subscriptions.plan.reviewPlan': {
    es: 'Revisar plan',
    pt: 'Rever o plano',
    en: 'Review plan',
  },
  'subscriptions.plan.confirmPlanDetails.goBack': {
    es: 'Volver a editar el plan',
    pt: 'Voltar para editar o plano',
    en: 'Back to edit the plan',
  },
  'subscriptions.plan.confirmPlanDetails.pageTitle': {
    es: 'Confirmar detalles del plan',
    pt: 'Confirmar detalhes do plano',
    en: 'Confirm plan details',
  },
  'subscriptions.plan.confirmPlanDetails.pageDescription': {
    es: 'Por favor, revisa la información antes de crear el plan.',
    pt: 'Por favor, revise as informações antes de criar o plano.',
    en: 'Please review the information before creating the plan.',
  },
  'subscriptions.plan.confirmUpdatePlanDetails.pageDescription': {
    es: 'Por favor, revisa los detalles antes de actualizar el plan.',
    pt: 'Por favor, revise os detalhes antes de atualizar o plano.',
    en: 'Please review the details before updating the plan.',
  },
  'subscriptions.plan.confirmPlanDetails.createPlan': {
    es: 'CREAR PLAN',
    pt: 'CRIAR PLANO',
    en: 'CREATE PLAN',
  },
  'subscriptions.plan.confirmUpdatePlanDetails.updatePlan': {
    es: 'ACTUALIZAR PLAN',
    pt: 'ATUALIZAR PLANO',
    en: 'UPDATE PLAN',
  },
  'subscriptions.plan.confirmPlanDetails.cancel': {
    es: 'CANCELAR',
    pt: 'CANCELAR',
    en: 'CANCEL',
  },
  'subscriptions.plan.sharePage.pageTitle': {
    es: '¡Plan de suscripción listo! Compártelo con tus clientes',
    pt: 'Plano de assinatura pronto! Compartilhe com seus clientes',
    en: 'Subscription plan ready! Share it with your clients',
  },
  'subscriptions.plan.sharePage.pageDescription': {
    es: 'Copia y comparte este link del plan',
    pt: 'Copie e compartilhe este link do plano',
    en: 'Copy and share this plan link',
  },
  'subscriptions.plan.sharePage.copyLink': {
    es: 'COPIAR LINK',
    pt: 'COPIAR LINK',
    en: 'COPY LINK',
  },
  'subscriptions.plan.sharePage.shareVia': {
    es: 'O comparte este link del plan a través de',
    pt: 'Ou compartilhe este link do plano através de',
    en: 'Or share this plan link via',
  },
  'subscriptions.plan.updateSubscription.pageTitle': {
    es: 'Editar tu plan de suscripción',
    pt: 'Editar seu plano de assinatura',
    en: 'Edit your subscription plan',
  },
  'subscriptions.plan.updateSubscription.pageDescription': {
    es: 'Aquí puedes actualizar la información de tu plan de suscripción.',
    pt: 'Aqui você pode atualizar as informações do seu plano de assinatura.',
    en: 'Here you can update your subscription plan information.',
  },
  'subscriptions.plan.updateSubscription.reviewPlan': {
    es: 'REVISAR PLAN',
    pt: 'REVISAR PLANO',
    en: 'REVIEW PLAN',
  },
  'subscriptions.plan.updateSubscription.confirmPlanDetails.pageTitle': {
    es: 'Confirmar detalles del plan',
    pt: 'Confirmar detalhes do plano',
    en: 'Confirm plan details',
  },
  'subscriptions.plan.updateSubscription.confirmPlanDetails.pageDescription': {
    es: 'Por favor, revisa los detalles antes de actualizar el plan.',
    pt: 'Por favor, revise os detalhes antes de atualizar o plano.',
    en: 'Please review the details before updating the plan.',
  },
  'subscriptions.plan.updateSubscription.confirmPlanDetails.updatePlan': {
    es: 'ACTUALIZAR PLAN',
    pt: 'ATUALIZAR PLANO',
    en: 'UPDATE PLAN',
  },
  'subscriptions.plan.updateSubscription.confirmPlanDetails.cancel': {
    es: 'CANCELAR',
    pt: 'CANCELAR',
    en: 'CANCEL',
  },
  'subscriptions.plans.empty.title': {
    en: "You don't have plans created yet",
    es: 'Aún no tienes planes creados',
    pt: 'Você ainda não tem planos criados',
  },
  'subscriptions.plans.empty.body': {
    en: 'Create a plan and collect payments easily.',
    es: 'Crea un plan y recibe pagos fácilmente.',
    pt: 'Crie um plano e receba pagamentos facilmente.',
  },
  'subscriptions.plans.active': {
    en: 'Active',
    es: 'Activo',
    pt: 'Ativo',
  },
  'subscriptions.plans.inactive': {
    en: 'Inactive',
    es: 'Inactivo',
    pt: 'Inativo',
  },
  'subscriptions.plans.amount': {
    en: 'Your client will pay',
    es: 'Tu cliente pagará',
    pt: 'Seu cliente vai pagar',
  },
  'subscriptions.plans.country': {
    en: "Subscribers' country",
    es: 'País de los suscriptores',
    pt: 'País dos assinantes',
  },
  'subscriptions.plans.details': {
    en: 'Plan details',
    es: 'Detalles del plan',
    pt: 'Detalhes do plano',
  },
  'subscriptions.plans.details.backBtn': {
    en: 'Back to plans',
    es: 'Volver a mis planes',
    pt: 'Voltar aos meus planos',
  },
  'subscriptions.plans.details.backEdit': {
    en: 'Back to edit the plan',
    es: 'Volver a editar el plan',
    pt: 'Voltar para editar o plano',
  },
  'subscriptions.plans.details.cancel': {
    en: 'Cancel plan',
    es: 'Cancelar plan',
    pt: 'Cancelar plano',
  },
  'subscriptions.plans.details.edit': {
    en: 'Edit plan',
    es: 'Editar plan',
    pt: 'Editar plano',
  },
  'subscriptions.plans.details.share': {
    en: 'Share plan',
    es: 'Compartir plan',
    pt: 'Compartilhar plano',
  },
  'subscriptions.plans.details.date': {
    en: 'Plan date',
    es: 'Fecha del plan',
    pt: 'Data do plano',
  },
  'subscriptions.plans.details.paymentFrequency': {
    en: 'Payment frequency',
    es: 'Frecuencia de cobro',
    pt: 'Frequência de pagamento',
  },
  'subscriptions.plans.details.subscribers': {
    en: 'Subscribers',
    es: 'Suscriptores',
    pt: 'Assinantes',
  },
  'subscriptions.cancel.title': {
    en: 'Are you sure you want to cancel this subscription?',
    es: '¿Estás seguro de que quieres cancelar esta suscripción?',
    pt: 'Tem certeza de que deseja cancelar esta assinatura?',
  },
  'subscriptions.cancel.body1': {
    en: 'By cancelling the subscription your customer will no longer be charged. Please note that this action is irreversible.',
    es: 'Al cancelar la suscripción, ya no le cobrarás a tu cliente. Ten en cuenta que esta acción es irreversible.',
    pt: 'Ao cancelar a assinatura, seu cliente não será mais cobrado. Por favor, note que esta ação é irreversível.',
  },
  'subscriptions.cancel.body2': {
    en: "You'll still be able to view the payment status of that subscriber from the Subscribers tab.",
    es: 'Podrás seguir viendo el estado de pagos de ese suscriptor desde la pestaña Suscriptores.',
    pt: 'Você ainda poderá visualizar o status de pagamento desse assinante na guia Assinantes.',
  },
  'subscriptions.cancel.confirm': {
    en: 'YES, CANCEL THE SUBSCRIPTION',
    es: 'SÍ, CANCELAR LA SUSCRIPCIÓN',
    pt: 'SIM, CANCELAR A ASSINATURA',
  },
  'subscriptions.cancel.no': {
    en: 'NO, THANKS',
    es: 'NO, GRACIAS',
    pt: 'NÃO, OBRIGADO',
  },
  'subscriptions.plans.cancel.title': {
    en: 'Are you sure you want to cancel this plan?',
    es: '¿Seguro que quieres cancelar este plan?',
    pt: 'Tem certeza de que deseja cancelar este plano?',
  },
  'subscriptions.plans.cancel.body1': {
    en: 'By cancelling the plan all active subscribers in this plan will no longer be charged.',
    es: 'Al cancelarlo, dejarás de cobrarle a todos los suscriptores activos de este plan.',
    pt: 'Ao cancelar o plano, todos os assinantes ativos neste plano não serão mais cobrados.',
  },
  'subscriptions.plans.cancel.body2': {
    en: "You'll still be able to view your inactive plan from the Plans tab.",
    es: 'Podrás seguir viendo a tu plan inactivo desde la pestaña Planes.',
    pt: 'Você ainda poderá visualizar seu plano inativo na guia Planos.',
  },
  'subscriptions.plans.cancel.confirm': {
    en: 'YES, CANCEL THE PLAN',
    es: 'SI, CANCELAR EL PLAN',
    pt: 'SIM, CANCELAR O PLANO',
  },
  'subscriptions.planSummary.title': {
    en: 'Plan summary',
    es: 'Resumen del plan',
    pt: 'Resumo do plano',
  },
  'checkout_themes.button': {
    en: 'CREATE THEME',
    es: 'CREAR TEMA',
    pt: 'CRIAR TEMA',
  },

  'checkout_themes.createTheme.title': {
    en: 'Create a new theme',
    es: 'Crear un nuevo tema',
    pt: 'Criar um novo tema',
  },
  'checkout_themes.updateTheme.title': {
    en: 'Copy theme',
    es: 'Copiar tema',
    pt: 'Copiar tema',
  },
  'checkout_themes.createTheme.create': {
    en: 'Add theme',
    es: 'Agregar tema',
    pt: 'Adicionar tema',
  },
  'checkout_themes.updateTheme.update': {
    en: 'Copy theme',
    es: 'Copiar tema',
    pt: 'Copiar tema',
  },
  'checkout_themes.createTheme.name': {
    en: 'Name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'checkout_themes.createTheme.primary_color': {
    en: 'Primary Color',
    es: 'Color Primario',
    pt: 'Cor Primária',
  },
  'checkout_themes.createTheme.text_primary_color': {
    en: 'Text Primary Color',
    es: 'Color Primario de Texto',
    pt: 'Cor Primária do Texto',
  },
  'checkout_themes.createTheme.text_secondary_color': {
    en: 'Text Secondary Color',
    es: 'Color Secundario de Texto',
    pt: 'Cor Secundária do Texto',
  },
  'checkout_themes.createTheme.bg_primary_color': {
    en: 'Background Primary Color',
    es: 'Color Primario de Fondo',
    pt: 'Cor Primária de Fundo',
  },
  'checkout_themes.createTheme.preview': {
    en: 'Preview theme',
    es: 'Vista previa',
    pt: 'Visualizar tema',
  },
  'checkout_themes.createTheme.nameRequired': {
    en: 'Name is required',
    es: 'El nombre es requerido',
    pt: 'Nome é obrigatório',
  },
  'checkout_themes.createTheme.primaryColorRequired': {
    en: 'Primary color is required',
    es: 'El color primario es requerido',
    pt: 'Cor primária é obrigatória',
  },
  'checkout_themes.createTheme.textPrimaryColorRequired': {
    en: 'Text primary color is required',
    es: 'El color primario de texto es requerido',
    pt: 'Cor primária do texto é obrigatória',
  },
  'checkout_themes.createTheme.bgPrimaryColorRequired': {
    en: 'Background primary color is required',
    es: 'El color primario de fondo es requerido',
    pt: 'Cor primária de fundo é obrigatória',
  },
  'checkout_themes.createTheme.uploadLogo.allowedDesc': {
    en: 'Maximum size <b>{0}MB</b>.<br/>Allowed extensions: <b>{1}</b>.',
    es: 'Checkout Logo <br/>Tamaño máximo <b>{0}MB</b>.<br/>Extensiones permitidas: <b>{1}</b>.',
    pt: 'Tamanho máximo <b>{0}MB</b>.<br/>Extensões permitidas: <b>{1}</b>.',
  },
  'checkout_themes.review': {
    en: 'Review',
    es: 'Revisión',
    pt: 'Revisão',
  },
  'checkout_themes.status.approved': {
    en: 'Approved',
    es: 'Aprobado',
    pt: 'Aprovado',
  },
  'checkout_themes.status.pending': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'checkout_themes.status.rejected': {
    en: 'Rejected',
    es: 'Rechazado',
    pt: 'Rejeitado',
  },
  'checkout_themes.status.enable': {
    en: 'Enable theme',
    es: 'Habilitar tema',
    pt: 'Habilitar tema',
  },
  'checkout_themes.status.disable': {
    en: 'Disable theme',
    es: 'Deshabilitar tema',
    pt: 'Desabilitar tema',
  },
  'checkout_themes.id': {
    en: 'ID',
    es: 'ID',
    pt: 'ID',
  },
  'checkout_themes.creationDate': {
    en: 'Creation date',
    es: 'Fecha de creación',
    pt: 'Data de criação',
  },
  'checkout_themes.status': {
    en: 'Status',
    es: 'Estado',
    pt: 'Status',
  },
  'checkout_themes.name': {
    en: 'Name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'checkout_themes.emptyTable.title': {
    en: 'You don´t have checkout themes yet',
    es: 'Aún no tienes temas de checkout',
    pt: 'Você ainda não tem temas de checkout',
  },
  'checkout_themes.emptyTable.body': {
    en: 'Create a theme to customize the checkout experience.',
    es: 'Crea un tema para personalizar la experiencia de pago.',
    pt: 'Crie um tema para personalizar a experiência de pagamento.',
  },
  'checkout_themes.phoneRequired.label': {
    en: "Require a mandatory 'Phone' field on checkout",
    es: "Solicitar un campo 'Teléfono' obligatorio en el checkout",
    pt: "Solicitar um campo 'Telefone' obrigatório no checkout",
  },
  'checkout_themes.phoneRequired.success': {
    en: 'Configuration saved',
    es: 'Configuración guardada',
    pt: 'Configuração salva',
  },
  'create_checkout_themes.success': {
    en: 'Theme created successfully!',
    es: '¡Tema creado con éxito!',
    pt: 'Tema criado com sucesso!',
  },
  'split_payments.status.ACTIVE': {
    en: 'Active',
    es: 'Activo',
    pt: 'Ativo',
  },
  'split_payments.status.CANCELLED': {
    en: 'Ended',
    es: 'Finalizado',
    pt: 'Finalizado',
  },
  'split_payments.status.REJECTED': {
    en: 'Rejected',
    es: 'Rechazado',
    pt: 'Rejeitado',
  },
  'split_payments.status.PENDING': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'split_payments.title': {
    en: 'Split Payments',
    es: 'Split Payments',
    pt: 'Split Payments',
  },
  'split_payments.subtitle': {
    en: 'Manage shared payments automatically for collaborative businesses.',
    es: 'Gestioná pagos compartidos automáticamente para negocios colaborativos.',
    pt: 'Gerencie pagamentos compartilhados automaticamente para negócios colaborativos.',
  },
  'split_payments.desc.divide_payments': {
    en: 'Automatically divide your payments with Split Payments',
    es: 'Dividí tus cobros automáticamente con Split Payments',
    pt: 'Divida seus pagamentos automaticamente com o Split Payments',
  },
  'split_payments.desc.optimize_operation': {
    en: 'Optimize your operation and generate new income opportunities with a clear and automated shared payment system.',
    es: 'Optimizá tu operación y generá nuevas oportunidades de ingreso con un sistema de pagos compartidos, claro y automatizado.',
    pt: 'Otimize sua operação e gere novas oportunidades de receita com um sistema de pagamento compartilhado claro e automatizado.',
  },
  'split_payments.invite_collaborate': {
    en: 'Invite to collaborate',
    es: 'Invitar a colaborar',
    pt: 'Convidar para colaborar',
  },
  'split_payments.cancel.headline': {
    en: 'Are you sure you want to cancel the collaboration?',
    es: '¿Estás seguro de que querés cancelar la colaboración?',
    pt: 'Você tem certeza de que deseja cancelar a colaboração?',
  },
  'split_payments.cancel.description': {
    en: 'If you confirm, the collaboration will be cancelled.',
    es: 'Si confirmás, la colaboración quedará anulada.',
    pt: 'Se você confirmar, a colaboração será cancelada.',
  },
  'split_payments.search.fantasy_name': {
    en: 'Fantasy name',
    es: 'Nombre de fantasía',
    pt: 'Nome fantasia',
  },
  'split_payments.search.code': {
    en: 'Integrate code',
    es: 'Código integrador',
    pt: 'Código integrador',
  },
  'split_payments.search.placeholder': {
    en: 'Search Collaborations',
    es: 'Buscar Colaboraciones',
    pt: 'Buscar Colaborações',
  },
  'split_payments.table.type': {
    en: 'Type',
    es: 'Tipo',
    pt: 'Tipo',
  },
  'split_payments.table.id': {
    en: 'ID',
    es: 'ID',
    pt: 'ID',
  },
  'split_payments.table.integrator_code': {
    en: 'Integrator Code',
    es: 'Código Integrador',
    pt: 'Código Integrador',
  },
  'split_payments.table.name': {
    en: 'Name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'split_payments.table.transactions': {
    en: 'Transactions',
    es: 'Transacciones',
    pt: 'Transações',
  },
  'split_payments.table.amount': {
    en: 'Amount',
    es: 'Monto',
    pt: 'Valor',
  },
  'split_payments.table.collaborator_balance': {
    en: 'Collaborator Balance',
    es: 'Saldo Colaborador',
    pt: 'Saldo Colaborador',
  },
  'split_payments.table.seller_balance': {
    en: 'Seller Balance',
    es: 'Saldo Vendedor',
    pt: 'Saldo Vendedor',
  },
  'split_payments.table.fixed_collaborator_commission': {
    en: 'Fixed Collaborator Commission',
    es: 'Comisión Colaborador Fijo',
    pt: 'Comissão Colaborador Fixo',
  },
  'split_payments.table.status': {
    en: 'Status',
    es: 'Status',
    pt: 'Status',
  },
  'split_payments.table.action.information': {
    en: 'Collaboration information',
    es: 'Información de la colaboración',
    pt: 'Informações da colaboração',
  },
  'split_payments.table.action.cancel': {
    en: 'Request collaboration cancellation',
    es: 'Solicitar finalización de la colaboración',
    pt: 'Solicitar finalização da colaboração',
  },
  'split_payments.table.action.manage': {
    en: 'Manage collaboration',
    es: 'Manejar colaboración',
    pt: 'Manejar colaboração',
  },
  'split_payments.creation.invite': {
    en: 'Invite to collaborate',
    es: 'Invitar a colaborar',
    pt: 'Convidar para colaborar',
  },
  'split_payments.creation.start_collab': {
    en: 'Start a collaboration',
    es: 'Iniciá una colaboración',
    pt: 'Iniciar uma colaboração',
  },
  'split_payments.creation.allow_collab': {
    en: 'Allows a Collaborator to automatically receive a share of the revenue from a sale made by a Seller, without handling third-party funds or operational complications.',
    es: 'Permite que un Colaborador reciba automáticamente una parte de los ingresos de una venta realizada por un Vendedor, sin manejar fondos ajenos ni complicaciones operativas.',
    pt: 'Permite que um Colaborador receba automaticamente uma parte da receita de uma venda feita por um Vendedor, sem lidar com fundos de terceiros ou complicações operacionais.',
  },
  'split_payments.creation.learn_more': {
    en: 'Learn more about',
    es: 'Conocé más sobre',
    pt: 'Saiba mais sobre',
  },
  'split_payments.creation.learn_more.link': {
    en: 'Split Payments for collaborations',
    es: 'Split Payments para colaboraciones',
    pt: 'Split Payments para colaborações',
  },
  'split_payments.creation.learn_more.href': {
    en: 'https://helpcenter.dlocalgo.com/en/articles/12059682-split-payments',
    es: 'https://helpcenter.dlocalgo.com/es/articles/12059682-split-payments',
    pt: 'https://helpcenter.dlocalgo.com/pt-BR/articles/12059682-split-payments',
  },
  'split_payments.creation.user_type': {
    en: 'Define your role in this collaboration',
    es: 'Define tu rol en esta colaboración',
    pt: 'Defina o seu papel nesta colaboração',
  },
  'split_payments.creation.user_type.seller': {
    en: 'I AM A SELLER',
    es: 'SOY VENDEDOR',
    pt: 'SOU VENDEDOR',
  },
  'split_payments.creation.user_type.collaborator': {
    en: 'I AM A COLLABORATOR',
    es: 'SOY COLABORADOR',
    pt: 'SOU COLABORADOR',
  },
  'split_payments.creation.user_type.seller.desc': {
    en: 'I OFFER the final product or service. I receive most of the revenue and take responsibility for refunds and chargebacks.',
    es: 'Ofrezco el producto o servicio final. Recibo la mayor parte del ingreso y asumo la responsabilidad por reembolsos y contracargos.',
    pt: 'Ofereço o produto ou serviço final. Recebo a maior parte da receita e assumo a responsabilidade por reembolsos e chargebacks.',
  },
  'split_payments.creation.user_type.collaborator.desc': {
    en: 'I TECHNICALLY INTEGRATE the platform and manage the collection. I receive a commission for each sale and am not responsible for refunds or chargebacks.',
    es: 'Integro técnicamente la plataforma y gestiono el cobro. Recibo una comisión por cada venta y no me responsabilizo por reembolsos ni contracargos.',
    pt: 'Integro tecnicamente a plataforma e gerencio a cobrança. Recebo uma comissão por cada venda e não sou responsável por reembolsos ou chargebacks.',
  },
  'split_payments.creation.menu.introduction': {
    en: 'Introduction',
    es: 'Introducción',
    pt: 'Introdução',
  },
  'split_payments.creation.menu.seller_collab': {
    en: 'Seller / Collaborator',
    es: 'Vendedor / Colaborador',
    pt: 'Vendedor / Colaborador',
  },
  'split_payments.creation.menu.collaboration_info': {
    en: 'Collaboration information',
    es: 'Información de la colaboración',
    pt: 'Informações da colaboração',
  },
  'split_payments.creation.menu.terms_and_conditions': {
    en: 'Terms and conditions',
    es: 'Términos y condiciones',
    pt: 'Termos e condições',
  },
  'split_payments.creation.menu.terms_and_conditions_approve': {
    en: 'Terms and conditions approval',
    es: 'Aprobación de términos y condiciones',
    pt: 'Aprovação de termos e condições',
  },
  'split_payments.creation.menu.agreement': {
    en: 'Agreement summary',
    es: 'Resumen del acuerdo',
    pt: 'Resumo do acordo',
  },
  'split_payments.terms_and_conditions.body': {
    en: `<h3>Terms and Conditions of Use of Split Payments</h3>
<p>These terms and conditions constitute an agreement between the Seller and the Collaborator regarding the use of the Split Payments functionality, available on the dLocal Go platform. By accepting these terms, both parties agree to the conditions detailed below.</p>

<h4>1. Purpose</h4>
<p>Split Payments allows the automatic division of the amount of a transaction between two active accounts on the platform, under a collaboration relationship previously accepted by both parties.</p>

<h4>2. Definitions</h4>
<p><strong>Collaborator:</strong> A user who technically integrates and manages the transaction, receiving a previously agreed commission. They are not responsible for refunds or chargebacks.</p>
<p><strong>Seller:</strong> A user who offers the final product or service, receiving the main portion of the transaction. They are responsible for the operation, including refunds and chargebacks.</p>
<p><strong>Collaboration:</strong> The relationship between a Seller and a Collaborator that enables the use of Split Payments.</p>

<h4>3. Conditions of Use</h4>
<ul>
  <li>Both parties must have an approved and active account on the platform.</li>
  <li>The Collaboration must be mutually accepted, including the commission percentage to be applied.</li>
  <li>The division of funds will be performed automatically in each transaction, according to the defined and recorded percentage.</li>
  <li>Technical integration must be done via API using the unique association code generated when configuring the Collaboration.</li>
</ul>

<h4>4. Responsibilities</h4>
<p>The Seller is solely responsible for executing the sale, as well as for any refund, chargeback, or dispute related to the transaction.</p>
<p>The Collaborator receives their commission automatically at the time of the transaction, without access to or direct management of the total amount collected.</p>

<h4>5. Duration and Termination</h4>
<ul>
  <li>Collaborations can be revoked at any time by either party, without the need for justification.</li>
  <li>Revoking a Collaboration does not affect transactions already processed and does not imply retroactive modification of the applied Split.</li>
  <li>Changes to the commission percentage require the creation of a new Collaboration and cancellation of the current one.</li>
</ul>

<h4>6. Information and Reports</h4>
<p>The Seller may access the details of their transactions through the platform’s standard reports.</p>
<p>The Collaborator will have access to basic statistics from the Split Payments section or via the available API.</p>

<h4>7. Acceptance</h4>
<p>The use of Split Payments implies full acceptance of these terms and conditions by both parties. By activating a Collaboration, both the Seller and the Collaborator acknowledge that they have read and understood these terms and conditions.</p>
`,
    es: `<h3>Términos y Condiciones - Split Payments</h3>
<p>Estos términos y condiciones constituyen un acuerdo entre el Vendedor y el Colaborador respecto al uso de la funcionalidad Split Payments, disponible en la plataforma dLocal Go. Al aceptar estos términos, ambas partes manifiestan su conformidad con las condiciones que se detallan a continuación.</p>

<h4>1. Objetivo</h4>
<p>Split Payments permite dividir de forma automática el monto de una transacción entre dos cuentas activas dentro de la plataforma, bajo una relación de colaboración previamente aceptada por ambas partes.</p>

<h4>2. Definiciones</h4>
<p><strong>Colaborador:</strong> Usuario que integra técnicamente y gestiona el cobro de una transacción, recibiendo una comisión previamente acordada. No tiene responsabilidad sobre reembolsos ni contracargos.</p>
<p><strong>Vendedor:</strong> Usuario que ofrece el producto o servicio final, recibiendo el porcentaje principal de la transacción. Es responsable de la operación, incluyendo reembolsos y contracargos.</p>
<p><strong>Colaboración:</strong> Relación entre un Vendedor y un Colaborador que permite el uso de Split Payments.</p>

<h4>3. Condiciones de uso</h4>
<ul>
  <li>Ambas partes deben contar con una cuenta aprobada y activa en la plataforma.</li>
  <li>La Colaboración debe ser aceptada mutuamente, incluyendo el porcentaje de comisión a aplicar.</li>
  <li>La división de fondos se realizará automáticamente en cada transacción, según el porcentaje definido y registrado.</li>
  <li>La integración técnica debe realizarse vía API utilizando el código único de asociación generado al configurar la Colaboración.</li>
</ul>

<h4>4. Responsabilidades</h4>
<p>El Vendedor es el único responsable por la ejecución de la venta, así como por cualquier solicitud de reembolso, contracargo o disputa vinculada a la transacción.</p>
<p>El Colaborador recibe su comisión automáticamente al momento de la transacción, sin acceso ni gestión directa sobre el total del monto cobrado.</p>

<h4>5. Vigencia y finalización</h4>
<ul>
  <li>Las Colaboraciones pueden ser revocadas en cualquier momento por cualquiera de las partes, sin necesidad de justificación.</li>
  <li>La revocación de una Colaboración no afecta las transacciones ya procesadas ni implica modificación retroactiva del Split aplicado.</li>
  <li>Modificaciones en el porcentaje de comisión requieren la creación de una nueva Colaboración y cancelación de la actual.</li>
</ul>

<h4>6. Información y reportes</h4>
<p>El Vendedor podrá acceder al detalle de sus transacciones a través de los reportes habituales de la plataforma.</p>
<p>El Colaborador tendrá acceso a estadísticas básicas desde la sección de Split Payments o a través de la API disponible.</p>

<h4>7. Aceptación</h4>
<p>El uso de Split Payments implica la aceptación plena de estos términos y condiciones por parte de ambas partes. Al activar una Colaboración, tanto el Vendedor como el Colaborador reconocen haber leído y comprendido estos términos y condiciones.</p>
`,
    pt: `<h3>Termos e Condições de Uso do Split Payments</h3>
<p>Estes termos e condições constituem um acordo entre o Vendedor e o Colaborador sobre o uso da funcionalidade Split Payments, disponível na plataforma dLocal Go. Ao aceitar estes termos, ambas as partes declaram sua concordância com as condições detalhadas a seguir.</p>

<h4>1. Objetivo</h4>
<p>O Split Payments permite dividir automaticamente o valor de uma transação entre duas contas ativas na plataforma, com base em uma relação de colaboração previamente aceita por ambas as partes.</p>

<h4>2. Definições</h4>
<p><strong>Colaborador:</strong> Usuário que realiza a integração técnica e gerencia a cobrança de uma transação, recebendo uma comissão previamente acordada. Não é responsável por reembolsos ou contestações.</p>
<p><strong>Vendedor:</strong> Usuário que oferece o produto ou serviço final, recebendo a maior parte do valor da transação. É responsável pela operação, incluindo reembolsos e contestações.</p>
<p><strong>Colaboração:</strong> Relação entre um Vendedor e um Colaborador que permite o uso do Split Payments.</p>

<h4>3. Condições de Uso</h4>
<ul>
  <li>Ambas as partes devem ter uma conta aprovada e ativa na plataforma.</li>
  <li>A Colaboração deve ser aceita mutuamente, incluindo o percentual de comissão a ser aplicado.</li>
  <li>A divisão dos valores será feita automaticamente em cada transação, conforme o percentual definido e registrado.</li>
  <li>A integração técnica deve ser feita via API utilizando o código único de associação gerado na configuração da Colaboração.</li>
</ul>

<h4>4. Responsabilidades</h4>
<p>O Vendedor é o único responsável pela execução da venda, bem como por qualquer solicitação de reembolso, contestação ou disputa relacionada à transação.</p>
<p>O Colaborador recebe sua comissão automaticamente no momento da transação, sem acesso ou gestão direta sobre o valor total cobrado.</p>

<h4>5. Vigência e Rescisão</h4>
<ul>
  <li>As Colaborações podem ser revogadas a qualquer momento por qualquer uma das partes, sem necessidade de justificativa.</li>
  <li>A revogação de uma Colaboração não afeta as transações já processadas nem implica modificação retroativa do Split aplicado.</li>
  <li>Modificações no percentual de comissão requerem a criação de uma nova Colaboração e o cancelamento da atual.</li>
</ul>

<h4>6. Informações e Relatórios</h4>
<p>O Vendedor poderá acessar os detalhes de suas transações através dos relatórios padrão da plataforma.</p>
<p>O Colaborador terá acesso a estatísticas básicas na seção Split Payments ou via API disponível.</p>

<h4>7. Aceitação</h4>
<p>O uso do Split Payments implica na aceitação total destes termos e condições por ambas as partes. Ao ativar uma Colaboração, tanto o Vendedor quanto o Colaborador reconhecem que leram e compreenderam estes termos e condições.</p>
`,
  },
  'split_payments.creation.required.name': {
    en: 'Name is required',
    es: 'El nombre es requerido',
    pt: 'O nome é obrigatório',
  },
  'split_payments.creation.valid.email': {
    en: 'Email must be valid',
    es: 'El email debe ser válido',
    pt: 'O email deve ser válido',
  },
  'split_payments.creation.required.category': {
    en: 'You must select a collaboration category',
    es: 'Debes seleccionar una categoría de colaboración',
    pt: 'Você deve selecionar uma categoria de colaboração',
  },
  'split_payments.creation.valid.commission': {
    en: 'Commission percentage must be a number between 0.01 and 100',
    es: 'El porcentaje de comisión debe ser un número entre 0.01 y 100',
    pt: 'O percentual de comissão deve ser um número entre 0,01 e 100',
  },
  'split_payments.creation.accepted.terms': {
    en: 'You must accept the terms and conditions',
    es: 'Debes aceptar los términos y condiciones',
    pt: 'Você deve aceitar os termos e condições',
  },
  'split_payments.creation.name': {
    en: 'Name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'split_payments.creation.collaboratorEmail': {
    en: 'Collaborator email',
    es: 'Email del colaborador/a',
    pt: 'Email do colaborador',
  },
  'split_payments.creation.sellerEmail': {
    en: 'Seller email',
    es: 'Email del vendedor/a',
    pt: 'Email do vendedor',
  },
  'split_payments.creation.email.desc': {
    en: 'To be a collaborator, the person must complete the full registration on dlocalgo',
    es: 'Para ser colaborador es necesario que la persona haga el registro completo en dlocalgo',
    pt: 'Para ser colaborador, a pessoa deve completar o registro completo no dlocalgo',
  },
  'split_payments.creation.category.partner': {
    en: 'Partner',
    es: 'Socio',
    pt: 'Parceiro',
  },
  'split_payments.creation.category.agency': {
    en: 'Agency',
    es: 'Agencia',
    pt: 'Agência',
  },
  'split_payments.creation.category.independent_developer': {
    en: 'Independent Developer',
    es: 'Desarrollador independiente',
    pt: 'Desenvolvedor independente',
  },
  'split_payments.creation.category.marketplace': {
    en: 'Marketplace',
    es: 'Marketplace',
    pt: 'Marketplace',
  },
  'split_payments.creation.commission': {
    en: 'What commission percentage will the collaborator receive?',
    es: '¿Qué porcentaje de comisión recibirá el colaborador?',
    pt: 'Qual porcentagem de comissão o colaborador receberá?',
  },
  'split_payments.creation.commission.placeholder': {
    en: 'E.g. 10%',
    es: 'Ej. 10 %',
    pt: 'Ex.: 10%',
  },
  'split_payments.creation.commission.tooltip': {
    en: 'This is the percentage of each payment that the collaborator will receive.',
    es: 'Es el porcentaje de cada pago que recibirá el colaborador.',
    pt: 'É a porcentagem de cada pagamento que o colaborador receberá.',
  },
  'split_payments.creation.collab_terms_conditions': {
    en: 'Terms and conditions of collaboration',
    es: 'Términos y condiciones de colaboración',
    pt: 'Termos e condições de colaboração',
  },
  'split_payments.creation.terms_conditions': {
    en: 'Split Payments Terms and Conditions',
    es: 'Términos de Split Payment',
    pt: 'Termos do Split Payment',
  },
  'split_payments.creation.read_terms': {
    en: 'I have read and accept the Split Payments terms and conditions',
    es: 'Leí y acepto los términos y condiciones de Split Payment',
    pt: 'Li e aceito os termos e condições do Split Payment',
  },
  'split_payments.creation.resume.required.infoAgree': {
    en: 'You must accept the information.',
    es: 'Debe aceptar la información.',
    pt: 'Você deve aceitar as informações.',
  },
  'split_payments.creation.resume.required.collabAgree': {
    en: 'You must accept the collaboration terms.',
    es: 'Debe aceptar los términos de colaboración.',
    pt: 'Você deve aceitar os termos de colaboração.',
  },
  'split_payments.creation.resume.title': {
    en: 'Split Payment/Collaboration Agreement Summary',
    es: 'Resumen del acuerdo de Split Payment/Colaboración',
    pt: 'Resumo do Acordo de Split Payment/Colaboração',
  },
  'split_payments.creation.resume.review_info': {
    en: 'Review the information before sending the Split Payment invitation',
    es: 'Revisa la información antes de enviar la invitación de Split Payment',
    pt: 'Revise as informações antes de enviar o convite de Split Payment',
  },
  'split_payments.creation.resume.start_date_desc': {
    en: 'The start date of the agreement will be counted from the moment it is accepted.',
    es: 'La fecha de inicio del acuerdo se contará a partir del momento en que sea aceptado.',
    pt: 'A data de início do acordo será contada a partir do momento em que for aceito.',
  },
  'split_payments.creation.resume.name': {
    en: 'Name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'split_payments.creation.resume.email': {
    en: 'Email',
    es: 'Email',
    pt: 'Email',
  },
  'split_payments.creation.resume.category': {
    en: 'Collaborator category',
    es: 'Categoría del colaborador/a',
    pt: 'Categoria do colaborador',
  },
  'split_payments.creation.resume.receive_commissions': {
    en: 'Receive commissions from sales',
    es: 'Recibir comisiones de las ventas',
    pt: 'Receber comissões das vendas',
  },
  'split_payments.creation.resume.commission_percentage': {
    en: 'Commission percentage (%)',
    es: 'Porcentaje de las comisiones (%)',
    pt: 'Porcentagem das comissões (%)',
  },
  'split_payments.creation.resume.agreeInfo': {
    en: 'I have read and agree with the information.',
    es: 'Leí y estoy de acuerdo con la información.',
    pt: 'Li e concordo com as informações.',
  },
  'split_payments.creation.resume.seller_agree': {
    en: 'I understand that the Seller will be responsible for managing refunds and chargebacks, while the Collaborator will handle the integration.',
    es: 'Entiendo que el vendedor será responsable de gestionar reembolsos y contracargos, mientras que el colaborador se encargará de la integración.',
    pt: 'Entendo que o Vendedor será responsável por gerenciar reembolsos e contestações, enquanto o Colaborador lidará com a integração.',
  },
  'split_payments.creation.resume.send_invitation': {
    en: 'Send Split Payment invitation',
    es: 'Enviar invitación de split payment',
    pt: 'Enviar convite de split payment',
  },
  'split_payments.filter.status': {
    en: 'Transaction status',
    es: 'Estado de la transacción',
    pt: 'Estado da transação',
  },
  'split_payments.filter.status.titleOptions': {
    en: 'Filter by status',
    es: 'Filtrar por estado',
    pt: 'Filtrar por status',
  },
  'exportSplits.title': {
    en: 'Download report',
    es: 'Descargar reporte',
    pt: 'Baixar relatório',
  },
  'exportSplits.open': {
    en: 'Export',
    es: 'Exportar',
    pt: 'Exportar',
  },
  'exportSplits.exportBtn': {
    en: 'Download',
    es: 'Descargar',
    pt: 'Baixar',
  },
  'exportSplits.range': {
    en: 'Select date range',
    es: 'Seleccione el rango de fechas',
    pt: 'Selecione o intervalo de datas',
  },
  'exportSplits.successMessage': {
    en: 'If the file download does not start, check that your browser has not blocked it.',
    es: 'Si la descarga del archivo no se inicia, verifique que su navegador no lo haya bloqueado.',
    pt: 'Se o download do arquivo não iniciar, verifique se seu navegador não o bloqueou.',
  },
  'exportSplits.downloadAgain': {
    en: 'You can try to download it again by clicking ',
    es: 'Puedes intentar descargarlo nuevamente haciendo clic ',
    pt: 'Você pode tentar baixá-lo novamente clicando ',
  },
  'exportSplits.downloadAgain.here': {
    en: 'here.',
    es: 'aquí.',
    pt: 'aqui.',
  },
  'exportSplits.invalidDates': {
    en: 'The selected dates are invalid.',
    es: 'Las fechas seleccionadas son inválidas.',
    pt: 'As datas selecionadas são inválidas.',
  },
  'exportSplits.rangeError': {
    en: 'The date range cannot be greater than 31 days.',
    es: 'El rango de fechas no puede ser mayor a 31 días.',
    pt: 'O intervalo de datas não pode ser superior a 31 dias.',
  },
  'exportSplits.empty': {
    en: 'No data to download found.',
    es: 'No se encontraron datos para descargar.',
    pt: 'Nenhum dado para download encontrado.',
  },
  'exportSplits.otherFilters': {
    en: 'Optional filters',
    es: 'Filtros opcionales',
    pt: 'Filtros opcionais',
  },
  'splitDrawer.title': {
    en: 'Agreement summary',
    es: 'Resumen del acuerdo',
    pt: 'Resumo do acordo',
  },
  'splitDrawer.subtitle': {
    en: 'Collaboration information',
    es: 'Información de la colaboración',
    pt: 'Informações da colaboração',
  },
  'splitDrawer.table.collaborator': {
    en: 'Collaborator',
    es: 'Colaborador(a)',
    pt: 'Colaborador(a)',
  },
  'splitDrawer.table.seller': {
    en: 'Seller',
    es: 'Vendedor(a)',
    pt: 'Vendedor(a)',
  },
  'splitDrawer.table.type': {
    en: 'Collaboration type',
    es: 'Tipo de colaboración',
    pt: 'Tipo de colaboração',
  },
  'splitDrawer.table.commission': {
    en: 'Commission for direct sales',
    es: 'Comisión para ventas directas',
    pt: 'Comissão para vendas diretas',
  },
  'splitDrawer.table.termsOfUse': {
    en: 'Terms of use of collaboration',
    es: 'Términos de uso de la colaboración',
    pt: 'Termos de uso da colaboração',
  },
  'marketing.pixel.title': {
    en: 'Meta Pixel',
    es: 'Píxel de Meta',
    pt: 'Pixel do Meta',
  },
  'marketing.pixel.subtitle': {
    en: 'If you have already created a Facebook pixel, add it to the store to measure the effectiveness of your marketing campaigns.',
    es: 'Si ya creaste un píxel de Facebook, sumalo a la tienda para medir la efectividad de tus campañas de marketing.',
    pt: 'Se você já criou um pixel do Facebook, adicione-o à loja para medir a eficácia de suas campanhas de marketing.',
  },
  'marketing.pixel.input.title': {
    en: 'Paste here your ID',
    es: 'Pega aquí tu ID',
    pt: 'Cole seu ID aqui',
  },
  'marketing.pixel.input.placeholder': {
    en: 'You can find your dataset ID in your Facebook account settings.',
    es: 'Encontrarás tu ID del conjunto de datos en la configuración de tu cuenta de Facebook.',
    pt: 'Você pode encontrar seu ID do conjunto de dados nas configurações da sua conta do Facebook.',
  },
  'marketing.pixelToken.input.title': {
    en: 'Paste here your pixel Access Token (Optional)',
    es: 'Pega aquí tu access token (Opcional)',
    pt: 'Cole seu access token aqui (Opcional)',
  },
  'marketing.pixelToken.input.placeholder': {
    en: 'You can find your pixel Access Token in your Facebook account settings.',
    es: 'Encontrarás tu access token en la configuración de tu cuenta de Facebook.',
    pt: 'Você pode encontrar seu access token nas configurações da sua conta do Facebook.',
  },
  'marketing.pixel.configHelp.title': {
    en: 'How to set up the Facebook Pixel?',
    es: '¿Cómo configurar el Pixel de Facebook?',
    pt: 'Como configurar o Pixel do Facebook?',
  },
  'marketing.pixel.configHelp.link': {
    en: 'https://www.facebook.com/business/help/952192354843755',
    es: 'https://www.facebook.com/business/help/952192354843755',
    pt: 'https://www.facebook.com/business/help/952192354843755',
  },
  'marketing.analytics.title': {
    en: 'Google Analytics 4',
    es: 'Google Analytics 4',
    pt: 'Google Analytics 4',
  },
  'marketing.analytics.subtitle': {
    en: 'If you already have a Google Analytics 4 account, add the code to measure conversions and evaluate the performance of your campaigns. You can easily link these conversions to Google Ads.',
    es: 'Si ya contás con una cuenta en Google Analytics 4, incorporá el código para medir conversiones y evaluar el rendimiento de tus campañas. Podés vincular estas conversiones con Google Ads fácilmente.',
    pt: 'Se você já tem uma conta no Google Analytics 4, incorpore o código para medir conversões e avaliar o desempenho de suas campanhas. Você pode vincular essas conversões ao Google Ads facilmente.',
  },
  'marketing.analytics.input.title': {
    en: 'Measurement ID',
    es: 'ID de medición',
    pt: 'ID de medição',
  },
  'marketing.analytics.input.placeholder': {
    en: 'EX:   G-Y4JC6GH7G5',
    es: 'EJ:   G-Y4JC6GH7G5',
    pt: 'EJ:   G-Y4JC6GH7G5',
  },
  'marketing.analytics.configHelp.title': {
    en: 'How to link Google Analytics?',
    es: '¿Cómo vincular Google Analytics?',
    pt: 'Como vincular o Google Analytics?',
  },
  'marketing.analytics.configHelp.link': {
    en: 'https://support.google.com/analytics/answer/10089681?hl=en',
    es: 'https://support.google.com/analytics/answer/10089681?hl=es',
    pt: 'https://support.google.com/analytics/answer/10089681?hl=pt-BR',
  },
  'marketing.success.headline': {
    en: 'Changes saved successfully',
    es: 'Cambios guardados con éxito',
    pt: 'Alterações salvas com sucesso',
  },
  'marketing.success.button': {
    en: 'Continue',
    es: 'Continuar',
    pt: 'Continuar',
  },
  'menu.item.USER_MANAGEMENT': {
    en: 'User Management',
    es: 'Gestión de usuarios',
    pt: 'Gestão de usuários',
  },
  'menu.item.USER_MANAGEMENT.desc': {
    en: 'Manage account users, assign predefined roles and control access permissions.',
    es: 'Gestiona los usuarios de la cuenta, asigna roles predefinidos y controla los permisos de acceso.',
    pt: 'Gerencie os usuários da conta, atribua funções predefinidas e controle as permissões de acesso.',
  },
  'menu.item.SIDEBAR_COBRAR': {
    en: 'Collect',
    es: 'Cobrar',
    pt: 'Cobrar',
  },
  'menu.item.SIDEBAR_PAGAR': {
    en: 'Pay',
    es: 'Pagar',
    pt: 'Pagar',
  },
  'menu.item.SIDEBAR_MOVIMIENTOS': {
    en: 'Activity',
    es: 'Movimientos',
    pt: 'Movimentos',
  },
  'movements.subheadline': {
    en: 'Access the details of all your movements and manage them in one place.',
    es: 'Accede al detalle de todos tus movimientos y gestiónalos en un solo lugar.',
    pt: 'Acesse os detalhes de todos os seus movimentos e gerencie-os em um só lugar.',
  },
  'charges.subheadline': {
    en: 'Collect however and wherever you want, with solutions designed to grow without limits.',
    es: 'Cobra como quieras, donde quieras, con soluciones pensadas para crecer sin límites.',
    pt: 'Cobre como quiser, onde quiser, com soluções pensadas para crescer sem limites.',
  },
  'charges.paymentLink.tooltip': {
    en: 'Create and share payment links to collect in local currency.',
    es: 'Crea y comparte enlaces de pago para cobrar en moneda local.',
    pt: 'Crie e compartilhe links de pagamento para cobrar em moeda local.',
  },
  'charges.subscriptions.tooltip': {
    en: 'It repeats automatically until the plan is cancelled. No end date.',
    es: 'Se repite automáticamente hasta cancelar el plan. Sin fecha de fin.',
    pt: 'Repete-se automaticamente até o cancelamento do plano. Sem data de término.',
  },
  'charges.paymentButton.tooltip': {
    en: 'It integrates into your website, with no need for complex development.',
    es: 'Se integra en tu sitio web, sin necesidad de desarrollos complejos.',
    pt: 'Integra-se ao seu site, sem necessidade de desenvolvimentos complexos.',
  },
  'charges.oneTimePaymentLink.tooltip': {
    en: '<strong>Ideal for a specific sale:</strong> the link is no longer available after payment.',
    es: '<strong>Ideal para una venta específica:</strong> el link deja de estar disponible después del pago.',
    pt: '<strong>Ideal para uma venda específica:</strong> o link deixa de estar disponível após o pagamento.',
  },
  'charges.oneTimePaymentLink.desc': {
    en: 'Generate a single-use link to collect a fixed amount',
    es: 'Genera un link de un único uso para cobrar un monto fijo',
    pt: 'Gere um link de uso único para cobrar um valor fixo',
  },
  'charges.recurringPaymentLink.desc': {
    en: 'One link, multiple charges',
    es: 'Un link, múltiples cobros',
    pt: 'Um link, múltiplas cobranças',
  },
  'charges.openPaymentLink.desc': {
    en: 'The customer enters the amount they want to pay when opening the link',
    es: 'El cliente ingresa el monto que quiere pagar al abrir el link',
    pt: 'O cliente insere o valor que deseja pagar ao abrir o link',
  },
  'charges.qrPayment.desc': {
    en: 'Receive payments instantly by scanning a QR code',
    es: 'Recibe pagos al instante escaneando un código QR',
    pt: 'Receba pagamentos na hora escaneando um código QR',
  },
  'charges.subscriptions.desc': {
    en: 'Automatic and recurring charges, at the chosen frequency',
    es: 'Cobros automáticos y recurrentes, a la frecuencia elegida',
    pt: 'Cobranças automáticas e recorrentes, na frequência escolhida',
  },
  'charges.smartPayment.desc': {
    en: "Split the payment into months, without depending on the customer's card",
    es: 'Divide el pago en meses, sin depender de la tarjeta del cliente',
    pt: 'Divida o pagamento em meses, sem depender do cartão do cliente',
  },
  'charges.paymentButton.desc': {
    en: 'Add a payment button to your website and collect without leaving the page',
    es: 'Suma un botón de pago al sitio web y cobra sin salir de la página',
    pt: 'Adicione um botão de pagamento ao site e cobre sem sair da página',
  },
  'charges.recurringPaymentLink.tooltip': {
    en: '<strong>It never expires and has no usage limit:</strong> reuse it with one or many customers, as many times as needed.',
    es: '<strong>No vence ni tiene límite de usos:</strong> se reutiliza con uno o varios clientes, las veces que sea necesario.',
    pt: '<strong>Não expira nem tem limite de usos:</strong> reutilize-o com um ou vários clientes, quantas vezes for necessário.',
  },
  'charges.openPaymentLink.tooltip': {
    en: "Useful when you don't know the amount in advance. You can reuse it and set a different amount each time.",
    es: 'Útil cuando no conoces el monto de antemano. Puedes reutilizarlo y definir un monto diferente en cada ocasión.',
    pt: 'Útil quando você não sabe o valor de antemão. Você pode reutilizá-lo e definir um valor diferente a cada vez.',
  },
  'charges.qrPayment.tooltip': {
    en: '<strong>Ideal for in-person sales:</strong> download it, print it or share it.',
    es: '<strong>Ideal para ventas presenciales:</strong> descárgalo, imprímelo o compártelo.',
    pt: '<strong>Ideal para vendas presenciais:</strong> baixe, imprima ou compartilhe.',
  },
  'charges.smartPayment.tooltip': {
    en: 'Automatic charges in equal parts, with no card limit involved.',
    es: 'Cobros automáticos en partes iguales, sin límite de tarjeta de por medio.',
    pt: 'Cobranças automáticas em partes iguais, sem limite de cartão envolvido.',
  },
  'charges.ecommerce': {
    en: 'eCommerce',
    es: 'eCommerce',
    pt: 'eCommerce',
  },
  'charges.ecommerce.tooltip': {
    en: 'Integrate dLocal Go with your online store and accept local payment methods.',
    es: 'Integra dLocal Go con tu tienda online y acepta métodos de pago locales.',
    pt: 'Integre o dLocal Go à sua loja online e aceite métodos de pagamento locais.',
  },
  'menu.item.SIDEBAR_CONEXIONES': {
    en: 'Connections',
    es: 'Conexiones',
    pt: 'Conexões',
  },
  'menu.item.SIDEBAR_RENTABILIDAD': {
    en: 'Profitability',
    es: 'Rentabilidad',
    pt: 'Rentabilidade',
  },
  'menu.item.SIDEBAR_MARKETING': {
    en: 'Marketing',
    es: 'Marketing',
    pt: 'Marketing',
  },
  'menu.item.SIDEBAR_CONFIGURATION': {
    en: 'Settings',
    es: 'Configuración',
    pt: 'Configurações',
  },
  'menu.item.SIDEBAR_PROFILE': {
    en: 'Profile',
    es: 'Perfil',
    pt: 'Perfil',
  },
  'menu.subItem.PAYMENT_INTEGRATION': {
    en: 'eCommerce',
    es: 'eCommerce',
    pt: 'eCommerce',
  },
  'menu.subItem.PAYMENT_INTEGRATION_API': {
    en: 'API',
    es: 'API',
    pt: 'API',
  },
  'menu.subItem.PAYMENT_METHODS': {
    en: 'Payment methods',
    es: 'Métodos de pago',
    pt: 'Métodos de pagamento',
  },
  'menu.subItem.RENTABILITY_COVERAGE': {
    en: 'Coverage',
    es: 'Cobertura',
    pt: 'Cobertura',
  },
  'menu.subItem.RENTABILITY_CALCULATOR': {
    en: 'Calculator',
    es: 'Calculadora',
    pt: 'Calculadora',
  },
  'menu.subItem.RENTABILITY_ACCREDITATION_TIMES': {
    en: 'Accreditation times',
    es: 'Tiempos de acreditación',
    pt: 'Tempos de acreditação',
  },
  'menu.subItem.RENTABILITY_INSTALLMENTS': {
    en: 'Installments',
    es: 'Cuotas',
    pt: 'Cuotas',
  },
  'menu.subItem.RENTABILITY_PAYOUTS': {
    en: 'Payouts',
    es: 'Payouts',
    pt: 'Payouts',
  },
  'menu.subItem.RENTABILITY_THREE_D_SECURE': {
    en: '3D Secure',
    es: '3D Secure',
    pt: '3D Secure',
  },
  'rentability.subheadline': {
    en: 'Know your costs, timelines and coverage before you charge, and make decisions that protect your margin.',
    es: 'Conoce tus costos, plazos y cobertura antes de cobrar, y toma decisiones que cuiden tu margen.',
    pt: 'Conheça seus custos, prazos e cobertura antes de cobrar e tome decisões que cuidem da sua margem.',
  },
  'rentability.paymentMethods.desc': {
    en: 'See which payment methods your customers can use in each country.',
    es: 'Descubre con qué medios te pueden pagar tus clientes en cada país.',
    pt: 'Descubra com quais meios seus clientes podem pagar em cada país.',
  },
  'rentability.paymentMethods.tooltip': {
    en: 'Which methods each country accepts and their fee. To see where you can sell, go to Coverage.',
    es: 'Qué medios acepta cada país y su tarifa. Para ver dónde vender, ve a Cobertura.',
    pt: 'Quais meios cada país aceita e a tarifa. Para ver onde vender, vá em Cobertura.',
  },
  'rentability.payouts.desc': {
    en: 'See the costs and countries for sending money to third parties.',
    es: 'Conoce los costos y países para enviar dinero a terceros.',
    pt: 'Conheça os custos e países para enviar dinheiro a terceiros.',
  },
  'rentability.payouts.tooltip': {
    en: 'To estimate the cost of paying third parties. The transfer is created in Pay.',
    es: 'Para estimar el costo de pagar a terceros. El envío se crea en Pagar.',
    pt: 'Para estimar o custo de pagar terceiros. O envio é criado em Pagar.',
  },
  'rentability.coverage.desc': {
    en: 'Calculate how much you will receive after fees and conversion.',
    es: 'Calcula cuánto recibirás después de comisiones y conversión.',
    pt: 'Calcule quanto você receberá depois de comissões e conversão.',
  },
  'rentability.coverage.tooltip': {
    en: 'To check whether you can reach a country before expanding.',
    es: 'Para validar si llegas a un país antes de expandirte.',
    pt: 'Para validar se você chega a um país antes de expandir.',
  },
  'rentability.calculator.desc': {
    en: "Respond to your customers' disputes and protect your revenue.",
    es: 'Responde las disputas de tus clientes y protege tus ingresos.',
    pt: 'Responda às disputas dos seus clientes e proteja sua receita.',
  },
  'rentability.calculator.tooltip': {
    en: 'Before setting a price or quoting: see the net amount instantly.',
    es: 'Antes de fijar un precio o cotizar: ves el neto al instante.',
    pt: 'Antes de definir um preço ou cotar: veja o líquido na hora.',
  },
  'rentability.accreditation.desc': {
    en: 'See when the money from each sale will be available.',
    es: 'Mira cuándo estará disponible el dinero de cada venta.',
    pt: 'Veja quando o dinheiro de cada venda estará disponível.',
  },
  'rentability.accreditation.tooltip': {
    en: 'To plan your cash flow: cards take longer than transfers or cash.',
    es: 'Para planificar tu caja: las tarjetas tardan más que transferencias o efectivo.',
    pt: 'Para planejar seu caixa: os cartões demoram mais que transferências ou dinheiro.',
  },
  'rentability.installments.desc': {
    en: 'Review where to offer installments, their cost and who pays it.',
    es: 'Revisa dónde ofrecer cuotas, su costo y quién lo asume.',
    pt: 'Revise onde oferecer parcelas, o custo e quem assume.',
  },
  'rentability.installments.tooltip': {
    en: 'To decide whether you absorb the installment cost or the customer pays it.',
    es: 'Para decidir si absorbes el costo de las cuotas o lo paga el cliente.',
    pt: 'Para decidir se você absorve o custo das parcelas ou se o cliente paga.',
  },
  'rentability.threeDSecure.desc': {
    en: 'Turn two-step verification on or off by region.',
    es: 'Activa o desactiva la verificación en dos pasos por región.',
    pt: 'Ative ou desative a verificação em duas etapas por região.',
  },
  'rentability.threeDSecure.tooltip': {
    en: 'Less fraud and chargebacks, with an extra step and a fixed cost per region.',
    es: 'Menos fraude y contracargos, con un paso extra y un costo fijo por región.',
    pt: 'Menos fraude e chargebacks, com uma etapa extra e um custo fixo por região.',
  },
  'menu.subItem.MARKETING_CAMPAIGNS': {
    en: 'Campaigns',
    es: 'Campañas',
    pt: 'Campanhas',
  },
  'menu.subItem.CHECKOUT_THEMES': {
    en: 'Checkout themes',
    es: 'Temas de checkout',
    pt: 'Temas de checkout',
  },
  'menu.subItem.CLIENTS': {
    en: 'Clients',
    es: 'Clientes',
    pt: 'Clientes',
  },
  'menu.subItem.BANK_ACCOUNTS': {
    en: 'My bank accounts',
    es: 'Mis cuentas bancarias',
    pt: 'Minhas contas bancárias',
  },
  'menu.subItem.COMPANY_INFORMATION': {
    en: 'Company information',
    es: 'Datos de la empresa',
    pt: 'Dados da empresa',
  },
  'menu.subItem.USER_MANAGEMENT': {
    en: 'User management',
    es: 'Gestión de usuarios',
    pt: 'Gestão de usuários',
  },
  'menu.subItem.PROFILE_SECURITY': {
    en: 'Security',
    es: 'Seguridad',
    pt: 'Segurança',
  },
  'menu.subItem.PROFILE_PERSONAL_INFO': {
    en: 'Personal information',
    es: 'Información personal',
    pt: 'Informações pessoais',
  },
  'menu.subItem.TRANSACTIONS': {
    en: 'Transactions',
    es: 'Transacciones',
    pt: 'Transações',
  },
  'menu.subItem.REFUNDS': {
    en: 'Refunds',
    es: 'Reembolsos',
    pt: 'Reembolsos',
  },
  'menu.subItem.CHARGEBACKS': {
    en: 'Chargebacks',
    es: 'Contracargos',
    pt: 'Chargebacks',
  },
  'menu.subItem.SETTLEMENTS': {
    en: 'Withdraw funds',
    es: 'Retirar fondos',
    pt: 'Retirar fundos',
  },
  'menu.subItem.REPORTS': {
    en: 'Reports',
    es: 'Reportes',
    pt: 'Relatórios',
  },
  'menu.subItem.PAYOUTS': {
    en: 'Payouts',
    es: 'Pagos',
    pt: 'Pagamentos',
  },
  'menu.subItem.PAYOUT_CONTACTS': {
    en: 'Contacts',
    es: 'Contactos',
    pt: 'Contatos',
  },
  'menu.subItem.SPLIT_PAYMENTS': {
    en: 'Split Payments',
    es: 'Split Payments',
    pt: 'Split Payments',
  },
  'menu.subItem.ONE_TIME_PAYMENT_LINK': {
    en: 'One-time payment link',
    es: 'Link de pago único',
    pt: 'Link de pagamento único',
  },
  'menu.subItem.RECURRING_PAYMENT_LINK': {
    en: 'Recurring payment link',
    es: 'Link de pago recurrente',
    pt: 'Link de pagamento recorrente',
  },
  'menu.subItem.OPEN_PAYMENT_LINK': {
    en: 'Open payment link',
    es: 'Link de pago abierto',
    pt: 'Link de pagamento aberto',
  },
  'menu.subItem.QR_PAYMENT': {
    en: 'QR payments',
    es: 'Pagos con QR',
    pt: 'Pagamentos com QR',
  },
  'menu.subItem.SMART_PAYMENT': {
    en: 'Smart payment',
    es: 'Pago inteligente',
    pt: 'Pagamento inteligente',
  },
  'menu.subItem.SUBSCRIPTIONS': {
    en: 'Subscriptions',
    es: 'Suscripciones',
    pt: 'Assinaturas',
  },
  'menu.subItem.PAYMENT_BUTTON': {
    en: 'Payment button',
    es: 'Botón de pago',
    pt: 'Botão de pagamento',
  },
  'profilePage.heroSubtitle': {
    en: 'Manage your account information and settings effectively and securely.',
    es: 'Gestiona tu información y configuración de tu cuenta de forma eficaz y segura.',
    pt: 'Gerencie as informações e as configurações da sua conta de forma eficaz e segura.',
  },
  'profilePage.accountSettings': {
    en: 'Account settings',
    es: 'Configuración de la cuenta',
    pt: 'Configurações da conta',
  },
  'profilePage.passwordField': {
    en: 'Password',
    es: 'Contraseña',
    pt: 'Senha',
  },
  'profilePage.passwordMasked': {
    en: '••••••••',
    es: '••••••••',
    pt: '••••••••',
  },
  'profilePage.changePasswordCta': {
    en: 'CHANGE',
    es: 'CAMBIAR',
    pt: 'ALTERAR',
  },
  'profilePage.configure2faCta': {
    en: 'SET UP',
    es: 'CONFIGURAR',
    pt: 'CONFIGURAR',
  },
  'notificationPreferences.title': {
    en: 'Notifications',
    es: 'Notificaciones',
    pt: 'Notificações',
  },
  'notificationPreferences.salesEmail.label': {
    en: 'Sales email',
    es: 'Email de ventas',
    pt: 'E-mail de vendas',
  },
  'notificationPreferences.status.enabled': {
    en: 'Enabled',
    es: 'Habilitado',
    pt: 'Ativado',
  },
  'notificationPreferences.status.disabled': {
    en: 'Disabled',
    es: 'Deshabilitado',
    pt: 'Desativado',
  },
  'userManagement.subtitle': {
    en: 'Manage account users, assign predefined roles and control access permissions',
    es: 'Gestiona los usuarios de la cuenta, asigna roles predefinidos y controla los permisos de acceso',
    pt: 'Gerencie os usuários da conta, atribua funções predefinidas e controle as permissões de acesso',
  },
  'userManagement.description': {
    en: 'Share account management by inviting other team members.',
    es: 'Comparte la gestión de tu cuenta invitando a otros miembros del equipo.',
    pt: 'Compartilhe o gerenciamento da conta convidando outros membros da equipe.',
  },
  'userManagement.teamMembers': {
    en: 'Team Members',
    es: 'Miembros del Equipo',
    pt: 'Membros da Equipe',
  },
  'userManagement.membersCount': {
    en: '{0} members in your team',
    es: '{0} miembros en tu equipo',
    pt: '{0} membros em sua equipe',
  },
  'userManagement.invite': {
    en: 'Invite',
    es: 'Invitar',
    pt: 'Convidar',
  },
  'userManagement.member': {
    en: 'Member',
    es: 'Miembro',
    pt: 'Membro',
  },
  'userManagement.email': {
    en: 'Email',
    es: 'Email',
    pt: 'Email',
  },
  'userManagement.role': {
    en: 'Role',
    es: 'Rol',
    pt: 'Função',
  },
  'userManagement.status': {
    en: 'Status',
    es: 'Estado',
    pt: 'Status',
  },
  'userManagement.statusActive': {
    en: 'Active',
    es: 'Activo',
    pt: 'Ativo',
  },
  'userManagement.statusPending': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente',
  },
  'userManagement.changeRole': {
    en: 'Change Role',
    es: 'Cambiar Rol',
    pt: 'Alterar Função',
  },
  'userManagement.changeOwner': {
    en: 'Change account owner',
    es: 'Cambiar propietario de la cuenta',
    pt: 'Alterar proprietário da conta',
  },
  'userManagement.changeOwner.title': {
    en: 'You are about to assign a new owner',
    es: 'Estás por asignar un nuevo propietario',
    pt: 'Você está prestes a atribuir um novo proprietário',
  },
  'userManagement.changeOwner.description': {
    en: 'The owner (role Owner) will have full control over the account, including users, reports, integrations, security and billing. Your new role will be Admin, and you will be able to access the entire platform except for ownership, inviting and editing users, and configuring integrations, but you will not be able to transfer account ownership.',
    es: 'El propietario (<b>rol Owner</b>) tendrá control total sobre la cuenta, incluyendo usuarios, reportes, integraciones, seguridad y facturación.<br>Tu nuevo rol será <b>Admin</b>, podrás acceder a toda la plataforma, invitar, editar usuarios y configurar integraciones, pero no podrás transferir la propiedad de la cuenta.',
    pt: 'O proprietário (função Owner) terá controle total sobre a conta, incluindo usuários, relatórios, integrações, segurança e faturamento. Seu novo papel será Admin, e você poderá acessar toda a plataforma exceto a propriedade, convidar e editar usuários, e configurar integrações, mas não poderá transferir a propriedade da conta.',
  },
  'userManagement.changeOwner.confirm': {
    en: 'Confirm',
    es: 'Confirmar',
    pt: 'Confirmar',
  },
  'userManagement.changeOwner.cancel': {
    en: 'No, thanks',
    es: 'No, gracias',
    pt: 'Não, obrigado',
  },
  'userManagement.actions': {
    en: 'Actions',
    es: 'Acciones',
    pt: 'Ações',
  },
  'userManagement.removeUser': {
    en: 'Remove User',
    es: 'Remover Usuario',
    pt: 'Remover Usuário',
  },
  'userManagement.delete.title': {
    en: 'Are you sure you want to remove this user?',
    es: '¿Estás seguro de que quieres remover a este usuario?',
    pt: 'Tem certeza de que deseja remover este usuário?',
  },
  'userManagement.delete.body': {
    en: '{0} will no longer be able to access or operate on this account.',
    es: '{0} ya no podrá acceder ni operar en esta cuenta.',
    pt: '{0} não poderá mais acessar ou operar nesta conta.',
  },
  'userManagement.delete.confirm': {
    en: 'YES, REMOVE USER',
    es: 'SÍ, REMOVER AL USUARIO',
    pt: 'SIM, REMOVER USUÁRIO',
  },
  'userManagement.delete.no': {
    en: 'NO, THANKS',
    es: 'NO, GRACIAS',
    pt: 'NÃO, OBRIGADO',
  },
  'userManagement.deleteSuccess': {
    en: 'User removed',
    es: 'Usuario eliminado',
    pt: 'Usuário removido',
  },
  'userManagement.deleteSuccess.message': {
    en: '{0} was removed from the account.',
    es: '{0} fue removido de la cuenta.',
    pt: '{0} foi removido da conta.',
  },
  'userManagement.deleteSuccess.undo': {
    en: 'Undo',
    es: 'Deshacer',
    pt: 'Desfazer',
  },
  'userManagement.statusDeleted': {
    en: 'Deleted',
    es: 'Eliminado',
    pt: 'Excluído',
  },
  'userManagement.restoreUser': {
    en: 'Restore User',
    es: 'Restaurar Usuario',
    pt: 'Restaurar Usuário',
  },
  'userManagement.restore.title': {
    en: 'Are you sure you want to restore this user?',
    es: '¿Estás seguro de que quieres restaurar a este usuario?',
    pt: 'Tem certeza de que deseja restaurar este usuário?',
  },
  'userManagement.restore.body': {
    en: '{0} will regain access to this account.',
    es: '{0} recuperará el acceso a esta cuenta.',
    pt: '{0} recuperará o acesso a esta conta.',
  },
  'userManagement.restore.confirm': {
    en: 'YES, RESTORE USER',
    es: 'SÍ, RESTAURAR USUARIO',
    pt: 'SIM, RESTAURAR USUÁRIO',
  },
  'userManagement.restore.cancel': {
    en: 'NO, THANKS',
    es: 'NO, GRACIAS',
    pt: 'NÃO, OBRIGADO',
  },
  'userManagement.restoreSuccess': {
    en: 'User restored',
    es: 'Usuario restaurado',
    pt: 'Usuário restaurado',
  },
  'userManagement.restoreSuccess.message': {
    en: '{0} has been restored to the account.',
    es: '{0} ha sido restaurado en la cuenta.',
    pt: '{0} foi restaurado na conta.',
  },
  'userManagement.resendInvite': {
    en: 'Resend Invite',
    es: 'Reenviar Invitación',
    pt: 'Reenviar Convite',
  },
  'userManagement.resendInvite.title': {
    en: 'Are you sure you want to resend the invitation?',
    es: '¿Estás seguro de que quieres reenviar la invitación?',
    pt: 'Tem certeza de que deseja reenviar o convite?',
  },
  'userManagement.resendInvite.body': {
    en: 'A new invitation email will be sent to {0}.',
    es: 'Se enviará un nuevo correo de invitación a {0}.',
    pt: 'Um novo e-mail de convite será enviado para {0}.',
  },
  'userManagement.resendInvite.confirm': {
    en: 'YES, RESEND INVITE',
    es: 'SÍ, REENVIAR INVITACIÓN',
    pt: 'SIM, REENVIAR CONVITE',
  },
  'userManagement.resendInvite.cancel': {
    en: 'NO, THANKS',
    es: 'NO, GRACIAS',
    pt: 'NÃO, OBRIGADO',
  },
  'userManagement.resendInviteSuccess': {
    en: 'Invitation resent',
    es: 'Invitación reenviada',
    pt: 'Convite reenviado',
  },
  'userManagement.resendInviteSuccess.message': {
    en: 'A new invitation email has been sent to {0}.',
    es: 'Se ha enviado un nuevo correo de invitación a {0}.',
    pt: 'Um novo e-mail de convite foi enviado para {0}.',
  },
  'userManagement.changeOwnerSuccess': {
    en: 'All set! You have changed the account owner',
    es: '¡Listo! Cambiaste el propietario de la cuenta',
    pt: 'Tudo pronto! Você alterou o proprietário da conta',
  },
  'userManagement.changeOwnerSuccess.message': {
    en: 'You have assigned {0} as the account owner.',
    es: 'Asignaste a {0} como propietario de la cuenta.',
    pt: 'Você atribuiu {0} como proprietário da conta.',
  },
  'userManagement.emptyUsers.title': {
    en: 'No team members yet',
    es: 'Aún no hay miembros en el equipo',
    pt: 'Ainda não há membros na equipe',
  },
  'userManagement.emptyUsers.body': {
    en: 'Start inviting team members to collaborate on your account.',
    es: 'Comienza a invitar miembros del equipo para colaborar en tu cuenta.',
    pt: 'Comece a convidar membros da equipe para colaborar em sua conta.',
  },
  'userManagement.noPermission': {
    en: 'You do not have permission to access this section.',
    es: 'No tienes permiso para acceder a esta sección.',
    pt: 'Você não tem permissão para acessar esta seção.',
  },
  'userManagement.inviteTitle': {
    en: 'Invite team member',
    es: 'Invitar miembro del equipo',
    pt: 'Convidar membro da equipe',
  },
  'userManagement.inviteSubtitle': {
    en: 'Enter the email address of the person you want to invite',
    es: 'Ingresa el correo electrónico de la persona que deseas invitar',
    pt: 'Digite o endereço de email da pessoa que deseja convidar',
  },
  'userManagement.emailLabel': {
    en: 'Email address',
    es: 'Correo electrónico',
    pt: 'Endereço de email',
  },
  'userManagement.emailHelper': {
    en: 'The person will receive an invitation email to join your account.',
    es: 'La persona recibirá una invitación por correo para unirse a tu cuenta.',
    pt: 'A pessoa receberá um convite por email para se juntar à sua conta.',
  },
  'userManagement.fullNameLabel': {
    en: 'Full name',
    es: 'Nombre completo',
    pt: 'Nome completo',
  },
  'userManagement.assignRole': {
    en: 'Assign role',
    es: 'Asignar rol',
    pt: 'Atribuir função',
  },
  'userManagement.emailRequired': {
    en: 'Email address is required.',
    es: 'El correo electrónico es obligatorio.',
    pt: 'O endereço de email é obrigatório.',
  },
  'userManagement.emailInvalid': {
    en: 'Please enter a valid email address.',
    es: 'Por favor ingresa un correo electrónico válido.',
    pt: 'Por favor, digite um endereço de email válido.',
  },
  'userManagement.fullNameRequired': {
    en: 'Full name is required.',
    es: 'El nombre completo es obligatorio.',
    pt: 'O nome completo é obrigatório.',
  },
  'userManagement.fullNameFormat': {
    en: 'Please enter a valid full name (letters, spaces, apostrophes, hyphens).',
    es: 'Por favor ingresa un nombre y apellido válidos (letras, espacios, apóstrofes, guiones).',
    pt: 'Por favor, digite um nome e sobrenome válidos (letras, espaços, apóstrofos, hífens).',
  },
  'roles.ROLE_OWNER': {
    en: 'Owner',
    es: 'Owner',
    pt: 'Owner',
  },
  'roles.ROLE_ADMINISTRATOR': {
    en: 'Admin',
    es: 'Admin',
    pt: 'Admin',
  },
  'roles.ROLE_SALES_CS': {
    en: 'Sales / CS',
    es: 'Sales / CS',
    pt: 'Sales / CS',
  },
  'roles.ROLE_FINANCE': {
    en: 'Finance',
    es: 'Finance',
    pt: 'Finance',
  },
  'roles.ROLE_TECHNICAL': {
    en: 'Tech',
    es: 'Tech',
    pt: 'Tech',
  },
  'roles.ROLE_READ_ONLY': {
    en: 'Read only',
    es: 'Solo lectura',
    pt: 'Somente leitura',
  },
  'userManagement.step2.title': {
    en: 'Choose a role. We will assign the corresponding accesses based on your choice.',
    es: 'Elige un rol. Asignaremos los accesos correspondientes según tu elección.',
    pt: 'Escolha um papel. Atribuiremos os acessos correspondentes com base em sua escolha.',
  },
  'userManagement.step2.card_role.canDo': {
    en: 'Can Do',
    es: 'Puede',
    pt: 'Pode',
  },
  'userManagement.step2.card_role.cannotDo': {
    en: 'Cannot Do',
    es: 'No puede',
    pt: 'Não pode',
  },
  'userManagement.step2.ROLE_OWNER.subtitle': {
    en: 'Billing, security, users',
    es: 'Facturación, seguridad, usuarios',
    pt: 'Faturamento, segurança, usuários',
  },
  'userManagement.step2.ROLE_OWNER.description': {
    en: 'Total control over the organization.',
    es: 'Control total sobre la organización.',
    pt: 'Controle total sobre a organização.',
  },
  'userManagement.step2.ROLE_OWNER.canDo.0': {
    en: 'Manage everything: users, reports, integrations, security and billing.',
    es: 'Gestionar todo: usuarios, reportes, integraciones, seguridad y facturación.',
    pt: 'Gerenciar tudo: usuários, relatórios, integrações, segurança e faturamento.',
  },
  'userManagement.step2.ROLE_OWNER.canDo.1': {
    en: 'Transfer the ownership of the account.',
    es: 'Transferir la propiedad de la cuenta.',
    pt: 'Transferir a propriedade da conta.',
  },
  'userManagement.step2.ROLE_OWNER.cannotDo.0': {
    en: 'Delegate part of the role without transferring everything.',
    es: 'Delegar parte del rol sin transferir todo.',
    pt: 'Delegar parte da função sem transferir tudo.',
  },
  'userManagement.step2.ROLE_OWNER.cannotDo.1': {
    en: 'Use the role for daily tasks.',
    es: 'Usar el rol para tareas diarias.',
    pt: 'Usar a função para tarefas diárias.',
  },
  'userManagement.step2.ROLE_ADMINISTRATOR.subtitle': {
    en: 'Platform and team management',
    es: 'Gestión de plataforma y equipo',
    pt: 'Gestão de plataforma e equipe',
  },
  'userManagement.step2.ROLE_ADMINISTRATOR.description': {
    en: 'Wide access, except ownership.',
    es: 'Acceso amplio, excepto la propiedad.',
    pt: 'Acesso amplo, exceto a propriedade.',
  },
  'userManagement.step2.ROLE_ADMINISTRATOR.canDo.0': {
    en: 'Access to the entire platform, except ownership.',
    es: 'Acceder a toda la plataforma excepto la propiedad.',
    pt: 'Acesso a toda a plataforma, exceto a propriedade.',
  },
  'userManagement.step2.ROLE_ADMINISTRATOR.canDo.1': {
    en: 'Invite and edit users.',
    es: 'Invitar y editar usuarios.',
    pt: 'Convidar e editar usuários.',
  },
  'userManagement.step2.ROLE_ADMINISTRATOR.canDo.2': {
    en: 'Configure integrations.',
    es: 'Configurar integraciones',
    pt: 'Configurar integrações',
  },
  'userManagement.step2.ROLE_ADMINISTRATOR.cannotDo.0': {
    en: 'Transfer the ownership of the account.',
    es: 'Transferir la propiedad de la cuenta.',
    pt: 'Transferir a propriedade da conta.',
  },
  'userManagement.step2.ROLE_FINANCE.subtitle': {
    en: 'Reports, balances, chargebacks',
    es: 'Reportes, saldos, contracargos',
    pt: 'Relatórios, saldos, contracargos',
  },
  'userManagement.step2.ROLE_FINANCE.description': {
    en: 'Focus on financial control and visibility.',
    es: 'Enfoque en control y visibilidad financiera.',
    pt: 'Focar no controle e visibilidade financeira.',
  },
  'userManagement.step2.ROLE_FINANCE.canDo.0': {
    en: 'View all reports and balances.',
    es: 'Modificar configuraciones o usuarios.',
    pt: 'Visualizar todos os relatórios e saldos.',
  },
  'userManagement.step2.ROLE_FINANCE.canDo.1': {
    en: 'Access technical integrations.',
    es: 'Acceder a integraciones técnicas.',
    pt: 'Acessar integrações técnicas.',
  },
  'userManagement.step2.ROLE_FINANCE.cannotDo.0': {
    en: 'Change configurations or users.',
    es: 'Cambiar configuraciones o usuarios.',
    pt: 'Alterar configurações ou usuários.',
  },
  'userManagement.step2.ROLE_FINANCE.cannotDo.1': {
    en: 'Access technical integrations.',
    es: 'Acceder a integraciones técnicas.',
    pt: 'Acessar integrações técnicas.',
  },
  'userManagement.step2.ROLE_SALES_CS.subtitle': {
    en: 'Transactions, chargebacks, refunds',
    es: 'Transacciones, rechazos, reembolsos',
    pt: 'Transações, rejeições, reembolsos',
  },
  'userManagement.step2.ROLE_SALES_CS.description': {
    en: 'Focus on transactions and customer support.',
    es: 'Seguimiento de pagos y atención al cliente.',
    pt: 'Focar em transações e rejeições.',
  },
  'userManagement.step2.ROLE_SALES_CS.canDo.0': {
    en: 'View all transactions, chargebacks and refunds.',
    es: 'Ver transacciones, rechazos y reembolsos.',
    pt: 'Visualizar todas as transações, rejeições e reembolsos.',
  },
  'userManagement.step2.ROLE_SALES_CS.canDo.1': {
    en: 'Track chargebacks and refunds.',
    es: 'Dar seguimiento a cobros',
    pt: 'Rastrear rejeições e reembolsos.',
  },
  'userManagement.step2.ROLE_SALES_CS.cannotDo.0': {
    en: 'View global reports.',
    es: 'Ver reportes globales.',
    pt: 'Visualizar todos os relatórios.',
  },
  'userManagement.step2.ROLE_SALES_CS.cannotDo.1': {
    en: 'Edit users or configurations.',
    es: 'Editar Usuarios o configuraciones.',
    pt: 'Editar usuários ou configurações.',
  },
  'userManagement.step2.ROLE_TECHNICAL.subtitle': {
    en: 'API Keys, webhooks, integrations',
    es: 'API Keys, webhooks, integraciones',
    pt: 'API Keys, webhooks, integrações',
  },
  'userManagement.step2.ROLE_TECHNICAL.description': {
    en: 'Configure and maintain the technical part.',
    es: 'Configura y mantiene la parte técnica.',
    pt: 'Configura e mantém a parte técnica.',
  },
  'userManagement.step2.ROLE_TECHNICAL.canDo.0': {
    en: 'View all technical support.',
    es: 'Ver soporte técnico.',
    pt: 'Visualizar suporte técnico.',
  },
  'userManagement.step2.ROLE_TECHNICAL.canDo.1': {
    en: 'Track chargebacks and refunds.',
    es: 'Dar seguimiento a cobros',
    pt: 'Rastrear rejeições e reembolsos.',
  },
  'userManagement.step2.ROLE_TECHNICAL.cannotDo.0': {
    en: 'View global reports.',
    es: 'Ver reportes globales.',
    pt: 'Visualizar todos os relatórios.',
  },
  'userManagement.step2.ROLE_READ_ONLY.subtitle': {
    en: 'Access of read only',
    es: 'Acceso de solo lectura',
    pt: 'Acesso de leitura somente',
  },
  'userManagement.step2.ROLE_READ_ONLY.description': {
    en: 'Can view everything, without editing permissions.',
    es: 'Puede ver todo, sin permisos de edición.',
    pt: 'Pode ver tudo, sem permissões de edição.',
  },
  'userManagement.step2.ROLE_READ_ONLY.canDo.0': {
    en: 'View all information available.',
    es: 'Ver toda la información disponible.',
    pt: 'Visualizar toda a informação disponível.',
  },
  'userManagement.step2.ROLE_READ_ONLY.cannotDo.0': {
    en: 'Perform actions, change data or manage users.',
    es: 'Realizar acciones, cambiar datos o gestionar usuarios.',
    pt: 'Realizar ações, alterar dados ou gerenciar usuários.',
  },
  'userManagement.step2.footerMsg.ROLE_OWNER': {
    en: '<span>{0}</span> will have total control over the account, including users, billing and security.',
    es: '<span>{0}</span> tendrá control total sobre la cuenta, incluyendo usuarios, facturación y seguridad.',
    pt: '<span>{0}</span> terá controle total sobre a conta, incluindo usuários, faturamento e segurança.',
  },
  'userManagement.step2.footerMsg.ROLE_ADMINISTRATOR': {
    en: '<span>{0}</span> will be able to manage the platform and users, but will not have the ability to transfer the ownership of the account.',
    es: '<span>{0}</span> podrá gestionar la plataforma y los usuarios, pero no podrá transferir la propiedad de la cuenta.',
    pt: '<span>{0}</span> poderá gerenciar a plataforma e usuários, mas não terá a capacidade de transferir a propriedade da conta.',
  },
  'userManagement.step2.footerMsg.ROLE_FINANCE': {
    en: '<span>{0}</span> will be able to view and export reports, query balances and chargebacks, but will not have the ability to edit configurations or users.',
    es: '<span>{0}</span> podrá ver y exportar reportes, consultar saldos y contracargos, pero no podrá editar configuraciones ni usuarios.',
    pt: '<span>{0}</span> poderá visualizar e exportar relatórios, consultar saldos e contracargos, mas não poderá editar configurações ou usuários.',
  },
  'userManagement.step2.footerMsg.ROLE_SALES_CS': {
    en: '<span>{0}</span> will be able to view transactions, chargebacks and refunds, but will not have the ability to edit users or access global reports.',
    es: '<span>{0}</span> podrá ver transacciones, rechazos y reembolsos, pero no podrá editar usuarios ni acceder a reportes globales.',
    pt: '<span>{0}</span> poderá visualizar transações, rejeições e reembolsos, mas não poderá editar usuários nem acessar relatórios globais.',
  },
  'userManagement.step2.footerMsg.ROLE_TECHNICAL': {
    en: '<span>{0}</span> will be able to access API Keys, webhooks and integrations, but will not have the ability to modify financial or user data.',
    es: '<span>{0}</span> podrá acceder a API Keys, webhooks e integraciones, pero no podrá modificar datos financieros ni de usuarios.',
    pt: '<span>{0}</span> poderá acessar API Keys, webhooks e integrações, mas não poderá modificar dados financeiros ou de usuários.',
  },
  'userManagement.step2.footerMsg.ROLE_READ_ONLY': {
    en: '<span>{0}</span> will be able to view all account information, but will not have access to the configuration or be able to manage users.',
    es: '<span>{0}</span> podrá ver toda la información de la cuenta, pero no tendrá acceso a la configuración ni podrá administrar usuarios.',
    pt: '<span>{0}</span> poderá ver toda a informação da conta, mas não terá acesso à configuração nem poderá gerenciar usuários.',
  },
  'userManagement.step2.sendInvitation': {
    en: 'Send invitation',
    es: 'Enviar invitación',
    pt: 'Enviar convite',
  },
  'userManagement.inviteSuccess': {
    en: 'Invitation sent!',
    es: '¡Invitación enviada!',
    pt: '¡Convite enviado!',
  },
  'userManagement.inviteSuccess.message': {
    en: '<span>{0}</span> has been invited as {1}',
    es: '<span>{0}</span> ha sido invitado como {1}',
    pt: '<span>{0}</span> foi convidado como {1}',
  },
  'userManagement.step2.ROLE_OWNER.tooltip': {
    en: 'Use it if you are the responsible person. It is recommended to have only one owner (Owner) per account.',
    es: 'Úsalo si eres la persona responsable. Se recomienda tener solo un propietario (Owner) por cuenta.',
    pt: 'Úse se você for a pessoa responsável. É recomendado ter apenas um proprietário (Owner) por conta.',
  },
  'userManagement.step2.ROLE_ADMINISTRATOR.tooltip': {
    en: 'Perfect for a trusted person who manages the operation.',
    es: 'Perfecto para alguien de confianza que gestiona la operación.',
    pt: 'Perfeito para uma pessoa de confiança que gerencia a operação.',
  },
  'userManagement.step2.ROLE_FINANCE.tooltip': {
    en: 'Ideal for accountants, CFOs or those who reconcile chargebacks.',
    es: 'Ideal para contadores, CFOs o quienes concilian cobros.',
    pt: 'Ideal para alguém que é responsável por operações financeiras.',
  },
  'userManagement.step2.ROLE_SALES_CS.tooltip': {
    en: 'Thought for support teams or customer service.',
    es: 'Pensado para equipos de soporte o atención al cliente.',
    pt: 'Pensado para equipes de suporte ou atendimento ao cliente.',
  },
  'userManagement.step2.ROLE_TECHNICAL.tooltip': {
    en: 'Useful for CTOs, developers or technical integrators.',
    es: 'Útil para CTOs, desarrolladores o integradores técnicos.',
    pt: 'Útil para CTOs, desenvolvedores ou integradores técnicos.',
  },
  'userManagement.step2.ROLE_READ_ONLY.tooltip': {
    en: 'Safe for auditors or external profiles that need visibility without intervening.',
    es: 'Rol seguro para auditores o perfiles externos que necesitan visibilidad sin intervenir.',
    pt: 'Rol seguro para auditores ou perfis externos que precisam de visibilidade sem interferir.',
  },
  'openPaymentLink.title': {
    en: 'Share an open payment link',
    es: 'Comparte un link de pago abierto',
    pt: 'Compartilhe um link de pagamento aberto',
  },
  'openPaymentLink.subheadline': {
    en: 'Your clients enter the amount to be paid when opening the link.  Use it as many times as you want, with any person.',
    es: 'Tus clientes ingresan el monto a pagar al abrir el link.  Usalo las veces que quieras, con cualquier persona.',
    pt: 'Seus clientes informam o valor a ser pago ao abrir o link.  Use-o quantas vezes quiser, com qualquer pessoa.',
  },
  'openPaymentLink.copyLink': {
    en: 'Copy and share this link',
    es: 'Copia y comparte este link',
    pt: 'Copie e compartilhe este link',
  },
  'qrPayment.title': {
    en: 'Receive payments with QR',
    es: 'Recibe pagos con QR',
    pt: 'Receba pagamentos com QR',
  },
  'qrPayment.subheadline': {
    en: 'Your clients scan the QR code with their phone to pay instantly.',
    es: 'Tus clientes escanean el código QR con su celular para pagar al instante.',
    pt: 'Seus clientes escaneiam o código QR com seu celular para pagar instantaneamente.',
  },
  'qrPayment.download': {
    en: 'Download QR Code',
    es: 'Descargar código QR',
    pt: 'Baixar código QR',
  },
  'qrPayment.description': {
    en: 'Download the QR code and print it or share it so your clients can pay.',
    es: 'Descarga el código QR e imprimelo o compártelo para que tus clientes puedan pagar.',
    pt: 'Baixe o código QR e imprima-o ou compartilhe-o para que seus clientes possam pagar.',
  },
};
